webpackJsonp([1],Array(29).concat([
/* 29 */
/*!**********************************!*\
  !*** ./src/services/customer.js ***!
  \**********************************/
/*! exports provided: GET_CUSTOMER, POST_CUSTOMER, PUT_CUSTOMER, GET_HEALTHID_DIGITAL, GET_CUSTOMER_ANSWERS, GET_CUSTOMER_RISKS, GET_PROFILE_PICTURE */
/*! exports used: GET_CUSTOMER, GET_CUSTOMER_ANSWERS, GET_CUSTOMER_RISKS, GET_HEALTHID_DIGITAL, GET_PROFILE_PICTURE, POST_CUSTOMER */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_CUSTOMER; });
/* harmony export (immutable) */ __webpack_exports__["f"] = POST_CUSTOMER;
/* unused harmony export PUT_CUSTOMER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_HEALTHID_DIGITAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_CUSTOMER_ANSWERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_CUSTOMER_RISKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_PROFILE_PICTURE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(/*! ./api */ 39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(/*! axios */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var CUSTOMER_ENDPOINT = "customer";
var HEALTHID_DIGITAL_ENDPOINT = "healthid-digital";
var CUSTOMER_RISKS = "customer/metrics/updated";
var CUSTOMER_ANSWERS = "customer/answers";

var GET_CUSTOMER = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + CUSTOMER_ENDPOINT + '/user', {
							headers: {
								'Authorization': 'Bearer ' + window.localStorage.getItem('token')
							}
						});

					case 2:
						response = _context.sent;
						return _context.abrupt('return', response.data);

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function GET_CUSTOMER() {
		return _ref.apply(this, arguments);
	};
}();

function POST_CUSTOMER(form) {
	return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + CUSTOMER_ENDPOINT, form, {
		headers: {
			'Authorization': 'Bearer ' + window.localStorage.getItem('token')
		}
	});
}

var PUT_CUSTOMER = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(form) {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + CUSTOMER_ENDPOINT, form, {
							headers: {
								'Authorization': 'Bearer ' + window.localStorage.getItem('token')
							}
						});

					case 2:
						response = _context2.sent;
						return _context2.abrupt('return', response.data);

					case 4:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function PUT_CUSTOMER(_x) {
		return _ref2.apply(this, arguments);
	};
}();

var GET_HEALTHID_DIGITAL = function () {
	var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.next = 2;
						return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + HEALTHID_DIGITAL_ENDPOINT, {
							headers: {
								'Authorization': 'Bearer ' + window.localStorage.getItem('token')
							}
						});

					case 2:
						response = _context3.sent;
						return _context3.abrupt('return', response.data);

					case 4:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function GET_HEALTHID_DIGITAL() {
		return _ref3.apply(this, arguments);
	};
}();

var GET_CUSTOMER_ANSWERS = function () {
	var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.next = 2;
						return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + CUSTOMER_ANSWERS, {
							headers: {
								'Authorization': 'Bearer ' + window.localStorage.getItem('token')
							}
						});

					case 2:
						response = _context4.sent;
						return _context4.abrupt('return', response.data);

					case 4:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function GET_CUSTOMER_ANSWERS() {
		return _ref4.apply(this, arguments);
	};
}();

var GET_CUSTOMER_RISKS = function () {
	var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						_context5.next = 2;
						return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + CUSTOMER_RISKS, {
							headers: {
								'Authorization': 'Bearer ' + window.localStorage.getItem('token')
							}
						});

					case 2:
						response = _context5.sent;
						return _context5.abrupt('return', response.data);

					case 4:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this);
	}));

	return function GET_CUSTOMER_RISKS() {
		return _ref5.apply(this, arguments);
	};
}();

var GET_PROFILE_PICTURE = function () {
	var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee6() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						_context6.next = 2;
						return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + CUSTOMER_ENDPOINT + '/picture', {
							headers: {
								'Authorization': 'Bearer ' + window.localStorage.getItem('token')
							}
						});

					case 2:
						response = _context6.sent;
						return _context6.abrupt('return', response.data);

					case 4:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this);
	}));

	return function GET_PROFILE_PICTURE() {
		return _ref6.apply(this, arguments);
	};
}();

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/*!*****************************!*\
  !*** ./src/services/api.js ***!
  \*****************************/
/*! exports provided: API_HOST, AXIOS_INSTANCE, catchError */
/*! exports used: API_HOST, AXIOS_INSTANCE, catchError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AXIOS_INSTANCE; });
/* harmony export (immutable) */ __webpack_exports__["c"] = catchError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var API_HOST = "https://backoffice.healthidlab.com/api";

var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();

instance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status === 401) {
    catchError(error);
  }
  if (error.response.status === 403) {
    catchError(error);
  }

  throw error;
});

var AXIOS_INSTANCE = instance;

function unauthenticated() {
  window.localStorage.removeItem('token');
  window.location = '/';
}

function catchError(err) {
  if (err.response.status === 401) {
    unauthenticated();
  }
  if (err.response.status == 403) {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var kit = url.searchParams.get("kit_number");
    if (!!kit && kit != '') window.location = '/perfil?kit_number=' + kit;else window.location = '/perfil';
  }
  console.log(err.response);
  return err.response;
}

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/*!******************************!*\
  !*** ./src/services/user.js ***!
  \******************************/
/*! exports provided: USER_LOGIN, USER_LOGOUT, POST_USER, FORGOT_PASSWORD, VERIFY_FORGOT_PASSWORD, RECOVER_PASSWORD */
/*! exports used: FORGOT_PASSWORD, POST_USER, RECOVER_PASSWORD, USER_LOGIN, USER_LOGOUT, VERIFY_FORGOT_PASSWORD */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POST_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FORGOT_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VERIFY_FORGOT_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECOVER_PASSWORD; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(/*! ./api */ 39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(/*! axios */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var LOGIN_ENDPOINT = "login";
var LOGOUT_ENDPOINT = "logout";
var REGISTER_ENDPOINT = "register";
var FORGOT_ENDPOINT = "forgot-password";
var VERIFY_ENDPOINT = "forgot-password/verify";
var RECOVER_ENDPOINT = "recover-password";

var USER_LOGIN = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(form) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + LOGIN_ENDPOINT, form, {
                            headers: {
                                'Accept': 'application/json'
                            }
                        });

                    case 2:
                        response = _context.sent;
                        return _context.abrupt('return', response.data);

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function USER_LOGIN(_x) {
        return _ref.apply(this, arguments);
    };
}();

var USER_LOGOUT = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(form) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + LOGOUT_ENDPOINT, form, {
                            headers: {
                                'Authorization': 'Bearer ' + window.localStorage.getItem('token'),
                                'Accept': 'application/json'
                            }
                        });

                    case 2:
                        response = _context2.sent;
                        return _context2.abrupt('return', response.data);

                    case 4:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function USER_LOGOUT(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

var POST_USER = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(form) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + REGISTER_ENDPOINT, form, {
                            headers: {
                                'Accept': 'application/json'
                            }
                        });

                    case 2:
                        response = _context3.sent;
                        return _context3.abrupt('return', response.data);

                    case 4:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function POST_USER(_x3) {
        return _ref3.apply(this, arguments);
    };
}();

var FORGOT_PASSWORD = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(form) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + FORGOT_ENDPOINT, form);

                    case 2:
                        response = _context4.sent;
                        return _context4.abrupt('return', response.data);

                    case 4:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function FORGOT_PASSWORD(_x4) {
        return _ref4.apply(this, arguments);
    };
}();

var VERIFY_FORGOT_PASSWORD = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5(form) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + VERIFY_ENDPOINT + '?email=' + form.email + '&token=' + form.token);

                    case 2:
                        response = _context5.sent;
                        return _context5.abrupt('return', response.data);

                    case 4:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function VERIFY_FORGOT_PASSWORD(_x5) {
        return _ref5.apply(this, arguments);
    };
}();

var RECOVER_PASSWORD = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee6(form) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _context6.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + RECOVER_ENDPOINT, form);

                    case 2:
                        response = _context6.sent;
                        return _context6.abrupt('return', response.data);

                    case 4:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function RECOVER_PASSWORD(_x6) {
        return _ref6.apply(this, arguments);
    };
}();

/***/ }),
/* 49 */,
/* 50 */
/*!*****************************!*\
  !*** ./src/services/kit.js ***!
  \*****************************/
/*! exports provided: LIST_KIT, POST_KIT, POST_KIT_VALIDATE, GET_KIT_ANSWERS, LAST_ANSWERS */
/*! exports used: GET_KIT_ANSWERS, LAST_ANSWERS, LIST_KIT, POST_KIT, POST_KIT_VALIDATE */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LIST_KIT; });
/* harmony export (immutable) */ __webpack_exports__["d"] = POST_KIT;
/* harmony export (immutable) */ __webpack_exports__["e"] = POST_KIT_VALIDATE;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_KIT_ANSWERS; });
/* harmony export (immutable) */ __webpack_exports__["b"] = LAST_ANSWERS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(/*! ./api */ 39);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var LIST_KITS = "kits";
var ASSOCIATE_KIT = "associate-kit";
var VALIDATE_KIT = "associate-kit/validate";
var KIT_ANSWERS = "last";
var KIT_LAST_ANSWERS = "last";

var LIST_KIT = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(id) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + "/" + LIST_KITS, {
              headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
              }
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);

            Object(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* catchError */])(_context.t0);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 7]]);
  }));

  return function LIST_KIT(_x) {
    return _ref.apply(this, arguments);
  };
}();

function POST_KIT(form) {
  return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + "/" + ASSOCIATE_KIT, form, {
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('token')
    }
  }).catch(function (err) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* catchError */])(err);
  });
}

function POST_KIT_VALIDATE(form) {
  return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + "/" + VALIDATE_KIT, form, {
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('token')
    }
  });
}

var GET_KIT_ANSWERS = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(kit_id) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + "/" + LIST_KITS + "/" + kit_id, {
              headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
              }
            });

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);

            Object(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* catchError */])(_context2.t0);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 7]]);
  }));

  return function GET_KIT_ANSWERS(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

function LAST_ANSWERS() {
  return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + "/" + LIST_KITS + "/" + KIT_LAST_ANSWERS, {
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('token')
    }
  });
}

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/*!****************************!*\
  !*** ./src/models/User.js ***!
  \****************************/
/*! exports provided: User, isAuthenticated */
/*! exports used: User, isAuthenticated */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return User; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isAuthenticated;
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var User = function () {
    function User() {
        _classCallCheck(this, User);
    }

    _createClass(User, [{
        key: 'getUser',
        value: function getUser() {
            return window.localStorage.getItem('name');
        }
    }, {
        key: 'setUser',
        value: function setUser(name, email, token) {
            window.localStorage.setItem('name', name);
            window.localStorage.setItem('email', email);
            window.localStorage.setItem('token', token);
        }
    }, {
        key: 'logout',
        value: function logout() {
            window.localStorage.removeItem('name');
            window.localStorage.removeItem('email');
            window.localStorage.removeItem('token');
            location.reload();
        }
    }]);

    return User;
}();

function isAuthenticated() {
    var token = window.localStorage.getItem('token');
    if (token) {
        return true;
    }
    return false;
}

/***/ }),
/* 60 */
/*!***********************************************!*\
  !*** ./src/assets/images/risks ^\.\/.*\.png$ ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./activity_g.png": 669,
	"./activity_r.png": 670,
	"./activity_y.png": 671,
	"./age_g.png": 672,
	"./age_r.png": 673,
	"./age_y.png": 674,
	"./animal_g.png": 675,
	"./animal_r.png": 676,
	"./animal_y.png": 677,
	"./avatar_doencas_cronicas.png": 678,
	"./avatar_front_shadow.png": 679,
	"./avatar_longevidade.png": 680,
	"./avatar_riscos.png": 371,
	"./avatar_saude_coracao.png": 681,
	"./avatar_saude_preventiva.png": 682,
	"./avatar_side_shadow.png": 683,
	"./b_g.png": 372,
	"./b_r.png": 373,
	"./b_y.png": 374,
	"./botao.png": 684,
	"./caretaker_g.png": 685,
	"./caretaker_r.png": 686,
	"./caretaker_y.png": 687,
	"./circunference_g.png": 688,
	"./circunference_r.png": 689,
	"./clt_g.png": 690,
	"./clt_r.png": 691,
	"./clt_y.png": 692,
	"./creatinina_g.png": 693,
	"./creatinina_r.png": 694,
	"./daily_activity_g.png": 695,
	"./daily_activity_r.png": 696,
	"./daily_activity_y.png": 697,
	"./diabetes_g.png": 698,
	"./diabetes_r.png": 699,
	"./diabetes_y.png": 700,
	"./diseases_g.png": 701,
	"./diseases_r.png": 702,
	"./drink_g.png": 703,
	"./drink_r.png": 704,
	"./drink_y.png": 705,
	"./familiar_disease_g.png": 706,
	"./familiar_disease_r.png": 707,
	"./family_g.png": 708,
	"./family_r.png": 709,
	"./family_y.png": 710,
	"./fruits_g.png": 711,
	"./fruits_r.png": 712,
	"./fruits_y.png": 713,
	"./gender_g.png": 714,
	"./gender_r.png": 715,
	"./gender_y.png": 716,
	"./gli_g.png": 717,
	"./gli_r.png": 718,
	"./gli_y.png": 719,
	"./glucose_g.png": 720,
	"./glucose_r.png": 721,
	"./glucose_y.png": 722,
	"./hdl_g.png": 723,
	"./hdl_r.png": 724,
	"./hdl_y.png": 725,
	"./health_g.png": 726,
	"./health_r.png": 727,
	"./health_y.png": 728,
	"./heart_disease_g.png": 729,
	"./heart_disease_r.png": 730,
	"./heart_disease_y.png": 731,
	"./hemoglobin_g.png": 732,
	"./hemoglobin_r.png": 733,
	"./hemoglobin_y.png": 734,
	"./home_g.png": 735,
	"./home_r.png": 736,
	"./home_y.png": 737,
	"./hospitalized_g.png": 738,
	"./hospitalized_r.png": 739,
	"./hypertension_g.png": 740,
	"./hypertension_r.png": 741,
	"./hypertension_y.png": 742,
	"./icon_green.png": 743,
	"./icon_red.png": 744,
	"./icon_yellow.png": 745,
	"./imc_g.png": 746,
	"./imc_r.png": 747,
	"./imc_y.png": 748,
	"./ldl_g.png": 749,
	"./ldl_r.png": 750,
	"./ldl_y.png": 751,
	"./limited_activity_g.png": 752,
	"./limited_activity_r.png": 753,
	"./limited_activity_y.png": 754,
	"./medic_g.png": 755,
	"./medic_r.png": 756,
	"./pregnant_g.png": 757,
	"./pressure_g.png": 758,
	"./pressure_r.png": 759,
	"./pressure_y.png": 760,
	"./psychologic_g.png": 761,
	"./psychologic_r.png": 762,
	"./sleep_g.png": 763,
	"./sleep_r.png": 764,
	"./smoke_g.png": 765,
	"./smoke_r.png": 766,
	"./smoke_y.png": 767,
	"./tfg_g.png": 768,
	"./tfg_r.png": 769,
	"./tfg_y.png": 770,
	"./tri_g.png": 771,
	"./tri_r.png": 772,
	"./tri_y.png": 773,
	"./walk_support_g.png": 774,
	"./walk_support_r.png": 775,
	"./walk_support_y.png": 776
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/*!*********************************!*\
  !*** ./src/services/address.js ***!
  \*********************************/
/*! exports provided: ADDRESS_FIND, CITY_TIME */
/*! exports used: ADDRESS_FIND, CITY_TIME */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADDRESS_FIND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CITY_TIME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(/*! ./api */ 39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(/*! axios */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var ADDRESS_FIND = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(zip_code) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://viacep.com.br/ws/' + zip_code + '/json/');

                    case 2:
                        response = _context.sent;
                        return _context.abrupt('return', response.data);

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function ADDRESS_FIND(_x) {
        return _ref.apply(this, arguments);
    };
}();

var CITY_TIME = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(state, city) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        city = city.replace(' ', '%20');
                        console.log(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/cities/?state=' + state + '&city=' + city);
                        _context2.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/cities/?state=' + state + '&city=' + city, {
                            headers: {
                                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
                            }
                        });

                    case 4:
                        response = _context2.sent;
                        return _context2.abrupt('return', response.data);

                    case 6:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function CITY_TIME(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/*!**********************************!*\
  !*** ./src/services/schedule.js ***!
  \**********************************/
/*! exports provided: POST_SCHEDULE, LIST_SCHEDULES */
/*! exports used: LIST_SCHEDULES, POST_SCHEDULE */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POST_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LIST_SCHEDULES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(/*! ./api */ 39);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var SCHEDULES = "schedules";

var POST_SCHEDULE = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(form) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + SCHEDULES, form, {
              headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
              }
            });

          case 2:
            response = _context.sent;
            return _context.abrupt('return', response.data);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function POST_SCHEDULE(_x) {
    return _ref.apply(this, arguments);
  };
}();

var LIST_SCHEDULES = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + SCHEDULES, {
              headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
              }
            });

          case 2:
            response = _context2.sent;
            return _context2.abrupt('return', response.data);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function LIST_SCHEDULES() {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 136 */
/*!********************************!*\
  !*** ./src/services/result.js ***!
  \********************************/
/*! exports provided: LIST_RESULTS, GET_RESULTS_COUNT */
/*! exports used: GET_RESULTS_COUNT, LIST_RESULTS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LIST_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_RESULTS_COUNT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(/*! ./api */ 39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(/*! axios */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var RESULTS = "results";
var RESULTS_COUNT = "count";

var LIST_RESULTS = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + RESULTS, {
              headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token'),
                'Accept': 'application/json'
              }
            });

          case 2:
            response = _context.sent;
            return _context.abrupt('return', response.data);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function LIST_RESULTS() {
    return _ref.apply(this, arguments);
  };
}();

var GET_RESULTS_COUNT = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + RESULTS + '/' + RESULTS_COUNT, {
              headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
              }
            });

          case 3:
            response = _context2.sent;
            return _context2.abrupt('return', response.data);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2['catch'](0);

            catchError(_context2.t0);

          case 10:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 7]]);
  }));

  return function GET_RESULTS_COUNT() {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 137 */
/*!***************************************************!*\
  !*** ./src/assets/images/new_logo_horizontal.png ***!
  \***************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/new_logo_horizontal.1b6c2ea8.png";

/***/ }),
/* 138 */
/*!******************************!*\
  !*** ./src/services/form.js ***!
  \******************************/
/*! exports provided: GET_FORM, POST_FORM */
/*! exports used: GET_FORM, POST_FORM */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POST_FORM; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(/*! ./api */ 39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(/*! axios */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var FORMS = "form";
var FORMS_STEPS = "form-steps";

var GET_FORM = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(type) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + FORMS + '/' + type, {
              headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
              }
            });

          case 3:
            response = _context.sent;
            return _context.abrupt('return', response.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);

            Object(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* catchError */])(_context.t0);

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 7]]);
  }));

  return function GET_FORM(_x) {
    return _ref.apply(this, arguments);
  };
}();
var POST_FORM = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(kit, data) {
    var answers, response;
    return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            answers = {
              answers: data
            };

            console.log('?');
            _context2.prev = 2;
            _context2.next = 5;
            return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].post(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + FORMS_STEPS + '/' + kit, answers, {
              headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
              }
            });

          case 5:
            response = _context2.sent;
            return _context2.abrupt('return', response.data);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2['catch'](2);

            Object(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* catchError */])(_context2.t0);

          case 12:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[2, 9]]);
  }));

  return function POST_FORM(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/*!*********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 209 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Home/Home.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user__ = __webpack_require__(/*! ../../services/user */ 48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_User__ = __webpack_require__(/*! ../../models/User */ 59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_brands_svg_icons__ = __webpack_require__(/*! @fortawesome/free-brands-svg-icons */ 627);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__["s" /* faEye */]);
__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__["t" /* faEyeSlash */]);
__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_brands_svg_icons__["b" /* faGoogle */]);
__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_brands_svg_icons__["a" /* faFacebookSquare */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            showRegisterModal: false,
            showForgotModal: false,
            forgotPasswordUrl: "/esqueceu-senha",
            showPassword: false,
            loading: false,
            form: {
                email: null,
                password: null,
                remember: false
            },
            errors: {}
        };
    },

    methods: {
        clearErrors: function clearErrors() {
            this.errors = [];
        },
        handleShowPassword: function handleShowPassword() {
            this.showPassword = !this.showPassword;
            var password = document.getElementById('password');
            password.type = !!this.showPassword ? "text" : "password";
        },
        handleSubmit: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(event) {
                var response, user;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                event.preventDefault();
                                this.clearErrors();
                                this.loading = true;
                                _context.prev = 3;
                                _context.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_user__["d" /* USER_LOGIN */])(this.form);

                            case 6:
                                response = _context.sent;

                                if (response.token) {
                                    user = new __WEBPACK_IMPORTED_MODULE_2__models_User__["a" /* User */]();

                                    user.setUser(response.data.name, response.data.email, response.token);
                                    if (this.kitNumberParameter()) {
                                        window.location = "/cadastrar-kit?kit_number=" + this.kitNumberParameter();
                                    } else {
                                        window.location = "/kits";
                                    }
                                }
                                _context.next = 14;
                                break;

                            case 10:
                                _context.prev = 10;
                                _context.t0 = _context['catch'](3);

                                console.log(_context.t0.response.data.errors);
                                this.errors = _context.t0.response.data.errors;

                            case 14:
                                _context.prev = 14;

                                this.loading = false;
                                return _context.finish(14);

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[3, 10, 14, 17]]);
            }));

            function handleSubmit(_x) {
                return _ref.apply(this, arguments);
            }

            return handleSubmit;
        }(),
        kitNumberParameter: function kitNumberParameter() {
            var url_string = window.location.href;
            var url = new URL(url_string);
            var kit = url.searchParams.get("kit_number");
            return !!kit ? kit : false;
        }
    },
    mounted: function mounted() {
        console.log(this.kitNumberParameter());
    }
});

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Profile/Profile.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_customer__ = __webpack_require__(/*! ../../services/customer */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NewPasswordModal_NewPasswordModal__ = __webpack_require__(/*! ../../components/NewPasswordModal/NewPasswordModal */ 632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProfileSaveModal_RegisterKitModal__ = __webpack_require__(/*! ../../components/ProfileSaveModal/RegisterKitModal */ 635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProfileIncompleteModal_RegisterProfileModal__ = __webpack_require__(/*! ../../components/ProfileIncompleteModal/RegisterProfileModal */ 637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__ = __webpack_require__(/*! vue2-datepicker */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker_index_css__ = __webpack_require__(/*! vue2-datepicker/index.css */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_datepicker_locale_pt_br__ = __webpack_require__(/*! vue2-datepicker/locale/pt-br */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_datepicker_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_datepicker_locale_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(/*! moment */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














__WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons__["D" /* faShoppingCart */]);
__WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons__["m" /* faCog */]);
__WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons__["g" /* faCalendarAlt */]);
__WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons__["a" /* faAddressBook */]);
__WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons__["i" /* faCamera */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { DatePicker: __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__["default"], NewPasswordModal: __WEBPACK_IMPORTED_MODULE_2__components_NewPasswordModal_NewPasswordModal__["a" /* default */], RegisterKitModal: __WEBPACK_IMPORTED_MODULE_3__components_ProfileSaveModal_RegisterKitModal__["a" /* default */], RegisterProfileModal: __WEBPACK_IMPORTED_MODULE_4__components_ProfileIncompleteModal_RegisterProfileModal__["a" /* default */] },
  data: function data() {
    return {
      errors: {},
      errorPhoto: null,
      loading: false,
      loadingScreen: false,
      showPassword: false,
      showConfirmPassword: false,
      showPasswordModal: false,
      showKitModal: false,
      showProfileModal: false,
      showSavedMessage: false,
      form: {
        name: "",
        email: "",
        birth_date: "",
        cpf: "",
        gender: null,
        ethnicity: null,
        cellphone: "",
        cep: "",
        uf: "",
        city: "",
        street: "",
        number: "",
        district: "",
        status: "",
        password: "",
        password_confirmation: "",
        first_acess: 0,
        profile_picture: null
      },
      originalForm: null,
      numberToken: { N: { pattern: /[0-9]/ } }
    };
  },

  methods: {
    clean: function clean(obj) {
      for (var propName in obj) {
        if (!obj[propName]) {
          delete obj[propName];
        }
      }
      return obj;
    },
    clearErrors: function clearErrors() {
      this.errors = null;
      this.errorPhoto = null;
    },
    getUserData: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.loadingScreen = true;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["a" /* GET_CUSTOMER */])();

              case 4:
                response = _context.sent;


                if (!!response) {
                  if (!!response.customer) {
                    this.form = response.customer;
                    this.form.email = response.email;
                    this.form.phone1 = response.customer.cellphone;
                    this.form.birth_date = __WEBPACK_IMPORTED_MODULE_10_moment___default()(response.customer.birth_date, "YYYY-MM-DD").format("DD/MM/YYYY");
                    this.form.first_acess = 1;
                    this.$store.commit("setUser", response.customer);
                  }

                  if (!this.form.name && !!response.name) {
                    this.form.name = response.name;
                  }

                  if (!this.form.email && !!response.email) {
                    this.form.email = response.email;
                  }

                  if (!!this.form && this.form.first_acess === 0) {
                    this.showProfileModal = true;
                  }
                }

                this.originalForm = JSON.stringify(this.form);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 12:
                _context.prev = 12;

                this.loadingScreen = false;
                this.form.profile_picture = null;
                return _context.finish(12);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9, 12, 16]]);
      }));

      function getUserData() {
        return _ref.apply(this, arguments);
      }

      return getUserData;
    }(),
    infoChanged: function infoChanged() {
      return JSON.stringify(this.form) !== this.originalForm;
    },
    handleShowPassword: function handleShowPassword(field) {
      if (field === 0) this.showPassword = !this.showPassword;else this.showConfirmPassword = !this.showConfirmPassword;

      var password = field === 0 ? document.getElementById("password") : document.getElementById("confirm_password");

      if (field === 0) {
        password.type = "password";
        if (this.showPassword) password.type = "text";
      }
      if (field === 1) {
        password.type = "password";
        if (this.showConfirmPassword) password.type = "text";
      }
    },
    handleSubmit: function handleSubmit(event) {
      var _this = this;

      event.preventDefault();
      this.clearErrors();
      this.loading = true;
      var form = this.form;
      var keepDate = form.birth_date;

      if (!!form.birth_date) {
        var tmp = __WEBPACK_IMPORTED_MODULE_10_moment___default()(form.birth_date, "DD/MM/YYYY");
        var oldest = __WEBPACK_IMPORTED_MODULE_10_moment___default()("02/01/1903", "DD/MM/YYYY");
        var now = __WEBPACK_IMPORTED_MODULE_10_moment___default()();

        if (tmp.isValid() && tmp.isAfter(oldest) && tmp.isBefore(now)) {
          form.birth_date = tmp.format("YYYY-MM-DD");
        } else {
          this.errors = { "birth_date": ["Data de nascimento inválida"] };
          this.loading = false;
          return;
        }
      }

      if (!!form.cpf) {
        form.cpf = form.cpf.replace(/[^0-9]/g, "");
      }

      Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["f" /* POST_CUSTOMER */])(form).then(function (r) {
        if (_this.form.first_acess === 0) {
          _this.showKitModal = true;
        }
        _this.showSavedMessage = true;
        _this.loading = false;
        _this.errors = null;
        _this.getUserData();
      }, function (err) {
        form.birth_date = keepDate;
        _this.errors = err.response.data;
        _this.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.getUserData();
  }
});

/***/ }),
/* 219 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NewPasswordModal/NewPasswordModal.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_customer__ = __webpack_require__(/*! ../../services/customer */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__["s" /* faEye */]);
__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__["t" /* faEyeSlash */]);
__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__["B" /* faQuestionCircle */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "news-password-modal",
    components: {},
    data: function data() {
        return {
            loading: false,
            showPassword: false,
            showConfirmPassword: false,
            confirmed: false,
            form: {
                password: "",
                password_confirmation: ""
            },
            errors: []
        };
    },

    methods: {
        clearErrors: function clearErrors() {
            this.errors = [];
        },
        outsideClick: function outsideClick() {
            if (event.target === event.currentTarget) this.$emit('close');
        },
        handleSubmit: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(event) {
                var _this = this;

                var form;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                event.preventDefault();
                                this.clearErrors();
                                this.loading = true;
                                form = this.form;

                                Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["f" /* POST_CUSTOMER */])(form).then(function (r) {
                                    _this.loading = false;
                                    _this.errors = null;
                                    _this.confirmed = true;
                                }, function (err) {
                                    _this.errors = err.response.data;
                                    Object.assign(_this.errors, err.response.data.errors);
                                    _this.loading = false;
                                });

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function handleSubmit(_x) {
                return _ref.apply(this, arguments);
            }

            return handleSubmit;
        }(),
        handleShowPassword: function handleShowPassword(field) {
            if (field === 0) {
                this.showPassword = !this.showPassword;
            } else {
                this.showConfirmPassword = !this.showConfirmPassword;
            }
            var password = field === 0 ? document.getElementById('password') : document.getElementById('confirm_password');
            if (field === 0) if (this.showPassword) {
                password.type = "text";
            } else {
                password.type = "password";
            }
            if (field === 1) if (this.showConfirmPassword) {
                password.type = "text";
            } else {
                password.type = "password";
            }
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 220 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProfileSaveModal/RegisterKitModal.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "register-kit-modal",
    methods: {
        toRegisterKit: function toRegisterKit() {
            var url_string = window.location.href;
            var url = new URL(url_string);
            var kit = url.searchParams.get("kit_number");
            if (!!kit && kit != '') window.location = "/cadastrar-kit?kit_number=" + kit;else this.$router.push('/cadastrar-kit');
        }
    }
});

/***/ }),
/* 221 */
/*!*************************************************************!*\
  !*** ./src/assets/images/vector-fluxo-healthid-lab-com.png ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/vector-fluxo-healthid-lab-com.28c38f17.png";

/***/ }),
/* 222 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProfileIncompleteModal/RegisterProfileModal.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "register-profile-modal"
});

/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Dashboard/Dashboard.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            loading: false,
            loadingScreen: false,
            form: {}
        };
    },

    methods: {
        getUserData: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.loadingScreen = true;
                                try {} catch (error) {} finally {
                                    this.loadingScreen = false;
                                }

                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getUserData() {
                return _ref.apply(this, arguments);
            }

            return getUserData;
        }(),
        handleSubmit: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(event) {
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                event.preventDefault();
                                this.loading = true;
                                try {} catch (error) {} finally {
                                    this.loading = false;
                                }

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function handleSubmit(_x) {
                return _ref2.apply(this, arguments);
            }

            return handleSubmit;
        }()
    },
    mounted: function mounted() {
        this.getUserData();
    }
});

/***/ }),
/* 360 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Kits/Kits.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_document__ = __webpack_require__(/*! ../../services/document */ 361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_kit__ = __webpack_require__(/*! ../../services/kit */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_KitResults_KitResults__ = __webpack_require__(/*! ../../components/KitResults/KitResults */ 362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_KitRisks_KitRisks__ = __webpack_require__(/*! ../../components/KitRisks/KitRisks */ 366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_KitPlans_KitPlans__ = __webpack_require__(/*! ../../components/KitPlans/KitPlans */ 377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_KitTips_KitTips__ = __webpack_require__(/*! ../../components/KitTips/KitTips */ 380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OrientationModal_OrientationModal__ = __webpack_require__(/*! ../../components/OrientationModal/OrientationModal */ 809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ScheduleModal_ScheduleModal__ = __webpack_require__(/*! ../../components/ScheduleModal/ScheduleModal */ 812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(/*! moment */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
    components: { KitResults: __WEBPACK_IMPORTED_MODULE_3__components_KitResults_KitResults__["a" /* default */], KitRisks: __WEBPACK_IMPORTED_MODULE_4__components_KitRisks_KitRisks__["a" /* default */], KitPlans: __WEBPACK_IMPORTED_MODULE_5__components_KitPlans_KitPlans__["a" /* default */], KitTips: __WEBPACK_IMPORTED_MODULE_6__components_KitTips_KitTips__["a" /* default */], ScheduleModal: __WEBPACK_IMPORTED_MODULE_8__components_ScheduleModal_ScheduleModal__["a" /* default */], OrientationModal: __WEBPACK_IMPORTED_MODULE_7__components_OrientationModal_OrientationModal__["a" /* default */] },
    data: function data() {
        return {
            user: null,
            loading: false,
            loadingScreen: false,
            orientationModalPartner: null,
            results: [],
            showResultModal: false,
            resultModalData: null,
            showReturnModal: false,
            returnModalData: null,
            stockPic: "https://www.kindpng.com/picc/m/105-1055656_account-user-profile-avatar-avatar-user-profile-icon.png",
            currKit: { id: null, type: null },
            kitTypes: {},
            orientationModalOpen: false,
            scheduleModalOpen: false,
            scheduleModalKit: null,
            scheduleModalKitNumber: null
        };
    },

    watch: {
        '$route': function $route(to, from) {
            if (!to.query.kit) {
                window.scrollTo(0, 0);
                this.currKit.id = null;
                this.currKit.type = null;
            }
        }
    },
    methods: {
        checkCurrentKit: function checkCurrentKit(id) {
            try {
                if (id != null) {
                    var empty = !!this.currKit && this.currKit.type == null && this.currKit.id == null;
                    var selected = !!this.currKit && !!this.currKit.type && this.currKit.id === id;

                    return empty || selected;
                } else {
                    return !!this.currKit && !!this.currKit.type && this.currKit.id != null;
                }
            } catch (error) {
                console.log(error);
            }
        },
        setCurrentKit: function setCurrentKit(id, type) {
            try {
                window.scrollTo(0, 0);
                this.currKit.id = id;
                this.currKit.type = type;
                this.$router.push('kits?kit=' + id);
            } catch (error) {
                console.log(error);
            }
        },
        setInnerView: function setInnerView(view) {
            this.currKit.type = view;
        },
        getDate: function getDate(date) {
            date = new Date(date);
            date = this.aditionalZero(date.getDate()) + "/" + this.aditionalZero(date.getMonth() + 1) + "/" + date.getFullYear();
            return date;
        },
        aditionalZero: function aditionalZero(number) {
            return number <= 9 ? "0" + number : number;
        },
        getKitType: function getKitType(kitTypeId) {
            try {
                return this.kitTypes[kitTypeId];
            } catch (error) {
                console.log(error);
            }
        },
        altKitName: function altKitName(kit) {
            return kit.split("Check-Up ").pop();
        },
        getReturns: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response, missingForm, missingExam, complete, weird;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.loadingScreen = true;
                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__services_kit__["c" /* LIST_KIT */])();

                            case 4:
                                response = _context.sent;

                                if (!!response) {
                                    this.results = response;
                                    missingForm = [];
                                    missingExam = [];
                                    complete = [];
                                    weird = [];


                                    this.results.forEach(function (result) {
                                        if (result.kit_type_id > 2 && result.steps_answers == null || result.kit_type_id <= 2 && result.schedule == null) {
                                            missingForm.push(result);
                                        } else if (result.kit_type_id > 2 && result.steps_answers != null && result.exam == null || result.kit_type_id <= 2 && result.schedule != null && result.exam == null) {
                                            missingExam.push(result);
                                        } else if (result.kit_type_id > 2 && result.exam && result.exam.result || result.kit_type_id <= 2 && result.exam && result.exam.result) {
                                            complete.push(result);
                                        } else {
                                            weird.push(result);
                                        }
                                    });

                                    missingForm.sort(this.sortDates);
                                    missingExam.sort(this.sortDates);
                                    complete.sort(this.sortDates);
                                    weird.sort(this.sortDates);

                                    this.results = missingForm.concat(missingExam, complete, weird);
                                }
                                _context.next = 11;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context['catch'](0);

                                console.log(_context.t0);

                            case 11:
                                _context.prev = 11;

                                this.loadingScreen = false;
                                return _context.finish(11);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 8, 11, 14]]);
            }));

            function getReturns() {
                return _ref.apply(this, arguments);
            }

            return getReturns;
        }(),
        openResultModal: function openResultModal(kit) {
            try {
                this.resultModalData = {
                    customer: !!kit.customer && !!kit.customer.name ? kit.customer.name : '',
                    photo: !!kit.profile_picture ? kit.profile_picture : this.stockPic,
                    birthDate: !!kit.customer && !!kit.customer.birth_date ? this.getDate(kit.customer.birth_date) : '',
                    gender: !!kit.customer && !!kit.customer.gender ? kit.customer.gender : '',
                    kitNumber: !!kit.number ? kit.number : '',
                    kitId: !!kit.id ? kit.id : '',
                    kitType: !!kit.kit_type && kit.kit_type.id ? kit.kit_type.id : '',
                    value: !!kit.exam && !!kit.exam.result && kit.exam.result.value ? kit.exam.result.value : '',
                    created_at: !!kit.order ? this.getDate(kit.order[0].created_at) : '',
                    finished_at: !!kit.exam && kit.exam.created_at ? this.getDate(kit.exam.created_at) : '',
                    resultDocument: !!kit.exam && !!kit.exam.result_document_id ? kit.exam.result_document_id : null,
                    labDocument: !!kit.exam && !!kit.exam.lab_document_id ? kit.exam.lab_document_id : null
                };
                this.showResultModal = true;
            } catch (error) {
                console.log(error);
            }
        },
        getShippingType: function getShippingType(order) {
            if (!order) return null;
            if (!order.partner_place) return null;
            if (!order.partner_place.partner) return null;
            return order.partner_place.partner.shipping_type;
        },
        openOrientationModal: function openOrientationModal() {
            var shippingType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.orientationModalPartner = shippingType;
            this.orientationModalOpen = true;
        },
        openScheduleModal: function openScheduleModal(kitId, kitNumber) {
            this.scheduleModalKit = kitId;
            this.scheduleModalKitNumber = kitNumber;
            this.scheduleModalOpen = true;
        },
        updateKitSchedule: function updateKitSchedule(kit_number) {
            var kitIndex = this.results.find(function (result, x) {
                if (result.number == kit_number) return x;
            });
            kitIndex.schedule = true;
        },
        sortDates: function sortDates(a, b) {
            var testA = void 0,
                testB = null;

            if (!!a && !!a.order && !!a.order[0] && !!a.order[0].created_at) {
                testA = new Date(a.order[0].created_at);
            }

            if (!!b && !!b.order && !!b.order[0] && !!b.order[0].created_at) {
                testB = new Date(b.order[0].created_at);
            }

            return !!testA && !!testB ? testB - testA : 0;
        },
        openReturnModal: function openReturnModal(kit) {
            try {
                this.returnModalData = {
                    customer: !!kit.customer && !!kit.customer.name ? kit.customer.name : '',
                    kitId: !!kit.id ? kit.id : '',
                    kitType: !!kit.kit_type && !!kit.kit_type.id ? kit.kit_type.id : '',
                    disease: !!kit.disease ? kit.disease : '',
                    annexDocument: !!kit.exam && !!kit.exam.annex_document_id ? kit.exam.annex_document_id : null,
                    labDocument: !!kit.exam && !!kit.exam.lab_document_id ? kit.exam.lab_document_id : null
                };
                this.showReturnModal = true;
            } catch (error) {
                console.log(error);
            }
        },
        goToForm: function goToForm(kitNumber) {
            window.location = "/cadastrar-kit?kit_number=" + kitNumber;
        },
        getLink: function getLink(id, doc) {
            Object(__WEBPACK_IMPORTED_MODULE_1__services_document__["a" /* GET_DOCUMENT */])(id, 3, doc).then(function (res) {
                window.open(res.link, '_blank').focus();
            });
        },
        getSampleDate: function getSampleDate(result) {
            var response = '';
            if (!!result.field_answers) {
                result.field_answers.map(function (answer) {
                    if (answer.field.title == 'Data e hora da coleta de sangue' || answer.field.title == 'data e hora da coleta de sangue') response = !!answer.response.date ? answer.response.date : answer.response;
                });
            }
            if (response === '' && !!result.schedule) {
                response = result.schedule.sample_date;
                var date = __WEBPACK_IMPORTED_MODULE_9_moment___default()(response);
                date.locale('pt-br');
                response = date.calendar();
            }
            return response;
        }
    },
    mounted: function mounted() {
        var user = window.localStorage.getItem('name');
        this.user = user.split(' ')[0];
        try {
            this.kitTypes['check-up-anticorpos-igg-covid'] = 'Check-Up Anticorpos IgG COVID';
            this.kitTypes['check-up-anticorpos-vacina-covid'] = 'Check-Up Anticorpos Vacina COVID';
            this.kitTypes['check-up-doencas-completo'] = 'Check-Up Completo';
            this.kitTypes['check-up-saude-do-coracao'] = 'Check-Up Saúde do Coração';
            this.kitTypes['check-up-longevidade-saudavel'] = 'Check-Up Longevidade Saudável';
            this.kitTypes['check-up-doencas-cronicas'] = 'Check-Up Doenças Crônicas';
            this.kitTypes['check-up-saude-preventiva'] = 'Check-Up Saúde Preventiva';

            this.getReturns();
        } catch (error) {
            console.log(error);
        }
    }
});

/***/ }),
/* 361 */
/*!**********************************!*\
  !*** ./src/services/document.js ***!
  \**********************************/
/*! exports provided: GET_DOCUMENT */
/*! exports used: GET_DOCUMENT */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_DOCUMENT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(/*! ./api */ 39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(/*! axios */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var DOCUMENT_ENDPOINT = "documents";

var GET_DOCUMENT = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(kit) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var document = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var response;
    return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/' + DOCUMENT_ENDPOINT + '/' + kit, {
              headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
              }
            });

          case 2:
            response = _context.sent;
            return _context.abrupt('return', response.data);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function GET_DOCUMENT(_x3) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 362 */
/*!**************************************************!*\
  !*** ./src/components/KitResults/KitResults.vue ***!
  \**************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitResults_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./KitResults.vue */ 363);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00154d1c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitResults_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-00154d1c","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./KitResults.vue */ 656);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-00154d1c","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./KitResults.vue */ 649)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00154d1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00154d1c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 363 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/KitResults/KitResults.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ValueCard__ = __webpack_require__(/*! ./ValueCard */ 650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextModal__ = __webpack_require__(/*! ./TextModal */ 653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(/*! moment */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__["c" /* faArrowLeft */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "kit-results",
  components: { ValueCard: __WEBPACK_IMPORTED_MODULE_0__ValueCard__["a" /* default */], TextModal: __WEBPACK_IMPORTED_MODULE_1__TextModal__["a" /* default */] },
  props: {
    result: Object
  },
  data: function data() {
    return {
      igg: null,
      quantivac: null,
      hdl: null,
      ldl: null,
      hba1c: null,
      glicose: null,
      triglicerideos: null,
      colesterol: null,
      creatinine: null,
      tfg: null,
      diseases: {
        hasHeartDisease: false,
        hasDiabetes: false,
        hasHypertension: false,
        hasAvc: false,
        hasDyslipidimia: false,
        hasMetabolic: false,
        hasOsteoporosis: false
      },
      customer: null,
      textModal: false,
      textModalExam: {}
    };
  },

  methods: {
    back: function back() {
      this.$emit("back");
    },
    getDiseases: function getDiseases() {
      this.diseases.hasHeartDisease = this.answerSearch("Você é portador de alguma doença do coração?") == "Sim" ? true : false;
      this.diseases.hasDiabetes = this.answerSearch("Você é portador de Diabetes?") == "Sim, Descontrolada" || this.answerSearch("Você é portador de Diabetes?") == "Sim, Controlada" ? true : false;
      this.diseases.hasHypertension = this.answerSearch("Você é portador de Hipertensão?") != "Não" ? true : false;
      this.diseases.hasAvc = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes("avc") ? true : false;
      this.diseases.hasDyslipidimia = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes("dislipidemia") ? true : false;

      this.diseases.hasOsteoporosis = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes("Osteoporose") ? true : false;
    },
    answerSearch: function answerSearch(field) {
      var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var answers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      var ans = null;
      if (!!this.result.field_answers) if (multiple) {
        if (answers.length > 0) {
          ans = this.result.field_answers.filter(function (a) {
            return a.field.title == field && answers.includes(a.option.value);
          }).map(function (a) {
            return a.option.value;
          });
          return ans.join(", ");
        } else {
          ans = this.result.field_answers.filter(function (a) {
            return a.field.title == field;
          }).map(function (a) {
            return a.option.value;
          });
          return ans;
        }
      } else {
        this.result.field_answers.map(function (answer) {
          if (answer.field.title == field && !multiple) ans = answer.response !== null ? answer.response : answer.option.label;
        });
      }
      return ans;
    },
    getAge: function getAge(birth_date) {
      var now = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      var birthdate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(birth_date);
      return now.diff(birthdate, "years");
    },
    openModal: function openModal(open) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var exam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.textModalExam = exam;
      this.textModalExam.title = title;
      this.textModal = open;
    }
  },
  mounted: function mounted() {
    this.getDiseases();

    var cardiovascular = null;
    this.result.metric.forEach(function (risk) {
      if (risk.risk.name == "Risco Cardiovascular") cardiovascular = risk.ticket.label;
    });

    if (!!this.result) {
      if (!!this.result.customer) {
        this.customer = this.result.customer;

        if (!!this.customer.birth_date) {
          this.customer.age = this.getAge(this.customer.birth_date);
        }
      }
      if (!!this.result.exam && !!this.result.exam.result) {
        var result = this.result.exam.result;

        if (!!result.value) this.igg = { label: "", value: result.value };
        if (!!result.value) this.quantivac = { label: "", value: result.value };
        if (!!result.hdl) this.hdl = { label: "", value: result.hdl };
        if (!!result.ldl) this.ldl = { label: "", value: result.ldl };
        if (!!result.hba1c) this.hba1c = { label: "", value: result.hba1c };
        if (!!result.glicose) this.glicose = { label: "", value: result.glicose };
        if (!!result.triglicerideos) this.triglicerideos = {
          label: "",
          value: result.triglicerideos
        };
        if (!!result.colesterol_total) this.colesterol = { label: "", value: result.colesterol_total };
        if (!!result.creatinine) this.creatinine = { label: "", value: result.creatinine };
        if (!!result.tfg) this.tfg = { label: "", value: result.tfg.toFixed(2) };
      }
    }

    if (!!this.igg || !!this.quantivac) {
      if (this.result.kit_type.tag_type === "check-up-anticorpos-igg-covid") {
        this.igg.metric_labels = [{
          name: "Negativo",
          color: "dark-green",
          interval: { desc: "Inferior a 0.8 mg/dL", min: 0, max: 0.8 }
        }, {
          name: "Indeterminado",
          color: "orange",
          interval: { desc: "De a 0.8 a 1 mg/dL", min: 0.8, max: 1.1 }
        }, {
          name: "Positivo",
          color: "red",
          interval: {
            desc: "Superior ou igual a 1.1 mg/dL",
            min: 1.1,
            max: 2.2
          }
        }];
        if (this.igg.value < 0.8) this.igg.label = "Negativo";else if (this.igg.value >= 0.8 && this.igg.value < 1.1) this.igg.label = "Indeterminado";else if (this.igg.value >= 1.1) this.igg.label = "Positivo";
      } else if (this.result.kit_type.tag_type === "check-up-anticorpos-vacina-covid") {
        this.quantivac.metric_labels = [{
          name: "Não detectado",
          color: "red",
          interval: { desc: "Inferior a 8 RU/ml", min: 0, max: 8 }
        }, {
          name: "Indeterminado",
          color: "orange",
          interval: { desc: "De 8 RU/ml a 10 RU/ml", min: 8, max: 11 }
        }, {
          name: "Elevado",
          color: "dark-green",
          interval: { desc: "Superior ou igual a 11 RU/ml", min: 11, max: 22 }
        }];
        if (this.quantivac.value < 8) this.quantivac.label = "Não detectado";else if (this.quantivac.value >= 8 && this.quantivac.value < 11) this.quantivac.label = "Indeterminado";else if (this.quantivac.value >= 11) this.quantivac.label = "Elevado";
      }
    }

    if (!!this.colesterol && !!this.customer.age) {
      if (this.customer.age > 20) {
        this.colesterol.metric_labels = [{
          name: "Normal",
          color: "dark-green",
          interval: { desc: "Inferior a 190mg/dL", min: 0, max: 190 }
        }, {
          name: "Elevado",
          color: "red",
          interval: {
            desc: "Superior ou igual a 190mg/dL",
            min: 190,
            max: 380
          }
        }];
        if (this.colesterol.value < 190) this.colesterol.label = "Normal";else if (this.colesterol.value >= 190) this.colesterol.label = "Elevado";else this.colesterol.label = "Erro!";
      } else {
        this.colesterol.metric_labels = [{
          name: "Normal",
          color: "dark-green",
          interval: { desc: "Inferior a 190mg/dL", min: 0, max: 170 }
        }, {
          name: "Elevado",
          color: "red",
          interval: {
            desc: "Superior ou igual a 190mg/dL",
            min: 170,
            max: 340
          }
        }];
        if (this.colesterol.value < 170) this.colesterol.label = "Normal";else if (this.colesterol.value >= 170) this.colesterol.label = "Elevado";else this.colesterol.label = "Erro!";
      }
    }

    if (!!this.ldl && !!this.customer.age) {
      var range = 130;
      if (cardiovascular == "Risco Baixo" || cardiovascular == "Baixo") {
        if (this.ldl.value > 190 || this.hasDiabetes) range = 100;
        if (this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes("Doença Renal Crônica")) range = 70;
      } else if (cardiovascular == "Risco Médio" || cardiovascular == "Médio") {
        range = 100;
        if (this.hasDiabetes || this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes("Doença Renal Crônica")) range = 70;
      } else if (cardiovascular == "Risco Alto" || cardiovascular == "Alto") {
        range = 70;
      } else if (cardiovascular == "Risco Muito Alto" || cardiovascular == "Muito Alto") {
        range = 50;
      } else {
        range = 130;
      }
      if (this.ldl.value < range) this.ldl.label = "Normal";else this.ldl.label = "Elevado";
      this.result.exam.result.ldlAlt = {
        range: range,
        label: this.ldl.label
      };
      this.ldl.metric_labels = [{
        name: "Normal",
        color: "dark-green",
        interval: { desc: "Inferior a " + range + "mg/dL", min: 0, max: range }
      }, {
        name: "Elevado",
        color: "red",
        interval: {
          desc: "Igual ou superior a " + range + "mg/dL",
          min: range,
          max: range * 2
        }
      }];
    }

    if (!!this.hdl && !!this.customer.age) {
      if (this.customer.age > 20) {
        this.hdl.metric_labels = [{
          name: "Alterado",
          color: "red",
          interval: { desc: "Inferior ou igual a 40mg/dL", min: 0, max: 40 }
        }, {
          name: "Normal",
          color: "dark-green",
          interval: { desc: "Superior a 40mg/dL", min: 40, max: 80 }
        }];
        if (this.hdl.value <= 40) this.hdl.label = "Alterado";else if (this.hdl.value > 40) this.hdl.label = "Normal";else this.hdl.label = "ERRO!";
      } else {
        this.hdl.metric_labels = [{
          name: "Alterado",
          color: "red",
          interval: { desc: "Inferior ou igual a 45mg/dL", min: 0, max: 45 }
        }, {
          name: "Normal",
          color: "dark-green",
          interval: { desc: "Superior a 45mg/dL", min: 45, max: 90 }
        }];
        if (this.hdl.value <= 45) this.hdl.label = "Alterado";else if (this.hdl.value > 45) this.hdl.label = "Normal";else this.hdl.label = "ERRO!";
      }
    }

    if (!!this.triglicerideos && !!this.customer.age) {
      if (this.customer.age < 10) {
        this.triglicerideos.metric_labels = [{
          name: "Normal",
          color: "dark-green",
          interval: { desc: "Inferior a 85mg/dL", min: 0, max: 85 }
        }, {
          name: "Elevado",
          color: "red",
          interval: {
            desc: "Superior ou igual a 170mg/dL",
            min: 85,
            max: 170
          }
        }];
        if (this.triglicerideos.value < 85) this.triglicerideos.label = "Normal";else if (this.triglicerideos.value >= 85) this.triglicerideos.label = "Elevado";else this.triglicerideos.label = "ERRO!";
      } else if (this.customer.age >= 10 && this.customer.age < 20) {
        this.triglicerideos.metric_labels = [{
          name: "Normal",
          color: "dark-green",
          interval: { desc: "Inferior a 100mg/dL", min: 0, max: 100 }
        }, {
          name: "Elevado",
          color: "red",
          interval: {
            desc: "Superior ou igual a 100mg/dL",
            min: 100,
            max: 200
          }
        }];
        if (this.triglicerideos.value < 100) this.triglicerideos.label = "Normal";else if (this.triglicerideos.value >= 100) this.triglicerideos.label = "Elevado";else this.triglicerideos.label = "ERRO!";
      } else if (this.customer.age >= 20) {
        this.triglicerideos.metric_labels = [{
          name: "Normal",
          color: "dark-green",
          interval: { desc: "Inferior a 150mg/dL", min: 0, max: 150 }
        }, {
          name: "Pouco Elevado",
          color: "yellow",
          interval: { desc: "De 150mg/dL a 199mg/dL", min: 150, max: 200 }
        }, {
          name: "Elevado",
          color: "red",
          interval: { desc: "Acima de 199mg/dL", min: 200, max: 400 }
        }];
        if (this.triglicerideos.value < 150) this.triglicerideos.label = "Normal";else if (this.triglicerideos.value >= 150 && this.triglicerideos.value < 200) this.triglicerideos.label = "Pouco Elevado";else if (this.triglicerideos.value >= 200) this.triglicerideos.label = "Elevado";else this.triglicerideos.label = "ERRO!";
      }
    }

    if (!!this.hba1c) {
      this.hba1c.metric_labels = [{
        name: "Normal",
        color: "dark-green",
        interval: { desc: "Inferior a 5,7%", min: 0, max: 5.6 }
      }, {
        name: "Pré-diabéticos",
        color: "yellow",
        interval: { desc: "De 5,7% a 6,4%", min: 5.7, max: 6.4 }
      }, {
        name: "Diabete Mellitus",
        color: "red",
        interval: { desc: "Igual ou superior a 6,5%", min: 6.5 }
      }];
      if (this.hba1c.value < 5.7) this.hba1c.label = "Normal";else if (this.hba1c.value >= 5.7 && this.hba1c.value < 6.5) this.hba1c.label = "Pré-diabéticos";else if (this.hba1c.value >= 6.5) this.hba1c.label = "Diabete Mellitus";else this.hba1c.label = "ERRO!";
    }

    if (!!this.glicose) {
      this.glicose.metric_labels = [{
        name: "Hipoglicemia",
        color: "yellow",
        interval: { desc: "Inferior a 70mg/dL", min: 0, max: 70 }
      }, {
        name: "Normal",
        color: "dark-green",
        interval: { desc: "De 70mg/dL a 99mg/dL", min: 70, max: 100 }
      }, {
        name: "Glicemia Elevada",
        color: "red",
        interval: { desc: "Acima de 100mg/dL", min: 100, max: 200 }
      }];
      if (this.glicose.value < 70) this.glicose.label = "Hipoglicemia";else if (this.glicose.value >= 70 && this.glicose.value < 100) this.glicose.label = "Normal";else if (this.glicose.value >= 100) this.glicose.label = "Glicemia Elevada";else this.glicose.label = "ERRO!";
    }

    if (!!this.creatinine && this.result.kit_type.tag_type == 'check-up-saude-preventiva') {
      var now = __WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date());
      var birthdate = this.customer.birth_date;
      var monthsDiff = now.diff(birthdate, 'months'); // 1
      var minLimit = monthsDiff <= 1 ? 0.3 : this.customer.age <= 2 ? 0.2 : this.customer.age <= 12 ? 0.3 : this.customer.age <= 18 ? 0.5 : this.customer.age > 18 && this.customer.gender == 'M' ? 0.7 : this.customer.age > 18 && this.customer.gender == 'F' ? 0.5 : 0.7;
      var maxLimit = monthsDiff <= 1 ? 1 : this.customer.age <= 2 ? 0.4 : this.customer.age <= 12 ? 0.7 : this.customer.age <= 18 ? 1 : this.customer.age > 18 && this.customer.gender == 'M' ? 1.2 : this.customer.age > 18 && this.customer.gender == 'F' ? 1 : 1.2;

      this.creatinine.metric_labels = [{
        name: "Alterado",
        color: "red",
        interval: { desc: "Inferior a 0.5mg/dL", min: 0, max: minLimit }
      }, {
        name: "Normal",
        color: "dark-green",
        interval: { desc: "De 0.5mg/dL a 1mg/dL", min: minLimit, max: maxLimit }
      }, {
        name: "Alterado ",
        color: "red",
        interval: { desc: "Superior a 1mg/dL", min: maxLimit, max: maxLimit * 2 }
      }];
      if (this.creatinine.value < minLimit) this.creatinine.label = "Alterado";else if (this.creatinine.value >= minLimit && this.creatinine.value <= maxLimit) this.creatinine.label = "Normal";else if (this.creatinine.value > maxLimit) this.creatinine.label = "Alterado ";else this.creatinine.label = "ERRO!";
    }

    if (!!this.tfg && this.result.kit_type.tag_type == 'check-up-saude-preventiva') {
      this.tfg.metric_labels = [{
        name: "Falência Renal",
        color: "purple",
        interval: { desc: "Inferior a 14mL/min x 1,73m²", min: 0, max: 15 }
      }, {
        name: "Redução Severa",
        color: "red",
        interval: { desc: "De 15mL/min x 1,73m² a 29mL/min x 1,73m²", min: 15, max: 30 }
      }, {
        name: "Redução Moderada-Severa",
        color: "orange",
        interval: { desc: "De 30mL/min x 1,73m² a 44mL/min x 1,73m²", min: 30, max: 45 }
      }, {
        name: "Redução Discreta-Moderada",
        color: "yellow",
        interval: { desc: "De 45mL/min x 1,73m² a 59mL/min x 1,73m²", min: 45, max: 60 }
      }, {
        name: "Redução Discreta",
        color: "green",
        interval: { desc: "De 60mL/min x 1,73m² a 89mL/min x 1,73m²", min: 60, max: 90 }
      }, {
        name: "Normalidade",
        color: "dark-green",
        interval: { desc: "Acima de 90mL/min x 1,73m²", min: 90, max: 180 }
      }];
      if (this.tfg.value > 90) this.tfg.label = "Normalidade";else if (this.tfg.value >= 60 && this.tfg.value <= 89) this.tfg.label = "Redução Discreta";else if (this.tfg.value >= 45 && this.tfg.value <= 59) this.tfg.label = "Redução Discreta-Moderada";else if (this.tfg.value >= 30 && this.tfg.value <= 44) this.tfg.label = "Redução Moderada-Severa";else if (this.tfg.value >= 15 && this.tfg.value <= 29) this.tfg.label = "Redução Severa";else if (this.tfg.value <= 14) this.tfg.label = "Falência Renal";else this.tfg.label = "ERRO!";
    }
  }
});

/***/ }),
/* 364 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/KitResults/ValueCard.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["k" /* faCheckCircle */]);
__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["q" /* faExclamationCircle */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "value-card",
    components: {},
    props: {
        title: String,
        altTitle: String,
        result: Object,
        labels: Array,
        percentage: false,
        quantivac: false,
        tfg: false
    },
    data: function data() {
        return {};
    },

    methods: {
        getMarkPosition: function getMarkPosition(interval) {
            var value = 0;
            var min = 0;
            var max = (interval.max = !!interval.max ? interval.max : interval.min * 2) - interval.min;
            var resultValue = this.result.value - interval.min;
            value = resultValue / max * 100;
            value = value - 0.5;

            if (value > 99.5) value = 99.5;

            return 'left: ' + value + '%';
        },
        getValueColor: function getValueColor() {
            var currentLabel = this.result.label;
            var color = '';
            this.labels.map(function (label) {
                if (currentLabel == label.name) color = label.color;
            });

            return color;
        },
        getIntervalDesc: function getIntervalDesc() {
            var currentLabel = this.result.label;
            var interval = '';
            this.labels.map(function (label) {
                if (currentLabel == label.name) interval = label.interval.desc;
            });

            return interval;
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 365 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/KitResults/TextModal.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "text-modal",
    components: {},
    props: ['exam', 'diseases'],
    data: function data() {
        return {};
    },

    methods: {
        outsideClick: function outsideClick() {
            if (event.target === event.currentTarget) this.$emit('close');
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 366 */
/*!**********************************************!*\
  !*** ./src/components/KitRisks/KitRisks.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitRisks_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./KitRisks.vue */ 367);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56228c80_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitRisks_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-56228c80","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./KitRisks.vue */ 784);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-56228c80","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./KitRisks.vue */ 657)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56228c80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitRisks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56228c80_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitRisks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 367 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/KitRisks/KitRisks.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_kit__ = __webpack_require__(/*! ../../services/kit */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RiskModal__ = __webpack_require__(/*! ./RiskModal */ 658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KitRisksDetails_KitRisksDetails_vue__ = __webpack_require__(/*! ../KitRisksDetails/KitRisksDetails.vue */ 663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(/*! lodash */ 777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RiskAvatar_RiskAvatar_vue__ = __webpack_require__(/*! ../RiskAvatar/RiskAvatar.vue */ 778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RisksCard_RisksCard_vue__ = __webpack_require__(/*! ../RisksCard/RisksCard.vue */ 781);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["y" /* faMinusCircle */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["l" /* faCircle */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["x" /* faInfoCircle */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["C" /* faReceipt */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "kit-risks",
  components: { RiskModal: __WEBPACK_IMPORTED_MODULE_2__RiskModal__["a" /* default */], KitRisksDetails: __WEBPACK_IMPORTED_MODULE_3__KitRisksDetails_KitRisksDetails_vue__["a" /* default */], RiskAvatar: __WEBPACK_IMPORTED_MODULE_7__RiskAvatar_RiskAvatar_vue__["a" /* default */], RisksCard: __WEBPACK_IMPORTED_MODULE_8__RisksCard_RisksCard_vue__["a" /* default */] },
  props: {
    result: Object
  },
  data: function data() {
    return {
      firstPanel: false,
      secondPanel: false,
      thirdPanel: false,
      fourthPanel: false,
      loading: false,
      metrics: null,
      currentRisks: 0,
      diagnostics: [],
      risks: [],
      factors: [],
      headItems: {
        risks: [],
        factors: []
      },
      torsoItems: {
        risks: [],
        factors: []
      },
      abdomenItems: {
        diagnostics: [],
        risks: [],
        factors: []
      },
      pelvisItems: {
        risks: [],
        factors: []
      },
      legItems: {
        risks: [],
        factors: []
      },
      outItems: {
        risks: [],
        factors: []
      },
      formAnswers: [],
      riskModal: {},
      riskModalOpen: false,
      prevention: [],
      hasHeartDisease: false,
      hasDiabetes: false,
      hasHypertension: false,
      hasAvc: false,
      hasDyslipidimia: false,
      hasMetabolic: false,
      hasOsteoporosis: false
    };
  },

  methods: {
    back: function back() {
      this.$emit('back');
    },
    loadKit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(kit_id) {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.loading = true;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__services_kit__["a" /* GET_KIT_ANSWERS */])(kit_id);

              case 4:
                data = _context.sent;

                this.metrics = data.metric;
                this.formAnswers = data.field_answers;
                this.formAnswers.filter(function (a) {
                  return a.field.id == 'afaf2530-c963-4907-a519-9e2eef07bddc';
                });
                if (this.formAnswers.length > 0) {
                  this.hasHeartDisease = this.answerSearch('Você é portador de alguma doença do coração?') == 'Sim' ? true : false;
                  this.hasDiabetes = ['Sim, Descontrolada', 'Sim, Controlada'].includes(this.answerSearch('Você é portador de Diabetes?'));
                  this.hasHypertension = this.answerSearch('Você é portador de Hipertensão?') != 'Não' ? true : false;
                  this.hasAvc = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes('avc') ? true : false;
                  this.hasDyslipidimia = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes('dislipidemia') ? true : false;
                  this.hasOsteoporosis = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes('Osteoporose') ? true : false;
                }

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 14:
                _context.prev = 14;

                this.loading = false;
                return _context.finish(14);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11, 14, 17]]);
      }));

      function loadKit(_x) {
        return _ref.apply(this, arguments);
      }

      return loadKit;
    }(),
    openPanel: function openPanel() {
      var mobile = window.screen.width <= 1000;
      if (mobile) {
        this.firstPanel = !this.firstPanel;
      }
    },
    openModal: function openModal() {
      var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var altTitle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var risk = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (!!open && !!title) {
        this.riskModalOpen = open;
        this.riskModal = {
          title: title,
          altTitle: altTitle,
          risk: risk
        };
      } else if (!open) {
        this.riskModalOpen = open;
      }
    },
    changeRisks: function changeRisks(risk) {
      this.currentRisks = this.currentRisks == risk ? 0 : risk;
    },
    responsiveAvatar: function responsiveAvatar() {
      var mobile = window.screen.width <= 1200;
      if (this.currentRisks != 0 && mobile) return false;
      return true;
    },
    getDotColor: function getDotColor(label) {
      switch (label) {
        case 'indeferido':
        case 'Baixo':
        case 'Não detectado':
          return 'dot-green';
        case 'Médio':
        case 'Médio baixo':
          return 'dot-yellow';
        case 'Médio alto':
        case 'Alto':
        case 'Detectado':
          return 'dot-red';
        default:
          return 'dot-green';
      }
    },
    getUserExams: function getUserExams() {
      var userGender = this.result.customer.gender;
      var userAge = this.result.customer.age;
      if (userGender == 'M') {
        if (userAge >= 40) {
          this.addPrevention('colesterol, triglicerídeos e glicose', '6');
          this.addPrevention('prostata', '12');
          this.addPrevention('ecocardiograma / raio-x do tórax e ultrasom do coração', '12');
          this.addPrevention('colonoscopia', '12');
        } else {
          this.addPrevention('colesterol, triglicerídeos e glicose', '12');
        }
      } else if (userGender == 'F') {
        if (userAge >= 40) {
          this.addPrevention('colesterol, triglicerídeos e glicose', '6');
          this.addPrevention('mamografia', '12');
          this.addPrevention('densiometria óssea', '24');
          this.addPrevention('papanicolau', '12');
          this.addPrevention('ecocardiograma / raio-x do tórax e ultrasom do coração', '12');
          this.addPrevention('colonoscopia', '12');
        } else {
          this.addPrevention('colesterol, triglicerídeos e glicose', '12');
          this.addPrevention('mamografia', '12');
          this.addPrevention('papanicolau', '12');
        }
      }

      if (this.hasHeartDisease) {
        this.addPrevention('cardiologista', '6');
        this.addPrevention('nutricionista', '25');
      }
      if (this.hasDiabetes) {
        this.addPrevention('endocrinologista', '3');
        this.addPrevention('nutricionista', '25');
      }
      if (this.hasHypertension) {
        this.addPrevention('cardiologista', '3');
        this.addPrevention('nutricionista', '25');
      }
      if (this.hasAvc) {
        this.addPrevention('neurologista', '6');
        this.addPrevention('cardiologista', '6');
        this.addPrevention('nutricionista', '25');
      }
      if (this.hasDyslipidimia) {
        this.addPrevention('cardiologista', '6');
        this.addPrevention('endocrinologista', '6');
        this.addPrevention('nutricionista', '25');
      }
      if (this.hasMetabolic) {
        this.addPrevention('endocrinologista', '6');
        this.addPrevention('cardiologista', '6');
        this.addPrevention('nutricionista', '25');
      }
      if (this.hasOsteoporosis) {
        this.addPrevention('reumatologista', '6');
        this.addPrevention('ortopedista', '6');
        this.addPrevention('ginecologista', '12');
        this.addPrevention('nutricionista', '25');
      }

      if (!this.hasHeartDisease && !this.hasDiabetes && !this.hasHypertension && !this.hasAvc && !this.hasDyslipidimia && !this.hasMetabolic && !this.hasOsteoporosis) this.addPrevention('clinico geral', '12');
    },
    addPrevention: function addPrevention(exam, period) {
      var _this = this;

      var insert = true;
      this.prevention.map(function (ex, x) {
        if (ex.includes(exam) && x <= period) {
          insert = false;
        } else if (ex.includes(exam) && x > period) {
          _this.prevention[x].map(function (a, y) {
            if (a == exam) _this.prevention[x].splice(y, 1);
          });
        }
      });
      if (insert) this.prevention[period].push(exam);
    },
    answerSearch: function answerSearch(field) {
      var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var answers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      var ans = null;
      if (multiple) {
        if (answers.length > 0) {
          ans = this.formAnswers.filter(function (a) {
            return a.field.title == field && answers.includes(a.option.value);
          }).map(function (a) {
            return a.option.value;
          });
          return ans.join(', ');
        } else {
          ans = this.formAnswers.filter(function (a) {
            return a.field.title == field;
          }).map(function (a) {
            return a.option.value;
          });
          return ans;
        }
      } else {
        this.formAnswers.map(function (answer) {
          if (answer.field.title == field && !multiple) ans = answer.response !== null ? answer.response : answer.option.label;
        });
      }
      return ans;
    }
  },
  mounted: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _this2 = this;

      var treatMetrics, _self;

      return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.loadKit(this.result.id);

            case 2:

              this.diagnostics = [];
              this.risks = [];
              this.factors = [];

              treatMetrics = {};
              _self = this;


              treatMetrics['Diagnostico Preliminar de Diabetes Mellitus'] = {
                validate: function validate(param) {
                  return !param.hasDiabetes;
                },

                code: 'diagnostico_diabetes',
                name: 'Diagnostico Preliminar de Diabetes Mellitus',
                label: 'indeferido',
                color: 'black',
                type: 'diagnostics',
                location: 'abdomen',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco Internação'] = {
                validate: function validate(param) {
                  return param.result.kit_type.tag_type == "check-up-saude-do-coracao" || param.result.kit_type.tag_type == "check-up-longevidade-saudavel" || param.result.kit_type.tag_type == "check-up-saude-preventiva";
                },

                code: 'risco_internacao',
                title: 'Internação',
                altTitle: 'internacao',
                name: 'Risco Internação',
                label: 'indeferido',
                color: 'black',
                type: 'risks',
                location: 'out',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco Cardiovascular'] = {
                validate: function validate(param) {
                  return param.result.kit_type.tag_type == "check-up-saude-do-coracao" || param.result.kit_type.tag_type == "check-up-doencas-cronicas" || param.result.kit_type.tag_type == "check-up-saude-preventiva" && !param.hasHeartDisease;
                },

                code: 'risco_cardiovascular',
                title: 'Risco Cardiovascular',
                altTitle: 'cardiovascular',
                name: 'Risco Cardiovascular',
                label: 'indeferido',
                color: 'black',
                type: 'risks',
                location: 'torso',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco Psicológico'] = {
                validate: function validate(param) {
                  return param.result.kit_type.tag_type == "check-up-doencas-cronicas" || param.result.kit_type.tag_type == "check-up-longevidade-saudavel" || param.result.kit_type.tag_type == "check-up-saude-preventiva";
                },

                code: 'risco_psicologico',
                title: 'Psicológico',
                altTitle: 'psicologico',
                name: 'Risco Psicológico',
                label: 'indeferido',
                color: 'black',
                type: 'risks',
                location: 'head',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco Fragilidade'] = {
                validate: function validate(param) {
                  return param.result.kit_type.tag_type == "check-up-doencas-cronicas" || param.result.kit_type.tag_type == "check-up-longevidade-saudavel";
                },

                code: 'risco_fragilidade',
                title: 'Fragilidade',
                altTitle: 'fragilidade',
                name: 'Risco Fragilidade',
                label: 'indeferido',
                color: 'black',
                type: 'risks',
                location: 'out',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco de Lesão Muscular'] = {
                validate: function validate(param) {
                  return param.result.kit_type.tag_type == "check-up-doencas-cronicas" || param.result.kit_type.tag_type == "check-up-longevidade-saudavel" || param.result.kit_type.tag_type == "check-up-saude-preventiva";
                },

                code: 'risco_muscular',
                title: 'Lesão Muscular',
                altTitle: 'muscular',
                name: 'Fatores Preliminares para Desenvolver Lesão Muscular',
                label: 'indeferido',
                color: 'black',
                type: 'factors',
                location: 'leg',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco de desenvolver Hipertensão'] = {
                validate: function validate(param) {
                  return (param.result.kit_type.tag_type == "check-up-doencas-cronicas" || param.result.kit_type.tag_type == "check-up-longevidade-saudavel" || param.result.kit_type.tag_type == "check-up-saude-preventiva" && !param.hasHypertension) && !param.hasHypertension;
                },

                code: 'risco_hipertensao',
                title: 'Hipertensão',
                altTitle: 'hipertensao',
                name: 'Fatores Preliminares para Desenvolver Hipertensão',
                label: 'indeferido',
                color: 'black',
                type: 'factors',
                location: 'torso',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco de desenvolver Diabetes'] = {
                validate: function validate(param) {
                  return (param.result.kit_type.tag_type == "check-up-doencas-cronicas" || param.result.kit_type.tag_type == "check-up-longevidade-saudavel" || param.result.kit_type.tag_type == "check-up-saude-preventiva" && !param.hasDiabetes) && !param.hasDiabetes && param.result.exam.result.hba1c < 6.5;
                },

                code: 'risco_diabetes',
                title: 'Diabetes',
                altTitle: 'diabetes',
                name: 'Fatores Preliminares para Desenvolver Diabetes',
                label: 'indeferido',
                color: 'black',
                type: 'factors',
                location: 'abdomen',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco de sofrer AVC'] = {
                validate: function validate(param) {
                  return param.result.kit_type.tag_type == "check-up-saude-do-coracao" || param.result.kit_type.tag_type == "check-up-saude-preventiva";
                },

                code: 'avc',
                title: 'Acidente Vascular Cerebral (AVC)',
                altTitle: 'avc',
                name: 'Fatores Preliminares para Desenvolver AVC',
                label: 'indeferido',
                color: 'black',
                type: 'factors',
                location: 'head',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco de desenvolver Doença do Coração'] = {
                validate: function validate(param) {
                  return (param.result.kit_type.tag_type == "check-up-saude-do-coracao" || param.result.kit_type.tag_type == "check-up-longevidade-saudavel" || param.result.kit_type.tag_type == "check-up-saude-preventiva" && !param.hasHeartDisease) && !param.hasHeartDisease;
                },

                code: 'risco_coracao',
                title: 'Doenças do coração',
                altTitle: 'coracao',
                name: 'Fatores Preliminares para Desenvolver Doenças do Coração',
                label: 'indeferido',
                color: 'black',
                type: 'factors',
                location: 'torso',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco de desenvolver Osteoporose'] = {
                validate: function validate(param) {
                  return (param.result.kit_type.tag_type == "check-up-longevidade-saudavel" || param.result.kit_type.tag_type == "check-up-saude-preventiva") && !param.hasOsteoporosis;
                },

                code: 'risco_osteoporose',
                title: 'Osteoporose',
                altTitle: 'osteoporose',
                name: 'Fatores Preliminares para Desenvolver Osteoporose',
                label: 'indeferido',
                color: 'black',
                type: 'factors',
                location: 'leg',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco de desenvolver Dislipidemia'] = {
                validate: function validate(param) {
                  return param.result.kit_type.tag_type == "check-up-saude-do-coracao" || param.result.kit_type.tag_type == "check-up-doencas-cronicas" || param.result.kit_type.tag_type == "check-up-saude-preventiva";
                },

                code: 'risco_dislipidemia',
                title: 'Dislipidemia',
                altTitle: 'dislipidemia',
                name: 'Fatores Preliminares para Desenvolver Dislipidemia',
                label: 'indeferido',
                color: 'black',
                type: 'factors',
                location: 'torso',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco de desenvolver Síndrome Metabólica'] = {
                validate: function validate(param) {
                  return param.result.kit_type.tag_type == "check-up-saude-do-coracao" || param.result.kit_type.tag_type == "check-up-doencas-cronicas" || param.result.kit_type.tag_type == "check-up-longevidade-saudavel" || param.result.kit_type.tag_type == "check-up-saude-preventiva";
                },

                code: 'risco_metabolica',
                title: 'Síndrome Metabólica',
                altTitle: 'metabolica',
                name: 'Fatores Preliminares para Desenvolver Síndrome Metabólica',
                label: 'indeferido',
                color: 'black',
                type: 'factors',
                location: 'abdomen',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              treatMetrics['Risco Doenca Renal'] = {
                validate: function validate(param) {
                  return param.result.kit_type.tag_type == "check-up-saude-preventiva";
                },

                code: 'risco_renal',
                title: 'Doença Renal Crônica',
                altTitle: 'renal',
                name: 'Fatores Preliminares para Desenvolver Doença Renal Crônica',
                label: 'indeferido',
                color: 'black',
                type: 'factors',
                location: 'abdomen',
                setLabel: function setLabel(newLabel) {
                  this.label = newLabel;
                  this.color = _self.getDotColor(this.label);
                }
              };

              if (!!this.result && !!this.result.customer && !!this.result.customer.updated_metrics) {
                this.metrics.forEach(function (metric) {
                  var treat = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(treatMetrics, metric.risk.name, null);
                  if (treat && treat.validate(_this2)) {
                    if (metric.ticket.label) treat.setLabel(metric.ticket.label);
                    _this2[treat.type].push(treat);
                  }
                });
              }
              this.$forceUpdate();

              this.firstPanel = !(window.screen.width <= 1000);

              this.headItems.risks = this.risks.filter(function (risk) {
                return risk.location == 'head';
              });
              this.headItems.factors = this.factors.filter(function (factor) {
                return factor.location == 'head';
              });
              this.torsoItems.risks = this.risks.filter(function (risk) {
                return risk.location == 'torso';
              });
              this.torsoItems.factors = this.factors.filter(function (factor) {
                return factor.location == 'torso';
              });
              this.abdomenItems.diagnostics = this.diagnostics.filter(function (risk) {
                return risk.location == 'abdomen';
              });
              this.abdomenItems.risks = this.risks.filter(function (risk) {
                return risk.location == 'abdomen';
              });
              this.abdomenItems.factors = this.factors.filter(function (factor) {
                return factor.location == 'abdomen';
              });
              this.pelvisItems.risks = this.risks.filter(function (risk) {
                return risk.location == 'pelvis';
              });
              this.pelvisItems.factors = this.factors.filter(function (factor) {
                return factor.location == 'pelvis';
              });
              this.legItems.risks = this.risks.filter(function (risk) {
                return risk.location == 'leg';
              });
              this.legItems.factors = this.factors.filter(function (factor) {
                return factor.location == 'leg';
              });
              this.outItems.risks = this.risks.filter(function (risk) {
                return risk.location == 'out';
              });
              this.outItems.factors = this.factors.filter(function (factor) {
                return factor.location == 'out';
              });

              this.prevention['1'] = [];
              this.prevention['3'] = [];
              this.prevention['6'] = [];
              this.prevention['12'] = [];
              this.prevention['24'] = [];
              this.prevention['25'] = [];
              this.getUserExams();

            case 44:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }()
});

/***/ }),
/* 368 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/KitRisks/RiskModal.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "risk-modal",
    components: {},
    props: {
        customer: Object,
        result: Object,
        risk: Object,
        answers: Array
    },
    data: function data() {
        return {
            plural: false,
            metricList: []
        };
    },

    methods: {
        outsideClick: function outsideClick() {
            if (event.target === event.currentTarget) this.$emit('close');
        },
        loadMetrics: function loadMetrics(title) {
            title = title.toLowerCase();
            var gender = this.customer.gender;
            if (gender == 'M') {
                gender = 'Masculino';
            } else if (gender == 'F') {
                gender = 'Feminino';
            } else {
                gender = 'Outro';
            }

            var imc = this.answerSearch("imc");
            imc = parseFloat(imc.weigth) / (parseFloat(imc.heigth.replace(',', '.')) * parseFloat(imc.heigth.replace(',', '.')));
            imc = imc.toString().substr(0, 4);
            switch (title) {
                case 'risco de internação':
                    this.addMetric('Sexo', gender);
                    this.addMetric('Idade', this.customer.age);
                    this.addMetric('Auto percepção da saúde', this.answerSearch("Em geral você diria que a sua saúde é? (Própria saúde em relação a outras pessoas da sua idade)"));
                    this.addMetric('Internação no último ano', this.answerSearch("Esteve internado no último ano?"));
                    this.addMetric('Atendimento médico ou clinica no último ano', this.answerSearch("Esteve internado no último ano?"));
                    this.addMetric('Diabético', this.answerSearch("Você é portador de Diabetes?"));
                    break;
                case 'risco cardiovascular':
                    this.addMetric('Sexo', gender);
                    this.addMetric('Idade', this.customer.age);
                    this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                    this.addMetric('Diabético', this.answerSearch("Você é portador de Diabetes?"));
                    this.addMetric('Resultado de HDL', !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de LDL', !!this.result.ldl ? this.result.ldl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Pressão Arterial (sistólica)', this.answerSearch("Sistólica (alta):"));
                    this.addMetric('Pressão Arterial (diastólica)', this.answerSearch("Diastólica (baixa):"));
                    break;
                case 'risco de fragilidade':
                    this.addMetric('Sexo', gender);
                    this.addMetric('Idade', this.customer.age);
                    this.addMetric('Cuidador informal', this.fieldAnswerSearch("Selecione abaixo as situações que se encaixam na sua rotina", "Caso necessário, não possuo alguém da minha confiança para tomar conta de mim"));
                    this.addMetric('Problema de saúde que limita atividade', this.fieldAnswerSearch("Selecione abaixo as situações que se encaixam na sua rotina", "Possuo problemas de saúde que limitam a realização de atividades que dependam de esforços físicos"));
                    this.addMetric('Necessita de ajuda para atividades diárias', this.fieldAnswerSearch("Selecione abaixo as situações que se encaixam na sua rotina", "Necessito de ajuda para realizar as atividades diárias como banho, vestir, comer e/ou andar"));
                    this.addMetric('Problema de saúde que faz ficar em casa', this.fieldAnswerSearch("Selecione abaixo as situações que se encaixam na sua rotina", "Possuo problema de saúde que me faz ficar em casa"));
                    this.addMetric('Usa meios auxiliares', this.fieldAnswerSearch("Selecione abaixo as situações que se encaixam na sua rotina", "Uso meios auxiliares de locomoção (andador, bengala ou cadeira de rodas)"));
                    break;
                case 'fatores preliminares para desenvolver lesão muscular':
                    this.addMetric('Seu IMC', imc);
                    this.addMetric('Idade', this.customer.age);
                    this.addMetric('Auto percepção da saúde', this.answerSearch("Em geral você diria que a sua saúde é? (Própria saúde em relação a outras pessoas da sua idade)"));
                    this.addMetric('Sono', this.answerSearch("Quantas horas você dorme por dia aproximadamente?"));
                    this.addMetric('Atividade física', this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?"));
                    this.addMetric('Consumo de frutas e verduras', this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires)."));
                    this.addMetric('Consumo de gordura animal', this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?"));
                    this.addMetric('Bebida alcoólica', this.answerSearch("Você costuma tomar bebida alcoólica com frequência (1 dose = 350 ml de cerveja, 100 ml de vinho ou 30 ml de destilado)?"));
                    this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                    if (!!this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true, ["Lesões no fêmur ou joelho", "Hérnia de disco ou transtornos de discos intervertebrais", "Lesões no ombro", "Lesões no tornozelo e pé", "Tendinites", "Artrites", "Lesões no punho e mão"])) this.addMetric('Doenças autorreferidas', this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true, ["Lesões no fêmur ou joelho", "Hérnia de disco ou transtornos de discos intervertebrais", "Lesões no ombro", "Lesões no tornozelo e pé", "Tendinites", "Artrites", "Lesões no punho e mão"]));
                    break;
                case 'fatores preliminares para desenvolver doenças do coração':
                    this.addMetric('Sexo', gender);
                    this.addMetric('Idade', this.customer.age);
                    this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                    this.addMetric('Diabético', this.answerSearch("Você é portador de Diabetes?"));
                    this.addMetric('Resultado de HDL', !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de LDL', !!this.result.ldl ? this.result.ldl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Pressão Arterial (sistólica)', this.answerSearch("Sistólica (alta):"));
                    this.addMetric('Pressão Arterial (diastólica)', this.answerSearch("Diastólica (baixa):"));
                    break;
                case 'fatores preliminares para desenvolver avc':
                    this.addMetric('Seu IMC', imc);
                    this.addMetric('Atividade física', this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?"));
                    this.addMetric('Consumo de frutas e verduras', this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires)."));
                    this.addMetric('Consumo de gordura animal', this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?"));
                    this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                    this.addMetric('Pressão Arterial (sistólica)', this.answerSearch("Sistólica (alta):"));
                    this.addMetric('Pressão Arterial (diastólica)', this.answerSearch("Diastólica (baixa):"));
                    if (this.answerSearch("Você é portador de quais doenças ou condições abaixo?") == 'Dependência a álcool ou drogas' || this.answerSearch("Você é portador de quais doenças ou condições abaixo?") == 'Dislipidemia') this.addMetric('Doenças autorreferidas', this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true));
                    this.addMetric('Resultado de HDL', !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de LDL', !!this.result.ldl ? this.result.ldl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de colesterol total', !!this.result.colesterol_total ? this.result.colesterol_total + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de triglicerídeos', !!this.result.triglicerideos ? this.result.triglicerideos + 'mg/dL' : 'Não aferido');
                    break;
                case 'fatores preliminares para desenvolver dislipidemia':
                    this.addMetric('Seu IMC', imc);
                    this.addMetric('Atividade física', this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?"));
                    this.addMetric('Consumo de frutas e verduras', this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires)."));
                    this.addMetric('Consumo de gordura animal', this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?"));
                    this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                    this.addMetric('Pressão Arterial (sistólica)', this.answerSearch("Sistólica (alta):"));
                    this.addMetric('Pressão Arterial (diastólica)', this.answerSearch("Diastólica (baixa):"));
                    if (this.answerSearch("Você é portador de quais doenças ou condições abaixo?") == 'Dependência a álcool ou drogas') this.addMetric('Doenças autorreferidas', this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true));
                    this.addMetric('Resultado de HDL', !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de LDL', !!this.result.ldl ? this.result.ldl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de colesterol total', !!this.result.colesterol_total ? this.result.colesterol_total + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de triglicerídeos', !!this.result.triglicerideos ? this.result.triglicerideos + 'mg/dL' : 'Não aferido');
                    break;
                case 'fatores preliminares para desenvolver síndrome metabólica':
                    this.addMetric('Circunferência abdominal', this.answerSearch("Circunferência abdominal"));
                    this.addMetric('Pressão Arterial (sistólica)', this.answerSearch("Sistólica (alta):"));
                    this.addMetric('Pressão Arterial (diastólica)', this.answerSearch("Diastólica (baixa):"));
                    this.addMetric('Resultado de HDL', !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de LDL', !!this.result.ldl ? this.result.ldl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de colesterol total', !!this.result.colesterol_total ? this.result.colesterol_total + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de triglicerídeos', !!this.result.triglicerideos ? this.result.triglicerideos + 'mg/dL' : 'Não aferido');
                    if (!!this.result.glicose) this.addMetric('Resultado de glicose', !!this.result.glicose ? this.result.glicose + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de hemoglobina glicada (HbA1c)', !!this.result.hba1c ? this.result.hba1c + 'mg/dL' : 'Não aferido');
                    break;
                case 'fatores preliminares para desenvolver hipertensão':
                    this.addMetric('Seu IMC', imc);
                    this.addMetric('Idade', this.customer.age);
                    this.addMetric('Atividade física', this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?"));
                    this.addMetric('Consumo de frutas e verduras', this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires)."));
                    this.addMetric('Consumo de gordura animal', this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?"));
                    this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                    this.addMetric('Resultado de HDL', !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de LDL', !!this.result.ldl ? this.result.ldl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de colesterol total', !!this.result.colesterol_total ? this.result.colesterol_total + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de triglicerídeos', !!this.result.triglicerideos ? this.result.triglicerideos + 'mg/dL' : 'Não aferido');
                case 'fatores preliminares para desenvolver diabetes':
                    this.addMetric('Seu IMC', imc);
                    this.addMetric('Idade', this.customer.age);
                    this.addMetric('Atividade física', this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?"));
                    this.addMetric('Consumo de frutas e verduras', this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires)."));
                    this.addMetric('Consumo de gordura animal', this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?"));
                    this.addMetric('Bebida alcoólica', this.answerSearch("Você costuma tomar bebida alcoólica com frequência (1 dose = 350 ml de cerveja, 100 ml de vinho ou 30 ml de destilado)?"));
                    this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                    if (gender == 'Feminino') this.addMetric('Gravidez', this.answerSearch("Você está grávida?"));
                    this.addMetric('Resultado de HDL', !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de LDL', !!this.result.ldl ? this.result.ldl + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de colesterol total', !!this.result.colesterol_total ? this.result.colesterol_total + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de triglicerídeos', !!this.result.triglicerideos ? this.result.triglicerideos + 'mg/dL' : 'Não aferido');
                    if (!!this.result.glicose) this.addMetric('Resultado de glicose', !!this.result.glicose ? this.result.glicose + 'mg/dL' : 'Não aferido');
                    this.addMetric('Resultado de hemoglobina glicada (HbA1c)', !!this.result.hba1c ? this.result.hba1c + 'mg/dL' : 'Não aferido');
                    break;
                case 'fatores preliminares para desenvolver osteoporose':
                    this.addMetric('Sexo', gender);
                    this.addMetric('Idade', this.customer.age);
                    this.addMetric('Seu IMC', imc);
                    this.addMetric('Atividade física', this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?"));
                    this.addMetric('Consumo de frutas e verduras', this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires)."));
                    this.addMetric('Consumo de gordura animal', this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?"));
                    this.addMetric('Bebida alcoólica', this.answerSearch("Você costuma tomar bebida alcoólica com frequência (1 dose = 350 ml de cerveja, 100 ml de vinho ou 30 ml de destilado)?"));
                    this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                    if (this.answerSearch("Você é portador de quais doenças ou condições abaixo?") == 'Dependência a álcool ou drogas') this.addMetric('Doenças autorreferidas', this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true));
                    break;
                default:
                    break;
            }
        },
        addMetric: function addMetric(title, value) {
            this.metricList.push([title, value]);
        },
        answerSearch: function answerSearch(field) {
            var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var answers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

            var ans = null;
            if (multiple) {
                if (answers.length > 0) {
                    ans = this.answers.filter(function (a) {
                        return a.field.title == field && answers.includes(a.option.value);
                    }).map(function (a) {
                        return a.option.value;
                    });
                    return ans.join(', ');
                } else {
                    ans = this.answers.filter(function (a) {
                        return a.field.title == field;
                    }).map(function (a) {
                        return a.option.value;
                    });
                    return ans.join(', ');
                }
            } else {
                this.answers.map(function (answer) {
                    if (answer.field.title == field && !multiple) ans = answer.response !== null ? answer.response : answer.option.label;
                });
            }
            return ans;
        },
        fieldAnswerSearch: function fieldAnswerSearch(field, option) {
            var ans = 'Não';
            this.answers.map(function (answer) {
                if (answer.field.title == field && answer.option.label == option) {
                    ans = 'Sim';
                }
            });
            return ans;
        }
    },
    mounted: function mounted() {
        if (this.risk.title.split(" ", 2)[0].toLowerCase() == 'fatores') this.plural = true;

        this.loadMetrics(this.risk.title);
    }
});

/***/ }),
/* 369 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/KitRisksDetails/KitRisksDetails.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DetailText__ = __webpack_require__(/*! ./DetailText */ 665);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "kit-risks-details",
    components: { DetailText: __WEBPACK_IMPORTED_MODULE_0__DetailText__["a" /* default */] },
    props: {
        customer: Object,
        result: Object,
        risk: Object,
        answers: Array
    },
    data: function data() {
        return {
            user: {
                age: null,
                pressure_high: null,
                pressure_low: null,
                circunference: null,
                gender: null
            },
            icons: [],
            iconsSec: [],
            answersRisks: {
                imc: {},
                hdl: {},
                ldl: {},
                clt: {},
                tri: {},
                hba1c: {},
                gli: {},
                creatinine: {},
                tfg: {},
                smoke: {},
                drink: {},
                diabetes: {},
                heartDisease: {},
                selfHealth: {},
                hospitalized: {},
                medic: {},
                caretaker: {},
                limitedActivity: {},
                dailyActivity: {},
                dailyOth: {},
                home: {},
                walkSupport: {},
                activity: {},
                fruits: {},
                animal: {},
                diseases: {},
                sleep: {},
                pregnant: {}
            },
            imodifFac: ['Idade', 'Sexo biológico', 'Histórico Familiar Doença Crônica']
        };
    },

    methods: {
        outsideClick: function outsideClick() {
            if (event.target === event.currentTarget) this.$emit('close');
        },
        loadUser: function loadUser() {
            this.user.age = this.customer.age;
            this.user.pressure_high = this.answerSearch("Sistólica (alta):");
            this.user.pressure_low = this.answerSearch("Diastólica (baixa):");
            this.user.circunference = this.answerSearch("Circunferência abdominal (centímetros)");
            this.user.gender = this.customer.gender == 'M' ? 'Masculino' : 'Feminino';
        },
        loadRisks: function loadRisks() {
            var imc = this.answerSearch("imc");
            imc = parseFloat(imc.weigth) / (parseFloat(imc.heigth.replace(',', '.')) * parseFloat(imc.heigth.replace(',', '.')));
            imc = imc.toString().substr(0, 4);

            this.answersRisks.imc.realValue = imc;
            this.answersRisks.imc.value = imc + " kg/m²";
            if (imc <= 18.4) this.answersRisks.imc.risk = 'yellow';else if (imc >= 18.5 && imc <= 24.9) this.answersRisks.imc.risk = 'green';else this.answersRisks.imc.risk = 'red';

            if (!!this.result.hdl) {
                this.answersRisks.hdl.value = this.result.hdl + ' mg/dL';
                if (this.customer.age > 20) this.answersRisks.hdl.risk = this.result.hdl > 40 ? 'green' : 'red';else this.answersRisks.hdl.risk = this.result.hdl > 45 ? 'green' : 'red';
            }
            if (!!this.result.ldl) {
                this.answersRisks.ldl.value = this.result.ldl + ' mg/dL';
                if (!!this.result.ldlAlt) {
                    if (this.result.ldl < this.result.ldlAlt.range) this.answersRisks.ldl.risk = 'green';else this.answersRisks.ldl.risk = 'red';
                } else {
                    if (this.customer.age > 19) if (this.result.ldl <= 129) this.answersRisks.ldl.risk = 'green';else if (this.result.ldl > 129 && this.result.ldl <= 159) this.answersRisks.ldl.risk = 'yellow';else if (this.result.ldl >= 160) this.answersRisks.ldl.risk = 'red';else if (this.result.ldl < 110) this.answersRisks.ldl.risk = 'green';else if (this.result.ldl >= 110 && this.result.ldl <= 129) this.answersRisks.ldl.risk = 'yellow';else if (this.result.ldl >= 130) this.answersRisks.ldl.risk = 'red';
                }
            }
            if (!!this.result.colesterol_total) {
                this.answersRisks.clt.value = this.result.colesterol_total + ' mg/dL';
                if (this.customer.age > 19) this.answersRisks.clt.risk = this.result.colesterol_total <= 129 ? 'green' : 'red';else this.answersRisks.clt.risk = this.result.colesterol_total <= 110 ? 'green' : 'red';
            }
            if (!!this.result.triglicerideos) {
                this.answersRisks.tri.value = this.result.triglicerideos + ' mg/dL';
                if (this.customer.age > 19) this.answersRisks.tri.risk = this.result.triglicerideos <= 129 ? 'green' : 'red';else this.answersRisks.tri.risk = this.result.triglicerideos <= 110 ? 'green' : 'red';
            }
            if (!!this.result.hba1c) {
                this.answersRisks.hba1c.value = this.result.hba1c + ' %';
                if (this.result.hba1c < 5.7 || this.result.glicose >= 70 && this.result.glicose <= 99) this.answersRisks.hba1c.risk = 'green';else if (this.result.hba1c >= 5.7 && this.result.hba1c <= 6.4 || this.result.glicose < 70) this.answersRisks.hba1c.risk = 'yellow';else this.answersRisks.hba1c.risk = 'red';
            }
            if (!!this.result.glicose) {
                this.answersRisks.gli.value = this.result.glicose + ' mg/dL';
                if (this.result.glicose < 70) this.answersRisks.gli.risk = 'yellow';else if (this.result.glicose >= 70 && this.result.glicose <= 99) this.answersRisks.gli.risk = 'green';else this.answersRisks.gli.risk = 'red';
            }
            if (!!this.result.creatinine) {
                this.answersRisks.creatinine.value = this.result.creatinine + ' mg/dL';
                var minLimit = this.customer.age < 1 ? 0.3 : this.customer.age <= 2 ? 0.2 : this.customer.age <= 12 ? 0.3 : this.customer.age <= 18 ? 0.5 : this.customer.age > 18 && this.customer.gender == 'M' ? 0.7 : this.customer.age > 18 && this.customer.gender == 'F' ? 0.5 : 0.7;
                var maxLimit = this.customer.age < 1 ? 1 : this.customer.age <= 2 ? 0.4 : this.customer.age <= 12 ? 0.7 : this.customer.age <= 18 ? 1 : this.customer.age > 18 && this.customer.gender == 'M' ? 1.2 : this.customer.age > 18 && this.customer.gender == 'F' ? 1 : 1.2;
                if (this.result.creatinine < minLimit) this.answersRisks.creatinine.risk = 'red';else if (this.result.creatinine >= minLimit && this.result.creatinine <= maxLimit) this.answersRisks.creatinine.risk = 'green';else if (this.result.creatinine >= maxLimit) this.answersRisks.creatinine.risk = 'red';else this.answersRisks.creatinine.risk = 'red';
            }

            if (!!this.result.tfg) {
                this.answersRisks.tfg.value = this.result.tfg.toFixed(2) + ' mL/min x 1,73m²';

                if (this.result.tfg >= 60) this.answersRisks.tfg.risk = "green";else if (this.result.tfg > 30 && this.result.tfg <= 59) this.answersRisks.tfg.risk = "yellow";else if (this.result.tfg <= 29) this.answersRisks.tfg.risk = "red";
            }
            if (this.answerSearch("Você fuma?")) {
                this.answersRisks.smoke.value = this.answerSearch("Você fuma?");
                this.answersRisks.smoke.risk = this.answerSearch("Você fuma?") == 'Sim' ? 'red' : 'green';
            }
            if (this.answerSearch("Você costuma tomar bebida alcoólica com frequência (1 dose = 350 ml de cerveja, 100 ml de vinho ou 30 ml de destilado)?")) {
                this.answersRisks.drink.value = this.answerSearch("Você costuma tomar bebida alcoólica com frequência (1 dose = 350 ml de cerveja, 100 ml de vinho ou 30 ml de destilado)?");
                if (this.answersRisks.drink.value == 'Sete ou mais doses por semana') this.answersRisks.drink.risk = 'red';else if (this.answersRisks.drink.value == 'Três a seis doses por semana') this.answersRisks.drink.risk = 'yellow';else this.answersRisks.drink.risk = 'green';
            }
            if (this.answerSearch("Você é portador de Diabetes?")) {
                this.answersRisks.diabetes.value = this.answerSearch("Você é portador de Diabetes?");
                this.answersRisks.diabetes.risk = this.answerSearch("Você é portador de Diabetes?") == 'Sim' ? 'red' : 'green';
            }
            if (this.answerSearch("Você é portador de alguma doença do coração?")) {
                this.answersRisks.heartDisease.value = this.answerSearch("Você é portador de alguma doença do coração?");
                this.answersRisks.heartDisease.risk = this.answerSearch("Você é portador de alguma doença do coração?") == 'Sim' ? 'red' : 'green';
            }
            if (this.answerSearch("Em geral você diria que a sua saúde é? (Própria saúde em relação a outras pessoas da sua idade)")) {
                this.answersRisks.selfHealth.value = this.answerSearch("Em geral você diria que a sua saúde é? (Própria saúde em relação a outras pessoas da sua idade)");
                if (this.answersRisks.selfHealth.value == 'Excelente') this.answersRisks.selfHealth.risk = 'green';else if (this.answersRisks.selfHealth.risk = ['Boa', 'Regular'].includes(this.answersRisks.selfHealth.value)) this.answersRisks.selfHealth.risk = 'yellow';else this.answersRisks.selfHealth.risk = 'red';
            }
            if (this.answerSearch("Esteve internado no último ano?")) {
                this.answersRisks.hospitalized.value = this.answerSearch("Esteve internado no último ano?");
                this.answersRisks.hospitalized.risk = this.answerSearch("Esteve internado no último ano?") == 'Não, nenhuma vez' ? 'green' : 'red';
            }
            if (this.answerSearch("Quantas vezes você procurou atendimento médico ou clínica para tratamento no último ano?")) {
                this.answersRisks.medic.value = this.answerSearch("Quantas vezes você procurou atendimento médico ou clínica para tratamento no último ano?");
                this.answersRisks.medic.risk = this.answerSearch("Quantas vezes você procurou atendimento médico ou clínica para tratamento no último ano?") == 'Mais do que seis vezes' ? 'red' : 'green';
            }
            if (this.answerSearch("Selecione abaixo as situações que se encaixam na sua rotina")) {
                this.answersRisks.caretaker.value = this.fieldAnswerSearch("Selecione abaixo as situações que se encaixam na sua rotina", "Caso necessário, não possuo alguém da minha confiança para tomar conta de mim");
                this.answersRisks.caretaker.risk = this.answersRisks.caretaker.value == 'Sim' ? 'red' : 'green';
                this.answersRisks.limitedActivity.value = this.fieldAnswerSearch("Selecione abaixo as situações que se encaixam na sua rotina", "Possuo problemas de saúde que limitam a realização de atividades que dependam de esforços físicos");
                this.answersRisks.limitedActivity.risk = this.answersRisks.limitedActivity.value == 'Sim' ? 'red' : 'green';
                this.answersRisks.dailyActivity.value = this.fieldAnswerSearch("Selecione abaixo as situações que se encaixam na sua rotina", "Necessito de ajuda para realizar as atividades diárias como banho, vestir, comer e/ou andar");
                this.answersRisks.dailyActivity.risk = this.answersRisks.dailyActivity.value == 'Sim' ? 'red' : 'green';
                this.answersRisks.home.value = this.fieldAnswerSearch("Selecione abaixo as situações que se encaixam na sua rotina", "Possuo problema de saúde que me faz ficar em casa");
                this.answersRisks.home.risk = this.answersRisks.home.value == 'Sim' ? 'red' : 'green';
                this.answersRisks.walkSupport.value = this.fieldAnswerSearch("Selecione abaixo as situações que se encaixam na sua rotina", "Uso meios auxiliares de locomoção (andador, bengala ou cadeira de rodas)");
                this.answersRisks.walkSupport.risk = this.answersRisks.walkSupport.value == 'Sim' ? 'red' : 'green';
            }
            if (this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?")) {
                this.answersRisks.activity.value = this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?");
                if (this.answersRisks.activity.value == 'Nenhuma vez por semana') this.answersRisks.activity.risk = 'red';else if (this.answersRisks.activity.value == 'Menos de três vezes por semana') this.answersRisks.activity.risk = 'yellow';else this.answersRisks.activity.risk = 'green';
            }
            if (this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires).")) {
                this.answersRisks.fruits.value = this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires).");
                if (this.answersRisks.fruits.value == 'Nenhuma porção') this.answersRisks.fruits.risk = 'red';else if (this.answersRisks.fruits.value == 'Uma porção') this.answersRisks.fruits.risk = 'yellow';else this.answersRisks.fruits.risk = 'green';
            }
            if (this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?")) {
                this.answersRisks.animal.value = this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?");
                if (this.answersRisks.animal.value == 'Quase sempre') this.answersRisks.animal.risk = 'red';else if (this.answersRisks.animal.value == 'Moderadamente') this.answersRisks.animal.risk = 'yellow';else this.answersRisks.animal.risk = 'green';
            }
            if (this.answerSearch("Você é portador de quais doenças ou condições abaixo?")) {
                this.answersRisks.diseases.value = this.answerSearch("Você é portador de quais doenças ou condições abaixo?");
                this.answersRisks.diseases.risk = this.answersRisks.diseases.value.length > 0 ? 'red' : 'green';
            }
            if (this.answerSearch("Quantas horas você dorme por dia aproximadamente?")) {
                this.answersRisks.sleep.value = this.answerSearch("Quantas horas você dorme por dia aproximadamente?");
                this.answersRisks.sleep.risk = this.answersRisks.sleep.value == 'Menos que 6 horas' ? 'red' : 'green';
            }
            if (this.answerSearch("Você está grávida?")) {
                this.answersRisks.pregnant.value = this.answerSearch("Você está grávida?");
                this.answersRisks.pregnant.risk = this.answersRisks.pregnant.value == 'Sim' ? 'red' : 'green';
            }
        },
        loadIcons: function loadIcons() {
            var pressureHighVal = this.user.pressure_high.split('-')[0].replace('>', '').replace('<', '').replace('=', '');
            var pressureLowVal = this.user.pressure_low.split('-')[0].replace('>', '').replace('<', '').replace('=', '');
            var circunferenceRisk = this.user.gender == 'Masculino' && this.user.circunference > 102 ? 'red' : this.user.gender == 'Feminino' && this.user.circunference > 88 ? 'red' : 'green';
            var cronica = !!this.answers.find(function (an) {
                return an.field.title == 'Possui histórico familiar de doença crônica?' && an.option.value == 'sim-historico-familiar-de-doenca-do-coracao';
            });
            var cronicaDiab = !!this.answers.find(function (an) {
                return an.field.title == 'Possui histórico familiar de doença crônica?' && an.option.value == 'sim-historico-familiar-de-diabetes';
            });
            var cronicaHip = !!this.answers.find(function (an) {
                return an.field.title == 'Possui histórico familiar de doença crônica?' && an.option.value == 'sim-historico-familiar-de-hipertensao';
            });
            var cronicaRenal = !!this.answers.find(function (an) {
                return an.field.title == 'Possui histórico familiar de doença crônica?' && an.option.value == 'sim-historico-familiar-de-doenca-renal-cronica';
            });
            var hipert = this.answers.find(function (an) {
                return an.field.title == 'Você é portador de Hipertensão?';
            });
            var hipertMed = this.answers.find(function (an) {
                return an.field.title == 'Você toma remédios para Hipertensão?';
            });
            switch (this.risk.altTitle) {
                case 'cardiovascular':
                    if (!!this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true, ["Arterosclerose", "Infarto"])) this.addIcon('Doenças autorreferidas', this.answersRisks.diseases.value, 'diseases', this.answersRisks.diseases.value);
                    if (this.user.gender == 'Masculino') this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 55 ? 'red' : this.customer.age >= 45 ? 'yellow' : 'green');else this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 50 ? 'red' : this.customer.age >= 45 ? 'yellow' : 'green');
                    if (!!this.answersRisks.hdl.value && this.user.gender == 'Masculino') this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', this.result.hdl >= 45 ? 'green' : this.result.hdl >= 35 ? 'yellow' : 'red');else if (!!this.answersRisks.hdl.value && this.user.gender == 'Feminino') this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', this.result.hdl >= 50 ? 'green' : this.result.hdl >= 35 ? 'yellow' : 'red');
                    if (this.user.gender == 'Masculino') this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', this.answersRisks.diabetes.value == 'Não' ? 'green' : 'yellow');else this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', this.answersRisks.diabetes.value == 'Não' ? 'green' : 'red');
                    this.addIcon('Pressão (Sistólica)', this.user.pressure_high, 'pressure', pressureHighVal >= 160 ? 'red' : pressureHighVal >= 130 ? 'yellow' : 'green');
                    this.addIcon('Pressão (Diastólica)', this.user.pressure_low, 'pressure', pressureLowVal >= 100 ? 'red' : pressureLowVal >= 85 ? 'yellow' : 'green');
                    this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', this.answersRisks.smoke.risk);
                    if (!!this.answersRisks.ldl.value && this.user.gender == 'Masculino') this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', this.result.ldl >= 190 ? 'red' : this.result.ldl >= 130 ? 'yellow' : 'green');else if (!!this.answersRisks.ldl.value && this.user.gender == 'Feminino') this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', this.result.ldl >= 160 ? 'red' : this.result.ldl >= 130 ? 'yellow' : 'green');
                    break;
                case 'internacao':
                    this.addIcon('Auto percepção da saúde', this.answersRisks.selfHealth.value, 'health', this.answersRisks.selfHealth.risk);
                    if (this.user.gender == 'Masculino') this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 80 ? 'red' : this.customer.age >= 75 ? 'yellow' : 'green');else this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 80 ? 'red' : this.customer.age >= 75 ? 'yellow' : 'green');
                    this.addIcon('Internação no último ano', this.answersRisks.hospitalized.value, 'hospitalized', this.answersRisks.hospitalized.risk);
                    this.addIcon('Doença do Coração', this.answersRisks.heartDisease.value, 'heart_disease', this.answersRisks.heartDisease.risk);
                    this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', this.answersRisks.diabetes.risk);
                    this.addIcon('Atendimento médico ou clinica no último ano', this.answersRisks.medic.value, 'medic', this.answersRisks.medic.risk);
                    this.addIcon('Sexo biológico', this.user.gender, 'gender', this.user.gender == 'Masculino' ? 'red' : 'green');
                    if (this.answersRisks.caretaker.risk == 'red') this.addIcon('Cuidador informal', this.answersRisks.caretaker.value, 'caretaker', this.answersRisks.caretaker.risk);
                    if (this.answersRisks.limitedActivity.risk == 'red') this.addIcon('Atividade limitada', this.answersRisks.limitedActivity.value, 'limited_activity', this.answersRisks.limitedActivity.risk);
                    if (this.answersRisks.dailyActivity.risk == 'red') this.addIcon('Ajuda para atividades diárias', this.answersRisks.dailyActivity.value, 'daily_activity', this.answersRisks.dailyActivity.risk);
                    if (this.answersRisks.home.risk == 'red') this.addIcon('Problema de saúde que faz ficar em casa', this.answersRisks.home.value, 'home', this.answersRisks.home.risk);
                    if (this.answersRisks.walkSupport.risk == 'red') this.addIcon('Usa meios auxiliares', this.answersRisks.walkSupport.value, 'walk_support', this.answersRisks.walkSupport.risk);
                    break;
                case 'fragilidade':
                    this.addIcon('Cuidador informal', this.answersRisks.caretaker.value, 'caretaker', this.answersRisks.caretaker.risk);
                    this.addIcon('Atividade limitada', this.answersRisks.limitedActivity.value, 'limited_activity', this.answersRisks.limitedActivity.risk);
                    this.addIcon('Ajuda para atividades diárias', this.answersRisks.dailyActivity.value, 'daily_activity', this.answersRisks.dailyActivity.risk);
                    this.addIcon('Problema de saúde que faz ficar em casa', this.answersRisks.home.value, 'home', this.answersRisks.home.risk);
                    this.addIcon('Usa meios auxiliares', this.answersRisks.walkSupport.value, 'walk_support', this.answersRisks.walkSupport.risk);
                    break;
                case 'avc':
                    this.addIcon('Sexo biológico', this.user.gender, 'gender', this.user.gender == 'Masculino' ? 'green' : 'yellow');
                    this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 75 ? 'red' : this.customer.age >= 50 ? 'yellow' : 'green');
                    this.addIcon('IMC', this.answersRisks.imc.value, 'imc', this.answersRisks.imc.realValue >= 35 ? 'red' : this.answersRisks.imc.realValue >= 30 ? 'yellow' : 'green');
                    this.addIcon('Atividade física', this.answersRisks.activity.value, 'activity', this.answersRisks.activity.value == 'Nenhuma vez por semana' ? 'yellow' : 'green');
                    this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', this.answersRisks.smoke.value == 'Não' ? 'green' : 'yellow');
                    if (cronica) this.addIcon('Histórico Familiar Doença Crônica', 'Doença do Coração', 'family', 'yellow');
                    this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', this.answersRisks.diabetes.value == 'Não' ? 'green' : this.answersRisks.diabetes.value == 'Sim, controlada' ? 'yellow' : 'yellow');
                    if (!!hipertMed) this.addIcon('Remédio para Hipertensão', hipertMed.option.label, 'hypertension', hipertMed.option.label == 'Sim' ? 'red' : 'yellow');else if (!!hipert) this.addIcon('Hipertensão', hipert.option.label, 'hypertension', 'green');
                    this.addIcon('Pressão (Sistólica)', this.user.pressure_high, 'pressure', pressureHighVal >= 140 ? 'red' : pressureHighVal >= 130 ? 'yellow' : 'green');
                    this.addIcon('Doença do Coração', this.answersRisks.heartDisease.value, 'heart_disease', this.answersRisks.heartDisease.value == 'Sim' ? 'yellow' : 'green');
                    if (!!this.answersRisks.hdl.value) this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', this.result.hdl < 35 ? 'yellow' : 'green');
                    if (!!this.answersRisks.ldl.value && this.user.gender == 'Masculino' && this.result.ldl >= 130) this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', this.result.ldl >= 190 ? 'red' : this.result.ldl >= 130 ? 'yellow' : 'green');else if (!!this.answersRisks.ldl.value && this.user.gender == 'Feminino') this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', this.result.ldl >= 190 ? 'red' : this.result.ldl >= 130 ? 'yellow' : 'green');
                    this.addIcon('Hemoglobina Glicada (HbA1c)', this.answersRisks.hba1c.value, 'hemoglobin', this.result.hba1c >= 5.7 ? 'red' : 'green');
                    break;
                case 'coracao':
                    if (!!this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true, ["Arterosclerose", "Infarto"])) this.addIcon('Doenças autorreferidas', this.answersRisks.diseases.value, 'diseases', this.answersRisks.diseases.value);
                    if (this.user.gender == 'Masculino') this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 55 ? 'red' : this.customer.age >= 45 ? 'yellow' : 'green');else this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 50 ? 'red' : this.customer.age >= 45 ? 'yellow' : 'green');
                    if (!!this.answersRisks.hdl.value && this.user.gender == 'Masculino') this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', this.result.hdl >= 45 ? 'green' : this.result.hdl >= 35 ? 'yellow' : 'red');else if (!!this.answersRisks.hdl.value && this.user.gender == 'Feminino') this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', this.result.hdl >= 50 ? 'green' : this.result.hdl >= 35 ? 'yellow' : 'red');
                    if (this.user.gender == 'Masculino') this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', this.answersRisks.diabetes.value == 'Não' ? 'green' : 'yellow');else this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', this.answersRisks.diabetes.value == 'Não' ? 'green' : 'red');
                    this.addIcon('Pressão (Sistólica)', this.user.pressure_high, 'pressure', pressureHighVal >= 160 ? 'red' : pressureHighVal >= 130 ? 'yellow' : 'green');
                    this.addIcon('Pressão (Diastólica)', this.user.pressure_low, 'pressure', pressureLowVal >= 100 ? 'red' : pressureLowVal >= 85 ? 'yellow' : 'green');
                    this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', this.answersRisks.smoke.risk);
                    if (!!this.answersRisks.ldl.value && this.user.gender == 'Masculino') this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', this.result.ldl >= 190 ? 'red' : this.result.ldl >= 130 ? 'yellow' : 'green');else if (!!this.answersRisks.ldl.value && this.user.gender == 'Feminino') this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', this.result.ldl >= 160 ? 'red' : this.result.ldl >= 130 ? 'yellow' : 'green');
                    break;
                case 'dislipidemia':
                    this.addIcon('Atividade física', this.answersRisks.activity.value, 'activity', this.answersRisks.activity.value == 'Nenhuma vez por semana' ? 'yellow' : 'green');
                    this.addIcon('Consumo de gordura animal', this.answersRisks.animal.value, 'animal', this.answersRisks.animal.value == 'Quase sempre' ? 'yellow' : 'green');
                    this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', this.answersRisks.diabetes.value == 'Não' ? 'green' : 'green');
                    if (!!this.answersRisks.hdl.value) this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', this.result.hdl < 35 ? 'red' : 'green');
                    if (!!this.answersRisks.ldl.value) this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', this.result.ldl >= 130 ? 'red' : 'green');
                    if (!!this.answersRisks.tri.value) this.addIcon('Triglicerídeos', this.answersRisks.tri.value, 'tri', this.result.triglicerideos >= 150 ? 'red' : 'green');
                    if (!!this.answersRisks.hba1c.value) this.addIcon('Hemoglobina Glicada (HbA1c)', this.answersRisks.hba1c.value, 'hemoglobin', this.result.hba1c >= 5.7 ? 'red' : 'green');
                    break;
                case 'metabolica':
                    this.addIcon('Circunferência abdominal', this.user.circunference, 'circunference', circunferenceRisk);
                    this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', this.answersRisks.diabetes.risk);
                    this.addIcon('Pressão (Sistólica)', this.user.pressure_high, 'pressure', pressureHighVal >= 140 ? 'red' : pressureHighVal >= 130 ? 'yellow' : 'green');
                    this.addIcon('Pressão (Diastólica)', this.user.pressure_low, 'pressure', pressureLowVal >= 90 ? 'red' : pressureLowVal >= 85 ? 'yellow' : 'green');
                    if (!!this.answersRisks.hdl.value) this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', this.answersRisks.hdl.risk);
                    if (!!this.answersRisks.ldl.value) this.addIcon('Triglicerídeos', this.answersRisks.tri.value, 'tri', this.answersRisks.tri.risk);
                    if (!!this.answersRisks.hba1c.value) this.addIcon('Hemoglobina Glicada (HbA1c)', this.answersRisks.hba1c.value, 'hemoglobin', this.result.hba1c >= 5.7 ? 'red' : 'green');
                    break;
                case 'muscular':
                    this.addIcon('IMC', this.answersRisks.imc.value, 'imc', this.answersRisks.imc.risk);
                    this.addIcon('Auto percepção da saúde', this.answersRisks.selfHealth.value, 'health', this.answersRisks.selfHealth.risk);
                    this.addIcon('Horas de sono', this.answersRisks.sleep.value, 'sleep', this.answersRisks.sleep.risk);
                    this.addIcon('Atividade física', this.answersRisks.activity.value, 'activity', this.answersRisks.activity.risk);
                    this.addIcon('Consumo de frutas e verduras', this.answersRisks.fruits.value, 'fruits', this.answersRisks.fruits.risk);
                    this.addIcon('Consumo de gordura animal', this.answersRisks.animal.value, 'animal', this.answersRisks.animal.risk);
                    this.addIcon('Bebida alcoolica', this.answersRisks.drink.value, 'drink', this.answersRisks.drink.risk);
                    this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', this.answersRisks.smoke.risk);
                    if (!!this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true, ["Lesões no fêmur ou joelho", "Hérnia de disco ou transtornos de discos intervertebrais", "Lesões no ombro", "Lesões no tornozelo e pé", "Tendinites", "Artrites", "Lesões no punho e mão"])) this.addIcon('Doenças autorreferidas', this.answersRisks.diseases.value, 'diseases', this.answersRisks.diseases.value);
                    break;
                case 'hipertensao':
                    this.addIcon('Pressão (Sistólica)', this.user.pressure_high, 'pressure', pressureHighVal >= 160 ? 'red' : pressureHighVal >= 130 ? 'yellow' : 'green');
                    this.addIcon('Pressão (Diastólica)', this.user.pressure_low, 'pressure', pressureLowVal >= 90 ? 'red' : pressureLowVal >= 85 ? 'yellow' : 'green');
                    this.addIcon('IMC', this.answersRisks.imc.value, 'imc', this.answersRisks.imc.realValue >= 25 ? 'red' : this.answersRisks.imc.realValue >= 18.5 ? 'green' : 'yellow', true);
                    this.addIcon('Atividade física', this.answersRisks.activity.value, 'activity', this.answersRisks.activity.value == 'Nenhuma vez por semana' ? 'red' : this.answersRisks.activity.value == 'Menos de três vezes por semana' ? 'yellow' : 'green', true);
                    this.addIcon('Consumo de frutas e verduras', this.answersRisks.fruits.value, 'fruits', this.answersRisks.fruits.value == 'Nenhuma porção' ? 'red' : this.answersRisks.fruits.value == 'Uma porção' ? 'yellow' : 'green', true);
                    this.addIcon('Consumo de gordura animal', this.answersRisks.animal.value, 'animal', this.answersRisks.animal.value == 'Quase sempre' ? 'red' : this.answersRisks.animal.value == 'Moderadamente' ? 'yellow' : 'green', true);
                    this.addIcon('Bebida alcoolica', this.answersRisks.drink.value, 'drink', this.answersRisks.drink.value == 'Sete ou mais doses por semana' ? 'red' : this.answersRisks.drink.value == 'Três a seis doses por semana' ? 'yellow' : 'green', true);
                    this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', this.answersRisks.smoke.value == 'Sim' ? 'red' : this.answersRisks.smoke.value == 'Parei há um ano' ? 'yellow' : 'green', true);
                    if (cronicaHip) this.addIcon('Histórico Familiar Doença Crônica', 'Hipertensão', 'family', 'red', true);
                    this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', this.answersRisks.diabetes.value == 'Não' ? 'green' : this.answersRisks.diabetes.value == 'Sim, controlada' ? 'yellow' : 'red', true);
                    if (!!this.answersRisks.hdl.value) this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', this.answersRisks.hdl.risk, true);
                    if (!!this.answersRisks.ldl.value) this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'hdl', this.answersRisks.ldl.risk, true);
                    if (!!this.answersRisks.hba1c.value) this.addIcon('Hemoglobina Glicada (HbA1c)', this.answersRisks.hba1c.value, 'hemoglobin', this.result.hba1c >= 5.7 ? 'red' : 'green', true);
                    break;
                case 'diabetes':
                    this.addIcon('Sexo biológico', this.user.gender, 'gender', this.user.gender == 'Masculino' ? 'yellow' : 'green');
                    this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 50 ? 'red' : this.customer.age >= 40 ? 'yellow' : 'green');
                    this.addIcon('IMC', this.answersRisks.imc.value, 'imc', this.answersRisks.imc.realValue >= 35 ? 'red' : this.answersRisks.imc.realValue >= 30 ? 'yellow' : 'green');
                    this.addIcon('Atividade física', this.answersRisks.activity.value, 'activity', this.answersRisks.activity.value == 'Nenhuma vez por semana' ? 'yellow' : 'green');
                    if (cronicaDiab) this.addIcon('Histórico Familiar Doença Crônica', 'Diabetes', 'family', 'yellow');
                    if (!!hipertMed) this.addIcon('Remédio para Hipertensão', hipertMed.option.label, 'hypertension', 'yellow');else if (!!hipert) this.addIcon('Hipertensão', hipert.option.label, 'hypertension', 'green');
                    this.addIcon('Hemoglobina Glicada (HbA1c)', this.answersRisks.hba1c.value, 'hemoglobin', this.result.hba1c >= 5.7 ? 'red' : 'green');
                    break;
                case 'osteoporose':
                    this.addIcon('IMC', this.answersRisks.imc.value, 'imc', this.answersRisks.imc.risk);
                    this.addIcon('Atividade física', this.answersRisks.activity.value, 'activity', this.answersRisks.activity.risk);
                    this.addIcon('Consumo de frutas e verduras', this.answersRisks.fruits.value, 'fruits', this.answersRisks.fruits.risk);
                    this.addIcon('Consumo de gordura animal', this.answersRisks.animal.value, 'animal', this.answersRisks.animal.risk);
                    this.addIcon('Bebida alcoolica', this.answersRisks.drink.value, 'drink', this.answersRisks.drink.risk);
                    this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', this.answersRisks.smoke.risk);
                    if (this.answerSearch("Você é portador de quais doenças ou condições abaixo?") == 'Dependência a álcool ou drogas') this.addIcon('Doenças autorreferidas', this.answersRisks.diseases.value, 'diseases', this.answersRisks.diseases.value);
                    break;
                case 'renal':
                    this.addIcon('IMC', this.answersRisks.imc.value, 'imc', this.answersRisks.imc.risk);
                    this.addIcon('Creatinina', this.answersRisks.creatinine.value, 'creatinina', this.answersRisks.creatinine.risk);
                    this.addIcon('Filtração Glomerular Estimada', this.answersRisks.tfg.value, 'tfg', this.answersRisks.tfg.risk);
                    this.addIcon('Hemoglobina Glicada (HbA1c)', this.answersRisks.hba1c.value, 'hemoglobin', this.result.hba1c >= 5.7 ? 'red' : 'green');
                    this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', this.answersRisks.smoke.risk);
                    if (cronicaRenal) this.addIcon('Histórico Familiar Doença Crônica', 'Renal', 'family', 'yellow');
                    this.addIcon('Doença do Coração', this.answersRisks.heartDisease.value, 'heart_disease', this.answersRisks.heartDisease.value == 'Sim' ? 'yellow' : 'green');
                    this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', this.answersRisks.diabetes.value == 'Não' ? 'green' : 'red');
                    if (!!hipertMed) this.addIcon('Remédio para Hipertensão', hipertMed.option.label, 'hypertension', hipertMed.option.label == 'Sim' ? 'red' : 'yellow');else if (!!hipert) this.addIcon('Hipertensão', hipert.option.label, 'hypertension', 'green');
                    break;
                default:
                    break;
            }
        },
        addIcon: function addIcon(title, answer, icon, risk) {
            var isSec = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

            if (!isSec) this.icons.push({
                title: title,
                answer: answer,
                icon: icon,
                risk: risk
            });else this.iconsSec.push({
                title: title,
                answer: answer,
                icon: icon,
                risk: risk
            });
        },
        getIcon: function getIcon(icon, color) {
            var iconColor = '';
            switch (color) {
                case 'red':
                    iconColor = 'r';
                    break;
                case 'yellow':
                    iconColor = 'y';
                    break;
                case 'green':
                    iconColor = 'g';
                    break;
                default:
                    iconColor = 'g';
                    break;
            }
            return icon + '_' + iconColor;
        },
        getRiskColor: function getRiskColor(risk) {
            switch (risk) {
                case 'Baixo':
                case 'Médio baixo':
                case 'Não detectado':
                    return 'green';
                case 'Médio':
                case 'Médio alto':
                    return 'yellow';
                case 'Alto':
                case 'Detectado':
                    return 'red';
                default:
                    return '';
            }
        },
        answerSearch: function answerSearch(field) {
            var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var answers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

            var ans = null;
            if (multiple) {
                if (answers.length > 0) {
                    ans = this.answers.filter(function (a) {
                        return a.field.title == field && answers.includes(a.option.value);
                    }).map(function (a) {
                        return a.option.value;
                    });
                    return ans.join(', ');
                } else {
                    ans = this.answers.filter(function (a) {
                        return a.field.title == field;
                    }).map(function (a) {
                        return a.option.value;
                    });
                    return ans;
                }
            } else {
                this.answers.map(function (answer) {
                    if (answer.field.title == field && !multiple) ans = answer.response !== null ? answer.response : answer.option.label;
                });
            }
            return ans;
        },
        fieldAnswerSearch: function fieldAnswerSearch(field, option) {
            var ans = 'Não';
            this.answers.map(function (answer) {
                if (answer.field.title == field && answer.option.label == option) {
                    ans = 'Sim';
                }
            });
            return ans;
        }
    },
    mounted: function mounted() {
        console.log('results', this.result);
        this.loadRisks();
        this.loadUser();
        this.loadIcons();
    }
});

/***/ }),
/* 370 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/KitRisksDetails/DetailText.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        risk: String
    }
});

/***/ }),
/* 371 */
/*!***************************************************!*\
  !*** ./src/assets/images/risks/avatar_riscos.png ***!
  \***************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/avatar_riscos.1828a379.png";

/***/ }),
/* 372 */
/*!*****************************************!*\
  !*** ./src/assets/images/risks/b_g.png ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/b_g.46b0617f.png";

/***/ }),
/* 373 */
/*!*****************************************!*\
  !*** ./src/assets/images/risks/b_r.png ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/b_r.73ec6803.png";

/***/ }),
/* 374 */
/*!*****************************************!*\
  !*** ./src/assets/images/risks/b_y.png ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/b_y.daccdb6e.png";

/***/ }),
/* 375 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RiskAvatar/RiskAvatar.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "risk-avatar",
    components: {},
    props: {
        kitTypeId: Number,
        currentRisk: Number,
        customer: Object,
        answers: Array,
        showHead: Boolean,
        showTorso: Boolean,
        showAbdomen: Boolean,
        showPelvis: Boolean,
        showLeg: Boolean,
        showOut: Boolean
    },
    data: function data() {
        return {
            kitType: null,
            user: {
                age: null,
                pressure_high: null,
                pressure_low: null,
                circunference: null,
                gender: null
            }
        };
    },

    watch: {
        currentRisk: function currentRisk(newRisk, oldRisk) {
            // let details = this.$refs.details
            // if(newRisk != 0 && oldRisk == 0) { details.classList.remove("open"); details.classList.add("closee"); }
            // if(newRisk == 0 && oldRisk != 0) { details.classList.remove("closee"); details.classList.add("open"); }
        }
    },
    methods: {
        loadUser: function loadUser() {
            this.user.age = this.customer.age;
            this.user.pressure_high = this.answerSearch("Sistólica (alta):");
            this.user.pressure_low = this.answerSearch("Diastólica (baixa):");
            this.user.circunference = this.answerSearch("Circunferência abdominal (centímetros)");
            this.user.gender = this.customer.gender == 'M' ? 'Masculino' : 'Feminino';
        },
        answerSearch: function answerSearch(field) {
            var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var answers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

            var ans = null;
            if (multiple) {
                if (answers.length > 0) {
                    ans = this.answers.filter(function (a) {
                        return a.field.title == field && answers.includes(a.option.value);
                    }).map(function (a) {
                        return a.option.value;
                    });
                    return ans.join(', ');
                } else {
                    ans = this.answers.filter(function (a) {
                        return a.field.title == field;
                    }).map(function (a) {
                        return a.option.value;
                    });
                    return ans;
                }
            } else {
                this.answers.map(function (answer) {
                    if (answer.field.title == field && !multiple) ans = answer.response !== null ? answer.response : answer.option.label;
                });
            }
            return ans;
        }
    },
    mounted: function mounted() {
        this.loadUser();
    }
});

/***/ }),
/* 376 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RisksCard/RisksCard.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "risks-card",
  components: {},
  props: {
    diagnostics: Array,
    risks: Array,
    factors: Array
  },
  data: function data() {
    return {};
  },

  methods: {
    getRiskIcon: function getRiskIcon(label) {
      switch (label) {
        case 'Não detectado':
          return 'b_g';
        case 'Baixo':
          return 'b_g';
        case 'Médio baixo':
          return 'b_g';
        case 'Médio':
          return 'b_y';
        case 'Médio alto':
          return 'b_y';
        case 'Alto':
          return 'b_r';
        case 'Detectado':
          return 'b_r';
        default:
          return 'b_g';
      }
    },
    close: function close() {
      this.$emit('close');
    },
    outsideClick: function outsideClick() {
      var mobile = window.screen.width <= 910;
      if (mobile && event.target === event.currentTarget) this.$emit('close');
    }
  },
  mounted: function mounted() {
    console.log('>>', this.factors);
  }
});

/***/ }),
/* 377 */
/*!**********************************************!*\
  !*** ./src/components/KitPlans/KitPlans.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitPlans_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./KitPlans.vue */ 378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069a08e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitPlans_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-069a08e4","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./KitPlans.vue */ 791);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-069a08e4","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./KitPlans.vue */ 785)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-069a08e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitPlans_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069a08e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitPlans_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 378 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/KitPlans/KitPlans.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_kit__ = __webpack_require__(/*! ../../services/kit */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(/*! ./Modal */ 786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__["B" /* faQuestionCircle */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "kit-plans",
    components: { Modal: __WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* default */] },
    props: {
        result: Object
    },
    data: function data() {
        return {
            loading: false,
            metrics: null,
            fMetrics: [],
            formAnswers: [],
            riskModal: {},
            riskModalOpen: false,
            preventionExams: [],
            preventionSpecialists: [],
            hasHeartDisease: false,
            hasDiabetes: false,
            hasHypertension: false,
            hasAvc: false,
            hasDyslipidimia: false,
            hasMetabolic: false,
            hasOsteoporosis: false,
            modal: false,
            modalImg: null
        };
    },

    methods: {
        back: function back() {
            this.$emit('back');
        },
        loadKit: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(kit_id) {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.loading = true;
                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_kit__["a" /* GET_KIT_ANSWERS */])(kit_id);

                            case 4:
                                data = _context.sent;

                                this.metrics = data.metric;
                                this.formAnswers = data.field_answers;
                                this.formAnswers.filter(function (a) {
                                    return a.field.id == 'afaf2530-c963-4907-a519-9e2eef07bddc';
                                });
                                if (this.formAnswers.length > 0) {
                                    this.hasHeartDisease = this.answerSearch('Você é portador de alguma doença do coração?') == 'Sim' ? true : false;
                                    this.hasDiabetes = this.answerSearch('Você é portador de Diabetes?') == 'Sim, Descontrolada' || this.answerSearch('Você é portador de Diabetes?') == 'Sim, Controlada' ? true : false;
                                    this.hasHypertension = this.answerSearch('Você é portador de Hipertensão?') != 'Não' ? true : false;
                                    this.hasAvc = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes('avc') ? true : false;
                                    this.hasDyslipidimia = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes('dislipidemia') ? true : false;

                                    this.hasOsteoporosis = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes('Osteoporose') ? true : false;
                                }

                                _context.next = 14;
                                break;

                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context['catch'](0);

                                console.log(_context.t0);

                            case 14:
                                _context.prev = 14;

                                this.loading = false;
                                return _context.finish(14);

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 11, 14, 17]]);
            }));

            function loadKit(_x) {
                return _ref.apply(this, arguments);
            }

            return loadKit;
        }(),
        openModal: function openModal(img) {
            this.modalImg = img;
            return this.modal = true;
        },
        getUserExams: function getUserExams() {
            var userGender = this.result.customer.gender;
            var userAge = this.result.customer.age;
            if (userGender == 'M') {
                if (userAge >= 40) {
                    this.addPrevention('colesterol, triglicerídeos e glicose', '6', 'ex');
                    this.addPrevention('prostata', '12', 'ex');
                    this.addPrevention('ecocardiograma / raio-x do tórax e ultrasom do coração', '12', 'ex');
                    this.addPrevention('colonoscopia', '12', 'ex');
                } else {
                    this.addPrevention('colesterol, triglicerídeos e glicose', '12', 'ex');
                }
            } else if (userGender == 'F') {
                if (userAge >= 40) {
                    this.addPrevention('colesterol, triglicerídeos e glicose', '6', 'ex');
                    this.addPrevention('mamografia', '12', 'ex');
                    this.addPrevention('densiometria óssea', '24', 'ex');
                    this.addPrevention('papanicolau', '12', 'ex');
                    this.addPrevention('ecocardiograma / raio-x do tórax e ultrasom do coração', '12', 'ex');
                    this.addPrevention('colonoscopia', '12', 'ex');
                } else {
                    this.addPrevention('colesterol, triglicerídeos e glicose', '12', 'ex');
                    this.addPrevention('mamografia', '12', 'ex');
                    this.addPrevention('papanicolau', '12', 'ex');
                }
            }

            if (this.hasHeartDisease) {
                this.addPrevention('cardiologista', '6', 'es');
                this.addPrevention('nutricionista', '3', 'es');
            }
            if (this.hasDiabetes) {
                this.addPrevention('endocrinologista', '3', 'es');
                this.addPrevention('nutricionista', '3', 'es');
            }
            if (this.hasHypertension) {
                this.addPrevention('cardiologista', '3', 'es');
                this.addPrevention('nutricionista', '3', 'es');
            }
            if (this.hasAvc) {
                this.addPrevention('neurologista', '6', 'es');
                this.addPrevention('cardiologista', '6', 'es');
                this.addPrevention('nutricionista', '3', 'es');
            }
            if (this.hasDyslipidimia) {
                this.addPrevention('cardiologista', '6', 'es');
                this.addPrevention('endocrinologista', '6', 'es');
                this.addPrevention('nutricionista', '3', 'es');
            }
            if (this.hasMetabolic) {
                this.addPrevention('endocrinologista', '3 a 6', 'es');
                this.addPrevention('cardiologista', '3 a 6', 'es');
                this.addPrevention('nutricionista', '3', 'es');
            }
            if (this.hasOsteoporosis) {
                this.addPrevention('reumatologista', '3 a 6', 'es');
                this.addPrevention('ortopedista', '3 a 6', 'es');
                this.addPrevention('ginecologista', '12', 'es');
                this.addPrevention('nutricionista', '3', 'es');
            }

            if (!this.hasHeartDisease && !this.hasDiabetes && !this.hasHypertension && !this.hasAvc && !this.hasDyslipidimia && !this.hasMetabolic && !this.hasOsteoporosis) this.addPrevention('clinico geral', '12', 'es');
        },
        addPrevention: function addPrevention(prevention, period, type) {
            var _this = this;

            var insert = true;

            if (type == 'es') {
                this.preventionSpecialists.map(function (interval, x) {
                    interval.map(function (item, i) {
                        if (item == prevention) {
                            if (x <= period) {
                                insert = false;
                            } else {
                                _this.preventionSpecialists[x].splice(i, 1);
                            }
                        }
                    });
                });
                if (insert) {
                    this.preventionSpecialists[period].push(prevention);
                }
            }

            if (type == 'ex') {
                this.preventionExams.map(function (interval, x) {
                    interval.map(function (item, i) {
                        if (item == prevention) {
                            if (x <= period) {
                                insert = false;
                            } else {
                                _this.preventionExams[x].splice(i, 1);
                            }
                        }
                    });
                });
                if (insert) {
                    this.preventionExams[period].push(prevention);
                }
            }
        },
        answerSearch: function answerSearch(field) {
            var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var answers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

            var ans = null;
            if (multiple) {
                if (answers.length > 0) {
                    ans = this.formAnswers.filter(function (a) {
                        return a.field.title == field && answers.includes(a.option.value);
                    }).map(function (a) {
                        return a.option.value;
                    });
                    return ans.join(', ');
                } else {
                    ans = this.formAnswers.filter(function (a) {
                        return a.field.title == field;
                    }).map(function (a) {
                        return a.option.value;
                    });
                    return ans;
                }
            } else {
                this.formAnswers.map(function (answer) {
                    if (answer.field.title == field && !multiple) ans = answer.response !== null ? answer.response : answer.option.label;
                });
            }
            return ans;
        }
    },
    mounted: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return this.loadKit(this.result.id);

                        case 2:
                            this.$forceUpdate();

                            this.preventionExams['3'] = [];
                            this.preventionExams['6'] = [];
                            this.preventionExams['12'] = [];
                            this.preventionExams['24'] = [];
                            this.preventionSpecialists['3'] = [];
                            this.preventionSpecialists['6'] = [];
                            this.preventionSpecialists['12'] = [];
                            this.preventionSpecialists['24'] = [];
                            this.getUserExams();

                        case 12:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function mounted() {
            return _ref2.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),
/* 379 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/KitPlans/Modal.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "modal",
    props: ['title', 'img'],
    components: {},
    data: function data() {
        return {
            plural: false,
            metricList: []
        };
    },

    methods: {
        outsideClick: function outsideClick() {
            if (event.target === event.currentTarget) this.$emit('close');
        }
    }
});

/***/ }),
/* 380 */
/*!********************************************!*\
  !*** ./src/components/KitTips/KitTips.vue ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitTips_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./KitTips.vue */ 381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_280e45ce_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitTips_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-280e45ce","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./KitTips.vue */ 802);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-280e45ce","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./KitTips.vue */ 796)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-280e45ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitTips_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_280e45ce_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitTips_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 381 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/KitTips/KitTips.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReturnModal_ReturnModal__ = __webpack_require__(/*! ../ReturnModal/ReturnModal */ 797);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "kit-tips",
    components: { ReturnModal: __WEBPACK_IMPORTED_MODULE_0__ReturnModal_ReturnModal__["a" /* default */] },
    props: {
        result: Object
    },
    setup: function setup(props) {
        var result = props.result;
        return { result: result };
    },

    methods: {
        back: function back() {
            this.$emit('back');
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 382 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ReturnModal/ReturnModal.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_document__ = __webpack_require__(/*! ../../services/document */ 361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_2__fortawesome_free_solid_svg_icons__["o" /* faDownload */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        data: null
    },
    data: function data() {
        return {
            values: null,
            loading: false
        };
    },

    methods: {
        outsideClick: function outsideClick() {
            if (event.target === event.currentTarget) this.$emit('close');
        },
        getLink: function getLink(type) {
            var _this = this;

            this.loading = true;
            Object(__WEBPACK_IMPORTED_MODULE_0__services_document__["a" /* GET_DOCUMENT */])(this.data.kitId, type, type == 2 ? this.data.annexDocument : this.data.labDocument).then(function (res) {
                window.open(res.link, '_blank').focus();
            }).finally(function (res) {
                _this.loading = false;
            });
        }
    },
    mounted: function mounted() {
        console.log(this.data);
    }
});

/***/ }),
/* 383 */
/*!*******************************************!*\
  !*** ./src/assets/images/return/igg1.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/igg1.0efffc16.png";

/***/ }),
/* 384 */
/*!******************************************!*\
  !*** ./src/assets/images/return/qt1.png ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/qt1.f789eb16.png";

/***/ }),
/* 385 */
/*!*************************************************!*\
  !*** ./src/assets/images/alimentacao_saude.png ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/alimentacao_saude.736d9c78.png";

/***/ }),
/* 386 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/OrientationModal/OrientationModal.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    props: {
        shippingType: null
    },
    data: function data() {
        return {};
    },

    methods: {
        outsideClick: function outsideClick() {
            if (event.target === event.currentTarget) this.$emit('close');
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 387 */
/*!******************************************!*\
  !*** ./src/assets/images/correios_3.png ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/correios_3.6809d22a.png";

/***/ }),
/* 388 */
/*!******************************************!*\
  !*** ./src/assets/images/correios_2.png ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/correios_2.7b718de0.png";

/***/ }),
/* 389 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ScheduleModal/ScheduleModal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_schedule__ = __webpack_require__(/*! ../../services/schedule */ 135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_address__ = __webpack_require__(/*! ../../services/address */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(/*! vue2-datepicker */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css__ = __webpack_require__(/*! vue2-datepicker/index.css */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker_locale_pt_br__ = __webpack_require__(/*! vue2-datepicker/locale/pt-br */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_datepicker_locale_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(/*! moment */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    kit_id: null,
    kit_number: null
  },
  data: function data() {
    return {
      loading: false,
      loadingScreen: false,
      notFound: false,
      turns: false,
      form: {},
      errors: [],
      success: false
    };
  },

  methods: {
    outsideClick: function outsideClick() {
      if (event.target === event.currentTarget && !this.loadingScreen) this.$emit('close');
    },
    clearErrors: function clearErrors() {
      this.errors = [];
    },
    findAddress: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, response2;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.clearErrors();

                if (!(this.form.zip_code.length === 9)) {
                  _context.next = 25;
                  break;
                }

                this.notFound = false;
                this.loadingScreen = true;
                _context.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_address__["a" /* ADDRESS_FIND */])(this.form.zip_code);

              case 6:
                response = _context.sent;

                if (!(response && response.logradouro)) {
                  _context.next = 17;
                  break;
                }

                this.form.address = response.logradouro;
                this.form.city_name = response.localidade;
                this.form.neighbourhood = response.bairro;
                _context.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_address__["b" /* CITY_TIME */])(response.uf, response.localidade);

              case 13:
                response2 = _context.sent;

                if (response2) {
                  this.form.state_id = response2.state_id;
                  this.form.state_name = response2.state;
                  this.form.city_id = response2.city_id;
                  this.form.city_name = response2.city;
                  this.turns = response2.turns;
                }
                _context.next = 24;
                break;

              case 17:
                this.errors.zip_code = ["CEP não encontrado."];
                this.form.address = null;
                this.form.city_name = null;
                this.form.state_id = null;
                this.form.state_name = null;
                this.form.city_id = null;
                this.turns = null;

              case 24:
                this.loadingScreen = false;

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function findAddress() {
        return _ref.apply(this, arguments);
      }

      return findAddress;
    }(),
    handleOnScheduleChange: function handleOnScheduleChange(_ref2) {
      var value = _ref2.value;

      if (this.turns[value]) {
        this.form.schedule = this.turns[value];
        this.form.schedule_date = this.turns[value].full_date;
      } else {
        this.form.schedule = {};
      }
    },
    handleSubmit: function handleSubmit(event) {
      var _this = this;

      event.preventDefault();
      this.clearErrors();
      this.loading = true;
      var kit_number = this.kit_number;
      var form = Object.assign({ kit_number: kit_number }, this.form);
      Object(__WEBPACK_IMPORTED_MODULE_1__services_schedule__["b" /* POST_SCHEDULE */])(form).then(function (resp) {
        _this.$emit('updateKit', _this.kit_number);
        _this.success = true;
      }, function (error) {
        return _this.errors = error.response.data;
      }).then(function (resp) {
        _this.loading = false;
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 390 */
/*!**************************************************************!*\
  !*** ./src/assets/images/vector-fluxo-healthid-lab-moto.png ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/vector-fluxo-healthid-lab-moto.02c785d8.png";

/***/ }),
/* 391 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Results/Results.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_result__ = __webpack_require__(/*! ../../services/result */ 136);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            loading: false,
            loadingScreen: false,
            results: {}
        };
    },

    methods: {
        getResults: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.loadingScreen = true;
                                _context.prev = 1;
                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_result__["b" /* LIST_RESULTS */])();

                            case 4:
                                response = _context.sent;

                                if (response) {
                                    this.results = response;
                                }
                                _context.next = 10;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](1);

                            case 10:
                                _context.prev = 10;

                                this.loadingScreen = false;
                                return _context.finish(10);

                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 8, 10, 13]]);
            }));

            function getResults() {
                return _ref.apply(this, arguments);
            }

            return getResults;
        }(),
        getDate: function getDate(date) {
            date = new Date(date);
            date = this.aditionalZero(date.getDate()) + "/" + this.aditionalZero(date.getMonth() + 1) + "/" + date.getFullYear();
            return date;
        },
        aditionalZero: function aditionalZero(number) {
            if (number <= 9) return "0" + number;else return number;
        }
    },
    mounted: function mounted() {
        this.getResults();
    }
});

/***/ }),
/* 392 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Returns/Returns.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_result__ = __webpack_require__(/*! ../../services/result */ 136);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            loading: false,
            loadingScreen: false,
            results: {}
        };
    },

    methods: {
        getReturns: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.loadingScreen = true;
                                _context.prev = 1;
                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_result__["b" /* LIST_RESULTS */])();

                            case 4:
                                response = _context.sent;

                                if (response) {
                                    this.results = response;
                                }
                                _context.next = 10;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](1);

                            case 10:
                                _context.prev = 10;

                                this.loadingScreen = false;
                                return _context.finish(10);

                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 8, 10, 13]]);
            }));

            function getReturns() {
                return _ref.apply(this, arguments);
            }

            return getReturns;
        }(),
        getDate: function getDate(date) {
            date = new Date(date);
            date = this.aditionalZero(date.getDate()) + "/" + this.aditionalZero(date.getMonth() + 1) + "/" + date.getFullYear();
            return date;
        },
        aditionalZero: function aditionalZero(number) {
            if (number <= 9) return "0" + number;else return number;
        }
    },
    mounted: function mounted() {
        this.getReturns();
    }
});

/***/ }),
/* 393 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Schedules/Schedules.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_schedule__ = __webpack_require__(/*! ../../services/schedule */ 135);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            loading: false,
            loadingScreen: false,
            schedules: {}
        };
    },

    methods: {
        getSchedules: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.loadingScreen = true;
                                _context.prev = 1;
                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_schedule__["a" /* LIST_SCHEDULES */])();

                            case 4:
                                response = _context.sent;

                                if (response) {
                                    this.schedules = response;
                                }
                                _context.next = 10;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context['catch'](1);

                            case 10:
                                _context.prev = 10;

                                this.loadingScreen = false;
                                return _context.finish(10);

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 8, 10, 13]]);
            }));

            function getSchedules() {
                return _ref.apply(this, arguments);
            }

            return getSchedules;
        }()
    },
    mounted: function mounted() {
        this.getSchedules();
    }
});

/***/ }),
/* 394 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/HealthIdDigital/HealthIdDigital.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_customer__ = __webpack_require__(/*! ../../services/customer */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_kit__ = __webpack_require__(/*! ../../services/kit */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CardHealthId_CardHealthId__ = __webpack_require__(/*! ../../components/CardHealthId/CardHealthId */ 395);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: { CardHealthId: __WEBPACK_IMPORTED_MODULE_3__components_CardHealthId_CardHealthId__["a" /* default */] },
    data: function data() {
        return {
            loadingScreen: true,
            values: {}
        };
    },

    methods: {
        getData: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response, risks, answers;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["a" /* GET_CUSTOMER */])();

                            case 3:
                                response = _context.sent;

                                this.values = response;

                                _context.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["c" /* GET_CUSTOMER_RISKS */])();

                            case 7:
                                risks = _context.sent;

                                this.values.risks = risks;

                                _context.next = 11;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__services_kit__["b" /* LAST_ANSWERS */])();

                            case 11:
                                answers = _context.sent;

                                if (answers.data && answers.data.field_answers) this.getAnswers(answers.data.field_answers);
                                _context.next = 18;
                                break;

                            case 15:
                                _context.prev = 15;
                                _context.t0 = _context['catch'](0);

                                console.log(_context.t0);

                            case 18:
                                _context.prev = 18;

                                this.loadingScreen = false;
                                return _context.finish(18);

                            case 21:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 15, 18, 21]]);
            }));

            function getData() {
                return _ref.apply(this, arguments);
            }

            return getData;
        }(),
        getAnswers: function getAnswers(answers) {
            var height = null;
            var weight = null;
            answers.map(function (answer) {
                if (answer.field.type == 'imc') {
                    weight = answer.response.weigth;
                    height = answer.response.heigth;
                }
            });
            this.values.customer.height = height;
            this.values.customer.weight = weight;
        }
    },
    mounted: function mounted() {
        this.getData();
    }
});

/***/ }),
/* 395 */
/*!******************************************************!*\
  !*** ./src/components/CardHealthId/CardHealthId.vue ***!
  \******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CardHealthId_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CardHealthId.vue */ 396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5e05426_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardHealthId_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-d5e05426","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CardHealthId.vue */ 854);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-d5e05426","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CardHealthId.vue */ 834)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5e05426"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CardHealthId_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5e05426_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardHealthId_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 396 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardHealthId/CardHealthId.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_customer__ = __webpack_require__(/*! ../../services/customer */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditModal_vue__ = __webpack_require__(/*! ./EditModal.vue */ 835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__["p" /* faEdit */]);
__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__["G" /* faTint */]);
__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__["z" /* faPenSquare */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['data'],
    name: "card-health-id",
    components: { EditModal: __WEBPACK_IMPORTED_MODULE_2__EditModal_vue__["a" /* default */] },
    data: function data() {
        return {
            loadingScreen: false,
            modalField: 0,
            modal: false,
            customer: {},
            answers: [],
            risks: [],
            diagnostics: [],
            factors: [],
            informedDiseases: [],
            profile_picture: null,
            remote_picture: null,
            birth_date: '',
            imc: null,
            last_kit_id: null
        };
    },

    methods: {
        openEditModal: function openEditModal(open, field) {
            this.modalField = field;
            this.modal = open;
        },
        getProfilePhoto: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["e" /* GET_PROFILE_PICTURE */])();

                            case 2:
                                this.remote_picture = _context.sent;

                                if (this.remote_picture != null) {
                                    this.profile_picture = this.remote_picture;
                                }

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getProfilePhoto() {
                return _ref.apply(this, arguments);
            }

            return getProfilePhoto;
        }(),
        getDate: function getDate(date) {
            var newDate = new Date(date);
            newDate = newDate.getDate() + '/' + this.aditionalZero(newDate.getMonth() + 1) + '/' + newDate.getFullYear();
            return newDate;
        },
        getBirthdate: function getBirthdate() {
            var date = new Date(this.customer.birth_date);
            date = this.aditionalZero(date.getDate()) + '/' + this.aditionalZero(date.getMonth() + 1) + '/' + date.getFullYear();
            this.birth_date = date;
        },
        aditionalZero: function aditionalZero(number) {
            if (number <= 9) return "0" + number;else return number;
        },
        getEthnicity: function getEthnicity() {
            var ethnicity = '';
            switch (this.customer.ethnicity) {
                case 'A':
                    ethnicity = 'Amarelo';
                    break;
                case 'B':
                    ethnicity = 'Branco';
                    break;
                case 'I':
                    ethnicity = 'Indígena';
                    break;
                case 'M':
                    ethnicity = 'Mestiço';
                    break;
                case 'N':
                    ethnicity = 'Negro';
                    break;
                case 'P':
                    ethnicity = 'Pardo';
                    break;
                default:
                    ethnicity = 'Amarelo';
                    break;
            }
            return ethnicity;
        },
        getMetrics: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _this = this;

                var data;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["c" /* GET_CUSTOMER_RISKS */])();

                            case 2:
                                data = _context2.sent;

                                data.map(function (item) {
                                    var item_label = item.label + ' ' + item.risk_name.replace('Risco', ' ');
                                    item_label = item_label.replace('detectado', 'detectado - ');
                                    var item_level = void 0;
                                    switch (item.label) {
                                        case 'Alto':
                                            item_level = 'high';
                                            break;
                                        case 'Médio':
                                        case 'Médio alto':
                                            item_level = 'medium';
                                            break;
                                        case 'Baixo':
                                        case 'Médio baixo':
                                            item_level = 'low';
                                            break;
                                        case 'Não detectado':
                                            item_level = 'low';
                                            break;
                                        case 'Detectado':
                                            item_level = 'high';
                                            break;
                                        default:
                                            item_level = 'undefined';
                                            break;
                                    }
                                    if (item.risk_name.startsWith('Risco de desenvolver') || item.risk_name.startsWith('Risco de sofrer') || item.risk_name.startsWith('Risco de Lesão')) {
                                        var name = 'Fatores Preliminares para Desenvolver ' + item.risk_name.replace('Risco de desenvolver', '').replace('Risco de sofrer', '').replace('Risco de', '') + ' - ' + item.label;
                                        _this.factors.push({ label: name, level: item_level, date: item.metrification_date });
                                    } else if (item.risk_name.startsWith("Diagnóstico Preliminar") || item.risk_name.startsWith("Diagnostico Preliminar")) {
                                        _this.diagnostics.push({ label: item_label, level: item_level, date: item.metrification_date });
                                    } else {
                                        _this.risks.push({ label: 'Risco ' + item_label, level: item_level, date: item.metrification_date });
                                    }
                                });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getMetrics() {
                return _ref2.apply(this, arguments);
            }

            return getMetrics;
        }(),
        getAnswers: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["b" /* GET_CUSTOMER_ANSWERS */])();

                            case 2:
                                data = _context3.sent;

                                this.responseAnswers = data.answers;
                                this.responseResult = data.last_result;
                                data.answers.imc ? this.answers.imc = data.answers.imc : '--';
                                data.answers['Você fuma?'] ? this.answers.fumante = data.answers['Você fuma?'] : '--';
                                data.answers['Sistólica (alta):'] ? this.answers.sistolica = data.answers['Sistólica (alta):'] : '--';
                                data.answers['Diastolica (baixa):'] ? this.answers.diastolica = data.answers['Diastolica (baixa):'] : '--';
                                data.answers['Diastólica (baixa):'] ? this.answers.diastolica = data.answers['Diastólica (baixa):'] : '--';
                                data.answers['Já tomou a vacina?'] ? this.answers.vaccine = data.answers['Já tomou a vacina?'] : 'Não informado';
                                data.answers['Você possui plano de saúde?'] ? this.answers.health_plan = data.answers['Qual?'] : 'Não informado';
                                data.answers['Você é portador de alguma doença do coração?'] == 'Sim' ? this.informedDiseases.push('Doença do coração') : null;
                                data.answers['Você é portador de Diabetes?'] == 'Sim' ? this.informedDiseases.push('Diabetes') : null;
                                data.answers['Você é portador de Hipertensão?'] == 'Sim' ? this.informedDiseases.push('Hipertensão') : false;
                                data.answers['Você é portador de quais doenças ou condições abaixo?'].includes('avc') ? this.informedDiseases.push('Avc') : false;
                                data.answers['Você é portador de quais doenças ou condições abaixo?'].includes('dislipidemia') ? this.informedDiseases.push('Dislipidemia') : false;
                                data.answers['Você é portador de quais doenças ou condições abaixo?'].includes('Osteoporose') ? this.informedDiseases.push('Osteoporose') : false;
                                this.answers.imc ? this.imc = JSON.parse(this.answers.imc) : null;

                            case 19:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function getAnswers() {
                return _ref3.apply(this, arguments);
            }

            return getAnswers;
        }(),
        updateCustomer: function updateCustomer(newCustomer) {

            this.customer = newCustomer;
            this.getProfilePhoto();
            this.$forceUpdate();
        },
        printFile: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;

                                this.loadingScreen = true;
                                _context4.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["d" /* GET_HEALTHID_DIGITAL */])();

                            case 4:
                                data = _context4.sent;

                                if (data.url) window.open(data.url);

                                _context4.next = 11;
                                break;

                            case 8:
                                _context4.prev = 8;
                                _context4.t0 = _context4['catch'](0);

                                console.log(_context4.t0);

                            case 11:
                                _context4.prev = 11;

                                this.loadingScreen = false;
                                return _context4.finish(11);

                            case 14:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[0, 8, 11, 14]]);
            }));

            function printFile() {
                return _ref4.apply(this, arguments);
            }

            return printFile;
        }()
    },
    mounted: function mounted() {
        var _this2 = this;

        this.customer = this.data.customer;

        this.getAnswers().then(function (r) {
            _this2.getMetrics();
        });
        this.getProfilePhoto();
        this.getBirthdate();
    }
});

/***/ }),
/* 397 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardHealthId/EditModal.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditAllergies__ = __webpack_require__(/*! ./EditAllergies */ 837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditBloodType__ = __webpack_require__(/*! ./EditBloodType */ 840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditEmergencyContact__ = __webpack_require__(/*! ./EditEmergencyContact */ 843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditHealthInsurance__ = __webpack_require__(/*! ./EditHealthInsurance */ 846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditPicture_vue__ = __webpack_require__(/*! ./EditPicture.vue */ 849);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['values', 'field'],
  name: "edit-modal",
  components: { EditAllergies: __WEBPACK_IMPORTED_MODULE_0__EditAllergies__["a" /* default */], EditBloodType: __WEBPACK_IMPORTED_MODULE_1__EditBloodType__["a" /* default */], EditEmergencyContact: __WEBPACK_IMPORTED_MODULE_2__EditEmergencyContact__["a" /* default */], EditHealthInsurance: __WEBPACK_IMPORTED_MODULE_3__EditHealthInsurance__["a" /* default */], EditPicture: __WEBPACK_IMPORTED_MODULE_4__EditPicture_vue__["a" /* default */] },
  data: function data() {
    return {
      isMounted: false,
      loading: false,
      loadingScreen: false,
      customer: {},
      titles: ['Editar Alergias', 'Editar Tipo sanguíneo', 'Editar contato de emergência', 'Editar plano de saúde']
    };
  },

  methods: {
    outsideClick: function outsideClick() {
      if (event.target === event.currentTarget) this.$emit('close');
    },
    getTitle: function getTitle() {
      return this.titles[this.field];
    },
    setLoadingScreen: function setLoadingScreen(val) {
      this.loadingScreen = val;
    },
    updateCustomer: function updateCustomer(newCustomer) {
      this.$emit('updateCustomer', newCustomer);
      this.$emit('close');
    }
  },
  mounted: function mounted() {
    this.customer = this.values;
    this.isMounted = true;
  }
});

/***/ }),
/* 398 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardHealthId/EditAllergies.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_customer__ = __webpack_require__(/*! ../../services/customer */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__["H" /* faTrashAlt */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['values'],
  name: "edit-allergies",
  data: function data() {
    return {
      loading: false,
      loadingScreen: false,
      customer: {},
      allergies: [''],
      errors: []
    };
  },

  methods: {
    outsideClick: function outsideClick() {
      if (event.target === event.currentTarget) this.$emit('close');
    },
    getCustomer: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit('setLoadingScreen', true);

                _context.prev = 1;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["a" /* GET_CUSTOMER */])();

              case 4:
                data = _context.sent;

                this.customer = data.customer;

                if (this.customer.health_information != null && this.customer.health_information.allergies) this.allergies = this.customer.health_information.allergies;

                if (this.allergies.length == 0) this.allergies = [''];

                if (this.customer.health_information == null) {
                  this.customer.health_information = {};
                  this.customer.health_information.allergies = [''];
                } else if (this.customer.health_information && !this.customer.health_information.allergies) {
                  this.customer.health_information.allergies = [''];
                }
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);

              case 14:
                _context.prev = 14;

                this.$emit('setLoadingScreen', false);
                return _context.finish(14);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 11, 14, 17]]);
      }));

      function getCustomer() {
        return _ref.apply(this, arguments);
      }

      return getCustomer;
    }(),
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.loading = true;
      var validate = this.verifyErrors();

      if (!validate) {
        this.loading = false;
        return false;
      }

      if (this.customer.health_information == null) {
        this.customer.health_information = { allergies: this.allergies };
      } else {
        this.customer.health_information.allergies = this.allergies;
      }

      var date = new Date(this.customer.birth_date);
      this.customer.birth_date = date.getFullYear() + '-' + this.aditionalZero(date.getMonth() + 1) + '-' + this.aditionalZero(date.getDate());
      this.customer.profile_picture = null;

      Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["f" /* POST_CUSTOMER */])(this.customer).then(function (resp) {
        _this.loading = false, _this.$emit('updateCustomer', _this.customer);
      });
    },
    aditionalZero: function aditionalZero(number) {
      if (number <= 9) return "0" + number;else return number;
    },
    verifyErrors: function verifyErrors() {
      var _this2 = this;

      var validate = true;
      this.errors = [];
      this.allergies.map(function (allergy, x) {
        if (allergy == '' || allergy == null) {
          _this2.errors[x] = 'Preencha o campo com sua alergia';
          validate = false;
        }
      });
      return validate;
    },
    addAllergy: function addAllergy() {
      this.allergies.push('');
    },
    reomveAllergy: function reomveAllergy(x) {
      this.allergies.splice(x, 1);
    }
  },
  mounted: function mounted() {
    this.getCustomer();
  }
});

/***/ }),
/* 399 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardHealthId/EditBloodType.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_customer__ = __webpack_require__(/*! ../../services/customer */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(/*! moment */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['values'],
  name: "edit-blood-type",
  data: function data() {
    return {
      loading: false,
      loadingScreen: false,
      customer: {},
      errors: ''
    };
  },

  methods: {
    outsideClick: function outsideClick() {
      if (event.target === event.currentTarget) this.$emit('close');
    },
    getCustomer: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit('setLoadingScreen', true);

                _context.prev = 1;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["a" /* GET_CUSTOMER */])();

              case 4:
                data = _context.sent;

                this.customer = data.customer;
                if (this.customer.health_information == null) {
                  this.customer.health_information = {};
                  this.customer.health_information.blood_type = '';
                } else if (this.customer.health_information != null && !this.customer.health_information.blood_type) {
                  this.customer.health_information.blood_type = '';
                }
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);

              case 12:
                _context.prev = 12;

                this.$emit('setLoadingScreen', false);
                return _context.finish(12);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9, 12, 15]]);
      }));

      function getCustomer() {
        return _ref.apply(this, arguments);
      }

      return getCustomer;
    }(),
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.loading = true;
      var validate = this.verifyErrors();

      if (!validate) {
        this.loading = false;
        return false;
      }

      var date = new Date(this.customer.birth_date);
      this.customer.birth_date = date.getFullYear() + '-' + this.aditionalZero(date.getMonth() + 1) + '-' + this.aditionalZero(date.getDate());
      this.customer.profile_picture = null;

      Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["f" /* POST_CUSTOMER */])(this.customer).then(function (resp) {
        _this.loading = false, _this.$emit('updateCustomer', _this.customer);
      });
    },
    aditionalZero: function aditionalZero(number) {
      if (number <= 9) return "0" + number;else return number;
    },
    verifyErrors: function verifyErrors() {
      var validate = true;
      this.errors = '';

      if (this.customer.health_information.blood_type == '') {
        this.errors = 'Escolha seu tipo sanguíneo';
        validate = false;
      }

      return validate;
    }
  },
  mounted: function mounted() {
    this.getCustomer();
  }
});

/***/ }),
/* 400 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardHealthId/EditEmergencyContact.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_customer__ = __webpack_require__(/*! ../../services/customer */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(/*! moment */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['values'],
  name: "edit-emergency-contact",
  data: function data() {
    return {
      loading: false,
      loadingScreen: false,
      customer: {},
      errors: {}
    };
  },

  methods: {
    outsideClick: function outsideClick() {
      if (event.target === event.currentTarget) this.$emit('close');
    },
    getCustomer: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit('setLoadingScreen', true);

                _context.prev = 1;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["a" /* GET_CUSTOMER */])();

              case 4:
                data = _context.sent;

                this.customer = data.customer;
                if (this.customer.emergency_contact == null) {
                  this.customer.emergency_contact = {
                    name: '',
                    phone: ''
                  };
                }
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);

              case 12:
                _context.prev = 12;

                this.$emit('setLoadingScreen', false);
                return _context.finish(12);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9, 12, 15]]);
      }));

      function getCustomer() {
        return _ref.apply(this, arguments);
      }

      return getCustomer;
    }(),
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.loading = true;
      var validate = this.verifyErrors();

      if (!validate) {
        this.loading = false;
        return false;
      }

      var date = new Date(this.customer.birth_date);
      this.customer.birth_date = date.getFullYear() + '-' + this.aditionalZero(date.getMonth() + 1) + '-' + this.aditionalZero(date.getDate());
      this.customer.profile_picture = null;

      Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["f" /* POST_CUSTOMER */])(this.customer).then(function (resp) {
        _this.loading = false, _this.$emit('updateCustomer', _this.customer);
      });
    },
    aditionalZero: function aditionalZero(number) {
      if (number <= 9) return "0" + number;else return number;
    },
    verifyErrors: function verifyErrors() {
      var validate = true;
      this.errors = {};

      if (this.customer.emergency_contact.name == '') {
        this.errors.name = 'Preencha o nome do contato';
        validate = false;
      }

      if (this.customer.emergency_contact.phone == '') {
        this.errors.phone = 'Preencha o telefone do contato';
        validate = false;
      }

      return validate;
    }
  },
  mounted: function mounted() {
    this.getCustomer();
  }
});

/***/ }),
/* 401 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardHealthId/EditHealthInsurance.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_customer__ = __webpack_require__(/*! ../../services/customer */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(/*! moment */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['values'],
  name: "edit-health-insurance",
  data: function data() {
    return {
      loading: false,
      loadingScreen: false,
      customer: {},
      errors: ''
    };
  },

  methods: {
    outsideClick: function outsideClick() {
      if (event.target === event.currentTarget) this.$emit('close');
    },
    getCustomer: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit('setLoadingScreen', true);

                _context.prev = 1;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["a" /* GET_CUSTOMER */])();

              case 4:
                data = _context.sent;

                this.customer = data.customer;
                if (this.customer.health_information == null) {
                  this.customer.health_information = {};
                }
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);

              case 12:
                _context.prev = 12;

                this.$emit('setLoadingScreen', false);
                return _context.finish(12);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9, 12, 15]]);
      }));

      function getCustomer() {
        return _ref.apply(this, arguments);
      }

      return getCustomer;
    }(),
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.loading = true;
      var validate = this.verifyErrors();

      if (!validate) {
        this.loading = false;
        return false;
      }

      var date = new Date(this.customer.birth_date);
      this.customer.birth_date = date.getFullYear() + '-' + this.aditionalZero(date.getMonth() + 1) + '-' + this.aditionalZero(date.getDate());
      this.customer.profile_picture = null;

      Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["f" /* POST_CUSTOMER */])(this.customer).then(function (resp) {
        _this.loading = false, _this.$emit('updateCustomer', _this.customer);
      });
    },
    aditionalZero: function aditionalZero(number) {
      if (number <= 9) return "0" + number;else return number;
    },
    verifyErrors: function verifyErrors() {
      var validate = true;
      this.errors = '';

      if (this.customer.health_information.health_insurance == '') {
        this.errors = 'Preencha o nome do plano';
        validate = false;
      }

      return validate;
    }
  },
  mounted: function mounted() {
    this.getCustomer();
  }
});

/***/ }),
/* 402 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CardHealthId/EditPicture.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_customer__ = __webpack_require__(/*! ../../services/customer */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_image_upload_resize__ = __webpack_require__(/*! vue-image-upload-resize */ 851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_image_upload_resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_image_upload_resize__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__["H" /* faTrashAlt */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['values'],
  name: "edit-picture",
  components: { ImageUploader: __WEBPACK_IMPORTED_MODULE_4_vue_image_upload_resize___default.a },

  data: function data() {
    return {
      fileName: null,
      image: null,
      loading: false,
      loadingScreen: false,
      customer: {},
      errors: [],
      profile_picture: null,
      preview: null,
      dragging: false,
      hasImage: false,
      form: {
        name: "",
        email: "",
        birth_date: "",
        cpf: "",
        gender: null,
        ethnicity: null,
        cellphone: "",
        cep: "",
        uf: "",
        city: "",
        street: "",
        number: "",
        district: "",
        status: "",
        password: "",
        password_confirmation: "",
        first_acess: 0,
        profile_picture: null
      }

    };
  },

  methods: {
    setImage: function setImage(input) {
      this.image = input;
      this.fileName = document.getElementById("fileInput").files[0]['name'];
      this.hasImage = true;
      this.preview = URL.createObjectURL(this.image);
    },

    dropImage: function dropImage(input) {
      this.image = input.dataTransfer.files[0];
      this.fileName = this.image.name;
      this.hasImage = true;
      this.toggleActive();
      this.preview = URL.createObjectURL(this.image);
    },

    toggleActive: function toggleActive() {
      this.dragging = !this.dragging;
    },
    findInput: function findInput() {
      document.getElementById('fileInput').click();
    },
    outsideClick: function outsideClick() {
      if (event.target === event.currentTarget) this.$emit('close');
    },
    clean: function clean(obj) {
      for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
          delete obj[propName];
        }
      }
      return obj;
    },
    getCustomer: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit('setLoadingScreen', true);

                _context.prev = 1;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["a" /* GET_CUSTOMER */])();

              case 4:
                data = _context.sent;

                this.customer = data.customer;

                if (!!this.customer.profile_picture) {
                  this.profile_picture = this.customer.profile_picture;
                }

                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);

              case 12:
                _context.prev = 12;

                this.$emit('setLoadingScreen', false);
                return _context.finish(12);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9, 12, 15]]);
      }));

      function getCustomer() {
        return _ref.apply(this, arguments);
      }

      return getCustomer;
    }(),
    handleSubmit: function handleSubmit() {
      var _this = this;

      var form = new FormData();
      form.append('profile_picture', this.image, this.image.name);
      this.loading = true;
      Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["f" /* POST_CUSTOMER */])(form).then(function (r) {
        _this.loading = false;
        _this.errors = null;
        _this.getCustomer();
        _this.$emit('updateCustomer', _this.customer);
      }, function (err) {
        _this.errors = err.response.data;
        _this.loading = false;
      });
    }
  },

  mounted: function mounted() {
    this.getCustomer();
  }
});

/***/ }),
/* 403 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/RegisterKit/RegisterKit.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_kit__ = __webpack_require__(/*! ../../services/kit */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RegisterKitSteps_DataKitCustomer__ = __webpack_require__(/*! ../../components/RegisterKitSteps/DataKitCustomer */ 859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RegisterKitSteps_KitNumber__ = __webpack_require__(/*! ../../components/RegisterKitSteps/KitNumber */ 862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RegisterKitSteps_DataKitHealthCustomer__ = __webpack_require__(/*! ../../components/RegisterKitSteps/DataKitHealthCustomer */ 865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RegisterKitSteps_DataKitSchedule__ = __webpack_require__(/*! ../../components/RegisterKitSteps/DataKitSchedule */ 878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RegisterKitSteps_KitOrientation__ = __webpack_require__(/*! ../../components/RegisterKitSteps/KitOrientation */ 881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RegisterKitSteps_PrivacyPolicy__ = __webpack_require__(/*! ../../components/RegisterKitSteps/PrivacyPolicy */ 884);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
	name: "RegisterKit",
	components: { PrivacyPolicy: __WEBPACK_IMPORTED_MODULE_6__components_RegisterKitSteps_PrivacyPolicy__["a" /* default */], KitNumber: __WEBPACK_IMPORTED_MODULE_2__components_RegisterKitSteps_KitNumber__["a" /* default */], DataKitCustomer: __WEBPACK_IMPORTED_MODULE_1__components_RegisterKitSteps_DataKitCustomer__["a" /* default */], DataKitHealthCustomer: __WEBPACK_IMPORTED_MODULE_3__components_RegisterKitSteps_DataKitHealthCustomer__["a" /* default */], DataKitSchedule: __WEBPACK_IMPORTED_MODULE_4__components_RegisterKitSteps_DataKitSchedule__["a" /* default */], KitOrientation: __WEBPACK_IMPORTED_MODULE_5__components_RegisterKitSteps_KitOrientation__["a" /* default */] },
	data: function data() {
		return {
			loadingScreen: false,
			activeStep: 0,
			formSteps: [],
			totalFormSteps: 3,
			shipping_type: 0,
			scheduleActiveStep: false,
			currentFormStep: null,
			form: {},
			kit_id: null,
			kit_type: null,
			tag_type: null
		};
	},
	methods: {
		setFormSteps: function setFormSteps(steps) {
			this.formSteps = steps;
			this.totalFormSteps += steps.length + 1;
		},
		formNextStep: function formNextStep() {
			var to = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (to) this.activeStep += 1;else this.activeStep -= 1;
		},
		forceNextStep: function forceNextStep() {
			if (this.form.verified && this.activeStep === 0) {
				this.activeStep += 2;
			} else {
				this.activeStep += 1;
			}
		},
		nextStep: function nextStep(obj) {
			console.log("step ativo", this.activeStep);
			this.tag_type = obj.tag_type || "";

			var f = this.form;
			this.form = Object.assign({}, f, obj);
			if (this.activeStep <= 2) {
				this.activeStep += 1;
				this.handleSubmit();
				return;
			}

			if (this.shipping_type && this.shipping_type == 3) {
				this.activeStep += 1;
			} else if (this.form.verified && this.activeStep === 0) {
				this.activeStep += 2;
			} else {
				this.activeStep += 2;
			}
			console.log(this.activeStep);
			this.handleSubmit();
		},
		handleSubmit: function handleSubmit() {
			var _this = this;

			Object(__WEBPACK_IMPORTED_MODULE_0__services_kit__["d" /* POST_KIT */])(this.form).then(function (resp) {
				_this.kit_id = resp.data.id;
				_this.kit_type = resp.data.kit_type_id;
				_this.shipping_type = resp.data.order_owner.partner_place.partner.shipping_type || null;
			});
		},
		stepsResponsible: function stepsResponsible() {
			var width = window.screen.width;
			return width >= 490;
		}
	}
});

/***/ }),
/* 404 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RegisterKitSteps/DataKitCustomer.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['next'],
  name: "DataKitCustomer",
  data: function data() {
    return {
      loading: false,
      errors: [],
      form: {
        cpf: "",
        ethnicity: "",
        gender: "",
        name: ""
      }
    };
  },
  methods: {
    handleSubmit: function handleSubmit(event) {
      event.preventDefault();
      this.$emit('next', this.form);
    }
  }
});

/***/ }),
/* 405 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RegisterKitSteps/KitNumber.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_kit__ = __webpack_require__(/*! ../../services/kit */ 50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['next'],
  name: "KitNumber",
  data: function data() {
    return {
      loading: false,
      errors: [],
      form: {
        kit_number: "",
        verify: true,
        verified: false
      }
    };
  },
  methods: {
    clearErrors: function clearErrors() {
      this.errors = [];
    },
    handleSubmit: function handleSubmit(event) {
      var _this = this;

      event.preventDefault();
      this.clearErrors();
      this.loading = true;
      Object(__WEBPACK_IMPORTED_MODULE_0__services_kit__["e" /* POST_KIT_VALIDATE */])(this.form).then(function (resp) {
        console.log(resp);
        _this.form.verified = resp.data.step, _this.form.shipping_type = resp.data.shipping_type, _this.form.tag_type = resp.data.tag_type, _this.$emit('next', _this.form);
      }, function (error) {
        return _this.errors = error.response.data;
      }).then(function (resp) {
        console.log(_this.errors);
        _this.loading = false;
      });
    }
  },
  mounted: function mounted() {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var kit = url.searchParams.get("kit_number");
    if (kit && kit != '') this.form.kit_number = kit;
  }
});

/***/ }),
/* 406 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RegisterKitSteps/DataKitHealthCustomer.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_kit__ = __webpack_require__(/*! ../../services/kit */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_form__ = __webpack_require__(/*! ../../services/form */ 138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormSteps_FormSteps__ = __webpack_require__(/*! ../FormSteps/FormSteps */ 867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(/*! vue2-datepicker */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css__ = __webpack_require__(/*! vue2-datepicker/index.css */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker_locale_pt_br__ = __webpack_require__(/*! vue2-datepicker/locale/pt-br */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_datepicker_locale_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(/*! moment */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_6_moment___default()().format();

__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["k" /* faCheckCircle */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__["default"], FormSteps: __WEBPACK_IMPORTED_MODULE_2__FormSteps_FormSteps__["a" /* default */] },
    props: ['next', 'kit', 'kit_id', 'kit_type', 'step'],
    name: "DataKitHealthCustomer",
    data: function data() {
        return {
            urlKey: 'https://ipgeolocation.abstractapi.com/v1/?api_key=4e6fee071709484e9b7deb66863896a9',
            loading: false,
            errors: [],
            form: {
                kit_number: null,
                digi_sig: {
                    date: null,
                    data: null
                },
                birth_date: null,
                height: null,
                weight: null,
                diseases: null,
                had_covid: null,
                diagnosis_date: null,
                evolution: null,
                symptoms: {
                    fadiga: false,
                    dor_cronica: false,
                    fraqueza_muscular: false,
                    dificuldade_respirar: false,
                    deficits_cognitivos: false,
                    febre_alta: false,
                    manchas_pele: false,
                    indisposicao: false
                },
                vaccine: '',
                first_shot: null,
                second_shot: null,
                accept_terms: false
            }
        };
    },
    mounted: function mounted() {
        this.form.kit_number = this.kit;
    },

    methods: {
        ipGet: function ipGet(url) {
            var ret = null;
            var xmlHttp = new XMLHttpRequest();
            xmlHttp.onreadystatechange = function () {
                if (xmlHttp.readyState === 4 && xmlHttp.status === 200) ret = xmlHttp.responseText;
            };
            xmlHttp.open("GET", url, false);
            xmlHttp.send(null);
            return ret;
        },
        clearErrors: function clearErrors() {
            this.errors = [];
        },
        switchHadCovid: function switchHadCovid(value) {
            this.form.had_covid = value;
        },
        onlyNumbers: function onlyNumbers(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        setFormSteps: function setFormSteps(steps) {
            this.$emit('setFormSteps', steps);
        },
        formNextStep: function formNextStep() {
            var to = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.$emit('formNextStep', to);
        },
        sendAnswers: function sendAnswers(answers) {
            var _this = this;

            Object(__WEBPACK_IMPORTED_MODULE_1__services_form__["b" /* POST_FORM */])(this.kit_id, answers).then(function (resp) {
                _this.$emit('next', _this.form);
            });
        },
        handleSubmit: function handleSubmit(event) {
            var _this2 = this;

            event.preventDefault();
            this.clearErrors();
            if (this.form.accept_terms !== 1 && this.form.accept_terms !== true) {
                this.errors.accept_terms = ["Que Pena! Mas precisamos dessa concordância para realizar a análise da sua amostra. Quer concordar com o termo de consentimento?"];
                return false;
            }
            this.loading = true;

            this.form.digi_sig.date = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD hh:mm:ss');
            this.form.digi_sig.data = this.ipGet(this.urlKey);

            Object(__WEBPACK_IMPORTED_MODULE_0__services_kit__["e" /* POST_KIT_VALIDATE */])(this.form).then(function (resp) {
                _this2.$emit('next', _this2.form);
            }, function (error) {
                return _this2.errors = error.response.data;
            }).then(function (resp) {
                _this2.loading = false;
            });
        }
    }
});

/***/ }),
/* 407 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FormSteps/FormSteps.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(/*! moment */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_form__ = __webpack_require__(/*! ../../services/form */ 138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormBuilder_DisplayRulesFunctions__ = __webpack_require__(/*! ../FormBuilder/DisplayRulesFunctions */ 408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormBuilder_FormBuilder__ = __webpack_require__(/*! ../FormBuilder/FormBuilder */ 869);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    components: { FormBuilder: __WEBPACK_IMPORTED_MODULE_5__FormBuilder_FormBuilder__["a" /* default */] },
    props: ['kit_type'],
    name: "FormSteps",
    data: function data() {
        return {
            currentFormStep: 0,
            currentFormStepId: null,
            firstFormStep: null,
            lastFormStep: null,
            steps: [],
            answers: {},
            errors: {},
            loading: false,
            loadingScreen: true,
            accept_terms: true
        };
    },
    mounted: function mounted() {
        this.loadForm();
    },

    methods: {
        nextStep: function nextStep() {
            if (!this.validateStep(this.steps[this.currentFormStep].id)) return false;

            this.currentFormStep += 1;
            this.currentFormStepId = this.steps[this.currentFormStep].id;
            this.$emit('formNextStep');
            window.scrollTo(0, 0);
        },
        returnStep: function returnStep() {
            this.errors = [];
            this.currentFormStep -= 1;
            this.currentFormStepId = this.steps[this.currentFormStep].id;
            this.$emit('formNextStep', false);
            window.scrollTo(0, 0);
        },
        loadForm: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _this = this;

                var data;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__services_form__["a" /* GET_FORM */])(this.kit_type);

                            case 3:
                                data = _context.sent;

                                data.steps.map(function (step) {
                                    var auxForm = {};
                                    var mapFields = step.fields.map(function (field) {
                                        return auxForm[field.id] = field.type == "multiselect" ? [] : field.type == "imc" ? { heigth: '', weigth: '' } : field.type == "datetime" ? { date: "", time: "" } : "";
                                    });
                                    _this.answers[step.id] = auxForm;
                                });
                                this.steps = data.steps;
                                this.steps.forEach(function (step, x) {
                                    if (step.title == 'Riscos do exame CLC') _this.steps.splice(x, 1);
                                });
                                this.currentFormStepId = this.steps[0].id;
                                this.firstFormStep = this.currentFormStepId;
                                this.lastFormStep = this.steps[this.steps.length - 1].id;
                                this.$emit('setFormSteps', this.steps);
                                _context.next = 16;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](0);

                                console.log(_context.t0);

                            case 16:
                                _context.prev = 16;

                                this.loadingScreen = false;
                                return _context.finish(16);

                            case 19:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 13, 16, 19]]);
            }));

            function loadForm() {
                return _ref.apply(this, arguments);
            }

            return loadForm;
        }(),
        validateStep: function validateStep(id) {
            var _this2 = this;

            var ret = true;
            this.errors = [];
            var step = {};
            this.steps.forEach(function (formStep) {
                if (formStep.id == id) step = formStep;
            });
            var answers = Object.keys(this.answers).map(function (key) {
                return [key, _this2.answers[key]];
            });
            answers.forEach(function (answer) {
                if (answer[0] == id) {
                    answers = answer[1];
                    answers = Object.keys(answers).map(function (key) {
                        return [key, answers[key]];
                    });
                }
            });
            answers.forEach(function (answer) {
                if (_typeof(answer[1]) === 'object') {
                    if (answer[1].heigth == '') {
                        _this2.errors['height'] = "Campo obrigatório";
                        ret = false;
                    }
                    if (answer[1].weigth == '') {
                        _this2.errors['weight'] = "Campo obrigatório";
                        ret = false;
                    }
                    if (answer[1].date == '') {
                        _this2.errors['date'] = "Campo obrigatório";
                        ret = false;
                    } else if (answer[1].date && answer[1].date.length < 10) {
                        _this2.errors['date'] = "Data incompleta";
                        ret = false;
                    } else {
                        try {
                            var dateIsValid = __WEBPACK_IMPORTED_MODULE_1_moment___default()(answer[1].date, 'DD/MM/YYYY', true).isValid();
                            var splDate = answer[1].date.split('/');
                            var parsedDate = Date.parse(splDate[2] + ',' + splDate[1] + ',' + splDate[0]);
                            if (!dateIsValid) {
                                _this2.errors['date'] = "Data inválida";
                                ret = false;
                            } else if (parsedDate > Date.now()) {
                                _this2.errors['date'] = "Data futura inválida";
                                ret = false;
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    }
                    if (answer[1].time == '') {
                        _this2.errors['time'] = "Campo obrigatório";
                        ret = false;
                    } else if (answer[1].time && answer[1].time.length < 5) {
                        _this2.errors['time'] = "Horário inválido";
                        ret = false;
                    } else {
                        try {
                            var hour = answer[1].time.replace(':', '');
                            hour = parseInt(hour);
                            if (hour > 2359) {
                                _this2.errors['time'] = "Horário inválido";
                                ret = false;
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    }
                }
                if (answer[1] == "" && _this2.isValid(answer[0])) {
                    _this2.errors[answer[0]] = "Campo obrigatório";
                    ret = false;
                }
            });
            if (!ret) this.errors['required'] = "Por favor, responda todas as perguntas obrigatórias.";

            return ret;
        },
        isValid: function isValid(id) {
            var _this3 = this;

            var ret = true;
            this.steps.forEach(function (step) {
                step.fields.forEach(function (field) {
                    var bypass = false;
                    if (id == field.id && (field.type == 'label' || field.type == 'title')) {
                        ret = false;
                        bypass = true;
                    }
                    if (id == field.id && field.title == 'Se já foi administrada a segunda dose, informe a data aqui:') {
                        ret = false;
                        bypass = true;
                    }
                    if (id == field.id && field.title == 'Você é portador de quais doenças ou condições abaixo?') {
                        ret = false;
                        bypass = true;
                    }
                    if (id == field.id && field.title == 'Tem alguma das doenças ou condições abaixo?') {
                        ret = false;
                        bypass = true;
                    }
                    if (id == field.id && field.title == 'Você está grávida?') {
                        ret = false;
                        bypass = true;
                    }
                    if (id == field.id && field.title == 'Selecione abaixo as situações que se encaixam na sua rotina') {
                        ret = false;
                        bypass = true;
                    }
                    if (id == field.id && field.display_rules.length > 0 && !bypass) {
                        var answers = _this3.answers;
                        field.display_rules.map(function (rule) {
                            ret = __WEBPACK_IMPORTED_MODULE_4__FormBuilder_DisplayRulesFunctions__["a" /* default */][rule.value_of_type](rule, answers, _this3.$store.state.user);
                            if (!ret) {
                                return ret;
                            }
                        });
                    }
                });
            });

            return ret;
        },
        handleSubmit: function handleSubmit() {
            var _this4 = this;

            if (!this.validateStep(this.steps[this.currentFormStep].id)) return false;
            this.errors = {};
            var steps = this.answers;
            var answers = [];

            steps = Object.keys(steps).map(function (key) {
                return [key, steps[key]];
            });
            steps.forEach(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    key = _ref3[0],
                    step = _ref3[1];

                var answer = Object.keys(step).map(function (key) {
                    return [key, step[key]];
                });
                answer.forEach(function (value) {
                    if (_typeof(value[1]) === 'object' && value[1].length === 0 && _this4.isValid(value[0])) {
                        _this4.errors[value[0]] = "Campo obrigatório";
                    } else if (value[1] === null || value[1] === "" && _this4.isValid(value[0])) {
                        _this4.errors[value[0]] = "Campo obrigatório";
                    }
                });
            });

            this.errors = Object.assign({}, this.errors);
            var errorsCount = Object.keys(this.errors).length;

            if (!this.accept_terms) {
                this.errors.accept_terms = ["Que Pena! Mas precisamos dessa concordância para realizar a análise da sua amostra. Quer concordar com o termo de consentimento?"];
                return false;
            } else {
                this.loading = true;
                this.$emit('send', this.answers);
            }
        },
        fakeSubmit: function fakeSubmit() {
            return null;
        }
    }
});

/***/ }),
/* 408 */
/*!*************************************************************!*\
  !*** ./src/components/FormBuilder/DisplayRulesFunctions.js ***!
  \*************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Rule = {
    "App\\Models\\Field": function AppModelsField(rule, answers) {
        var customer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        var ret = false;
        var steps = Object.keys(answers).map(function (key) {
            return [answers[key]];
        });
        steps.map(function (step) {
            step.map(function (val) {
                if (val[rule.value_of_id]) {
                    ret = eval("'" + val[rule.value_of_id] + "' " + rule.operator + " '" + rule.value + "'");
                }
            });
        });

        return ret;
    },
    "App\\Models\\Customer": function AppModelsCustomer(rule, answers) {
        var customer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        return eval("'" + customer[rule.field] + "' " + rule.operator + " '" + rule.value + "'");
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Rule);

/***/ }),
/* 409 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FormBuilder/FormBuilder.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_form__ = __webpack_require__(/*! ../../services/form */ 138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(/*! vue-multiselect */ 410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_vue_multiselect_min_css__ = __webpack_require__(/*! ../../assets/vue-multiselect.min.css */ 871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Fields_Cid10__ = __webpack_require__(/*! ./Fields/Cid10 */ 872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DisplayRulesFunctions__ = __webpack_require__(/*! ./DisplayRulesFunctions */ 408);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({

  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a, Cid10: __WEBPACK_IMPORTED_MODULE_4__Fields_Cid10__["a" /* default */] },
  props: ['value', 'builder', 'formAnswers', 'errors'],
  data: function data() {
    return {
      evaluation: null,
      answers: {},
      confirmed_at: null,
      options: [],
      titles: []
    };
  },
  mounted: function mounted() {},

  watch: {
    value: function value(newValue) {
      this.$emit('value', newValue);
    }
  },
  methods: {
    force: function force() {
      this.$parent.$children.map(function (child) {
        child.$forceUpdate();
      });
    },
    loadForm: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_1__services_form__["a" /* GET_FORM */])(this.kit_type);

              case 2:
                data = _context.sent;

                this.builder = data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadForm() {
        return _ref.apply(this, arguments);
      }

      return loadForm;
    }(),
    emit: function emit() {
      this.$emit('value', this.value);
      this.force();
    },
    emitMultiselect: function emitMultiselect(idComponent) {
      var answers = [];
      this.answers[idComponent].forEach(function (answer) {
        answers.push(answer.id);
      });
      this.value[idComponent] = answers;
      this.$emit('value', this.value);
    },
    isValid: function isValid(component) {
      var _this = this;

      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var ret = true;
      try {
        component.display_rules.forEach(function (rule) {
          if (rule.value_of_type && !__WEBPACK_IMPORTED_MODULE_5__DisplayRulesFunctions__["a" /* default */][rule.value_of_type](rule, _this.formAnswers, _this.$store.state.user)) {
            ret = false;
            return false;
          }
        });
      } catch (e) {
        console.log("tivemos um erro ", component, e);
      }
      return ret;
    },
    getMuliselect: function getMuliselect(items, answers) {
      var res = '';
      if (answers) answers.forEach(function (answer) {
        items.forEach(function (item) {
          if (answer == item.id) res = res + item.name + ', ';
        });
      });
      return res.slice(0, -2);
    },
    getMultiSize: function getMultiSize(items, answers) {
      var ret = 14;
      if (!!answers) answers.forEach(function (answer) {
        items.forEach(function (item) {
          if (answer == item.id) ret += 14;
        });
      });
      return 'height: ' + ret + 'px';
    },
    onlyNumbers: function onlyNumbers(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getLabelSize: function getLabelSize(length) {
      if (length < 49) {
        return 'sm';
      } else if (length >= 49 && length < 99) {
        return 'md';
      } else if (length >= 99 && length < 149) {
        return 'lg';
      } else if (length >= 149) {
        return 'xl';
      }
    }
  }
});

/***/ }),
/* 410 */,
/* 411 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FormBuilder/Fields/Cid10.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(/*! vue-multiselect */ 410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a },
    props: ['required', 'disabled', 'value'],
    name: "Cid10",
    data: function data() {
        return {
            items: [],
            isLoading: true
        };
    },

    watch: {
        value: function value(variable, var2) {
            this.$emit('input', this.value);
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (!this.disabled) {
            axios.get('/cid10').then(function (r) {
                _this.items = r.data;
                _this.isLoading = false;
            });
        } else {
            this.isLoading = false;
        }
    },

    methods: {
        asyncFind: function asyncFind(query) {
            debugger;
        },
        limitText: function limitText(count) {
            return 'and ' + count + ' other countries';
        }
    }
});

/***/ }),
/* 412 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RegisterKitSteps/DataKitSchedule.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_schedule__ = __webpack_require__(/*! ../../services/schedule */ 135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_address__ = __webpack_require__(/*! ../../services/address */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(/*! vue2-datepicker */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css__ = __webpack_require__(/*! vue2-datepicker/index.css */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker_locale_pt_br__ = __webpack_require__(/*! vue2-datepicker/locale/pt-br */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_datepicker_locale_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(/*! moment */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['next', 'kit', 'shipping_type', 'tag_type'],
	components: { DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__["default"] },
	name: "DataKitSchedule",
	data: function data() {
		return {
			step: 0,
			loading: false,
			loadingScreen: false,
			errors: [],
			form: {
				zip_code: null,
				address: null,
				number: null,
				complement: null,
				neighbourhood: null,
				city: null,
				city_name: null,
				state: null,
				state_name: null,
				schedule: {},
				schedule_date: null
			},
			turns: false,
			notFound: false
		};
	},
	methods: {
		toView: function toView(n) {
			this.step = n;
			window.scrollTo(0, 0);
		},
		clearErrors: function clearErrors() {
			this.errors = [];
		},
		findAddress: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
				var response, response2;
				return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.clearErrors();

								if (!(this.form.zip_code.length === 9)) {
									_context.next = 25;
									break;
								}

								this.notFound = false;
								this.loadingScreen = true;
								_context.next = 6;
								return Object(__WEBPACK_IMPORTED_MODULE_2__services_address__["a" /* ADDRESS_FIND */])(this.form.zip_code);

							case 6:
								response = _context.sent;

								if (!(response && response.logradouro)) {
									_context.next = 17;
									break;
								}

								this.form.address = response.logradouro;
								this.form.city_name = response.localidade;
								this.form.neighbourhood = response.bairro;
								_context.next = 13;
								return Object(__WEBPACK_IMPORTED_MODULE_2__services_address__["b" /* CITY_TIME */])(response.uf, response.localidade);

							case 13:
								response2 = _context.sent;

								if (response2) {
									this.form.state_id = response2.state_id;
									this.form.state_name = response2.state;
									this.form.city_id = response2.city_id;
									this.form.city_name = response2.city;
									this.turns = response2.turns;
								}
								_context.next = 24;
								break;

							case 17:
								this.errors.zip_code = ["CEP não encontrado."];
								this.form.address = null;
								this.form.city_name = null;
								this.form.state_id = null;
								this.form.state_name = null;
								this.form.city_id = null;
								this.turns = null;

							case 24:
								this.loadingScreen = false;

							case 25:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function findAddress() {
				return _ref.apply(this, arguments);
			}

			return findAddress;
		}(),
		handleOnScheduleChange: function handleOnScheduleChange(_ref2) {
			var value = _ref2.value;

			if (this.turns[value]) {
				this.form.schedule = this.turns[value];
				this.form.schedule_date = this.turns[value].full_date;
			} else {
				this.form.schedule = {};
			}
		},
		handleSubmit: function handleSubmit(event) {
			var _this = this;

			event.preventDefault();
			this.clearErrors();
			this.loading = true;
			var kit_number = this.kit;
			var form = Object.assign({ kit_number: kit_number }, this.form);
			Object(__WEBPACK_IMPORTED_MODULE_1__services_schedule__["b" /* POST_SCHEDULE */])(form).then(function (resp) {
				_this.toView(3);
			}, function (error) {
				return _this.errors = error.response.data;
			}).then(function (resp) {
				_this.loading = false;
			});
		},
		toKits: function toKits() {
			this.$router.push('/kits');
			window.scrollTo(0, 0);
		}
	}
});

/***/ }),
/* 413 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RegisterKitSteps/KitOrientation.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['next', 'shipping_type'],
  components: {},
  name: "KitOrientation",
  data: function data() {
    return {};
  },
  methods: {
    toView: function toView(n) {
      this.step = n;
      window.scrollTo(0, 0);
    }
  }
});

/***/ }),
/* 414 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RegisterKitSteps/PrivacyPolicy.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PrivacyPolicy",
  props: {
    next: Function
  },
  data: function data() {
    return {
      errors: {
        accept_terms: []
      },
      accept_terms: false
    };
  },

  methods: {
    handleSubmit: function handleSubmit() {
      if (!this.accept_terms) {
        this.errors.accept_terms.push("Que Pena! Mas precisamos dessa concordância para realizar a análise da sua amostra. Quer concordar com o termo de consentimento?");
        return false;
      } else {
        console.log();
        this.$emit('next', this.accept_terms);
      }
    }
  }
});

/***/ }),
/* 415 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ForgotPassword/ForgotPassword.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user__ = __webpack_require__(/*! ../../services/user */ 48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_User__ = __webpack_require__(/*! ../../models/User */ 59);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            showRegisterModal: false,
            forgotPasswordUrl: "",
            showPassword: false,
            loading: false,
            form: {
                email: null,
                password: null,
                remember: false
            },
            confirmed: false
        };
    },

    methods: {
        clearErrors: function clearErrors() {
            this.errors = [];
        },
        handleShowPassword: function handleShowPassword() {
            this.showPassword = !this.showPassword;
            var password = document.getElementById('password');
            if (this.showPassword) {
                password.type = "text";
            } else {
                password.type = "password";
            }
        },
        handleSubmit: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(event) {
                var _this = this;

                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                event.preventDefault();
                                this.clearErrors();
                                this.loading = true;
                                Object(__WEBPACK_IMPORTED_MODULE_1__services_user__["a" /* FORGOT_PASSWORD */])(this.form).then(function (resp) {
                                    _this.confirmed = true;
                                }, function (error) {
                                    return _this.errors = error.response.data.errors;
                                }).then(function (resp) {
                                    _this.loading = false;
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function handleSubmit(_x) {
                return _ref.apply(this, arguments);
            }

            return handleSubmit;
        }()
    },
    mounted: function mounted() {}
});

/***/ }),
/* 416 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/RecoverPassword/RecoverPassword.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user__ = __webpack_require__(/*! ../../services/user */ 48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_User__ = __webpack_require__(/*! ../../models/User */ 59);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            loading: false,
            loadingScreen: false,
            showPassword: false,
            showConfirmPassword: false,
            form: {
                email: null,
                token: null,
                password: null,
                password_confirmation: null
            },
            notFound: false,
            confirmed: false
        };
    },

    methods: {
        handleVerify: function handleVerify(form) {
            var _this = this;

            this.loadingScreen = true;
            Object(__WEBPACK_IMPORTED_MODULE_1__services_user__["f" /* VERIFY_FORGOT_PASSWORD */])(form).then(function (resp) {}, function (error) {
                return _this.notFound = true;
            }).then(function (resp) {
                _this.loadingScreen = false;
            });
        },
        handleSubmit: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(event) {
                var _this2 = this;

                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                event.preventDefault();
                                this.loading = true;
                                Object(__WEBPACK_IMPORTED_MODULE_1__services_user__["c" /* RECOVER_PASSWORD */])(this.form).then(function (resp) {
                                    _this2.confirmed = true;
                                }, function (error) {
                                    return _this2.errors = error.response.data.errors;
                                }).then(function (resp) {
                                    _this2.loading = false;
                                });

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function handleSubmit(_x) {
                return _ref.apply(this, arguments);
            }

            return handleSubmit;
        }(),
        validate: function validate(form) {
            var valid = true;
            for (var i in form.$children) {
                var item = form.$children;
                if (item[i].$options._componentTag == "header-div") continue;
                item[i].validate();
                if (item[i].type == 'password_confirm' && this.form.password != this.form.password_confirmation) {
                    item[i].errorMessage = 'As senhas digitadas não são iguais.';
                }
                if (item[i].errorMessage !== null) valid = false;
            }
            return valid;
        }
    },
    mounted: function mounted() {
        var url_string = window.location.href;
        var url = new URL(url_string);
        this.form.email = url.searchParams.get("email");
        this.form.token = url.searchParams.get("token");

        var form = {
            email: this.form.email,
            token: this.form.token
        };

        this.handleVerify(form);
    }
});

/***/ }),
/* 417 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CarePlan/CarePlan.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_customer__ = __webpack_require__(/*! ../../services/customer */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__["r" /* faExternalLinkAlt */]);
__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__["u" /* faFileAlt */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "care-plan",
    props: {
        result: Object
    },
    data: function data() {
        return {
            carePlans: null
        };
    },

    methods: {
        back: function back() {
            this.$emit('back');
        },
        getDate: function getDate(date) {
            date = new Date(date);
            date = this.aditionalZero(date.getDate()) + "/" + this.aditionalZero(date.getMonth() + 1) + "/" + date.getFullYear();
            return date;
        },
        aditionalZero: function aditionalZero(number) {
            return number <= 9 ? "0" + number : number;
        }
    },
    mounted: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
            var resp;
            return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_1__services_customer__["a" /* GET_CUSTOMER */])();

                        case 2:
                            resp = _context.sent;

                            this.carePlans = resp.customer.care_plan;

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),
/* 418 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CoordinatedCare/CoordinatedCare.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_coordinated_care__ = __webpack_require__(/*! ../../services/coordinated_care */ 899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_cover_png__ = __webpack_require__(/*! @/assets/images/no-cover.png */ 900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_cover_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_no_cover_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__["r" /* faExternalLinkAlt */]);
__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__["u" /* faFileAlt */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "coordinated-care",
    props: {
        result: Object
    },
    data: function data() {
        return {
            categories: [],
            posts: {}
        };
    },

    methods: {
        fixBrokenImage: function fixBrokenImage(e) {
            e.target.src = __WEBPACK_IMPORTED_MODULE_2__assets_images_no_cover_png___default.a;
        }
    },
    beforeMount: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, category, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, post, _ref2, attachment, cover_image;

            return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_1__services_coordinated_care__["b" /* GET_COORDINATED_CARES */])();

                        case 2:
                            this.categories = _context.sent;
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context.prev = 6;
                            _iterator = this.categories[Symbol.iterator]();

                        case 8:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context.next = 44;
                                break;
                            }

                            category = _step.value;
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context.prev = 13;
                            _iterator2 = category.posts[Symbol.iterator]();

                        case 15:
                            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                _context.next = 27;
                                break;
                            }

                            post = _step2.value;
                            _context.next = 19;
                            return Object(__WEBPACK_IMPORTED_MODULE_1__services_coordinated_care__["a" /* GET_CARE_FILES */])(post.id);

                        case 19:
                            _ref2 = _context.sent;
                            attachment = _ref2.attachment;
                            cover_image = _ref2.cover_image;

                            post.attachment = attachment;
                            post.cover_image = cover_image || __WEBPACK_IMPORTED_MODULE_2__assets_images_no_cover_png___default.a;

                        case 24:
                            _iteratorNormalCompletion2 = true;
                            _context.next = 15;
                            break;

                        case 27:
                            _context.next = 33;
                            break;

                        case 29:
                            _context.prev = 29;
                            _context.t0 = _context['catch'](13);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context.t0;

                        case 33:
                            _context.prev = 33;
                            _context.prev = 34;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 36:
                            _context.prev = 36;

                            if (!_didIteratorError2) {
                                _context.next = 39;
                                break;
                            }

                            throw _iteratorError2;

                        case 39:
                            return _context.finish(36);

                        case 40:
                            return _context.finish(33);

                        case 41:
                            _iteratorNormalCompletion = true;
                            _context.next = 8;
                            break;

                        case 44:
                            _context.next = 50;
                            break;

                        case 46:
                            _context.prev = 46;
                            _context.t1 = _context['catch'](6);
                            _didIteratorError = true;
                            _iteratorError = _context.t1;

                        case 50:
                            _context.prev = 50;
                            _context.prev = 51;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 53:
                            _context.prev = 53;

                            if (!_didIteratorError) {
                                _context.next = 56;
                                break;
                            }

                            throw _iteratorError;

                        case 56:
                            return _context.finish(53);

                        case 57:
                            return _context.finish(50);

                        case 58:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[6, 46, 50, 58], [13, 29, 33, 41], [34,, 36, 40], [51,, 53, 57]]);
        }));

        function beforeMount() {
            return _ref.apply(this, arguments);
        }

        return beforeMount;
    }()
});

/***/ }),
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header/Header.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "header-div",
    data: function data() {
        return {};
    },

    methods: {},
    mounted: function mounted() {}
});

/***/ }),
/* 585 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Footer/Footer.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "footer-div",
    data: function data() {
        return {};
    },

    methods: {},
    mounted: function mounted() {}
});

/***/ }),
/* 586 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Menu/Menu.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_User__ = __webpack_require__(/*! ../../models/User */ 59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_user__ = __webpack_require__(/*! ../../services/user */ 48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_result__ = __webpack_require__(/*! ../../services/result */ 136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_customer__ = __webpack_require__(/*! ../../services/customer */ 29);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["d" /* faBars */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["F" /* faTimes */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["A" /* faPlusCircle */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["w" /* faIdCard */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["f" /* faBox */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["I" /* faUserTie */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["j" /* faChartBar */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["g" /* faCalendarAlt */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["u" /* faFileAlt */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["a" /* faAddressBook */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["b" /* faArrowAltCircleLeft */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["n" /* faCoins */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["v" /* faHandHoldingHeart */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["e" /* faBookMedical */]);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["h" /* faCalendarCheck */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "side-menu",
    data: function data() {
        var _ref;

        return _ref = {
            modalRegisterKit: false,
            dropddownMenu: false,
            newKitUrl: 'cadastrar',
            profileUrl: 'perfil',
            kitsUrl: 'kits',
            digitalUrl: 'healthid-digital',
            carePlanUrl: 'care-plan',
            coordinatedCareUrl: 'coordinated-care'
        }, _defineProperty(_ref, 'kitsUrl', 'kits'), _defineProperty(_ref, 'dashboardUrl', 'dashboard'), _defineProperty(_ref, 'schedulesUrl', 'agendamentos'), _defineProperty(_ref, 'resultsUrl', 'resultados'), _defineProperty(_ref, 'returnsUrl', 'devolutivas'), _defineProperty(_ref, 'examsQuantity', 0), _defineProperty(_ref, 'hasCarePlan', false), _ref;
    },

    methods: {
        back: function back() {
            this.$emit('back');
        },
        toRegisterKit: function toRegisterKit() {
            var url_string = window.location.href;
            var url = new URL(url_string);
            var kit = url.searchParams.get("kit_number");
            if (!!kit && kit != '') this.$router.push('/cadastrar-kit?kit_number=' + kit);else this.$router.push('/cadastrar-kit');
        },
        switchDropdownMenu: function switchDropdownMenu() {
            this.dropddownMenu = !this.dropddownMenu;
        },
        examsQuant: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__services_result__["a" /* GET_RESULTS_COUNT */])();

                            case 2:
                                data = _context.sent;

                                this.$store.state.examsQuantity = data.exams;
                                this.examsQuantity = data.exams;

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function examsQuant() {
                return _ref2.apply(this, arguments);
            }

            return examsQuant;
        }(),
        logout: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var response, user;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__services_user__["e" /* USER_LOGOUT */])();

                            case 3:
                                response = _context2.sent;
                                user = new __WEBPACK_IMPORTED_MODULE_1__models_User__["a" /* User */]();

                                user.logout();
                                _context2.next = 11;
                                break;

                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2['catch'](0);

                                console.log(_context2.t0);

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 8]]);
            }));

            function logout() {
                return _ref3.apply(this, arguments);
            }

            return logout;
        }()
    },
    mounted: function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var customer, resp;
            return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            customer = this.$store.state.user;

                            if (customer) {
                                _context3.next = 7;
                                break;
                            }

                            _context3.next = 4;
                            return Object(__WEBPACK_IMPORTED_MODULE_6__services_customer__["a" /* GET_CUSTOMER */])();

                        case 4:
                            resp = _context3.sent;

                            this.$store.commit('setUser', resp.customer);
                            console.log("customer apos if", resp.customer);

                        case 7:
                            if (!this.$store.state.examsQuantity) {
                                this.examsQuant();
                            } else {
                                this.examsQuantity = this.$store.state.examsQuantity;
                            }

                            if (!!this.$store.state.user.care_plan && !!this.$store.state.user.care_plan.documents) this.hasCarePlan = true;

                        case 9:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref4.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),
/* 587 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Input/InputText.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var types = {
    email: {
        regex: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
        message: 'O E-mail digitado é inválido.'
    },
    password: {
        regex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/,
        message: 'A Senha digitada não é forte. Digite pelo menos um número, uma letra maiúscula, uma letra minúscula e um caracter especial.'
    },
    number: {
        regex: /^\d+$/,
        message: 'Utilize apenas números.'
    },
    cpf: {
        regex: '',
        mask: '###.###.###-##',
        message: 'O CPF digitado é inválido.'
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "input-text",
    model: {
        prop: 'value',
        event: 'input'
    },
    data: function data() {
        return {
            id: null,
            name: null,
            type: null,
            content: this.value,
            required: false,
            regexValidate: true,
            errorMessage: null,
            showPassword: false
        };
    },

    methods: {
        setType: function setType() {
            if (this.type == 'password' || this.type == 'password_confirm') return 'password';
            return 'text';
        },
        handleShowPassword: function handleShowPassword() {
            this.showPassword = !this.showPassword;
            var password = document.getElementById(this.id);
            if (this.showPassword) {
                password.type = "text";
            } else {
                password.type = "password";
            }
        },
        handleInput: function handleInput(e) {
            this.$emit('input', this.content);
        },
        validate: function validate() {
            if (this.required && (this.content == '' || this.content == null)) {
                this.errorMessage = 'O campo ' + this.name + ' \xE9 obrigat\xF3rio';
            } else if (this.regexValidate && types[this.type] && !types[this.type].regex.test(this.content)) {
                this.errorMessage = types[this.type].message;
            } else {
                this.clearErrors();
            }
        },
        clearErrors: function clearErrors() {
            this.errorMessage = null;
        }
    },
    mounted: function mounted() {
        this.id = this.$attrs.inId ? this.$attrs.inId : null;
        this.name = this.$attrs.inName ? this.$attrs.inName : null;
        this.type = this.$attrs.inType ? this.$attrs.inType : 'text';
        this.required = this.$attrs.inRequired ? this.$attrs.inRequired : false;
        if (this.$attrs.noValidation) this.regexValidate = false;
    }
});

/***/ }),
/* 588 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LoadingIcon/LoadingIcon.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["E" /* faSpinner */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "loading",
    data: function data() {
        return {};
    },

    methods: {},
    mounted: function mounted() {}
});

/***/ }),
/* 589 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LoadingScreen/LoadingScreen.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 22);
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_free_solid_svg_icons__["E" /* faSpinner */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "loading-screen",
    data: function data() {
        return {};
    },

    methods: {},
    mounted: function mounted() {}
});

/***/ }),
/* 590 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RegisterModal/RegisterModal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user__ = __webpack_require__(/*! ../../services/user */ 48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__steps_RegisterForm__ = __webpack_require__(/*! ./steps/RegisterForm */ 1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__steps_RegisterTips__ = __webpack_require__(/*! ./steps/RegisterTips */ 1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_User__ = __webpack_require__(/*! ../../models/User */ 59);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: "register-modal",
    components: { RegisterForm: __WEBPACK_IMPORTED_MODULE_2__steps_RegisterForm__["a" /* default */], RegisterTips: __WEBPACK_IMPORTED_MODULE_3__steps_RegisterTips__["a" /* default */] },
    data: function data() {
        return {
            currentStep: 0,
            formLogin: {}
        };
    },

    methods: {
        outsideClick: function outsideClick() {
            if (event.target === event.currentTarget) this.$emit('close');
        },
        validate: function validate(form) {
            var valid = true;
            for (var i in form.$children) {
                var item = form.$children;
                item[i].validate();
                if (item[i].type == 'password_confirm' && this.form.password != this.form.password_confirmation) {
                    item[i].errorMessage = 'As senhas digitadas não são iguais.';
                }
                if (item[i].errorMessage !== null) valid = false;
            }
            return valid;
        },
        handleSubmit: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(event) {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                event.preventDefault();
                                this.loading = true;

                                if (this.validate(this)) {
                                    _context.next = 5;
                                    break;
                                }

                                this.loading = false;
                                return _context.abrupt('return', false);

                            case 5:
                                _context.prev = 5;
                                _context.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_user__["b" /* POST_USER */])(this.form);

                            case 8:
                                response = _context.sent;

                                this.success = true;
                                _context.next = 14;
                                break;

                            case 12:
                                _context.prev = 12;
                                _context.t0 = _context['catch'](5);

                            case 14:
                                _context.prev = 14;

                                this.loading = false;
                                return _context.finish(14);

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[5, 12, 14, 17]]);
            }));

            function handleSubmit(_x) {
                return _ref.apply(this, arguments);
            }

            return handleSubmit;
        }(),
        nextStep: function nextStep(formLogin) {
            this.formLogin = formLogin;
            this.currentStep += 1;
        },
        login: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var response, user, url_string, url, kit;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_user__["d" /* USER_LOGIN */])(this.formLogin);

                            case 2:
                                response = _context2.sent;

                                if (response.token) {
                                    user = new __WEBPACK_IMPORTED_MODULE_4__models_User__["a" /* User */]();

                                    user.setUser(response.data.name, response.data.email, response.token);
                                    url_string = window.location.href;
                                    url = new URL(url_string);
                                    kit = url.searchParams.get("kit_number");

                                    if (!!kit && kit != '') window.location = '/perfil?kit_number=' + kit;else window.location = "/perfil";
                                }

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function login() {
                return _ref2.apply(this, arguments);
            }

            return login;
        }()
    },
    mounted: function mounted() {}
});

/***/ }),
/* 591 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RegisterModal/steps/RegisterForm.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user__ = __webpack_require__(/*! ../../../services/user */ 48);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "RegisterForm",
    data: function data() {
        return {
            showPassword: false,
            showConfirmPassword: false,
            loading: false,
            success: false,
            form: {
                name: null,
                email: null,
                password: null,
                password_confirmation: null
            },
            formLogin: {
                email: null,
                password: null
            },
            errors: []
        };
    },

    methods: {
        clearErrors: function clearErrors() {
            this.errors = [];
        },
        handleShowPassword: function handleShowPassword(field) {
            if (field === 0) {
                this.showPassword = !this.showPassword;
            } else {
                this.showConfirmPassword = !this.showConfirmPassword;
            }
            var password = field === 0 ? document.getElementById('password') : document.getElementById('confirm_password');
            if (field === 0) if (this.showPassword) {
                password.type = "text";
            } else {
                password.type = "password";
            }
            if (field === 1) if (this.showConfirmPassword) {
                password.type = "text";
            } else {
                password.type = "password";
            }
        },
        handleSubmit: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(event) {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                event.preventDefault();
                                this.loading = true;
                                this.clearErrors();
                                _context.prev = 3;
                                _context.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_1__services_user__["b" /* POST_USER */])(this.form);

                            case 6:
                                response = _context.sent;

                                this.formLogin.email = this.form.email;
                                this.formLogin.password = this.form.password;
                                this.$emit('next', this.formLogin);
                                _context.next = 15;
                                break;

                            case 12:
                                _context.prev = 12;
                                _context.t0 = _context['catch'](3);

                                this.errors = _context.t0.response.data.errors;

                            case 15:
                                _context.prev = 15;

                                this.loading = false;
                                return _context.finish(15);

                            case 18:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[3, 12, 15, 18]]);
            }));

            function handleSubmit(_x) {
                return _ref.apply(this, arguments);
            }

            return handleSubmit;
        }()
    },
    mounted: function mounted() {}
});

/***/ }),
/* 592 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RegisterModal/steps/RegisterTips.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "register-tips",
    data: function data() {
        return {
            currentStep: 0,
            loading: false
        };
    },

    methods: {
        switchStep: function switchStep(step) {
            this.currentStep = step;
        },
        login: function login() {
            this.loading = true;
            this.$emit('login');
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 593 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ForgotPasswordModal/ForgotPasswordModal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user__ = __webpack_require__(/*! ../../services/user */ 48);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "forgot-password-modal",
    components: {},
    data: function data() {
        return {
            showRegisterModal: false,
            forgotPasswordUrl: "",
            showPassword: false,
            loading: false,
            form: {
                email: null,
                password: null,
                remember: false
            },
            confirmed: false,
            errors: []
        };
    },

    methods: {
        clearErrors: function clearErrors() {
            this.errors = [];
        },
        handleShowPassword: function handleShowPassword() {
            this.showPassword = !this.showPassword;
            var password = document.getElementById('password');
            if (this.showPassword) {
                password.type = "text";
            } else {
                password.type = "password";
            }
        },
        outsideClick: function outsideClick() {
            if (event.target === event.currentTarget) this.$emit('close');
        },
        handleSubmit: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(event) {
                var _this = this;

                return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                event.preventDefault();
                                this.clearErrors();
                                this.loading = true;
                                Object(__WEBPACK_IMPORTED_MODULE_1__services_user__["a" /* FORGOT_PASSWORD */])(this.form).then(function (resp) {
                                    _this.confirmed = true;
                                }, function (error) {
                                    return _this.errors = error.response.data.errors;
                                }).then(function (resp) {
                                    _this.loading = false;
                                });

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function handleSubmit(_x) {
                return _ref.apply(this, arguments);
            }

            return handleSubmit;
        }()
    },
    mounted: function mounted() {}
});

/***/ }),
/* 594 */
/*!***********************************************!*\
  !*** multi ./src/polyfills.js ./src/index.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! /opt/atlassian/pipelines/agent/build/src/polyfills.js */595);
module.exports = __webpack_require__(/*! /opt/atlassian/pipelines/agent/build/src/index.js */598);


/***/ }),
/* 595 */
/*!**************************!*\
  !*** ./src/polyfills.js ***!
  \**************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

if (!window.Promise) {
  window.Promise = __webpack_require__(/*! promise-polyfill */ 596);
}

Object.assign = __webpack_require__(/*! object-assign */ 207);

/***/ }),
/* 596 */,
/* 597 */,
/* 598 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(/*! vue-router */ 600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue__ = __webpack_require__(/*! ./App.vue */ 601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_routes__ = __webpack_require__(/*! ./routes/routes */ 604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ant_design_vue__ = __webpack_require__(/*! ant-design-vue */ 902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_User__ = __webpack_require__(/*! ./models/User */ 59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ant_design_vue_dist_antd_css__ = __webpack_require__(/*! ant-design-vue/dist/antd.css */ 1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ant_design_vue_dist_antd_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ant_design_vue_dist_antd_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__globalComponents__ = __webpack_require__(/*! ./globalComponents */ 1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_vue_fontawesome__ = __webpack_require__(/*! @fortawesome/vue-fontawesome */ 1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_the_mask__ = __webpack_require__(/*! vue-the-mask */ 1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_the_mask__);













var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history', routes: __WEBPACK_IMPORTED_MODULE_4__routes_routes__["a" /* default */]
});

function kitNumberParameter() {
  var url_string = window.location.href;
  var url = new URL(url_string);
  var kit = url.searchParams.get("kit_number");
  return !!kit ? kit : false;
}

function hasCarePlan() {
  return store.state.user && store.state.user.care_plan;
}

function dateAditionalZero(number) {
  return number <= 9 ? "0" + number : number;
}

router.beforeEach(function (to, from, next) {
  if (to.name === 'home' && Object(__WEBPACK_IMPORTED_MODULE_6__models_User__["b" /* isAuthenticated */])()) next({ name: 'kits' });
  if (to.name === 'profile' && !Object(__WEBPACK_IMPORTED_MODULE_6__models_User__["b" /* isAuthenticated */])()) next({ name: 'home' });else if (to.name === 'cadastrar_kit' && !Object(__WEBPACK_IMPORTED_MODULE_6__models_User__["b" /* isAuthenticated */])() && kitNumberParameter()) next({
    name: 'home', query: { kit_number: kitNumberParameter() }
  });else if (to.name === 'cadastrar_kit' && !Object(__WEBPACK_IMPORTED_MODULE_6__models_User__["b" /* isAuthenticated */])()) next({ name: 'home' });else if (to.name === 'dashboard' && !Object(__WEBPACK_IMPORTED_MODULE_6__models_User__["b" /* isAuthenticated */])()) next({ name: 'home' });else if (to.name === 'kits' && !Object(__WEBPACK_IMPORTED_MODULE_6__models_User__["b" /* isAuthenticated */])()) next({ name: 'home' });else if (to.name === 'results' && !Object(__WEBPACK_IMPORTED_MODULE_6__models_User__["b" /* isAuthenticated */])()) next({ name: 'home' });else if (to.name === 'returns' && !Object(__WEBPACK_IMPORTED_MODULE_6__models_User__["b" /* isAuthenticated */])()) next({ name: 'home' });else if (to.name === 'schedules' && !Object(__WEBPACK_IMPORTED_MODULE_6__models_User__["b" /* isAuthenticated */])()) next({ name: 'home' });else if (to.name === 'healthid-digital' && !Object(__WEBPACK_IMPORTED_MODULE_6__models_User__["b" /* isAuthenticated */])()) next({ name: 'home' });else if (to.name === 'care-plan' && (!Object(__WEBPACK_IMPORTED_MODULE_6__models_User__["b" /* isAuthenticated */])() || !hasCarePlan())) next({ name: 'home' });else next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__globalComponents__["a" /* default */]);

/**
 * REDUX STORE INSTANTIABLE
 */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    user: null
  }, mutations: {
    setUser: function setUser(state, newState) {
      state.user = newState;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_9__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_ant_design_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  methods: {
    dateParse: function dateParse(date) {
      date = new Date(date);
      date = dateAditionalZero(date.getDate()) + "/" + dateAditionalZero(date.getMonth() + 1) + "/" + date.getFullYear();
      return date;
    }
  }
});
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app', render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App_vue__["a" /* default */]);
  }, router: router, store: store
});

/***/ }),
/* 599 */,
/* 600 */,
/* 601 */
/*!*********************!*\
  !*** ./src/App.vue ***!
  \*********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_113a447e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-113a447e","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 603);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-113a447e","scoped":false,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 602)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_113a447e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 602 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-113a447e","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-113a447e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('main',[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 604 */
/*!******************************!*\
  !*** ./src/routes/routes.js ***!
  \******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Home_Home_vue__ = __webpack_require__(/*! @/views/Home/Home.vue */ 605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Profile_Profile_vue__ = __webpack_require__(/*! @/views/Profile/Profile.vue */ 630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Dashboard_Dashboard_vue__ = __webpack_require__(/*! @/views/Dashboard/Dashboard.vue */ 644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Kits_Kits_vue__ = __webpack_require__(/*! @/views/Kits/Kits.vue */ 647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Results_Results_vue__ = __webpack_require__(/*! @/views/Results/Results.vue */ 823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Returns_Returns_vue__ = __webpack_require__(/*! @/views/Returns/Returns.vue */ 826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Schedules_Schedules_vue__ = __webpack_require__(/*! @/views/Schedules/Schedules.vue */ 829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_HealthIdDigital_HealthIdDigital_vue__ = __webpack_require__(/*! @/views/HealthIdDigital/HealthIdDigital.vue */ 832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_RegisterKit_RegisterKit__ = __webpack_require__(/*! ../views/RegisterKit/RegisterKit */ 857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_ForgotPassword_ForgotPassword__ = __webpack_require__(/*! @/views/ForgotPassword/ForgotPassword */ 888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_RecoverPassword_RecoverPassword__ = __webpack_require__(/*! @/views/RecoverPassword/RecoverPassword */ 891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CarePlan_CarePlan__ = __webpack_require__(/*! ../components/CarePlan/CarePlan */ 894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CoordinatedCare_CoordinatedCare__ = __webpack_require__(/*! ../components/CoordinatedCare/CoordinatedCare */ 897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_CardHealthId_CardHealthId__ = __webpack_require__(/*! @/components/CardHealthId/CardHealthId */ 395);















var routes = [{
  path: "/",
  name: "home",
  component: __WEBPACK_IMPORTED_MODULE_0__views_Home_Home_vue__["a" /* default */],
  children: []
}, {
  path: "/perfil",
  name: "profile",
  component: __WEBPACK_IMPORTED_MODULE_1__views_Profile_Profile_vue__["a" /* default */],
  children: []
}, {
  path: "/dashboard",
  name: "dashboard",
  component: __WEBPACK_IMPORTED_MODULE_2__views_Dashboard_Dashboard_vue__["a" /* default */],
  children: []
}, {
  path: "/kits",
  name: "kits",
  component: __WEBPACK_IMPORTED_MODULE_3__views_Kits_Kits_vue__["a" /* default */],
  children: []
}, {
  path: "/resultados",
  name: "results",
  component: __WEBPACK_IMPORTED_MODULE_4__views_Results_Results_vue__["a" /* default */],
  children: []
}, {
  path: "/devolutivas",
  name: "returns",
  component: __WEBPACK_IMPORTED_MODULE_5__views_Returns_Returns_vue__["a" /* default */],
  children: []
}, {
  path: "/agendamentos",
  name: "schedules",
  component: __WEBPACK_IMPORTED_MODULE_6__views_Schedules_Schedules_vue__["a" /* default */],
  children: []
}, {
  path: "/cadastrar-kit",
  name: "cadastrar_kit",
  component: __WEBPACK_IMPORTED_MODULE_8__views_RegisterKit_RegisterKit__["a" /* default */],
  children: []
}, {
  path: "/esqueceu-senha",
  name: "forgot",
  component: __WEBPACK_IMPORTED_MODULE_9__views_ForgotPassword_ForgotPassword__["a" /* default */],
  children: []
}, {
  path: "/recuperar-senha",
  name: "recover",
  component: __WEBPACK_IMPORTED_MODULE_10__views_RecoverPassword_RecoverPassword__["a" /* default */],
  children: []
}, {
  path: "/healthid-digital",
  name: "healthid-digital",
  component: __WEBPACK_IMPORTED_MODULE_7__views_HealthIdDigital_HealthIdDigital_vue__["a" /* default */],
  children: []
}, {
  path: "/care-plan",
  name: "care-plan",
  component: __WEBPACK_IMPORTED_MODULE_11__components_CarePlan_CarePlan__["a" /* default */],
  children: []
}, {
  path: "/coordinated-care",
  name: "coordinated-care",
  component: __WEBPACK_IMPORTED_MODULE_12__components_CoordinatedCare_CoordinatedCare__["a" /* default */],
  children: []
}, {
  path: "/cardhealthid",
  name: "recover",
  component: __WEBPACK_IMPORTED_MODULE_13__components_CardHealthId_CardHealthId__["a" /* default */],
  children: []
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 605 */
/*!*********************************!*\
  !*** ./src/views/Home/Home.vue ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_298a8af4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-298a8af4","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 628);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-298a8af4","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Home.vue */ 606)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-298a8af4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_298a8af4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 606 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-298a8af4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Home/Home.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-298a8af4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/Home.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-bg"},[(_vm.showRegisterModal)?_c('register-modal',{on:{"close":function($event){_vm.showRegisterModal = false}}}):_vm._e(),_vm._v(" "),(_vm.showForgotModal)?_c('forgot-password-modal',{on:{"close":function($event){_vm.showForgotModal = false}}}):_vm._e(),_vm._v(" "),_c('section',{staticClass:"home-container"},[_c('div',{staticClass:"form-container"},[_c('div',{staticClass:"form-box"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('form',{on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{staticClass:"text-main",attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"text-main",attrs:{"id":"email","name":"email","type":"text"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})]),_vm._v(" "),(!!_vm.errors && !!_vm.errors.email)?_c('small',{staticClass:"error text-main"},[_vm._v(_vm._s(_vm.errors.email.join()))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{staticClass:"text-main",attrs:{"for":"password"}},[_vm._v("Senha")]),_vm._v(" "),_c('span',{staticClass:"password-icon"},[(!_vm.showPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye-slash']},on:{"click":_vm.handleShowPassword}}):_vm._e(),_vm._v(" "),(_vm.showPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye']},on:{"click":_vm.handleShowPassword}}):_vm._e()],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"text-main",attrs:{"id":"password","name":"password","type":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}})]),_vm._v(" "),(_vm.errors && _vm.errors.password)?_c('small',{staticClass:"error text-main"},[_vm._v(_vm._s(_vm.errors.password.join()))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"split"},[_c('div',{staticClass:"checkbox-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.remember),expression:"form.remember"}],staticClass:"text-main",attrs:{"id":"remember","name":"remember","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.remember)?_vm._i(_vm.form.remember,null)>-1:(_vm.form.remember)},on:{"change":function($event){var $$a=_vm.form.remember,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "remember", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "remember", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "remember", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"text-main",attrs:{"for":"remember"}},[_vm._v("Lembrar-me")])]),_vm._v(" "),_c('a',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showForgotModal = true}}},[_vm._v("Esqueceu sua senha?")])]),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"button btn-primary"},[_vm._v("Entrar")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary",attrs:{"disabled":""}},[_c('loading')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"create-account"},[_c('span',[_vm._v("Não possui cadastro?")]),_vm._v(" "),_c('button',{staticClass:"button btn-primary register-button",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showRegisterModal = true}}},[_vm._v("\n                  Clique aqui e cadastre-se\n                ")])])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/logo-healthid.png */ 629)}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-container"},[_c('h1',[_vm._v("\n              Manter o controle de sua saúde nunca foi tão fácil.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-main"},[_vm._v("\n              Exames de saúde por meio de coleta rápida de sangue, para você controlar e melhorar a sua saúde, de hoje e\n              para o futuro.\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 629 */
/*!*********************************************!*\
  !*** ./src/assets/images/logo-healthid.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/logo-healthid.fc8b8c12.png";

/***/ }),
/* 630 */
/*!***************************************!*\
  !*** ./src/views/Profile/Profile.vue ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Profile.vue */ 218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaf5f954_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-aaf5f954","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Profile.vue */ 643);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-aaf5f954","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Profile.vue */ 631)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aaf5f954"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaf5f954_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aaf5f954","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Profile/Profile.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/*!**************************************************************!*\
  !*** ./src/components/NewPasswordModal/NewPasswordModal.vue ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_NewPasswordModal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NewPasswordModal.vue */ 219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f263952_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPasswordModal_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7f263952","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NewPasswordModal.vue */ 634);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7f263952","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NewPasswordModal.vue */ 633)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f263952"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_NewPasswordModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f263952_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPasswordModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 633 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f263952","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NewPasswordModal/NewPasswordModal.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/*!**************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f263952","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewPasswordModal/NewPasswordModal.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",on:{"click":function($event){return _vm.outsideClick()}}},[_c('div',{staticClass:"modal-box"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-box"},[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Nova senha *")]),_vm._v(" "),_c('span',{staticClass:"password-icon"},[[_c('a-tooltip',{staticStyle:{"margin":"0 5px"}},[_c('template',{slot:"title"},[_vm._v("\n                                            A senha deve ter no mínimo 6 caracteres e ser composta de, ao menos, letras e números.\n                                        ")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":['fa', 'question-circle']}})],2)],_vm._v(" "),(!_vm.showPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye-slash']},on:{"click":function($event){return _vm.handleShowPassword(0)}}}):_vm._e(),_vm._v(" "),(_vm.showPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye']},on:{"click":function($event){return _vm.handleShowPassword(0)}}}):_vm._e()],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],attrs:{"id":"password","name":"password","type":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.password)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.password.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"confirm_password"}},[_vm._v("Confirmar nova senha *")]),_vm._v(" "),_c('span',{staticClass:"password-icon"},[[_c('a-tooltip',{staticStyle:{"margin":"0 5px"}},[_c('template',{slot:"title"},[_vm._v("\n                                            Lembre-se, as senhas devem coincidir.\n                                        ")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":['fa', 'question-circle']}})],2)],_vm._v(" "),(!_vm.showConfirmPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye-slash']},on:{"click":function($event){return _vm.handleShowPassword(1)}}}):_vm._e(),_vm._v(" "),(_vm.showConfirmPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye']},on:{"click":function($event){return _vm.handleShowPassword(1)}}}):_vm._e()],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password_confirmation),expression:"form.password_confirmation"}],attrs:{"id":"confirm_password","name":"confirm_password","type":"password"},domProps:{"value":(_vm.form.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password_confirmation", $event.target.value)}}})]),_vm._v(" "),(!_vm.confirmed)?_c('div',{staticClass:"form-actions"},[(!_vm.loading)?_c('button',{staticClass:"button btn-primary",on:{"click":_vm.handleSubmit}},[_vm._v("Salvar")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-purple",attrs:{"disabled":""}},[_c('loading')],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.confirmed)?_c('div',{staticClass:"form-box"},[_vm._m(1)]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Gerar nova senha")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Sua senha foi alterada com sucesso!.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 635 */
/*!**************************************************************!*\
  !*** ./src/components/ProfileSaveModal/RegisterKitModal.vue ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterKitModal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RegisterKitModal.vue */ 220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_765f36ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterKitModal_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-765f36ae","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RegisterKitModal.vue */ 636);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterKitModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_765f36ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterKitModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 636 */
/*!***************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-765f36ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileSaveModal/RegisterKitModal.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",on:{"click":function($event){return _vm.outsideClick()}}},[_c('div',{staticClass:"modal-box"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"form-box",staticStyle:{"padding":"1rem"}},[_c('h3',[_vm._v("Muito obrigado por escolher a Health ID!")]),_vm._v(" "),_c('h4',[_vm._v("Clique abaixo e registre seu kit.")]),_vm._v(" "),_c('h5',[_vm._v("O número de registro do kit se encontra na embalagem metalizada dentro da caixa.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('button',{staticClass:"button btn-orange",staticStyle:{"width":"100%","margin":"21px 0"},on:{"click":function($event){$event.preventDefault();return _vm.toRegisterKit.apply(null, arguments)}}},[_vm._v("\n              Registrar Kit\n            ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/vector-fluxo-healthid-lab-com.png */ 221),"width":"300"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 637 */
/*!************************************************************************!*\
  !*** ./src/components/ProfileIncompleteModal/RegisterProfileModal.vue ***!
  \************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterProfileModal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RegisterProfileModal.vue */ 222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10ce3914_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterProfileModal_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-10ce3914","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RegisterProfileModal.vue */ 638);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterProfileModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10ce3914_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterProfileModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 638 */
/*!*************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10ce3914","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileIncompleteModal/RegisterProfileModal.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",on:{"click":function($event){return _vm.outsideClick()}}},[_c('div',{staticClass:"modal-box"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"max-width":"680px"}},[_c('div',{staticClass:"form-box",staticStyle:{"padding":"1rem"}},[_c('h4',[_vm._v("Complete os campos a seguir com as demais informações de cadastro.")]),_vm._v(" "),_c('h5',[_vm._v("É muito importante preencher todos os campos, pois será com base nesses dados que tracionaremos os cálculos de alguns riscos preditivos.")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"button btn-orange",staticStyle:{"width":"100%","margin":"21px 0"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('close')}}},[_vm._v("\n              Ok\n            ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */
/*!***************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaf5f954","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/Profile.vue ***!
  \***************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-menu'),_vm._v(" "),(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),(_vm.showPasswordModal)?_c('new-password-modal',{on:{"close":function($event){_vm.showPasswordModal = false}}}):_vm._e(),_vm._v(" "),(_vm.showKitModal === true)?_c('register-kit-modal',{on:{"close":function($event){_vm.showKitModal = false}}}):_vm._e(),_vm._v(" "),(_vm.showProfileModal === true)?_c('register-profile-modal',{on:{"close":function($event){_vm.showProfileModal = false}}}):_vm._e(),_vm._v(" "),_c('section',{staticClass:"container profile-container"},[_c('div',{staticClass:"profile"},[_c('h1',[_vm._v("Perfil")]),_vm._v(" "),_c('div',{staticClass:"profile-card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"box"},[_c('h2',[_vm._v("Dados Pessoais")]),_vm._v(" "),_c('form',{on:{"submit":_vm.handleSubmit}},[_c('input',{staticStyle:{"display":"none"},attrs:{"id":"photo","accept":".png, .jpg, .jpeg, .gif","name":"photo","type":"file"},on:{"change":function($event){return _vm.handleChangePhoto()}}}),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"cpf"}},[_vm._v("CPF")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cpf),expression:"form.cpf"},{name:"mask",rawName:"v-mask",value:('###.###.###-##'),expression:"'###.###.###-##'"}],attrs:{"id":"cpf","placeholder":"000.000.000-00","tokens":_vm.numberToken,"name":"cpf","type":"text"},domProps:{"value":(_vm.form.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cpf", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.cpf)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.cpf.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Nome Completo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],attrs:{"id":"name","name":"name","type":"text"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.name)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.name.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"gender"}},[_vm._v("Sexo biológico")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.gender),expression:"form.gender"}],attrs:{"id":"gender","name":"gender"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"}},[_vm._v("Selecione uma opção")]),_vm._v(" "),_c('option',{attrs:{"value":"M"}},[_vm._v("Masculino")]),_vm._v(" "),_c('option',{attrs:{"value":"F"}},[_vm._v("Feminino")])]),_vm._v(" "),(_vm.errors && _vm.errors.gender)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.gender.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"ethnicity"}},[_vm._v("Etnia")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.ethnicity),expression:"form.ethnicity"}],attrs:{"id":"ethnicity","name":"ethnicity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "ethnicity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"}},[_vm._v("Selecione uma opção")]),_vm._v(" "),_c('option',{attrs:{"value":"A"}},[_vm._v("Amarelo")]),_vm._v(" "),_c('option',{attrs:{"value":"B"}},[_vm._v("Branco")]),_vm._v(" "),_c('option',{attrs:{"value":"I"}},[_vm._v("Indígena")]),_vm._v(" "),_c('option',{attrs:{"value":"M"}},[_vm._v("Mestiço")]),_vm._v(" "),_c('option',{attrs:{"value":"N"}},[_vm._v("Negro")]),_vm._v(" "),_c('option',{attrs:{"value":"P"}},[_vm._v("Pardo")])]),_vm._v(" "),(_vm.errors && _vm.errors.ethnicity)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.ethnicity.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{staticClass:"datepicker-label",attrs:{"for":"birthdate"}},[_vm._v("Data de nascimento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.birth_date),expression:"form.birth_date"},{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],attrs:{"id":"birthdate","placeholder":"00/00/0000","tokens":_vm.numberToken,"name":"birthdate","type":"text"},domProps:{"value":(_vm.form.birth_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "birth_date", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.birth_date)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.birth_date.join()))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('h2',[_vm._v("Dados de Contato")]),_vm._v(" "),_c('form',{staticStyle:{"margin-bottom":".25rem"},on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],attrs:{"id":"email","name":"email","type":"text"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.email)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.email.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"cellphone"}},[_vm._v("Celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cellphone),expression:"form.cellphone"},{name:"mask",rawName:"v-mask",value:('(##) #####-####'),expression:"'(##) #####-####'"}],attrs:{"id":"cellphone","placeholder":"(00) 00000-0000","tokens":_vm.numberToken,"name":"cellphone","type":"text"},domProps:{"value":(_vm.form.cellphone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cellphone", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.cellphone)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.cellphone.join()))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer profile"},[(!_vm.loading && !_vm.errors && this.form.first_acess && this.showSavedMessage)?_c('div',{staticClass:"saved"},[_c('span',[_vm._v("Informações salvas com sucesso.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"actions"},[(!_vm.loading)?_c('button',{staticClass:"button btn-primary aff",on:{"click":_vm.handleSubmit}},[_vm._v("Salvar Informações")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-purple aff",attrs:{"disabled":""}},[_c('loading')],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"button btn-secondary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showPasswordModal = true}}},[_vm._v("\n                Nova senha\n              ")]):_vm._e()])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 644 */
/*!*******************************************!*\
  !*** ./src/views/Dashboard/Dashboard.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Dashboard.vue */ 359);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eff542f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4eff542f","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Dashboard.vue */ 646);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4eff542f","scoped":false,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Dashboard.vue */ 645)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eff542f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 645 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4eff542f","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Dashboard/Dashboard.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eff542f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard/Dashboard.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-menu'),_vm._v(" "),(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container profile-container"},[_c('div',{staticClass:"profile"},[_c('h1',[_vm._v("Dashboard")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"card-body"}),_vm._v(" "),_c('div',{staticClass:"card-footer"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 647 */
/*!*********************************!*\
  !*** ./src/views/Kits/Kits.vue ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Kits_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Kits.vue */ 360);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59366e6b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kits_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-59366e6b","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Kits.vue */ 815);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-59366e6b","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Kits.vue */ 648)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59366e6b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Kits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59366e6b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 648 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59366e6b","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Kits/Kits.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00154d1c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/KitResults/KitResults.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/*!*************************************************!*\
  !*** ./src/components/KitResults/ValueCard.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ValueCard_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ValueCard.vue */ 364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a22d498_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValueCard_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0a22d498","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ValueCard.vue */ 652);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0a22d498","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ValueCard.vue */ 651)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a22d498"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ValueCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a22d498_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValueCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 651 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a22d498","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/KitResults/ValueCard.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a22d498","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KitResults/ValueCard.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"value-card"},[_c('div',{staticClass:"value-metric"},[_c('span',{staticClass:"value-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"measured"},[_vm._v("mensurado em "+_vm._s(!!_vm.percentage ? 'porcentagem' : !!_vm.quantivac ? 'RU/ml' : !!_vm.tfg ? 'mL/min x 1,73m²' : 'mg/dL'))]),_vm._v(" "),_c('div',{staticClass:"value-bar"},[_c('div',{staticClass:"bar"},[_vm._l((_vm.labels),function(label,x){return [_c('div',{key:x,class:'area ' + label.color},[(_vm.result.label == label.name)?_c('div',{staticClass:"mark",style:(_vm.getMarkPosition(label.interval))},[_c('div',{staticClass:"value-box",class:_vm.getValueColor()},[_vm._v(_vm._s(_vm.result.value))])]):_vm._e(),_vm._v(" "),(!!label.interval.max)?_c('div',{staticClass:"limit"},[_c('div',{staticClass:"limit-value"},[_vm._v(_vm._s(label.interval.max))])]):_vm._e()])]})],2),_vm._v(" "),_c('div',{staticClass:"details"},_vm._l((_vm.labels),function(label,x){return _c('span',{key:x,staticClass:"detail"},[_vm._v("\n                        "+_vm._s(label.name)+"\n                    ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"reference"},[_c('div',{staticClass:"level-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"icon"},[(['Ótimo', 'Desejável', 'Normal'].includes(_vm.result.label))?_c('font-awesome-icon',{attrs:{"icon":['fa', 'check-circle']}}):_c('font-awesome-icon',{attrs:{"icon":['fa', 'exclamation-circle']}})],1),_vm._v(" "),_c('div',{staticClass:"level"},[_c('span',[_vm._v("Seu nível está")]),_vm._v(" "),_c('span',{staticClass:"level-text",class:_vm.getValueColor()},[_vm._v(_vm._s(_vm.result.label))])]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                        "+_vm._s(_vm.result.value)+" "+_vm._s(!!_vm.percentage ? '%' : !!_vm.quantivac ? 'RU/ml' : !!_vm.tfg ? 'mL/min x 1,73m²' : 'mg/dL')+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"range"},[_c('span',[_vm._v(_vm._s(_vm.getIntervalDesc()))])])])]),_vm._v(" "),_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.$emit('openModal', true, _vm.altTitle, _vm.result)}}},[_vm._v("O que significa?")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 653 */
/*!*************************************************!*\
  !*** ./src/components/KitResults/TextModal.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TextModal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TextModal.vue */ 365);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6489d620_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextModal_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6489d620","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TextModal.vue */ 655);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6489d620","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TextModal.vue */ 654)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6489d620"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TextModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6489d620_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 654 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6489d620","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/KitResults/TextModal.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6489d620","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KitResults/TextModal.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",on:{"click":function($event){return _vm.outsideClick()}}},[_c('div',{staticClass:"modal-box result-modal"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.exam.title == 'igg')?[(_vm.exam.label == 'Positivo')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Seu resultado foi POSITIVO, o que significa que seu organismo tem um alto grau de proteção \n                        contra o Vírus.\n                    ")]):_vm._e(),_vm._v(" "),(_vm.exam.label == 'Indeterminado')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Seu resultado foi INDETERMINADO, o que significa que o seu organismo possui alguma proteção contra o \n                        Vírus, porém não a ideal. Orientamos que verifique com o seu médico o motivo da variação.\n                    ")]):_vm._e(),_vm._v(" "),(_vm.exam.label == 'Negativo')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Seu resultado foi NEGATIVO, o que podemos considerar duas possibilidades:"),_c('br'),_vm._v("\n                        1) Você não teve contato com o vírus;"),_c('br'),_vm._v("\n                        2) O teste foi realizado enquanto ainda não havia a produção de anticorpos suficientes no organismo.\n                    ")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.exam.title == 'quantivac')?[(_vm.exam.label == 'Elevado')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Seu resultado foi ELEVADO, o que significa que a produção deste antígeno pelo seu organismo \n                        foi detectada em uma alta escala. O que é ótimo, pois significa que após a vacina, o seu organismo avançou para a criação de defesas contra \n                        os sintomas graves da COVID 19.\n                    ")]):_vm._e(),_vm._v(" "),(_vm.exam.label == 'Indeterminado')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Seu resultado foi INDETERMINADO, o que significa que não existe certeza sobre a eficácia da vacina \n                        no seu organismo. Orientamos que verifique com o seu médico o motivo da variação, bem como aguardar o período de aproximadamente 15 dias para \n                        realizar novo teste.\n                    ")]):_vm._e(),_vm._v(" "),(_vm.exam.label == 'Não detectado')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Seu resultado foi NÃO-DETECTADO, o que significa que a produção deste antígeno pelo seu organismo \n                        não foi detectada. Orientamos que verifique com o seu médico o motivo do resultado.\n                    ")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.exam.title == 'hdl')?[(_vm.exam.label == 'Normal')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" O HDL, ou lipoproteína de alta densidade, é conhecido como o colesterol \"bom\". Ele age como um faxineiro, \n                        removendo o colesterol das artérias e os leva de volta para o fígado, impedindo seu acúmulo. Por isso é importante que você mantenha o HDL sempre elevado. \n                        Ter níveis elevados de colesterol HDL pode diminuir o risco de ter ataques cardíacos e acidentes vasculares cerebrais.\n                    ")]):_vm._e(),_vm._v(" "),(_vm.exam.label == 'Alterado')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" O seu nível de colesterol HDL está abaixo do que é considerado aceitável. Cuidado! Isso costuma estar associado a um nível insuficiente de atividades físicas."),_c('br'),_c('br'),_vm._v("\n                        O HDL, ou lipoproteína de alta densidade é conhecido como o colesterol \"bom\". Ele age como um faxineiro, \n                        removendo o colesterol das artérias e os leva de volta para o fígado, impedindo seu acúmulo. Por isso é importante que você mantenha o HDL sempre elevado."),_c('br'),_c('br'),_vm._v("\n                        Possuir níveis abaixo do recomendado de colesterol HDL podem aumentar o risco de ter ataques cardíacos e acidentes vasculares cerebrais, \n                        sobretudo quando estiverem associados a níveis altos de colesterol LDL.\n                    ")]):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"font-style":"italic"}},[_vm._v("\n                        Atualização da Diretriz Brasileira de Dislipidemias e Prevenção da Aterosclerose. Arq Bras Cardiol 2017; 109(2Supl.1):1-76.\n                    ")])]:_vm._e(),_vm._v(" "),(_vm.exam.title == 'ldl')?[(_vm.exam.label == 'Normal')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" O seu nível de colesterol LDL está ótimo. Parabéns! Continue assim."),_c('br'),_c('br'),_vm._v("\n                        O LDL é conhecido como o colesterol \"ruim\". Pode levar a um acúmulo de placa nas artérias \n                        (Artérias são vasos sanguíneos que levam sangue para longe do coração e para o resto do corpo)."),_c('br'),_c('br'),_vm._v("\n                        Este acúmulo de gordura também é frequentemente referido como placa e é uma mistura endurecida de gordura, \n                        colesterol e outras substâncias no sangue.\n                    ")]):_vm._e(),_vm._v(" "),(_vm.exam.label == 'Elevado')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" O seu nível de colesterol LDL está elevado. Fique atento!"),_c('br'),_c('br'),_vm._v("\n                        Níveis elevados de colesterol LDL podem aumentar o acúmulo de gordura nos vasos sanguíneos, \n                        restringindo o fluxo de sangue por todo o corpo, podendo acarretar doenças cardíacas, AVC e hipertensão.\n                    ")]):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"font-style":"italic"}},[_vm._v("\n                        O seu valor de LDL foi considerado através do seu risco cardiológico e apresentado seu alvo terapêutico com base nas \n                        Diretrizes Brasileiras de Dislipidemia e Aterosclerose de 2017.\n                    ")])]:_vm._e(),_vm._v(" "),(_vm.exam.title == 'hba1c')?[(_vm.diseases.hasDiabetes)?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o exame:")]),_vm._v(" O exame de hemoglobina glicada é feito com o objetivo de avaliar os níveis de glicose nos últimos meses, \n                        sendo útil no diagnóstico da diabetes. Além disso, no caso de pessoas que já foram diagnosticadas com diabetes, esse exame é útil para verificar \n                        se o tratamento está sendo eficaz ou está sendo feito corretamente, pois caso não esteja, pode ser verificada alteração no resultado."),_c('br'),_c('br'),_vm._v("\n                        Ainda, quando o valor de hemoglobina glicada é muito superior ao normal há maior probabilidade da pessoa desenvolver complicações relacionadas com \n                        a diabetes, como alterações cardíacas, renais ou neuronais, por exemplo."),_c('br'),_c('br'),_vm._v("\n                        No caso das pessoas que já têm diagnóstico de diabetes mellitus, valores de Hb1Ac entre 6,5% e 7,0% demonstram que a doença está sendo bem controlada. \n                        Porém, valores de Hb1Ac acima de 8% indicam que a diabetes não está sendo controlada da melhor forma, havendo maior risco de complicações. \n                        Nesse caso é necessária avaliação médica para definição do tratamento.\n                    ")]):(_vm.exam.label == 'Normal')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Parabéns! O Resultado do exame aponta que você não apresenta condição de Diabetes Mellitus, \n                        tampouco risco aumentado para desenvolve-la."),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Sobre o exame:")]),_vm._v(" O exame de hemoglobina glicada é feito com o objetivo de avaliar os níveis de glicose nos últimos meses, \n                        sendo útil no diagnóstico da diabetes. Além disso, no caso de pessoas que já foram diagnosticadas com diabetes, esse exame é útil para verificar se \n                        o tratamento está sendo eficaz ou está sendo feito corretamente, pois caso não esteja, pode ser verificada alteração no resultado.\n                    ")]):(_vm.exam.label == 'Pré-Diabético')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Para o diagnóstico de Diabetes Mellitus a dosagem de HbA1c deve ser confirmada com novo exame \n                        em dia diferente ou através do seu médico. De acordo com o resultado do seu exame existe um risco aumentado para desenvolver Diabetes."),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Sobre o exame:")]),_vm._v(" O exame de hemoglobina glicada é feito com o objetivo de avaliar os níveis de glicose nos \n                        últimos meses, sendo útil no diagnóstico da diabetes. Além disso, no caso de pessoas que já foram diagnosticadas com diabetes, esse exame é\n                        útil para verificar se o tratamento está sendo eficaz ou está sendo feito corretamente, pois caso não esteja, pode ser verificada alteração no resultado.\n                    ")]):(_vm.exam.label == 'Diabete Mellitus')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Para o diagnóstico de Diabetes Mellitus a dosagem de HbA1c deve ser confirmada com novo exame em dia \n                        diferente ou através do seu médico. De acordo com o resultado do seu exame você tem um pré-diagnóstico de Diabetes Mellitus."),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Sobre o exame:")]),_vm._v(" O exame de hemoglobina glicada é feito com o objetivo de avaliar os níveis de glicose nos últimos meses,\n                        sendo útil no diagnóstico da diabetes. Além disso, no caso de pessoas que já foram diagnosticadas com diabetes, esse exame é útil para verificar se \n                        o tratamento está sendo eficaz ou está sendo feito corretamente, pois caso não esteja, pode ser verificada alteração no resultado.\n                    ")]):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"font-style":"italic"}},[_vm._v("\n                        Fonte: Professional Pratice Committee: Standards of Medical Care in Diabetes 2018/Diabetes Care 2018;41(Suppl.1):S3.\n                    ")])]:_vm._e(),_vm._v(" "),(_vm.exam.title == 'gli')?[(_vm.exam.label == 'Hipoglicemia')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" O exame ou teste de glicose, tem como objetivo verificar a quantidade de açúcar no sangue."),_c('br'),_c('br'),_vm._v("\n                        A glicose, chega no sangue principalmente através da ingestão dos alimentos que contém carboidratos,\n                        como bolo, massas e pães, mas também pode se originar da frutose encontrada nas frutas, por exemplo. \n                        Ela também é formada no nosso corpo a partir de outros substratos (no caso aqui só quando o organismo indica que há redução dos níveis de \n                        glicose no sangue e converter glicogênio em glicose. Retiraria essa informação)."),_c('br'),_c('br'),_vm._v("\n                        O fato de estar com o nível de glicose abaixo do normal pode não significar uma coisa boa. \n                        Tendo em vista que a glicose é a única fonte de energia do cérebro, a baixa glicemia é capaz de ocasionar inúmeros sintomas, \n                        tais como sonolência, desmaios, sudorese, dentre outros sintomas."),_c('br'),_c('br'),_vm._v("\n                        A glicemia baixa, ou hipoglicemia, pode ocorrer em qualquer indivíduo. Períodos de jejum muito extensos, \n                        atividades físicas por longos períodos, ou o uso de medicamentos e consumo de bebida alcoólica podem estar relacionados.\n                    ")]):_vm._e(),_vm._v(" "),(_vm.exam.label == 'Normal')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" O exame ou teste de glicose, tem como objetivo verificar a quantidade de açúcar no sangue (glicemia). "),_c('br'),_c('br'),_vm._v("\n                        A glicose chega no sangue principalmente através da ingestão dos alimentos que contém carboidratos, como bolo, massas e pães, \n                        mas também pode se originar da frutose encontrada nas frutas, por exemplo. Ela também formada no nosso corpo a partir de outros substratos."),_c('br'),_c('br'),_vm._v("\n                        Por isso, é importante manter os níveis de glicemia dentro dos limites recomendados, com a ingestão de alimentos ricos em fibras, proteínas e \n                        gorduras boas, além de uma rotina de atividades físicas diárias.\n                    ")]):_vm._e(),_vm._v(" "),(_vm.exam.label == 'Glicemia Elevada')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" O exame de glicose, também conhecido como teste da glicose, é feito com objetivo de verificar a quantidade de açúcar no sangue, \n                        que recebe o nome de glicemia, e é considerado o principal exame para diagnosticar a diabetes."),_c('br'),_c('br'),_vm._v("\n                        A glicose chega no sangue principalmente através da ingestão dos alimentos que contém carboidratos, como bolo, massas e pães, mas também pode se originar \n                        da frutose encontrada nas frutas, por exemplo. Ela também formada no nosso corpo a partir de outros substratos."),_c('br'),_c('br'),_vm._v("\n                        A glicemia alta, ou hiperglicemia, ocorre quando os níveis de açúcar no sangue estão muito elevados, podendo provocar o surgimento de diabetes ou\n                        complicações relacionadas com a diabetes, como alterações cardíacas, renais ou neuronais, por exemplo. Essa alteração normalmente não provoca sintomas,\n                        mas nos casos em que a glicemia está muito alta e por muito tempo, podem aparecer boca seca, dor de cabeça, sonolência e vontade frequente de urinar."),_c('br'),_c('br'),_vm._v("\n                        As principais medidas para amenizar essa condição são mudanças na dieta, reduzindo o consumo de alimentos ricos em açúcar e massas, bem como, \n                        por meio da realização de atividades físicas regularmente. No caso das pessoas que já têm diagnóstico de diabetes mellitus é sempre importante que se \n                        faça a medição diária da glicemia. Nesse caso é necessária avaliação médica para definição do tratamento. \n                    ")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.exam.title == 'tri')?[(_vm.exam.label == 'Normal')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Triglicerídeos são um tipo de gordura presente na sua corrente sanguínea. Altos níveis de triglicerídeos são um fator de risco para doenças cardíacas, \n                        problemas de tireoide, diabetes mal controlada, doença renal ou hepática. Portanto mantenha hábitos que promovam o controle do peso, \n                        através de uma dieta com baixo teor de açúcar, moderação no consumo de carne vermelha e, se possível, evitando alimentos ricos em gorduras saturadas.\n                    ")]):_vm._e(),_vm._v(" "),(_vm.exam.label == 'Pouco Elevado')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Triglicerídeos são um tipo de gordura na sua corrente sanguínea. \n                        Altos níveis de triglicerídeos são um fator de risco para doenças cardíacas, problemas de tireoide, \n                        diabetes mal controlada, doença renal ou hepática."),_c('br'),_c('br'),_vm._v("\n                        Triglicerídeos elevados podem resultar de:"),_c('br'),_vm._v("\n                        - Ganho de peso"),_c('br'),_vm._v("\n                        - Dieta com muitos açúcares adicionados ou simples, carne vermelha e alimentos ricos em gorduras saturadas (como leite integral e cream cheese)"),_c('br'),_vm._v("\n                        - Fatores genéticos - é possível ter triglicérides elevados por causa dos genes que você herda (mesmo que você tenha uma dieta bem equilibrada e se exercite regularmente)\n                        "),_c('br'),_c('br'),_vm._v("\n                        Se você costuma consumir mais calorias do que queima, principalmente calorias de carboidratos e gorduras, pode ter triglicérides elevados. Pode ser ainda um efeito colateral de certos medicamentos.\n                    ")]):_vm._e(),_vm._v(" "),(_vm.exam.label == 'Elevado')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Triglicerídeos são um tipo de gordura na sua corrente sanguínea. \n                        Altos níveis de triglicerídeos são um fator de risco para doenças cardíacas, problemas de tireoide, diabetes mal controlada, \n                        doença renal ou hepática."),_c('br'),_c('br'),_vm._v("\n                        Triglicerídeos elevados podem resultar de:"),_c('br'),_vm._v("\n                        - Ganho de peso"),_c('br'),_vm._v("\n                        - Dieta com muitos açúcares adicionados ou simples, carne vermelha e alimentos ricos em gorduras saturadas (como leite integral e cream cheese)"),_c('br'),_vm._v("\n                        - Fatores genéticos - é possível ter triglicérides elevados por causa dos genes que você herda (mesmo que você tenha uma dieta bem equilibrada e se exercite regularmente)"),_c('br'),_c('br'),_vm._v("\n                        Os triglicerídeos altos podem indicar risco aumentado de doença no fígado, aterosclerose, pancreatite, diabetes descompensada, hipotireoidismo e infarto do miocárdio. \n                        Se você está com este nível procure um médico para que ele possa lhes orientar.\n                    ")]):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"font-style":"italic"}},[_vm._v("\n                        Atualização da Diretriz Brasileira de Dislipidemias e Prevenção da Aterosclerose. Arq Bras Cardiol 2017; 109(2Supl.1):1-76.\n                    ")])]:_vm._e(),_vm._v(" "),(_vm.exam.title == 'clt')?[(_vm.exam.label === 'Normal')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Colesterol total é a quantidade combinada de diferentes tipos de colesterol \n                        encontrados no corpo, incluindo LDL, HDL e VLDL.\n                        "),_c('br'),_c('br'),_vm._v("\n                        Colesterol é uma substância gordurosa encontrada no sangue. É essencial no nosso organismo e importante para muitas das atividades do corpo, \n                        como a produção de hormônios, manutenção da temperatura corporal. Porém, altas quantidades de colesterol podem aumentar o \n                        risco de doenças cardíacas, AVC e hipertensão.\n                    ")]):_vm._e(),_vm._v(" "),(_vm.exam.label === 'Elevado')?_c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" Colesterol total é a quantidade combinada de diferentes tipos de colesterol \n                        encontrados no corpo, incluindo LDL, HDL e VLDL.\n                        "),_c('br'),_c('br'),_vm._v("\n                        Colesterol total alto pode ser um fator de risco para doenças cardíacas. Isso porque muito colesterol na\n                        corrente sanguínea pode levar à formação de placas nas artérias, o contribui para condições como angina,\n                        doença arterial carótidea, disfunção renal e doença arterial periférica.\n                    ")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.exam.title == 'creatinine')?[_vm._m(0)]:_vm._e(),_vm._v(" "),(_vm.exam.title == 'tfg')?[_vm._m(1)]:_vm._e()],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" A creatinina é uma substância que está presente no nosso sangue.\n                        "),_c('br'),_c('br'),_vm._v("\n                        Ela é produzida pelos músculos e eliminada pelos rins. A análise dos níveis de creatinina no sangue é importante para investigar a \n                        existência de alguma alteração nos rins, tendo em vista que nessa situação a concentração dessa proteína estará mais elevada no sangue.\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("Sobre o resultado:")]),_vm._v(" A taxa de filtração glomerular estimada (TFG) é uma medida que tem por finalidade\n                         verificar o funcionamento dos rins. Leva em consideração a dosagem de substâncias que são filtradas nos rins e não são \n                         reabsorvidas para o sangue. Para calculá-la leva-se em consideração o valor da creatinina sérica, a idade e o sexo do paciente.\n                          Atualmente a fórmula mais comumente utilizada é 2021 CKD-EPI.\n                    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 656 */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00154d1c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KitResults/KitResults.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card kit-data kit-results card-shrink"},[_c('div',{staticClass:"header-item btn-back",on:{"click":function($event){return _vm.$emit('back')}}},[_c('font-awesome-icon',{staticStyle:{"margin-right":"10px"},attrs:{"icon":['fa', 'arrow-left']}}),_vm._v(" "),_c('span',{staticClass:"desktop"},[_vm._v("Voltar")])],1),_vm._v(" "),_c('div',{staticClass:"rsl-header"},[(_vm.result.kit_type_id > 2)?_c('div',{staticClass:"header-item active",on:{"click":function($event){return _vm.$emit('changeView', 'rsl')}}},[_c('span',{staticClass:"item-text"},[_vm._v("Resultados")])]):_vm._e(),_vm._v(" "),(_vm.result.kit_type_id > 2)?_c('div',{staticClass:"header-item",on:{"click":function($event){return _vm.$emit('changeView', 'rsk')}}},[_c('span',{staticClass:"item-text"},[_vm._v("Riscos")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"header-item",on:{"click":function($event){return _vm.$emit('download', _vm.result.id)}}},[_c('font-awesome-icon',{staticClass:"desktop",staticStyle:{"margin-right":"5%"},attrs:{"icon":['fa', 'receipt']}}),_vm._v("\n        Laudo\n      ")],1)]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',{staticClass:"title"},[_vm._v("Testes e resultados")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.result.kit_type.name))]),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-anticorpos-igg-covid')?[_c('p',[_vm._v("\n          Este Check-up é indicado para quem teve contato com o vírus SARS-CoV-2\n          da COVID-19.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Quando temos contato com o vírus SARS-CoV-2, o sistema imunológico do\n          corpo organiza defesas capazes de limitar a ação de tais organismos\n          estranhos e gerar uma proteção quantos aos sintomas mais graves em uma\n          futura reinfecção.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          A boa notícia é que isso ocorre por meio da produção de anticorpos\n          naturais, sendo o IgG um deles, e que pode ser verificado através do\n          nosso Check-up Anticorpos IgG Covid. Desta forma, o resultado do seu\n          exame serve justamente para identificar se você teve em seu organismo\n          a produção desse anticorpo, através de contato com o vírus.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Todavia, é fundamental continuar usando máscara e a fazer\n          distanciamento social seguindo as recomendações dos órgãos\n          competentes.\n        ")])]:_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-anticorpos-vacina-covid')?[_c('p',[_vm._v("\n          Este Check-up é indicado a partir do momento em que temos contato com\n          a vacina e recebemos determinada carga do antídoto a fim de provocar a\n          produção de anticorpos em nosso organismo.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Quando esse processo é bem-sucedido o corpo torna-se capaz de combater\n          o vírus em uma futura infecção, gerando uma proteção quanto aos\n          sintomas e quadros mais graves. O exame em questão quantifica o\n          domínio S1 viral (Proteína Spike).\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          A boa notícia é que você consegue avaliar a quantidade de anticorpos\n          neutralizadores do vírus SARS-CoV-2 da COVID-19 gerados em seu\n          organismo após a aplicação da primeira ou segunda dose da vacina,\n          quando for o caso, com o nosso Check-up Anticorpos Quantivac.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Todavia, mesmo após as duas doses da vacina é fundamental continuar\n          usando máscara e a fazer distanciamento social seguindo as\n          recomendações dos órgãos competentes.\n        ")])]:_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-saude-do-coracao')?[_c('p',[_vm._v("\n          As Doenças Cardiovasculares, mais conhecidas como Doenças do Coração,\n          estão entre as principais caudas de morte no mundo. Um dos principais\n          motivos é porque os sintomas mais comuns podem passar de forma\n          imperceptível, tendo em vista a vida que levamos: cansaço frequente;\n          palpitações; suor frio; tonturas; dores no peito; enjoo ou perda de\n          apetite e etc.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          A boa notícia é que para prevenir as Doenças do Coração, basta\n          realizar check-ups com frequência, melhorar hábitos alimentares,\n          realizar atividades físicas e cuidar do bem-estar emocional.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Controlar o colesterol, a pressão arterial, para de fumar e perder\n          peso são as principais ferramentas contra as Doenças do Coração.\n        ")])]:_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-saude-preventiva')?[_c('p',[_vm._v("\n          A saúde preventiva é um conjunto de medidas e práticas que visam\n          evitar o surgimento de doenças e promover o bem-estar físico e mental.\n          É um enfoque proativo que se concentra na prevenção em vez de tratar\n          doenças já estabelecidas. A importância da saúde preventiva reside no\n          fato de que muitas doenças podem ser evitadas ou diagnosticadas\n          precocemente por meio de exames regulares, estilo de vida saudável e\n          adoção de medidas preventivas específicas.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          A boa notícia é que para prevenir, basta realizar check-ups com\n          frequência, melhorar hábitos alimentares, realizar atividades físicas\n          e cuidar do bem-estar emocional.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          A saúde preventiva é um investimento valioso, que proporciona\n          bem-estar físico, emocional e social, permitindo que desfrutemos de\n          uma vida longa e saudável.\n        ")])]:_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-doencas-cronicas')?[_c('p',[_vm._v("\n          As Doenças Crônicas são aquelas que duram mais de um ano e precisam de\n          cuidados médicos praticamente constantes. Diabetes e problemas\n          cardiovasculares estão na lista que reúne as principais causas de\n          internações médicas no Brasil e no mundo.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Além dos fatores genéticos, a alimentação inadequada, obesidade, uso\n          de álcool, cigarro e outras drogas, sedentarismo e falta de descanso\n          são os principais fatores que levam ao desenvolvimento dessas\n          patologias. A boa notícia é que para prevenir as Doenças Crônicas,\n          basta realizar check-ups com frequência, melhorar hábitos alimentares,\n          realizar atividades físicas e cuidar do bem-estar emocional.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Controlar o colesterol, a pressão arterial, para de fumar e beber em\n          acesso, perder peso são as principais ferramentas contra as Doenças\n          Crônicas.\n        ")])]:_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-longevidade-saudavel')?[_c('p',[_vm._v("\n          Longevidade nada mais é do que viver mais. E aqui vamos conduzir você\n          a viver mais e com qualidade, identificando riscos atrelados à saúde,\n          bem como o risco de vir a desenvolver doenças crônicas ou demais\n          patologias. A pessoa com mais idade pode ter alteração na imunidade e\n          maior risco de infecção, por exemplo. Desta forma, a chance de ter um\n          melhor envelhecimento está ligada diretamente a hábitos saudáveis e\n          características pessoais.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          A boa notícia é que para ajudar você nesta etapa e prevenir doenças,\n          basta realizar check-ups com frequência, melhorar hábitos alimentares,\n          realizar atividades físicas e cuidar do bem-estar emocional.\n        ")])]:_vm._e(),_vm._v(" "),(
          _vm.result.kit_type.tag_type === 'check-up-anticorpos-igg-covid' ||
            _vm.result.kit_type.tag_type === 'check-up-anticorpos-vacina-covid'
        )?[(_vm.result.kit_type.tag_type === 'check-up-anticorpos-igg-covid')?_c('value-card',{attrs:{"title":'Valor',"altTitle":'igg',"result":_vm.igg,"labels":_vm.igg.metric_labels},on:{"openModal":_vm.openModal}}):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-anticorpos-vacina-covid')?_c('value-card',{attrs:{"title":'Valor',"altTitle":'quantivac',"result":_vm.quantivac,"labels":_vm.quantivac.metric_labels,"quantivac":true},on:{"openModal":_vm.openModal}}):_vm._e()]:[(!!_vm.hdl)?_c('value-card',{attrs:{"title":'Colesterol HDL',"altTitle":'hdl',"result":_vm.hdl,"labels":_vm.hdl.metric_labels},on:{"openModal":_vm.openModal}}):_vm._e(),_vm._v(" "),(!!_vm.ldl)?_c('value-card',{attrs:{"title":'Colesterol LDL',"altTitle":'ldl',"result":_vm.ldl,"labels":_vm.ldl.metric_labels},on:{"openModal":_vm.openModal}}):_vm._e(),_vm._v(" "),(!!_vm.hba1c)?_c('value-card',{attrs:{"title":'Hemoglobina Glicada (HbA1c)',"altTitle":'hba1c',"result":_vm.hba1c,"labels":_vm.hba1c.metric_labels,"percentage":true},on:{"openModal":_vm.openModal}}):_vm._e(),_vm._v(" "),(!!_vm.glicose)?_c('value-card',{attrs:{"title":'Glicose',"result":_vm.glicose,"altTitle":'gli',"labels":_vm.glicose.metric_labels},on:{"openModal":_vm.openModal}}):_vm._e(),_vm._v(" "),(!!_vm.triglicerideos)?_c('value-card',{attrs:{"title":'Triglicerídeos',"altTitle":'tri',"result":_vm.triglicerideos,"labels":_vm.triglicerideos.metric_labels},on:{"openModal":_vm.openModal}}):_vm._e(),_vm._v(" "),(!!_vm.colesterol)?_c('value-card',{attrs:{"title":'Colesterol total',"altTitle":'clt',"result":_vm.colesterol,"labels":_vm.colesterol.metric_labels},on:{"openModal":_vm.openModal}}):_vm._e(),_vm._v(" "),(!!_vm.creatinine)?_c('value-card',{attrs:{"title":'Creatinina',"altTitle":'creatinine',"result":_vm.creatinine,"labels":_vm.creatinine.metric_labels},on:{"openModal":_vm.openModal}}):_vm._e(),_vm._v(" "),(!!_vm.tfg)?_c('value-card',{attrs:{"title":'Filtração Glomerular Estimada',"altTitle":'tfg',"result":_vm.tfg,"labels":_vm.tfg.metric_labels,"tfg":true},on:{"openModal":_vm.openModal}}):_vm._e()]],2),_vm._v(" "),([1, 2].includes(_vm.result.kit_type_id))?_c('span',{staticClass:"footer-text"},[_vm._v("Exames processados pelo Euroimmun Brasil Medicina Diagnóstica LTDA.")]):_c('span',{staticClass:"footer-text"},[_vm._v("Exames processados pelo Laboratório Health ID LAB Diagnóstica.")]),_vm._v(" "),(_vm.textModal)?_c('text-modal',{attrs:{"exam":_vm.textModalExam,"diseases":_vm.diseases},on:{"close":function($event){return _vm.openModal(false)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 657 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56228c80","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/KitRisks/KitRisks.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/*!***********************************************!*\
  !*** ./src/components/KitRisks/RiskModal.vue ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RiskModal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RiskModal.vue */ 368);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2b9df52_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RiskModal_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c2b9df52","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RiskModal.vue */ 660);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-c2b9df52","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RiskModal.vue */ 659)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c2b9df52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RiskModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2b9df52_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RiskModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 659 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c2b9df52","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/KitRisks/RiskModal.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2b9df52","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KitRisks/RiskModal.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",on:{"click":function($event){return _vm.outsideClick()}}},[_c('div',{staticClass:"modal-box"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.risk.label === 'gambs')?[(_vm.risk.title == 'cardio')?_c('img',{staticClass:"gambs-image",attrs:{"src":__webpack_require__(/*! @/assets/images/tela_riscocardio.png */ 661)}}):_c('img',{staticClass:"gambs-image",attrs:{"src":__webpack_require__(/*! @/assets/images/tela_riscos.png */ 662)}})]:[_c('p',{staticClass:"text"},[(_vm.risk.title.toLowerCase() == 'risco psicológico')?[_vm._v("\n                            O Risco Psicológico é estimado para identificar os transtornos psicológicos mais comuns."),_c('br'),_vm._v(" O seu Risco Psicológico está \n                            "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.risk.label))]),_vm._v("."),_c('br'),_vm._v(" "),(_vm.risk.label == 'Baixo')?[_vm._v("\n                                De acordo com suas respostas destacamos que você está no caminho certo para evitar o adoecimento mental, \n                                isso porque, neste momento, você apresenta um perfil com baixa tendência para desenvolvimento de transtornos psicológicos, \n                                tais como depressão e ansiedade. Esta é uma boa notícia! Assim como a física, a saúde mental é uma parte integrante e complementar \n                                à manutenção das funções do organismo. Ter saúde mental é conseguir lidar tanto com emoções positivas e negativas investindo em estratégias \n                                que possibilitem o equilíbrio das funções mentais.\n                            ")]:_vm._e(),_vm._v(" "),(_vm.risk.label == 'Médio')?[_vm._v("\n                                De acordo com as respostas apresentadas observamos que é importante começar a refletir sobre a necessidade de conhecer melhor suas emoções,\n                                 dedique um tempo para você, realize atividades prazerosas, cuide da sua alimentação e durma bem, evitando transtornos como depressão \n                                 e ansiedade. Isso não quer dizer que você já possua alguma dessas condições, apenas é importante estar atento a seriedade dos sintomas \n                                 associados a essas patologias. Assim como a física, a saúde mental é extremamente determinante para a correta manutenção das funções vitais \n                                 do organismo. Ter saúde mental é conseguir lidar tanto com emoções positivas e negativas investindo em estratégias que possibilitem o \n                                 equilíbrio das funções mentais.\n                            ")]:_vm._e(),_vm._v(" "),(_vm.risk.label == 'Alto')?[_vm._v("\n                                De acordo com suas respostas destacamos que é importante prevenir o adoecimento mental, isso porque, neste momento, \n                                você apresenta um perfil com maior tendência para desenvolvimento de transtornos psicológicos, tais como depressão e ansiedade. \n                                Isso não quer dizer que você já possua alguma dessas condições, apenas é importante estar atento a seriedade dos sintomas associados \n                                a essas patologias. Assim como a física, a saúde mental é extremamente determinante para a correta manutenção das funções vitais do \n                                organismo. Ter saúde mental é conseguir lidar tanto com emoções positivas e negativas investindo em estratégias que possibilitem o \n                                equilíbrio das funções mentais. Para maiores informações sugerimos a realização de avaliação psicológica com um especialista.\n                            ")]:_vm._e(),_vm._v(" "),(_vm.risk.title.toLowerCase() == 'risco psicológico')?_c('div',{staticClass:"bottom"},[_vm._v("\n                                Nota: Utilização de instrumento Beck Depression Inventory – Escala de Depressão de Beck ou Inventário de Depressão de Beck – e Escala de Hamilton (simplificado).\n                            ")]):_vm._e()]:[(_vm.risk.title.toLowerCase() == 'risco de internação')?[_vm._v("\n                                O risco de Internação é baseado na identificação dos indivíduos com maior risco para internação hospitalar.\n                            ")]:_vm._e(),_vm._v(" "),(_vm.risk.title.toLowerCase() == 'risco de fragilidade')?[_vm._v("\n                                O Risco de Fragilidade é estimado para identificar a vulnerabilidade funcional de pessoas da terceira idade.\n                            ")]:_vm._e(),_vm._v(" "),(_vm.risk.title.toLowerCase() == 'risco de cardiovascular')?[_vm._v("\n                                O Risco Cardiovascular é estabelecido para infarto do miocárdio e angina do eito em dez anos.\n                            ")]:_vm._e(),_vm._v(" "),(_vm.plural)?_c('span',[_vm._v("Os seus")]):_c('span',[_vm._v("O seu")]),_vm._v(" "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.risk.title))]),_vm._v(" "),(_vm.plural)?_c('span',[_vm._v("estão com risco")]):_c('span',[_vm._v("está")]),_vm._v(" "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.risk.label))]),_vm._v(", com base nos indicadores:\n                            "),(_vm.metricList.length > 0)?_c('div',{staticClass:"items"},_vm._l((_vm.metricList),function(metric,x){return _c('span',{key:x,staticClass:"item"},[_vm._v(_vm._s(metric[0])+" - "+_vm._s(metric[1])+";")])}),0):_c('div',{staticClass:"items"},[_c('span',{staticClass:"item"},[_vm._v("Sem valores para exibir.")])]),_vm._v(" "),(_vm.risk.title.toLowerCase() == 'risco de internação')?_c('div',{staticClass:"bottom"},[_vm._v("\n                                Nota: Cálculo de Risco baseado em estudo produzido por Boult e colaboradores (PACALA et al., 1995; BOULT et al., 1994; BOULT et al., 1993) e validado para o português por Dutra et al. (2011).\n                            ")]):_vm._e(),_vm._v(" "),(_vm.risk.title.toLowerCase() == 'risco de fragilidade')?_c('div',{staticClass:"bottom"},[_vm._v("\n                                Nota: Utilização de instrumento Probability of Repetead Admission (PRA) – Screening for risk of hospitalization in the elderly: a study based on a single entry point in a health maintenance organization in Brazil.\n                            ")]):_vm._e(),_vm._v(" "),(_vm.risk.title.toLowerCase() == 'risco de cardiovascular')?_c('div',{staticClass:"bottom"},[_vm._v("\n                                Nota: Cálculo de Risco baseado em Escore de Framingham.\n                            ")]):_vm._e()]],2)]],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 661 */
/*!************************************************!*\
  !*** ./src/assets/images/tela_riscocardio.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/tela_riscocardio.5378aa91.png";

/***/ }),
/* 662 */
/*!*******************************************!*\
  !*** ./src/assets/images/tela_riscos.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/tela_riscos.20efb888.png";

/***/ }),
/* 663 */
/*!************************************************************!*\
  !*** ./src/components/KitRisksDetails/KitRisksDetails.vue ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitRisksDetails_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./KitRisksDetails.vue */ 369);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84376b5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitRisksDetails_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-84376b5c","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./KitRisksDetails.vue */ 668);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-84376b5c","scoped":false,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./KitRisksDetails.vue */ 664)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitRisksDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84376b5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitRisksDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 664 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-84376b5c","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/KitRisksDetails/KitRisksDetails.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/*!*******************************************************!*\
  !*** ./src/components/KitRisksDetails/DetailText.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DetailText_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DetailText.vue */ 370);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a53e64c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailText_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-9a53e64c","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DetailText.vue */ 667);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-9a53e64c","scoped":false,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DetailText.vue */ 666)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DetailText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a53e64c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 666 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9a53e64c","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/KitRisksDetails/DetailText.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a53e64c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KitRisksDetails/DetailText.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[(_vm.risk == 'internacao')?[_vm._v("\n            O Risco de Internação é baseado na identificação dos indivíduos com maior risco para internação hospitalar com base em uma fórmula \n            internacionalmente validada, chamada Boult. Este instrumento considera oito aspectos relacionados a saúde, tais como histórico de saúde recente, \n            idade, doenças ativas e vulnerabilidade.\n        ")]:_vm._e(),_vm._v(" "),(_vm.risk == 'fragilidade')?[_vm._v("\n            O Risco de Fragilidade é estimado para identificar a vulnerabilidade funcional de pessoal da terceira idade, através do instrumento \n            Probability of Repetead Admission (PRA). Considera aspectos físicos, cognitivos e mentais.\n        ")]:_vm._e(),_vm._v(" "),(_vm.risk == 'psicologico')?[_vm._v("\n            O Risco Psicológico é estimado para identificar os transtornos psicológicos mais comuns. Ele foi estabelecido através da Escala de \n            Depressão de Beck ou “Beck Depression Inventory”, bem como Escala de Hamilton (simplificado).\n        ")]:_vm._e(),_vm._v(" "),(_vm.risk == 'cardiovascular')?[_vm._v("\n            O Risco Cardiovascular é estabelecido através de um estudo de corte a longo prazo (10 anos) sobre o sistema cardiovascular para o infarto do \n            miocárdio e angina do peito, de acordo com Score de Framingham. O estudo considera alguns hábitos de vida, exames laboratoriais, pressão arterial e \n            possui diabetes como fatores para o cálculo final.\n        ")]:_vm._e(),_vm._v(" "),(_vm.risk == 'dislipidemia')?[_vm._v("\n            Possui como principais fatores o nível de colesterol muito elevado ou gorduras no sangue. Via de regra está relacionada com obesidade, má alimentação e \n            falta de exercícios. A dislipidemia não gera sintomas e apresenta riscos importantes, como o entupimento de artérias, ataques cardíacos, AVC e demais problemas. \n            A boa notícia é que uma alimentação saudável, perda de peso, atividades física regulares e medicamentos hipolipemiantes podem reduzir os riscos e prevenir \n            complicações."),_c('br'),_vm._v("\n            Quer saber mais:"),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"blank","href":"https://abeso.org.br/conceitos/colesterol-dislipidemia/"}},[_vm._v("https://abeso.org.br/conceitos/colesterol-dislipidemia/")])]:_vm._e(),_vm._v(" "),(_vm.risk == 'metabolica')?[_vm._v("\n            Possui como principais fatores o nível de colesterol muito elevado, hipertensão arterial, alto nível de açúcar no sangue e excesso de gordura em torno da cintura. \n            A síndrome metabólica não gera sintomas e apresenta riscos importantes, como ataques cardíacos e AVC. A boa notícia é que uma alimentação saudável, perda de \n            peso, atividades física regulares e abandono do cigarro podem reduzir os riscos e prevenir complicações."),_c('br'),_vm._v("\n            Quer saber mais:"),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"blank","href":"https://bvsms.saude.gov.br/sindrome-metabolica/"}},[_vm._v("https://bvsms.saude.gov.br/sindrome-metabolica/")])]:_vm._e(),_vm._v(" "),(_vm.risk == 'avc')?[_vm._v("\n            O Acidente Vascular Cerebral (AVC) acontece quando vasos que levam sangue ao cérebro entopem ou se rompem. \n            Possui como principais fatores o nível de colesterol muito elevado, hipertensão arterial, diabetes tipo 2, obesidade, tabagismo, sedentarismo, \n            uso excessivo de álcool ou drogas e histórico familiar. Os sintomas de acidente vascular cerebral incluem dificuldade para andar, falar e compreender, \n            bem como paralisia ou dormência da face, do braço ou da perna. A boa notícia é que 90% dos AVC (s) são causados por fatores como obesidade, hipertensão, \n            tabagismo, diabetes, colesterol alto, sedentarismo, uso de drogas e estresse, ou seja, basta melhor hábitos de vida para não fazer o mesmo incidir. \n            Exceções são os fatores genéticos advindos de histórico familiar."),_c('br'),_vm._v("\n            Quer saber mais?"),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"blank","href":"https://bvsms.saude.gov.br/avc-acidente-vascular-cerebral/"}},[_vm._v("https://bvsms.saude.gov.br/avc-acidente-vascular-cerebral/")])]:_vm._e(),_vm._v(" "),(_vm.risk == 'coracao')?[_vm._v("\n            As doenças cardiovasculares são um conjunto de problemas que atingem o coração e os vasos sanguíneos, e que surgem com a idade, normalmente relacionadas a \n            hábitos de vida poucos saudáveis, como alimentação rica em gordura e falta de atividade física, por exemplo. Podem ser congênitas e também provocadas por \n            infecções por vírus e bactérias. As principais doenças do coração são: doença arterial coronariana; hipertensão; infarto; parada, insuficiência ou arritmia \n            cardíaca; doença arterial periférica; derrame cerebral; cardiopatia congênita; e etc. A boa notícia é que uma alimentação saudável, perda de peso, \n            atividades física regulares, abandono do cigarro, baixo consumo de álcool, manter a pressão e glicose sob controle, podem reduzir os riscos e prevenir\n            complicações."),_c('br'),_vm._v("\n            Quer saber mais?"),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"blank","href":"https://bvsms.saude.gov.br/saude-do-coracao/"}},[_vm._v("https://bvsms.saude.gov.br/saude-do-coracao/")])]:_vm._e(),_vm._v(" "),(_vm.risk == 'diabetes')?[_vm._v("\n            Possui como principais fatores o nível elevado de glicose (açúcar) no sangue. Os tipos mais comuns são Pré Diabetes (açúcar elevado no sangue), \n            Diabetes tipo 1 (pâncreas produz pouca ou nenhuma insulina) e Diabetes tipo 2 (afeta o processamento do açúcar do sangue). A diabetes tem como principais \n            sintomas: sede constante, fadiga, mudanças de humor, perda de peso, infecções, visão embaçada e etc. A boa notícia é que uma alimentação saudável, \n            redução do consumo de sal, açúcar e gorduras, atividades física regulares e abandono do cigarro podem reduzir os riscos e prevenir complicações."),_c('br'),_vm._v("\n            Quer saber mais?"),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"blank","href":"https://bvsms.saude.gov.br/diabetes/"}},[_vm._v("https://bvsms.saude.gov.br/diabetes/")])]:_vm._e(),_vm._v(" "),(_vm.risk == 'hipertensao')?[_vm._v("\n            É a condição na qual a força do sangue contra a parede das artérias é muito grande. É detectada a partir de 14/9 e considerada grave quanto se encontra acima \n            de 18/12. A grande maioria das pessoas não apresentam sintomas, todavia, se não for tratada, pode com o tempo causar problemas de saúde como doenças do \n            coração e AVC. Uma boa alimentação e com menos sal, praticar exercícios físicos com frequência, e o uso adequado de medicamentos auxiliam no controle e \n            ajudam a baixar a pressão arterial."),_c('br'),_vm._v("\n            Quer saber mais?"),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"blank","href":"https://bvsms.saude.gov.br/hipertensao-18/"}},[_vm._v("https://bvsms.saude.gov.br/hipertensao-18/")])]:_vm._e(),_vm._v(" "),(_vm.risk == 'muscular')?[_vm._v("\n            São diversos fatores que devem ser considerados para o surgimento de uma Lesão Muscular. Entre as principais estão a idade acima dos 40 anos, mau preparo para a \n            prática de exercícios físicos, má hidratação, abuso de álcool, longos períodos de afastamento do esporte, as reincidências de lesões, falta de aquecimento \n            previamente a atividade física, e uso de determinados medicamentos, principalmente os redutores de colesterol da classe Estatina. A melhor forma de prevenir \n            é praticando atividades físicas regularmente, mantendo uma alimentação saudável, evitar o consumo excessivo de álcool, melhorar a hidratação e realizar \n            aquecimento antes e depois das atividades."),_c('br'),_vm._v("\n            Quer saber mais?"),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"blank","href":"https://sbot.org.br/lesoes-musculares/"}},[_vm._v("https://sbot.org.br/lesoes-musculares/")])]:_vm._e(),_vm._v(" "),(_vm.risk == 'osteoporose')?[_vm._v("\n            É a condição na qual os ossos se tornam frágeis e quebradiços. Geralmente é decorrente do processo normal de envelhecimento, condições genéticas, \n            sedentarismo ou em pessoas com alimentação deficiente em cálcio e vitamina D. A grande maioria das pessoas não apresentam sintomas até que tenham uma\n             fratura óssea. Uma boa alimentação, a prática de exercícios leves com levantamento de peso para prevenir a perda óssea e o uso adequado de medicamentos \n             fazem parte do tratamento."),_c('br'),_vm._v("\n            Quer saber mais?"),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://bvsms.saude.gov.br/osteoporose-7/"}},[_vm._v("https://bvsms.saude.gov.br/osteoporose-7/")])]:_vm._e(),_vm._v(" "),(_vm.risk == 'renal')?[_vm._v("\n            Possui como um dos principais fatores os níveis de creatinina no sangue.\n            Essa substância é produzida pelos músculos e eliminada pelos rins, portanto, altas taxas significam que o corpo pode não estar conseguindo eliminá-la de forma adequada, indicando possíveis problemas.\n            Quando os níveis de creatinina no sangue estão bem mais altos que o normal, aparecem alguns sintomas: cansaço excessivo, náuseas e vômitos, sensação de falta de ar, inchaço nas pernas e nos braços, retenção de líquidos e etc.\n            A boa notícia é que uma alimentação saudável, como a redução do consumo de alimentos que aumentam o potássio é muito eficaz. Ainda, o controle da diabetes e ou hipertensão também é muito importante."),_c('br'),_vm._v("\n            Quer saber mais?"),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.gov.br/saude/pt-br/assuntos/saude-de-a-a-z/d/drc"}},[_vm._v("https://www.gov.br/saude/pt-br/assuntos/saude-de-a-a-z/d/drc")])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 668 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84376b5c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KitRisksDetails/KitRisksDetails.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"risk-details modal",on:{"click":function($event){return _vm.outsideClick()}}},[_c('div',{staticClass:"modal-box"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"content"},[_c('span',{staticClass:"title-mobile"},[_vm._v(_vm._s(_vm.risk.risk.name)+"  - "),_c('span',{class:_vm.getRiskColor(_vm.risk.risk.label)},[_vm._v(_vm._s(_vm.risk.risk.label))])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"risks"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.risk.risk.name)+" - "),_c('span',{class:_vm.getRiskColor(_vm.risk.risk.label)},[_vm._v(_vm._s(_vm.risk.risk.label))])]),_vm._v(" "),(_vm.risk.altTitle == 'psicologico')?[_c('div',{staticClass:"text"},[(_vm.risk.risk.label == 'Baixo')?[_vm._v("\n                                        De acordo com suas respostas destacamos que você está no caminho certo para evitar o adoecimento mental,\n                                        isso porque, neste momento, você apresenta um perfil com baixa tendência para desenvolvimento de transtornos psicológicos,\n                                        tais como depressão e ansiedade. Esta é uma boa notícia! Assim como a física, a saúde mental é uma parte integrante e complementar\n                                        à manutenção das funções do organismo. Ter saúde mental é conseguir lidar tanto com emoções positivas e negativas investindo em estratégias\n                                        que possibilitem o equilíbrio das funções mentais.\n                                    ")]:_vm._e(),_vm._v(" "),(_vm.risk.risk.label == 'Médio')?[_vm._v("\n                                        De acordo com as respostas apresentadas observamos que é importante começar a refletir sobre a necessidade de conhecer melhor suas emoções,\n                                        dedique um tempo para você, realize atividades prazerosas, cuide da sua alimentação e durma bem, evitando transtornos como depressão\n                                        e ansiedade. Isso não quer dizer que você já possua alguma dessas condições, apenas é importante estar atento a seriedade dos sintomas\n                                        associados a essas patologias. Assim como a física, a saúde mental é extremamente determinante para a correta manutenção das funções vitais\n                                        do organismo. Ter saúde mental é conseguir lidar tanto com emoções positivas e negativas investindo em estratégias que possibilitem o\n                                        equilíbrio das funções mentais.\n                                    ")]:_vm._e(),_vm._v(" "),(_vm.risk.risk.label == 'Alto')?[_vm._v("\n                                        De acordo com suas respostas destacamos que é importante prevenir o adoecimento mental, isso porque, neste momento,\n                                        você apresenta um perfil com maior tendência para desenvolvimento de transtornos psicológicos, tais como depressão e ansiedade.\n                                        Isso não quer dizer que você já possua alguma dessas condições, apenas é importante estar atento a seriedade dos sintomas associados\n                                        a essas patologias. Assim como a física, a saúde mental é extremamente determinante para a correta manutenção das funções vitais do\n                                        organismo. Ter saúde mental é conseguir lidar tanto com emoções positivas e negativas investindo em estratégias que possibilitem o\n                                        equilíbrio das funções mentais. Para maiores informações sugerimos a realização de avaliação psicológica com um especialista.\n                                    ")]:_vm._e()],2)]:(_vm.risk.altTitle == 'diagnostico_diabetes')?[_c('p',[_vm._v("Diabetes é uma doença crônica na qual o corpo não produz insulina ou não consegue empregar adequadamente a \n                                insulina que produz. A insulina é o hormônio produzido pelo pâncreas para metabolizar a glicose e, assim, \n                                transformá-la em energia para o corpo.")]),_vm._v(" "),_c('p',[_vm._v("A incapacidade de produzir insulina e a impossibilidade de usá-la de forma eficaz conduzem a níveis de glicose \n                                elevados no sangue: a hiperglicemia, caracterizando o diabetes.")]),_vm._v(" "),_c('p',[_vm._v("Conforme orienta a Sociedade Brasileira de Diabetes, para a confirmação do diagnóstico desta patologia é necessário \n                                a repetição dos exames alterados em uma segunda amostra.")]),_vm._v(" "),_c('p',[_vm._v("Ou seja, quando os valores de hemoglobina glicada são superiores a 6,5% é necessário repetir este exame para que seja \n                                confirmado ou não o diagnóstico de diabetes.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',[_vm._v("Fonte: Diretrizes da Sociedade Brasileira de Diabetes 2019-2020")])]:(_vm.risk.altTitle == 'hipertensao')?[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"risk-list"},_vm._l((_vm.icons),function(icon,x){return _c('div',{key:x,staticClass:"risk"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/risks */ 60)("./" + (_vm.getIcon(icon.icon, icon.risk)) + ".png")}}),_vm._v(" "),(_vm.imodifFac.includes(icon.title))?_c('div',{staticClass:"risk-info"},[[_c('a-tooltip',{staticStyle:{"margin":"0 5px"}},[_c('template',{slot:"title"},[_vm._v("\n                                                            Esse é um fator de risco imodificável, porém influencia para o desenvolvimento desta doença.\n                                                        ")]),_vm._v(" "),_c('font-awesome-icon',{staticClass:"btn-svg icon-info",attrs:{"icon":['fa', 'exclamation-circle']}})],2)]],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(icon.title))]),_vm._v(" "),_c('span',{staticClass:"info"},[_vm._v(_vm._s(icon.answer))])])])}),0),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"risk-list"},_vm._l((_vm.iconsSec),function(icon,x){return _c('div',{key:x,staticClass:"risk"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/risks */ 60)("./" + (_vm.getIcon(icon.icon, icon.risk)) + ".png")}}),_vm._v(" "),(_vm.imodifFac.includes(icon.title))?_c('div',{staticClass:"risk-info"},[[_c('a-tooltip',{staticStyle:{"margin":"0 5px"}},[_c('template',{slot:"title"},[_vm._v("\n                                                            Esse é um fator de risco imodificável, porém influencia para o desenvolvimento desta doença.\n                                                        ")]),_vm._v(" "),_c('font-awesome-icon',{staticClass:"btn-svg icon-info",attrs:{"icon":['fa', 'exclamation-circle']}})],2)]],2):(icon.title == 'Hemoglobina Glicada (HbA1c)' && _vm.risk.altTitle == 'diabetes')?_c('div',{staticClass:"risk-info"},[[_c('a-tooltip',{staticStyle:{"margin":"0 5px"}},[_c('template',{slot:"title"},[_vm._v("\n                                                            Este indicador é determinante para o risco de desenvolver diabetes. \n                                                        ")]),_vm._v(" "),_c('font-awesome-icon',{staticClass:"btn-svg icon-info",attrs:{"icon":['fa', 'exclamation-circle']}})],2)]],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(icon.title))]),_vm._v(" "),_c('span',{staticClass:"info"},[_vm._v(_vm._s(icon.answer))])])])}),0)]:[_c('div',{staticClass:"risk-list"},_vm._l((_vm.icons),function(icon,x){return _c('div',{key:x,staticClass:"risk"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/risks */ 60)("./" + (_vm.getIcon(icon.icon, icon.risk)) + ".png")}}),_vm._v(" "),(_vm.imodifFac.includes(icon.title))?_c('div',{staticClass:"risk-info"},[[_c('a-tooltip',{staticStyle:{"margin":"0 5px"}},[_c('template',{slot:"title"},[_vm._v("\n                                                            Esse é um fator de risco imodificável, porém influencia para o desenvolvimento desta doença.\n                                                        ")]),_vm._v(" "),_c('font-awesome-icon',{staticClass:"btn-svg icon-info",attrs:{"icon":['fa', 'exclamation-circle']}})],2)]],2):(icon.title == 'Hemoglobina Glicada (HbA1c)' && _vm.risk.altTitle == 'diabetes')?_c('div',{staticClass:"risk-info"},[[_c('a-tooltip',{staticStyle:{"margin":"0 5px"}},[_c('template',{slot:"title"},[_vm._v("\n                                                            Este indicador é determinante para o risco de desenvolver diabetes. \n                                                        ")]),_vm._v(" "),_c('font-awesome-icon',{staticClass:"btn-svg icon-info",attrs:{"icon":['fa', 'exclamation-circle']}})],2)]],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(icon.title))]),_vm._v(" "),_c('span',{staticClass:"info"},[_vm._v(_vm._s(icon.answer))])])])}),0)]],2),_vm._v(" "),(_vm.risk.altTitle != 'diagnostico_diabetes')?_c('div',{staticClass:"column"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"description"},[_c('div',{staticClass:"row column-reverse"},[_c('div',{staticClass:"column no-margin"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.risk.title))]),_vm._v(" "),_c('detail-text',{attrs:{"risk":_vm.risk.altTitle}})],1),_vm._v(" "),(_vm.risk.altTitle != 'psicologico' && _vm.risk.altTitle != 'diagnostico_diabetes')?_c('div',{staticClass:"column"},[_vm._m(3)]):_vm._e()])])])]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Quer saber mais?"),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://diabetes.org.br/#diabetes","target":"_blank"}},[_vm._v("Home - Sociedade Brasileira de Diabetes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"sub-title"},[_vm._v("Fatores Preponderantes - \n                                    "),_c('span',{staticClass:"sub-title-desc"},[_vm._v("São levados em consideração para o cálculo deste risco.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"sub-title"},[_vm._v("Fatores Secundários - \n                                    "),_c('span',{staticClass:"sub-title-desc"},[_vm._v("Não são pontuados para o cálculo deste risco, mas podem influenciar na sua pressão arterial ao longo do tempo. \n                                    Fique de olho nos indicadores abaixo para evitar o desenvolvimento de Hipertensão.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend-box"},[_c('span',{staticClass:"title"},[_vm._v("legenda")]),_vm._v(" "),_c('div',{staticClass:"legends"},[_c('div',{staticClass:"legend"},[_c('div',{staticClass:"circle"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/risks/b_g.png */ 372)}})]),_vm._v(" "),_c('div',{staticClass:"legend-text"},[_vm._v("\n                                                            Indicador de hábito ou condição foi pontuado de forma positiva. Procure manter assim. Parabéns!\n                                                        ")])]),_vm._v(" "),_c('div',{staticClass:"legend"},[_c('div',{staticClass:"circle"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/risks/b_y.png */ 374)}})]),_vm._v(" "),_c('div',{staticClass:"legend-text"},[_vm._v("\n                                                            Indicador de hábito ou condição que merece atenção. Melhore ou controle-o bem!\n                                                        ")])]),_vm._v(" "),_c('div',{staticClass:"legend"},[_c('div',{staticClass:"circle"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/risks/b_r.png */ 373)}})]),_vm._v(" "),_c('div',{staticClass:"legend-text"},[_vm._v("\n                                                            Indicador de hábito ou condição foi pontuado de forma negativa. \n                                                            Você precisa modificar este hábito ou manter controlada esta doença.\n                                                        ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 669 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/activity_g.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/activity_g.1466aa74.png";

/***/ }),
/* 670 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/activity_r.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/activity_r.486e032a.png";

/***/ }),
/* 671 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/activity_y.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/activity_y.54250346.png";

/***/ }),
/* 672 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/age_g.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/age_g.9188d4df.png";

/***/ }),
/* 673 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/age_r.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/age_r.abfb6dfc.png";

/***/ }),
/* 674 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/age_y.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/age_y.e6d0730c.png";

/***/ }),
/* 675 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/animal_g.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/animal_g.6e97a0d6.png";

/***/ }),
/* 676 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/animal_r.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/animal_r.209a5116.png";

/***/ }),
/* 677 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/animal_y.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/animal_y.c9aaadb1.png";

/***/ }),
/* 678 */
/*!*************************************************************!*\
  !*** ./src/assets/images/risks/avatar_doencas_cronicas.png ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/avatar_doencas_cronicas.adb15f17.png";

/***/ }),
/* 679 */
/*!*********************************************************!*\
  !*** ./src/assets/images/risks/avatar_front_shadow.png ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/avatar_front_shadow.64452cad.png";

/***/ }),
/* 680 */
/*!********************************************************!*\
  !*** ./src/assets/images/risks/avatar_longevidade.png ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/avatar_longevidade.cd54e97c.png";

/***/ }),
/* 681 */
/*!**********************************************************!*\
  !*** ./src/assets/images/risks/avatar_saude_coracao.png ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/avatar_saude_coracao.c615aa0b.png";

/***/ }),
/* 682 */
/*!*************************************************************!*\
  !*** ./src/assets/images/risks/avatar_saude_preventiva.png ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/avatar_saude_preventiva.cd54e97c.png";

/***/ }),
/* 683 */
/*!********************************************************!*\
  !*** ./src/assets/images/risks/avatar_side_shadow.png ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/avatar_side_shadow.1af95630.png";

/***/ }),
/* 684 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/botao.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/botao.bacf1785.png";

/***/ }),
/* 685 */
/*!*************************************************!*\
  !*** ./src/assets/images/risks/caretaker_g.png ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/caretaker_g.f09c93e5.png";

/***/ }),
/* 686 */
/*!*************************************************!*\
  !*** ./src/assets/images/risks/caretaker_r.png ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/caretaker_r.8a4e8fbf.png";

/***/ }),
/* 687 */
/*!*************************************************!*\
  !*** ./src/assets/images/risks/caretaker_y.png ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/caretaker_y.80111eb2.png";

/***/ }),
/* 688 */
/*!*****************************************************!*\
  !*** ./src/assets/images/risks/circunference_g.png ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/circunference_g.2aaf162a.png";

/***/ }),
/* 689 */
/*!*****************************************************!*\
  !*** ./src/assets/images/risks/circunference_r.png ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/circunference_r.c4e6fbbd.png";

/***/ }),
/* 690 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/clt_g.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/clt_g.e2959edc.png";

/***/ }),
/* 691 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/clt_r.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/clt_r.2ed2d1cf.png";

/***/ }),
/* 692 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/clt_y.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/clt_y.6c3d30fe.png";

/***/ }),
/* 693 */
/*!**************************************************!*\
  !*** ./src/assets/images/risks/creatinina_g.png ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/creatinina_g.71efe2f6.png";

/***/ }),
/* 694 */
/*!**************************************************!*\
  !*** ./src/assets/images/risks/creatinina_r.png ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/creatinina_r.c47f80f0.png";

/***/ }),
/* 695 */
/*!******************************************************!*\
  !*** ./src/assets/images/risks/daily_activity_g.png ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/daily_activity_g.d42d060e.png";

/***/ }),
/* 696 */
/*!******************************************************!*\
  !*** ./src/assets/images/risks/daily_activity_r.png ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/daily_activity_r.f77623de.png";

/***/ }),
/* 697 */
/*!******************************************************!*\
  !*** ./src/assets/images/risks/daily_activity_y.png ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/daily_activity_y.87da668a.png";

/***/ }),
/* 698 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/diabetes_g.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/diabetes_g.2cecf7d7.png";

/***/ }),
/* 699 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/diabetes_r.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/diabetes_r.1d53801b.png";

/***/ }),
/* 700 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/diabetes_y.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/diabetes_y.f2e0920e.png";

/***/ }),
/* 701 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/diseases_g.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/diseases_g.7eacf820.png";

/***/ }),
/* 702 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/diseases_r.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/diseases_r.e7c5e02b.png";

/***/ }),
/* 703 */
/*!*********************************************!*\
  !*** ./src/assets/images/risks/drink_g.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/drink_g.1e882e2a.png";

/***/ }),
/* 704 */
/*!*********************************************!*\
  !*** ./src/assets/images/risks/drink_r.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/drink_r.9ce939e7.png";

/***/ }),
/* 705 */
/*!*********************************************!*\
  !*** ./src/assets/images/risks/drink_y.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/drink_y.8591d4bc.png";

/***/ }),
/* 706 */
/*!********************************************************!*\
  !*** ./src/assets/images/risks/familiar_disease_g.png ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/familiar_disease_g.f4cd302b.png";

/***/ }),
/* 707 */
/*!********************************************************!*\
  !*** ./src/assets/images/risks/familiar_disease_r.png ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/familiar_disease_r.509358c8.png";

/***/ }),
/* 708 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/family_g.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/family_g.15e07a4b.png";

/***/ }),
/* 709 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/family_r.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/family_r.c2261bfc.png";

/***/ }),
/* 710 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/family_y.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/family_y.ac7f50cb.png";

/***/ }),
/* 711 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/fruits_g.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/fruits_g.5c0bd23e.png";

/***/ }),
/* 712 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/fruits_r.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/fruits_r.5e5528fa.png";

/***/ }),
/* 713 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/fruits_y.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/fruits_y.b27d9902.png";

/***/ }),
/* 714 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/gender_g.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/gender_g.ee3654af.png";

/***/ }),
/* 715 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/gender_r.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/gender_r.2c29fe33.png";

/***/ }),
/* 716 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/gender_y.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/gender_y.a14c62da.png";

/***/ }),
/* 717 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/gli_g.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/gli_g.ea94a4df.png";

/***/ }),
/* 718 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/gli_r.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/gli_r.a46bb346.png";

/***/ }),
/* 719 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/gli_y.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/gli_y.c0137456.png";

/***/ }),
/* 720 */
/*!***********************************************!*\
  !*** ./src/assets/images/risks/glucose_g.png ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/glucose_g.ea94a4df.png";

/***/ }),
/* 721 */
/*!***********************************************!*\
  !*** ./src/assets/images/risks/glucose_r.png ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/glucose_r.a46bb346.png";

/***/ }),
/* 722 */
/*!***********************************************!*\
  !*** ./src/assets/images/risks/glucose_y.png ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/glucose_y.c0137456.png";

/***/ }),
/* 723 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/hdl_g.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hdl_g.a1a76ebc.png";

/***/ }),
/* 724 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/hdl_r.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hdl_r.fa409702.png";

/***/ }),
/* 725 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/hdl_y.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hdl_y.e8272165.png";

/***/ }),
/* 726 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/health_g.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/health_g.f39b37e1.png";

/***/ }),
/* 727 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/health_r.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/health_r.0cf7747c.png";

/***/ }),
/* 728 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/health_y.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/health_y.d6e768b7.png";

/***/ }),
/* 729 */
/*!*****************************************************!*\
  !*** ./src/assets/images/risks/heart_disease_g.png ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/heart_disease_g.25e9f340.png";

/***/ }),
/* 730 */
/*!*****************************************************!*\
  !*** ./src/assets/images/risks/heart_disease_r.png ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/heart_disease_r.3c6bac9f.png";

/***/ }),
/* 731 */
/*!*****************************************************!*\
  !*** ./src/assets/images/risks/heart_disease_y.png ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/heart_disease_y.c62a7d6d.png";

/***/ }),
/* 732 */
/*!**************************************************!*\
  !*** ./src/assets/images/risks/hemoglobin_g.png ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hemoglobin_g.46f41b33.png";

/***/ }),
/* 733 */
/*!**************************************************!*\
  !*** ./src/assets/images/risks/hemoglobin_r.png ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hemoglobin_r.4ce35418.png";

/***/ }),
/* 734 */
/*!**************************************************!*\
  !*** ./src/assets/images/risks/hemoglobin_y.png ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hemoglobin_y.ddf4110d.png";

/***/ }),
/* 735 */
/*!********************************************!*\
  !*** ./src/assets/images/risks/home_g.png ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/home_g.7867e75b.png";

/***/ }),
/* 736 */
/*!********************************************!*\
  !*** ./src/assets/images/risks/home_r.png ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/home_r.42c1f0df.png";

/***/ }),
/* 737 */
/*!********************************************!*\
  !*** ./src/assets/images/risks/home_y.png ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/home_y.a96cf39b.png";

/***/ }),
/* 738 */
/*!****************************************************!*\
  !*** ./src/assets/images/risks/hospitalized_g.png ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hospitalized_g.47acc08a.png";

/***/ }),
/* 739 */
/*!****************************************************!*\
  !*** ./src/assets/images/risks/hospitalized_r.png ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hospitalized_r.b9943362.png";

/***/ }),
/* 740 */
/*!****************************************************!*\
  !*** ./src/assets/images/risks/hypertension_g.png ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hypertension_g.93cd9c03.png";

/***/ }),
/* 741 */
/*!****************************************************!*\
  !*** ./src/assets/images/risks/hypertension_r.png ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hypertension_r.80d73670.png";

/***/ }),
/* 742 */
/*!****************************************************!*\
  !*** ./src/assets/images/risks/hypertension_y.png ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hypertension_y.b9213219.png";

/***/ }),
/* 743 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/icon_green.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/icon_green.46b0617f.png";

/***/ }),
/* 744 */
/*!**********************************************!*\
  !*** ./src/assets/images/risks/icon_red.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/icon_red.73ec6803.png";

/***/ }),
/* 745 */
/*!*************************************************!*\
  !*** ./src/assets/images/risks/icon_yellow.png ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/icon_yellow.daccdb6e.png";

/***/ }),
/* 746 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/imc_g.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/imc_g.883e18e8.png";

/***/ }),
/* 747 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/imc_r.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/imc_r.d789881a.png";

/***/ }),
/* 748 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/imc_y.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/imc_y.afdb2c23.png";

/***/ }),
/* 749 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/ldl_g.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/ldl_g.30d07683.png";

/***/ }),
/* 750 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/ldl_r.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/ldl_r.e52755c4.png";

/***/ }),
/* 751 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/ldl_y.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/ldl_y.34a8274e.png";

/***/ }),
/* 752 */
/*!********************************************************!*\
  !*** ./src/assets/images/risks/limited_activity_g.png ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/limited_activity_g.2bb2d032.png";

/***/ }),
/* 753 */
/*!********************************************************!*\
  !*** ./src/assets/images/risks/limited_activity_r.png ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/limited_activity_r.c9e4f96d.png";

/***/ }),
/* 754 */
/*!********************************************************!*\
  !*** ./src/assets/images/risks/limited_activity_y.png ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/limited_activity_y.d2dc195c.png";

/***/ }),
/* 755 */
/*!*********************************************!*\
  !*** ./src/assets/images/risks/medic_g.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/medic_g.c0684288.png";

/***/ }),
/* 756 */
/*!*********************************************!*\
  !*** ./src/assets/images/risks/medic_r.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/medic_r.19bfdfb5.png";

/***/ }),
/* 757 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/pregnant_g.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/pregnant_g.bc2b53c0.png";

/***/ }),
/* 758 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/pressure_g.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/pressure_g.e40c99ac.png";

/***/ }),
/* 759 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/pressure_r.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/pressure_r.2ff868b0.png";

/***/ }),
/* 760 */
/*!************************************************!*\
  !*** ./src/assets/images/risks/pressure_y.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/pressure_y.d7c7569e.png";

/***/ }),
/* 761 */
/*!***************************************************!*\
  !*** ./src/assets/images/risks/psychologic_g.png ***!
  \***************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/psychologic_g.d97bbf29.png";

/***/ }),
/* 762 */
/*!***************************************************!*\
  !*** ./src/assets/images/risks/psychologic_r.png ***!
  \***************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/psychologic_r.e4639715.png";

/***/ }),
/* 763 */
/*!*********************************************!*\
  !*** ./src/assets/images/risks/sleep_g.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/sleep_g.fdeb3894.png";

/***/ }),
/* 764 */
/*!*********************************************!*\
  !*** ./src/assets/images/risks/sleep_r.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/sleep_r.9adf956a.png";

/***/ }),
/* 765 */
/*!*********************************************!*\
  !*** ./src/assets/images/risks/smoke_g.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/smoke_g.338c9a60.png";

/***/ }),
/* 766 */
/*!*********************************************!*\
  !*** ./src/assets/images/risks/smoke_r.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/smoke_r.0464ff1c.png";

/***/ }),
/* 767 */
/*!*********************************************!*\
  !*** ./src/assets/images/risks/smoke_y.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/smoke_y.2e3547c2.png";

/***/ }),
/* 768 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/tfg_g.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/tfg_g.2244bbb2.png";

/***/ }),
/* 769 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/tfg_r.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/tfg_r.2ba29a8b.png";

/***/ }),
/* 770 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/tfg_y.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/tfg_y.273d1471.png";

/***/ }),
/* 771 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/tri_g.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/tri_g.623bd12b.png";

/***/ }),
/* 772 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/tri_r.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/tri_r.846067da.png";

/***/ }),
/* 773 */
/*!*******************************************!*\
  !*** ./src/assets/images/risks/tri_y.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/tri_y.da39f05f.png";

/***/ }),
/* 774 */
/*!****************************************************!*\
  !*** ./src/assets/images/risks/walk_support_g.png ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/walk_support_g.5c27b2e3.png";

/***/ }),
/* 775 */
/*!****************************************************!*\
  !*** ./src/assets/images/risks/walk_support_r.png ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/walk_support_r.367eef8c.png";

/***/ }),
/* 776 */
/*!****************************************************!*\
  !*** ./src/assets/images/risks/walk_support_y.png ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/walk_support_y.c4d52ad8.png";

/***/ }),
/* 777 */,
/* 778 */
/*!**************************************************!*\
  !*** ./src/components/RiskAvatar/RiskAvatar.vue ***!
  \**************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RiskAvatar_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RiskAvatar.vue */ 375);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f7defe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RiskAvatar_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-56f7defe","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RiskAvatar.vue */ 780);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-56f7defe","scoped":false,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RiskAvatar.vue */ 779)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RiskAvatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f7defe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RiskAvatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 779 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56f7defe","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RiskAvatar/RiskAvatar.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56f7defe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RiskAvatar/RiskAvatar.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-container"},[_c('div',{ref:"details",staticClass:"avatar-details",attrs:{"id":"details"}},[_c('div',{staticClass:"detail"},[_c('span',{staticClass:"value-title"},[_vm._v("Idade")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.user.age))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('span',{staticClass:"value-title"},[_vm._v("Sexo biológico")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.user.gender))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('span',{staticClass:"value-title"},[_vm._v("Pressão (sistólica)")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.user.pressure_high)+" ")])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('span',{staticClass:"value-title"},[_vm._v("Pressão (diastólica)")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.user.pressure_low))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('span',{staticClass:"value-title"},[_vm._v("Circunferência abdominal")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.user.circunference))])])]),_vm._v(" "),_c('div',{staticClass:"avatar-box"},[_c('img',{staticClass:"avatar",attrs:{"src":__webpack_require__(/*! @/assets/images/risks/avatar_riscos.png */ 371)}}),_vm._v(" "),(_vm.showHead)?_c('div',{staticClass:"avatar-area cabeca",on:{"click":function($event){$event.preventDefault();return _vm.$emit('changeRisk', 1)}}},[_c('font-awesome-icon',{staticClass:"btn-svg",attrs:{"icon":['fa', 'plus-circle']}})],1):_vm._e(),_vm._v(" "),(_vm.showTorso)?_c('div',{staticClass:"avatar-area peito",on:{"click":function($event){$event.preventDefault();return _vm.$emit('changeRisk', 2)}}},[_c('font-awesome-icon',{staticClass:"btn-svg",attrs:{"icon":['fa', 'plus-circle']}})],1):_vm._e(),_vm._v(" "),(_vm.showAbdomen)?_c('div',{staticClass:"avatar-area abdomen",on:{"click":function($event){$event.preventDefault();return _vm.$emit('changeRisk', 3)}}},[_c('font-awesome-icon',{staticClass:"btn-svg",attrs:{"icon":['fa', 'plus-circle']}})],1):_vm._e(),_vm._v(" "),(_vm.showPelvis)?_c('div',{staticClass:"avatar-area pelvis",on:{"click":function($event){$event.preventDefault();return _vm.$emit('changeRisk', 4)}}},[_c('font-awesome-icon',{staticClass:"btn-svg",attrs:{"icon":['fa', 'plus-circle']}})],1):_vm._e(),_vm._v(" "),(_vm.showLeg)?_c('div',{staticClass:"avatar-area perna",on:{"click":function($event){$event.preventDefault();return _vm.$emit('changeRisk', 5)}}},[_c('font-awesome-icon',{staticClass:"btn-svg",attrs:{"icon":['fa', 'plus-circle']}})],1):_vm._e(),_vm._v(" "),(_vm.showOut)?_c('div',{staticClass:"avatar-area fora",on:{"click":function($event){$event.preventDefault();return _vm.$emit('changeRisk', 6)}}},[_c('font-awesome-icon',{staticClass:"btn-svg",attrs:{"icon":['fa', 'plus-circle']}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 781 */
/*!************************************************!*\
  !*** ./src/components/RisksCard/RisksCard.vue ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RisksCard_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RisksCard.vue */ 376);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348df840_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RisksCard_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-348df840","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RisksCard.vue */ 783);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-348df840","scoped":false,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RisksCard.vue */ 782)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RisksCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348df840_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RisksCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 782 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-348df840","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RisksCard/RisksCard.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-348df840","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RisksCard/RisksCard.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"risks-box",on:{"click":_vm.outsideClick}},[_c('div',{staticClass:"responsive-button"},[_c('span',{on:{"click":function($event){$event.preventDefault();return _vm.close()}}},[_c('font-awesome-icon',{staticStyle:{"margin-right":"10px"},attrs:{"icon":['fa', 'arrow-left']}}),_vm._v(" Voltar para Avatar")],1)]),_vm._v(" "),(_vm.diagnostics && _vm.diagnostics.length > 0)?[_c('div',{staticClass:"box-title"},[_vm._v("Diagnósticos Preliminares")]),_vm._v(" "),_c('div',{staticClass:"risks-grid diagnostics"},[_vm._l((_vm.diagnostics),function(diagnostic){return [_c('div',{key:diagnostic.name,staticClass:"risk-card diagnostic",on:{"click":function($event){return _vm.$emit('openRisk', true, diagnostic.name, diagnostic.code, diagnostic)}}},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"risk-icon"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/risks */ 60)("./" + (_vm.getRiskIcon(diagnostic.label)) + ".png")}})]),_vm._v(" "),_c('span',{staticClass:"risk-title"},[_vm._v("\n                "+_vm._s(diagnostic.name)+" - "),_c('span',{staticClass:"risk-label"},[_vm._v(_vm._s(diagnostic.label))])])]),_vm._v(" "),_c('span',{staticClass:"plus-icon"},[_c('font-awesome-icon',{staticClass:"btn-svg",attrs:{"icon":['fa', 'plus-circle']}})],1)])]})],2)]:_vm._e(),_vm._v(" "),(_vm.risks && _vm.risks.length > 0)?[_c('div',{staticClass:"box-title"},[_vm._v("Riscos")]),_vm._v(" "),_c('div',{staticClass:"risks-grid"},[_vm._l((_vm.risks),function(risk){return [_c('div',{key:risk.name,staticClass:"risk-card",on:{"click":function($event){return _vm.$emit('openRisk', true, risk.title, risk.altTitle, risk)}}},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"risk-icon"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/risks */ 60)("./" + (_vm.getRiskIcon(risk.label)) + ".png")}})]),_vm._v(" "),_c('span',{staticClass:"risk-title"},[_vm._v("\n                "+_vm._s(risk.name)+" - "),_c('span',{staticClass:"risk-label"},[_vm._v(_vm._s(risk.label))])])]),_vm._v(" "),_c('span',{staticClass:"plus-icon"},[_c('font-awesome-icon',{staticClass:"btn-svg",attrs:{"icon":['fa', 'plus-circle']}})],1)])]})],2)]:_vm._e(),_vm._v(" "),(_vm.factors && _vm.factors.length > 0)?[_c('div',{staticClass:"box-title"},[_vm._v("Fatores Preliminares")]),_vm._v(" "),_c('div',{staticClass:"risks-grid factors"},[_vm._l((_vm.factors),function(factor){return [_c('div',{key:factor.name,staticClass:"risk-card",on:{"click":function($event){return _vm.$emit('openRisk', true, factor.title, factor.altTitle, factor)}}},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"risk-icon"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/risks */ 60)("./" + (_vm.getRiskIcon(factor.label)) + ".png")}})]),_vm._v(" "),_c('span',{staticClass:"risk-title"},[_vm._v("\n                "+_vm._s(factor.name)+" - "),_c('span',{staticClass:"risk-label"},[_vm._v(_vm._s(factor.label))])])]),_vm._v(" "),_c('span',{staticClass:"plus-icon"},[_c('font-awesome-icon',{staticClass:"btn-svg",attrs:{"icon":['fa', 'plus-circle']}})],1)])]})],2)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 784 */
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56228c80","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KitRisks/KitRisks.vue ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card kit-data kit-risks card-shrink"},[_c('div',{staticClass:"header-item btn-back",on:{"click":function($event){return _vm.$emit('back')}}},[_c('font-awesome-icon',{staticStyle:{"margin-right":"10px"},attrs:{"icon":['fa', 'arrow-left']}}),_vm._v(" "),_c('span',{staticClass:"desktop"},[_vm._v("Voltar")])],1),_vm._v(" "),_c('div',{staticClass:"rsl-header"},[(_vm.result.kit_type_id > 2)?_c('div',{staticClass:"header-item",on:{"click":function($event){return _vm.$emit('changeView', 'rsl')}}},[_c('span',{staticClass:"item-text"},[_vm._v("Resultados")])]):_vm._e(),_vm._v(" "),(_vm.result.kit_type_id > 2)?_c('div',{staticClass:"header-item active",on:{"click":function($event){return _vm.$emit('changeView', 'rsk')}}},[_c('span',{staticClass:"item-text"},[_vm._v("Riscos")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"header-item",on:{"click":function($event){return _vm.$emit('download', _vm.result.id, _vm.result.exam.lab_document_id)}}},[_c('font-awesome-icon',{staticClass:"desktop",staticStyle:{"margin-right":"5%"},attrs:{"icon":['fa', 'receipt']}}),_vm._v(" Laudo\n            ")],1)]),_vm._v(" "),_c('div',{staticClass:"content-desktop"},[_c('span',{staticClass:"title"},[_vm._v("Riscos de Saúde")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('div',[_c('div',{on:{"click":_vm.openPanel}},[_c('div',{staticClass:"btn-expand"},[_c('h2',{staticStyle:{"margin-right":"15px","margin-bottom":"0"}},[_vm._v(" "+_vm._s(this.result.kit_type.name)+" ")]),_vm._v(" "),_c('font-awesome-icon',{staticClass:"btn-svg icon-info",attrs:{"icon":['fa', 'info-circle']}})],1)]),_vm._v(" "),_c('transition',{attrs:{"mode":"out-in","name":"slide-fade"}},[(_vm.firstPanel)?_c('div',{staticClass:"panel-info"},[_vm._v("\n              Quando você precisa realizar Check-up Saúde, o normal é você ir ao médico (a) e responder algumas\n              perguntas; realizar os exames que ele (a) solicitar; e depois retornar para que ela (e) possa avaliar os\n              seus exames. O médico (a), por sua vez, analisa o seu histórico, hábitos de vida e exames para chegar a\n              determinados diagnósticos, promovendo os tratamentos e orientações adequadas.\n              "),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"font-weight-bold"},[_vm._v("Os nossos check-ups reproduzem essa rotina")]),_vm._v(", todavia, utilizando\n              tecnologia e cruzando dados referentes aos seus hábitos de vida, exames físicos como pressão e\n              circunferência abdominal, além de exames laboratoriais.\n              "),_c('br'),_c('br'),_vm._v("\n              Com base em todos estes dados, "),_c('span',{staticClass:"font-weight-bold"},[_vm._v("aplicamos algoritmos médicos mundialmente reconhecidos e inteligência artificial")]),_vm._v("\n              para obter riscos precisos sobre a sua saúde. Importante destacar que não realizamos nenhum diagnóstico.\n              Nossa tecnologia é totalmente pautada em Medicina Preditiva/Preventiva e indica riscos à saúde. Ajudamos\n              você a ter mais saúde, qualidade de vida e estar sempre na melhor versão.\n              "),_c('br'),_c('br')]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"panel-info",staticStyle:{"margin-bottom":"18px"}},[_vm._v("\n          Clique nos botões de "),_c('font-awesome-icon',{staticClass:"btn-svg",attrs:{"icon":['fa', 'plus-circle']}}),_vm._v(" situados no avatar para acessar os riscos e fatores preliminares calculados para você.\n        ")],1),_vm._v(" "),_c('div',{staticClass:"avatar-and-risks"},[(_vm.responsiveAvatar())?_c('risk-avatar',{attrs:{"currentRisk":_vm.currentRisks,"kitTypeId":_vm.result.kit_type_id,"customer":_vm.result.customer,"answers":_vm.result.field_answers,"showHead":(_vm.headItems.risks.length > 0 || _vm.headItems.factors.length > 0),"showTorso":(_vm.torsoItems.risks.length > 0 || _vm.torsoItems.factors.length > 0),"showAbdomen":(_vm.abdomenItems.diagnostics.length > 0 || _vm.abdomenItems.risks.length > 0 || _vm.abdomenItems.factors.length > 0),"showPelvis":(_vm.pelvisItems.risks.length > 0 || _vm.pelvisItems.factors.length > 0),"showLeg":false && (_vm.legItems.risks.length > 3 || _vm.legItems.factors.length > 3),"showOut":(_vm.outItems.risks.length > 0 || _vm.outItems.factors.length > 0)},on:{"changeRisk":_vm.changeRisks}}):_vm._e(),_vm._v(" "),(_vm.currentRisks === 1)?_c('risks-card',{staticClass:"opeen",attrs:{"id":"head-risks","risks":_vm.headItems.risks,"factors":_vm.headItems.factors},on:{"close":function($event){return _vm.changeRisks(0)},"openRisk":_vm.openModal}}):_vm._e(),_vm._v(" "),(_vm.currentRisks === 2)?_c('risks-card',{attrs:{"id":"torso-risks","risks":_vm.torsoItems.risks,"factors":_vm.torsoItems.factors},on:{"close":function($event){return _vm.changeRisks(0)},"openRisk":_vm.openModal}}):_vm._e(),_vm._v(" "),(_vm.currentRisks === 3)?_c('risks-card',{attrs:{"id":"abdomen-risks","diagnostics":_vm.abdomenItems.diagnostics,"risks":_vm.abdomenItems.risks,"factors":_vm.abdomenItems.factors},on:{"close":function($event){return _vm.changeRisks(0)},"openRisk":_vm.openModal}}):_vm._e(),_vm._v(" "),(_vm.currentRisks === 4)?_c('risks-card',{attrs:{"id":"pelvis-risks","risks":_vm.pelvisItems.risks,"factors":_vm.pelvisItems.factors},on:{"close":function($event){return _vm.changeRisks(0)},"openRisk":_vm.openModal}}):_vm._e(),_vm._v(" "),(_vm.currentRisks === 5)?_c('risks-card',{attrs:{"id":"leg-risks","risks":_vm.legItems.risks,"factors":_vm.legItems.factors},on:{"close":function($event){return _vm.changeRisks(0)},"openRisk":_vm.openModal}}):_vm._e(),_vm._v(" "),(_vm.currentRisks === 6)?_c('risks-card',{attrs:{"id":"out-risks","risks":_vm.outItems.risks,"factors":_vm.outItems.factors},on:{"close":function($event){return _vm.changeRisks(0)},"openRisk":_vm.openModal}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"content-mobile"}),_vm._v(" "),(_vm.loading)?_c('loading-screen'):_vm._e(),_vm._v(" "),(_vm.riskModalOpen)?_c('kit-risks-details',{attrs:{"answers":_vm.formAnswers,"customer":_vm.result.customer,"result":_vm.result.exam.result,"risk":_vm.riskModal},on:{"close":function($event){return _vm.openModal(false, null, null)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 785 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-069a08e4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/KitPlans/KitPlans.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/*!*******************************************!*\
  !*** ./src/components/KitPlans/Modal.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Modal.vue */ 379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35f66992_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-35f66992","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Modal.vue */ 788);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-35f66992","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Modal.vue */ 787)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35f66992"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35f66992_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 787 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35f66992","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/KitPlans/Modal.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f66992","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KitPlans/Modal.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",on:{"click":function($event){return _vm.outsideClick()}}},[_c('div',{staticClass:"plan-modal modal-box"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.img == 'at')?_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/kit-plans/piramide-atividades.png */ 789)}}):_vm._e(),_vm._v(" "),(_vm.img == 'al')?_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/kit-plans/piramide-alimentar.png */ 790)}}):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 789 */
/*!*************************************************************!*\
  !*** ./src/assets/images/kit-plans/piramide-atividades.png ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/piramide-atividades.568d17e5.png";

/***/ }),
/* 790 */
/*!************************************************************!*\
  !*** ./src/assets/images/kit-plans/piramide-alimentar.png ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/piramide-alimentar.1b6fe501.png";

/***/ }),
/* 791 */
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-069a08e4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KitPlans/KitPlans.vue ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kit-plans card card-shrink"},[_c('div',{staticClass:"header"},[_c('button',{staticClass:"button item-btn",on:{"click":function($event){return _vm.$emit('back')}}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'arrow-left']}}),_vm._v(" Voltar")],1),_vm._v(" "),_c('button',{staticClass:"button btn-primary btn-min",on:{"click":function($event){return _vm.$emit('changeView', 'rsl')}}},[_vm._v("Resultados")]),_vm._v(" "),_c('button',{staticClass:"button btn-primary btn-min",on:{"click":function($event){return _vm.$emit('changeView', 'rsk')}}},[_vm._v("Riscos de Saúde")]),_vm._v(" "),_c('button',{staticClass:"button btn-primary btn-min",on:{"click":function($event){return _vm.$emit('changeView', 'tps')}}},[_vm._v("Dicas")]),_vm._v(" "),_c('button',{staticClass:"button btn-primary btn-min",on:{"click":function($event){return _vm.$emit('download', _vm.result.id, _vm.result.exam.lab_document_id)}}},[_vm._v("Laudo")])]),_vm._v(" "),(_vm.modal)?_c('modal',{attrs:{"title":_vm.modalImg == 'al' ? 'Pirâmide Alimentar' : 'Pirâmide de Atividades',"img":_vm.modalImg},on:{"close":function($event){_vm.modal = false}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Plano de cuidado")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.result.kit_type.name))]),_vm._v("\n            Agora que já conhecemos os detalhes da sua saúde, traçamos um plano de cuidado preventivo,\n            para evitar que você desenvolva certas doenças e para evitar riscos atrelados a saúde.\n            O plano de cuidado está pautado em 3 pilares: "),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pillar"},[_c('div',{staticClass:"pillar-content"},[_c('img',{staticClass:"pillar-icon",attrs:{"src":__webpack_require__(/*! @/assets/images/kit-plans/icons/Ativ.físicas.png */ 792)}}),_vm._v(" "),_c('div',[_c('span',[_vm._v("Praticar atividade física 30 minutos por dia e 5 vezes na semana. Respeite as suas limitações e pratique exercícios de acordo com a sua idade e condições físicas. Aqui o importante é a constância.")]),_vm._v(" "),_c('font-awesome-icon',{staticClass:"question-mark",attrs:{"icon":['fa', 'question-circle']},on:{"click":function($event){return _vm.openModal('at')}}})],1)])]),_vm._v(" "),_c('div',{staticClass:"pillar"},[_c('div',{staticClass:"pillar-content"},[_c('img',{staticClass:"pillar-icon",attrs:{"src":__webpack_require__(/*! @/assets/images/kit-plans/icons/Alimentos.png */ 793)}}),_vm._v(" "),_c('div',[_c('span',[_vm._v("Cuide da sua alimentação. Não comer frituras e gorduras com frequência ou em excesso. Coma frutas, legumes, verduras e cereais diariamente. Diminua o sal nas refeições. Evite doces e alimentos processados.")]),_vm._v(" "),_c('font-awesome-icon',{staticClass:"question-mark",attrs:{"icon":['fa', 'question-circle']},on:{"click":function($event){return _vm.openModal('al')}}})],1)])]),_vm._v(" "),_c('div',{staticClass:"pillar"},[_c('div',{staticClass:"pillar-content"},[_c('img',{staticClass:"pillar-icon",attrs:{"src":__webpack_require__(/*! @/assets/images/kit-plans/icons/Rotina Personalizada.png */ 794)}}),_vm._v(" "),_c('div',[_c('span',[_vm._v("Cuidar da saúde preventivamente é o que vai fazer com que você esteja sempre na melhor versão. Desenvolvemos uma rotina preventiva com profissionais de saúde. Considerando todos os dados e resultados, recomendamos que visite um(a)\n                        "),(typeof _vm.preventionSpecialists['3'] != 'undefined' && _vm.preventionSpecialists['3'].length > 0 )?_c('span',[_vm._l((_vm.preventionSpecialists['3']),function(item){return _c('span',{key:item,staticClass:"prevention"},[(_vm.preventionSpecialists['3'].at(-1) != item)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+",\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionSpecialists['3'].at(-1) == item && _vm.preventionSpecialists['3'].length > 1)?_c('span',[_vm._v("\n                                    e "+_vm._s(item)+"\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionSpecialists['3'].length == 1)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+"\n                                ")]):_vm._e()])}),_vm._v(" "),(_vm.preventionSpecialists['6'].length > 0 || _vm.preventionSpecialists['12'].length > 0 || _vm.preventionSpecialists['24'].length > 0)?_c('span',[_vm._v("\n                                a cada 3 meses;\n                            ")]):_c('span',[_vm._v("\n                                a cada 3 meses.\n                            ")])],2):_vm._e(),_vm._v(" "),(typeof _vm.preventionSpecialists['6'] != 'undefined' && _vm.preventionSpecialists['6'].length > 0 )?_c('span',[_vm._l((_vm.preventionSpecialists['6']),function(item){return _c('span',{key:item,staticClass:"prevention"},[(_vm.preventionSpecialists['6'].at(-1) != item)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+",\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionSpecialists['6'].at(-1) == item && _vm.preventionSpecialists['6'].length > 1)?_c('span',[_vm._v("\n                                    e "+_vm._s(item)+"\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionSpecialists['6'].length == 1)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+"\n                                ")]):_vm._e()])}),_vm._v(" "),(_vm.preventionSpecialists['12'].length > 0 || _vm.preventionSpecialists['24'].length > 0)?_c('span',[_vm._v("\n                                a cada 6 meses;\n                            ")]):_c('span',[_vm._v("\n                                a cada 6 meses.\n                            ")])],2):_vm._e(),_vm._v(" "),(typeof _vm.preventionSpecialists['12'] != 'undefined' && _vm.preventionSpecialists['12'].length > 0 )?_c('span',[_vm._l((_vm.preventionSpecialists['12']),function(item){return _c('span',{key:item,staticClass:"prevention"},[(_vm.preventionSpecialists['12'].at(-1) != item)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+",\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionSpecialists['12'].at(-1) == item && _vm.preventionSpecialists['12'].length > 1)?_c('span',[_vm._v("\n                                    e "+_vm._s(item)+"\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionSpecialists['12'].length == 1)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+"\n                                ")]):_vm._e()])}),_vm._v(" "),(_vm.preventionSpecialists['24'].length > 0)?_c('span',[_vm._v("\n                                a cada 12 meses;\n                            ")]):_c('span',[_vm._v("\n                                a cada 12 meses.\n                            ")])],2):_vm._e(),_vm._v(" "),(typeof _vm.preventionSpecialists['24'] != 'undefined' && _vm.preventionSpecialists['24'].length > 0 )?_c('span',[_vm._l((_vm.preventionSpecialists['24']),function(item){return _c('span',{key:item,staticClass:"prevention"},[(_vm.preventionSpecialists['24'].at(-1) != item)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+",\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionSpecialists['24'].at(-1) == item && _vm.preventionSpecialists['24'].length > 1)?_c('span',[_vm._v("\n                                    e "+_vm._s(item)+"\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionSpecialists['24'].length == 1)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+"\n                                ")]):_vm._e()])}),_vm._v(" "),_c('span',[_vm._v("\n                                a cada 24 meses.\n                            ")])],2):_vm._e()]),_vm._v(" "),_c('a',{attrs:{"href":"https://bvsms.saude.gov.br/check-up-medico/","target":"blank"}},[_c('font-awesome-icon',{staticClass:"question-mark",attrs:{"icon":['fa', 'question-circle']}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"pillar"},[_c('div',{staticClass:"pillar-content"},[_c('img',{staticClass:"pillar-icon",attrs:{"src":__webpack_require__(/*! @/assets/images/kit-plans/icons/Exames Preventivos.png */ 795)}}),_vm._v(" "),_c('div',[_c('span',[_vm._v("Aqui elencamos os principais exames preventivos para ajudar você manter seu Checkup Saúde sempre em dia, considerando a sua idade, gênero e resultados. Realize exames laboratoriais para verificar\n                        "),(typeof _vm.preventionExams['3'] != 'undefined' && _vm.preventionExams['3'].length > 0 )?_c('span',[_vm._l((_vm.preventionSpecialists['3']),function(item){return _c('span',{key:item,staticClass:"prevention"},[(_vm.preventionExams['3'].at(-1) != item)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+",\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionExams['3'].at(-1) == item && _vm.preventionExams['3'].length > 1)?_c('span',[_vm._v("\n                                    e "+_vm._s(item)+"\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionExams['3'].length == 1)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+"\n                                ")]):_vm._e()])}),_vm._v(" "),(_vm.preventionExams['6'].length > 0 || _vm.preventionExams['12'].length > 0 || _vm.preventionExams['24'].length > 0)?_c('span',[_vm._v("\n                                a cada 3 meses;\n                            ")]):_c('span',[_vm._v("\n                                a cada 3 meses.\n                            ")])],2):_vm._e(),_vm._v(" "),(typeof _vm.preventionExams['6'] != 'undefined' && _vm.preventionExams['6'].length > 0 )?_c('span',[_vm._l((_vm.preventionExams['6']),function(item){return _c('span',{key:item,staticClass:"prevention"},[(_vm.preventionExams['6'].at(-1) != item)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+",\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionExams['6'].at(-1) == item && _vm.preventionExams['6'].length > 1)?_c('span',[_vm._v("\n                                    e "+_vm._s(item)+"\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionExams['6'].length == 1)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+"\n                                ")]):_vm._e()])}),_vm._v(" "),(_vm.preventionExams['12'].length > 0 || _vm.preventionExams['24'].length > 0)?_c('span',[_vm._v("\n                                a cada 6 meses;\n                            ")]):_c('span',[_vm._v("\n                                a cada 6 meses.\n                            ")])],2):_vm._e(),_vm._v(" "),(typeof _vm.preventionExams['12'] != 'undefined' && _vm.preventionExams['12'].length > 0 )?_c('span',[_vm._l((_vm.preventionExams['12']),function(item){return _c('span',{key:item,staticClass:"prevention"},[(_vm.preventionExams['12'].at(-1) != item)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+",\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionExams['12'].at(-1) == item && _vm.preventionExams['12'].length > 1)?_c('span',[_vm._v("\n                                    e "+_vm._s(item)+"\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionExams['12'].length == 1)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+"\n                                ")]):_vm._e()])}),_vm._v(" "),(_vm.preventionExams['24'].length > 0)?_c('span',[_vm._v("\n                                a cada 12 meses;\n                            ")]):_c('span',[_vm._v("\n                                a cada 12 meses.\n                            ")])],2):_vm._e(),_vm._v(" "),(typeof _vm.preventionExams['24'] != 'undefined' && _vm.preventionExams['24'].length > 0 )?_c('span',[_vm._l((_vm.preventionExams['24']),function(item){return _c('span',{key:item,staticClass:"prevention"},[(_vm.preventionExams['24'].at(-1) != item)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+",\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionExams['24'].at(-1) == item && _vm.preventionExams['24'].length > 1)?_c('span',[_vm._v("\n                                    e "+_vm._s(item)+"\n                                ")]):_vm._e(),_vm._v(" "),(_vm.preventionExams['24'].length == 1)?_c('span',[_vm._v("\n                                    "+_vm._s(item)+"\n                                ")]):_vm._e()])}),_vm._v(" "),_c('span',[_vm._v("\n                                a cada 24 meses.\n                            ")])],2):_vm._e()]),_vm._v(" "),_c('a',{attrs:{"href":"https://bvsms.saude.gov.br/check-up-medico/","target":"blank"}},[_c('font-awesome-icon',{staticClass:"question-mark",attrs:{"icon":['fa', 'question-circle']}})],1)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pillar-text"},[_c('span',{staticClass:"pillar-rep"},[_vm._v("I")]),_vm._v(" hábitos de vida, pois eles são os principais\n            responsáveis para o desenvolvimento da maioria das doenças; "),_c('br'),_vm._v(" "),_c('span',{staticClass:"pillar-rep"},[_vm._v("II")]),_vm._v(" rotina personalizada, considerando os seu diagnóstico preliminar, riscos saúde e fatores preliminares; "),_c('br'),_vm._v(" "),_c('span',{staticClass:"pillar-rep"},[_vm._v("III")]),_vm._v(" e exames preventivos necessários e que consideram a sua idade como parâmetro.\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 792 */
/*!************************************************************!*\
  !*** ./src/assets/images/kit-plans/icons/Ativ.físicas.png ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Ativ.físicas.df509b4d.png";

/***/ }),
/* 793 */
/*!*********************************************************!*\
  !*** ./src/assets/images/kit-plans/icons/Alimentos.png ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Alimentos.bea3fae3.png";

/***/ }),
/* 794 */
/*!********************************************************************!*\
  !*** ./src/assets/images/kit-plans/icons/Rotina Personalizada.png ***!
  \********************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Rotina Personalizada.2c39fad4.png";

/***/ }),
/* 795 */
/*!******************************************************************!*\
  !*** ./src/assets/images/kit-plans/icons/Exames Preventivos.png ***!
  \******************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Exames Preventivos.7af186d6.png";

/***/ }),
/* 796 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-280e45ce","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/KitTips/KitTips.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/*!****************************************************!*\
  !*** ./src/components/ReturnModal/ReturnModal.vue ***!
  \****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnModal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReturnModal.vue */ 382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_112f2464_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnModal_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-112f2464","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReturnModal.vue */ 799);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-112f2464","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ReturnModal.vue */ 798)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-112f2464"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_112f2464_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 798 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-112f2464","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ReturnModal/ReturnModal.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-112f2464","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReturnModal/ReturnModal.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"return-wrapper"},[_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"wrapper"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"img"},[(_vm.data.kit_type_id == 1)?_c('img',{attrs:{"id":"igg-one","src":__webpack_require__(/*! @/assets/images/return/igg1.png */ 383),"alt":"iggOne.png"}}):_vm._e(),_vm._v(" "),(_vm.data.kit_type_id == 2)?_c('img',{attrs:{"id":"qt-one","src":__webpack_require__(/*! @/assets/images/return/qt1.png */ 384),"alt":"qt1.png"}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"img margin-ba"},[(_vm.data.kit_type_id == 1)?_c('img',{attrs:{"id":"igg-two","src":__webpack_require__(/*! @/assets/images/return/igg2.png */ 800),"alt":"iggTwo.png"}}):_vm._e(),_vm._v(" "),(_vm.data.kit_type_id == 2)?_c('img',{attrs:{"id":"qt2-two","src":__webpack_require__(/*! @/assets/images/return/qt2.png */ 801),"alt":"qt2.png"}}):_vm._e()]),_vm._v(" "),_c('div',[(_vm.data.kit_type_id == 1)?_c('div',{staticClass:"purple bold",staticStyle:{"margin-bottom":"15px"}},[_vm._v("\n                    Você sabia que IgG é uma classe de"),_c('br'),_vm._v("\n                    anticorpos (moléculas de defesa),"),_c('br'),_vm._v("\n                    produzidos pelo corpo especificamente"),_c('br'),_vm._v("\n                    contra uma substância estranha ao"),_c('br'),_vm._v("\n                    organismo, que pode ser um vírus,"),_c('br'),_vm._v("\n                    bactéria ou toxina?\n                ")]):_vm._e(),_vm._v(" "),(_vm.data.kit_type_id == 2)?_c('div',{staticClass:"purple bold",staticStyle:{"margin-bottom":"15px"}},[_vm._v("\n                    Em relação as vacinas para o"),_c('br'),_vm._v("\n                    Covid-19, ainda há algumas dúvidas sobre o"),_c('br'),_vm._v("\n                    processo de imunização, sua segurança e"),_c('br'),_vm._v("\n                    sua eficácia.\n                ")]):_vm._e(),_vm._v(" "),(_vm.data.kit_type_id == 1)?_c('div',{staticClass:"group bold",staticStyle:{"margin-bottom":"15px"}},[_vm._m(1),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.data.kit_type_id == 2)?_c('div',{staticClass:"group bold",staticStyle:{"margin-bottom":"15px"}},[_vm._m(3),_vm._v(" "),_vm._m(4)]):_vm._e(),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),(_vm.data.disease && _vm.data.disease != null)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"purple disease-text"},[_vm._v("\n                Notamos que você informou "+_vm._s(_vm.data.disease)+" na pergunta sobre doenças ou condições específicas. \n                Estudos indicam que tal condição inclui você no grupo de risco para o Covid-19."),_c('br'),_c('br'),_vm._v("\n                As principais recomendações para pacientes que tenham comorbidades, \n                estando assim em grupo de risco, é redobrar os cuidados e manter a adoção de medidas preventivas, \n                principalmente o isolamento social, uso da máscara e a higienização constante das mãos com álcool em gel. \n                Outra medida importante é não suspender o tratamento com medicamentos de uso contínuo. \n                Havendo dúvidas com relação ao tratamento de condições preexistentes, converse com o seu médico.\n            ")]),_vm._v(" "),_c('div',{staticClass:"img margin-ba"},[(_vm.data.kit_type_id == 1)?_c('img',{attrs:{"id":"igg-1","src":__webpack_require__(/*! @/assets/images/return/igg1.png */ 383),"alt":"iggTwo.png"}}):_vm._e(),_vm._v(" "),(_vm.data.kit_type_id == 2)?_c('img',{attrs:{"id":"qt-1","src":__webpack_require__(/*! @/assets/images/return/qt1.png */ 384),"alt":"qt1.png"}}):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wrapper",class:_vm.data.disease && _vm.data.disease != null ? 'reverse' : ''},[_c('div',[(_vm.data.kit_type_id == 2)?_c('div',{staticClass:"green"},[_vm._v("\n                    Por fim, não esqueça que o tempo de proteção é"),_c('br'),_vm._v("\n                    desconhecido ainda pela Sociedade Científica. A"),_c('br'),_vm._v("\n                    Organização Mundial de Saúde considera aceitável o prazo"),_c('br'),_vm._v("\n                    de 06 (seis) meses.\n                ")]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('div',{staticClass:"purple"},[_vm._v("\n                        Com objetivo de ajudar no processo de cuidado de"),_c('br'),_vm._v("\n                        sua saúde e no esclarecimento de possíveis dúvidas,"),_c('br'),_vm._v("\n                        o Health Id Lab elaborou algumas dicas e orientações"),_c('br'),_vm._v("\n                        personalizadas de acordo com seu perfil. Confira o"),_c('br'),_vm._v("\n                        conteúdo a seguir e nunca esqueça que a saúde é o"),_c('br'),_vm._v("\n                        seu maior patrimônio.\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-bg-2"},[_vm._v("\n                        Para o exame que"),_c('br'),_vm._v("\n                        será realizado,"),_c('br'),_vm._v("\n                        quando o resultado"),_c('br'),_vm._v("\n                        do teste de IgG"),_c('br'),_vm._v("\n                        aparecer como"),_c('br'),_vm._v("\n                        positivo, a indicação é"),_c('br'),_vm._v("\n                        de que a pessoa teve"),_c('br'),_vm._v("\n                        contato com o vírus"),_c('br'),_vm._v("\n                        do COVID-19 e, então,"),_c('br'),_vm._v("\n                        iniciou a produção de"),_c('br'),_vm._v("\n                        anticorpos contra ele."),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-bg-1"},[_vm._v("\n                        Um resultado negativo,"),_c('br'),_vm._v("\n                        por outro lado, se deve"),_c('br'),_vm._v("\n                        ao fato do teste ter sido"),_c('br'),_vm._v("\n                        realizado quando ainda"),_c('br'),_vm._v("\n                        não havia a produção de"),_c('br'),_vm._v("\n                        anticorpos no organismo,"),_c('br'),_vm._v("\n                        o que não significa que"),_c('br'),_vm._v("\n                        a pessoa não tenha tido"),_c('br'),_vm._v("\n                        contato com o vírus, pois"),_c('br'),_vm._v("\n                        pode ter ocorrido a"),_c('br'),_vm._v("\n                        infecção, porém sem"),_c('br'),_vm._v("\n                        tempo suficiente para a"),_c('br'),_vm._v("\n                        produção dos anticorpos.\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-bg-2"},[_vm._v("\n                        Primeiro é importante"),_c('br'),_vm._v("\n                        destacar que, mesmo"),_c('br'),_vm._v("\n                        após as duas doses"),_c('br'),_vm._v("\n                        da vacina, nosso"),_c('br'),_vm._v("\n                        organismo não gera"),_c('br'),_vm._v("\n                        uma resposta imune"),_c('br'),_vm._v("\n                        imediata variando de"),_c('br'),_vm._v("\n                        individuo para"),_c('br'),_vm._v("\n                        indivíduo. Os"),_c('br'),_vm._v("\n                        resultados dos"),_c('br'),_vm._v("\n                        estudos levam em"),_c('br'),_vm._v("\n                        conta dados do 15º"),_c('br'),_vm._v("\n                        dia, após a segunda"),_c('br'),_vm._v("\n                        dose das vacinas.\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-bg-1"},[_vm._v("\n                        Também cabe salientar"),_c('br'),_vm._v("\n                        que a grande eficácia das"),_c('br'),_vm._v("\n                        vacinas ocorre para"),_c('br'),_vm._v("\n                        casos graves. Ou seja,"),_c('br'),_vm._v("\n                        você pode ter a doença"),_c('br'),_vm._v("\n                        mesmo com imunização"),_c('br'),_vm._v("\n                        completa. Neste caso,"),_c('br'),_vm._v("\n                        espera-se que seu"),_c('br'),_vm._v("\n                        organismo esteja mais"),_c('br'),_vm._v("\n                        capacitado a uma"),_c('br'),_vm._v("\n                        resposta otimizada,"),_c('br'),_vm._v("\n                        minimizando as chances"),_c('br'),_vm._v("\n                        de casos graves e"),_c('br'),_vm._v("\n                        excluindo no caso de"),_c('br'),_vm._v("\n                        novas variantes.\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purple",staticStyle:{"margin-bottom":"15px"}},[_vm._v("\n                    Desse modo, é fundamental continuar usando máscara"),_c('br'),_vm._v("\n                    e a fazer distanciamento social seguindo as"),_c('br'),_vm._v("\n                    recomendações dos órgãos competentes."),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 800 */
/*!*******************************************!*\
  !*** ./src/assets/images/return/igg2.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/igg2.d544cd2e.png";

/***/ }),
/* 801 */
/*!******************************************!*\
  !*** ./src/assets/images/return/qt2.png ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/qt2.789ebf1e.png";

/***/ }),
/* 802 */
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-280e45ce","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KitTips/KitTips.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kit-tips card card-shrink",class:'card table kit-type-id-' + _vm.result.kit_type_id + '-color'},[_c('div',{staticClass:"back"},[_c('button',{staticClass:"button item-btn",on:{"click":function($event){return _vm.$emit('back')}}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'arrow-left']}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('button',{staticClass:"button btn-primary btn-min",on:{"click":function($event){return _vm.$emit('changeView', 'rsl')}}},[_vm._v("Resultados")]),_vm._v(" "),(_vm.result.kit_type_id > 2)?_c('button',{staticClass:"button btn-primary btn-min",on:{"click":function($event){return _vm.$emit('changeView', 'rsk')}}},[_vm._v("Riscos de Saúde")]):_vm._e(),_vm._v(" "),(_vm.result.kit_type_id > 2)?_c('button',{staticClass:"button btn-primary btn-min",on:{"click":function($event){return _vm.$emit('changeView', 'pln')}}},[_vm._v("Plano de cuidado")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button btn-primary btn-min",on:{"click":function($event){return _vm.$emit('download', _vm.result.id, _vm.result.exam.lab_document_id)}}},[_vm._v("Laudo")])]),_vm._v(" "),_c('div',{staticClass:"tips-header"},[_c('div',{staticClass:"image-section-title"},[_c('span',{staticClass:"title"},[_vm._v("Dicas & Orientações para o empoderamento de sua saúde")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.result.kit_type.name))])])]),_vm._v(" "),(_vm.result.kit_type_id <= 2)?[_c('return-modal',{attrs:{"data":_vm.result}})]:_vm._e(),_vm._v(" "),(_vm.result.kit_type_id > 2)?[_c('div',{staticClass:"content"},[(_vm.result.kit_type.tag_type === 'check-up-saude-do-coracao')?_c('div',{staticClass:"kit-explanation"},[_c('p',[_vm._v("Olá, "+_vm._s(_vm.result.customer.name)+"!")]),_vm._v(" "),_c('p',[_vm._v("É um prazer termos você como cliente para que possamos lhe ajudar no cuidado com a sua saúde.")]),_vm._v(" "),_c('p',[_vm._v("O "),_c('span',{staticClass:"bold archivo"},[_vm._v(_vm._s(_vm.result.kit_type.name))]),_vm._v(" lhe entrega muito mais que resultados, mas\n\t\t\t\ttambém dicas e orientações de como você pode seguir a sua vida, a fim de prevenir ou auxiliar no combate às\n\t\t\t\tcardiopatias.")]),_vm._v(" "),_c('p',[_vm._v("De acordo com as informações obtidas através das respostas do seu formulário e o resultado de seus exames,\n\t\t\t\tmontamos dicas e orientações para você e por você.")]),_vm._v(" "),_c('p',[_vm._v("Se você possui alguma cardiopatia, desconfia que tem alguma doença cardíaca ou se você tem histórico familiar\n\t\t\t\tda doença, orientamos sempre a necessidade de consultar um médico, pois a cardiopatia é mais fácil de ser\n\t\t\t\ttratada quando detectada precocemente.")]),_vm._v(" "),_c('p',[_vm._v("Vale lembrar que muitas formas de doenças cardíacas podem ser prevenidas com a adoção de um estilo de vida\n\t\t\t\tmais saudável e é para isso que estamos aqui!")]),_vm._v(" "),_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-doencas-cronicas')?_c('div',{staticClass:"kit-explanation"},[_c('p',[_vm._v("Olá, "+_vm._s(_vm.result.customer.name)+"!")]),_vm._v(" "),_c('p',[_vm._v("É um prazer termos você como cliente para que possamos lhe ajudar no cuidado com a sua saúde.")]),_vm._v(" "),_c('p',[_vm._v("O "),_c('span',{staticClass:"bold archivo"},[_vm._v(_vm._s(_vm.result.kit_type.name))]),_vm._v(" lhe entrega, além de resultados, dicas e\n\t\t\torientações de como você deve seguir a sua rotina, a fim de prevenir ou auxiliar no combate as principais\n\t\t\tdoenças crônicas.")]),_vm._v(" "),_c('p',[_vm._v("De acordo com as informações obtidas através das respostas do seu formulário e o resultado de seus exames,\n\t\t\tmontamos dicas e orientações para você e por você.")]),_vm._v(" "),_c('p',[_vm._v("Se você possui alguma doença crônica, desconfia que tem ou se você tem histórico familiar de alguma doença,\n\t\t\torientamos sempre a necessidade de consultar um médico, pois é mais fácil de ser tratada quando detectada\n\t\t\tprecocemente.")]),_vm._v(" "),_c('p',[_vm._v("Vale lembrar que muitas formas de doenças crônicas são caracterizadas pela progressão lenta e de longa\n\t\t\tduração, podendo ser silenciosas ou sintomáticas. Entretanto, muitas destas doenças possuem tratamentos\n\t\t\tadequados que garantem melhoras significativas no bem-estar e qualidade de sua vida.")]),_vm._v(" "),_c('p',[_vm._v("Mudanças nos hábitos são necessárias tanto no controle como na prevenção das doenças crônicas. Os fatores de\n\t\t\trisco evitáveis têm um papel importante no surgimento e progressão destas doenças. Um estilo de vida saudável\n\t\t\tpode melhorar a expectativa e a qualidade de vida.")]),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-longevidade-saudavel')?_c('div',{staticClass:"kit-explanation"},[_c('p',[_vm._v("Olá, "+_vm._s(_vm.result.customer.name)+"!")]),_vm._v(" "),_c('p',[_vm._v("É um prazer termos você como cliente para que possamos lhe ajudar no cuidado com a sua saúde.")]),_vm._v(" "),_c('p',[_vm._v("O "),_c('span',{staticClass:"bold archivo"},[_vm._v(_vm._s(_vm.result.kit_type.name))]),_vm._v(" lhe entrega, além de resultados, dicas e\n\t\t\torientações de como você deve seguir a sua rotina, a fim de lhe dar maior tranquilidade com relação à sua\n\t\t\tsaúde e bem-estar.")]),_vm._v(" "),_c('p',[_vm._v("De acordo com as informações obtidas através das respostas do seu formulário e o resultado de seus exames,\n\t\t\tmontamos dicas e orientações para você e por você.")]),_vm._v(" "),_c('p',[_vm._v("Queremos aqui lhe fornecer informações para que você realize as mudanças necessárias em seus hábitos de vida\n\t\t\tpara auxiliar a ter um envelhecimento mais saudável.")]),_vm._v(" "),_c('p',[_vm._v("Seja o jovem do futuro e tenha saúde para viver muito mais.")]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),_vm._m(3),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-saude-do-coracao')?_c('div',{staticClass:"hashtag rotate"},[_c('span',{attrs:{"id":"1"}},[_vm._v("#Insira alimentos cardioprotetores na sua dieta!")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"section"},[(_vm.result.kit_type.tag_type === 'check-up-saude-do-coracao')?_c('div',{staticClass:"section-title"},[_c('span',{staticClass:"upper"},[_vm._v("Mas o que são alimento")]),_vm._v(" "),_c('span',{staticClass:"lower"},[_vm._v("cardioprotetores?")])]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-saude-do-coracao')?_c('div',{staticClass:"text"},[_c('p',[_vm._v("\n\t\t\t\t\tVocê já deve ter ouvido falar dos alimentos cardioprotetores, aqueles que possuem ação sobre a diminuição da\n\t\t\t\t\tpressão arterial,\n\t\t\t\t\tdo colesterol ruim, triglicérides e controle do peso. Também contribuem na melhora do colesterol bom e a\n\t\t\t\t\tdiminuição da agregação plaquetária,\n\t\t\t\t\tque é responsável por controlar a boa circulação sanguínea para evitar coágulos e derrames.\n\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t\tOs alimentos que pertencem a esse grupo são aqueles que protegem o coração, como vitaminas, minerais, fibras\n\t\t\t\t\te antioxidantes,\n\t\t\t\t\te que não apresentem nutrientes que podem prejudicar o coração, como gordura saturada, colesterol e sódio.\n\t\t\t\t")])]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-doencas-cronicas')?_c('div',{staticClass:"text"},[_vm._m(4),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\tAs dietas alimentares predominantemente baseadas em vegetais reduzem o risco de desenvolver e/ou agravar\n\t\t\t\tobesidade,\n\t\t\t\tdiabetes, hipertensão, dislipidemia, entre outras. Dietas a base de vegetais são ricas em hortaliças,\n\t\t\t\tfrutas, grãos integrais,\n\t\t\t\tleguminosas, frutas secas e contém apenas pequenas porções de carne e laticínios. Estas dietas ajudam a\n\t\t\t\tatingir e manter um peso saudável,\n\t\t\t\treduzem a pressão sanguínea e ainda são ricas em fontes de fibras alimentares (que protegem contra o câncer\n\t\t\t\tcolorretal).\n\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\tAs frutas e os vegetais contribuem para a prevenção de doenças cardiovasculares. É possível que determinados\n\t\t\t\tvegetais e frutas,\n\t\t\t\tincluindo vegetais crucíferos, como repolho e brócolis e muitas frutas ou vegetais ricas em ácido fólico,\n\t\t\t\tainda protejam contra o\n\t\t\t\tdesenvolvimento de câncer do cólon, retal, bucal, de faringe, de laringe e de esôfago.\n\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\tComer carne vermelha e processada aumenta o risco de desenvolver câncer colorretal. Gorduras saturada e\n\t\t\t\ttrans aumentam o colesterol no\n\t\t\t\tsangue e o risco cardiovascular. A alta ingestão de sódio/sal é um dos fatores de risco principais para\n\t\t\t\tpressão sanguínea elevada, doenças cardiovasculares e provavelmente câncer de estômago.\n\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\tDietas ricas em carne e laticínios também aumentam a pressão sanguínea. As dietas ricas em alimentos ou\n\t\t\t\tbebidas de alta densidade energética,\n\t\t\t\taltamente processados e ricos em amidos ou açúcares refinados contribuem para o sobrepeso e a obesidade.\n\t\t\t")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\tSobrepeso e obesidade estão associados ao aumento da mortalidade e risco elevado de doença ou morte\n\t\t\t\tprovocados por doenças cardiovasculares,\n\t\t\t\tdiabetes e diversos tipos de câncer. Isto ocorre pelo aumento da pressão sanguínea e do colesterol no\n\t\t\t\tsangue, da resistência à insulina e de inflamação,\n\t\t\t\tassim como dos níveis hormonais.\n\t\t\t")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\tPara melhor resultado no tratamento de hipertensão arterial é fundamental a adoção de um hábito alimentar\n\t\t\t\tsaudável,\n\t\t\t\talém da realização de atividades físicas, redução do consumo de bebidas alcoólicas e cessação do hábito de\n\t\t\t\tfumar.\n\t\t\t")]),_vm._v(" "),_vm._m(12)]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-longevidade-saudavel')?_c('div',{staticClass:"text"},[_vm._m(13),_vm._v(" "),_c('p',[_vm._v("\n            Coma diariamente verduras escuras, leites e seus derivados, ou seja, uma dieta que forneça os nutrientes\n            essenciais e as\n            quantidades adequadas de calorias, evitando o excesso de açúcar, carboidratos e alimentos gordurosos.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Vamos passar 9 dicas para auxiliar na sua alimentação:\n          ")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22)]):_vm._e()]),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-saude-do-coracao')?_c('div',{staticClass:"section flex-start"},[_vm._m(23),_vm._v(" "),_vm._m(24)]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-saude-do-coracao')?_c('div',{staticClass:"section"},[_vm._m(25)]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-saude-do-coracao')?_c('div',{staticClass:"section flex-start"},[_vm._m(26),_vm._v(" "),_vm._m(27)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container-gambs"},[_vm._m(28),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-saude-do-coracao')?_c('div',{staticClass:"text"},[_c('p',[_vm._v("\n            Todas as atividades aeróbicas em geral são adequadas para a melhoria da saúde, já que a grande vantagem\n            desses exercícios é a\n            elevação da capacidade cardiorrespiratória.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            A prática regular de atividades físicas ajuda na prevenção de doenças cardiovasculares, pois reduz a\n            tensão arterial e o colesterol,\n            aumenta a energia e melhora qualidade do sono, além de ajudar a manter o peso saudável e controlar o\n            estresse.\n          ")])]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-doencas-cronicas')?_c('div',{staticClass:"text"},[_vm._m(29),_vm._v(" "),_c('p',[_vm._v("\n            Os exercícios físicos são importantes para combater o sedentarismo e auxiliar no combate de doenças.\n            Mas, devemos antes de tudo alertar você que comprou o kit de Doenças Crônicas, que a recomendação aqui\n            é um pouco diferente daqueles indicados para o aperfeiçoamento do condicionamento físico, pois muito mais\n            que estética estamos\n            preocupados com a sua saúde.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Em suma, não é seguro prescrevemos para você atividades físicas de alta intensidade, com cronograma\n            especifico,\n            sem antes compreender a existência e estágio da doença crônica. Busque auxilio junto aos profissionais da\n            Educação Física e Fisioterapia,\n            levando consigo tudo que você terá de informações aqui no Health Lab.\n          ")]),_vm._v(" "),_vm._m(30),_vm._v(" "),_c('p',[_vm._v("\n            Não! A grande maioria dos portadores de doenças crônicas temem que a prática de exercícios físicos possa\n            agravar os males que sofrem.\n            No entanto, as atividades físicas são benéficas e precisam fazer parte do dia a dia das pessoas.\n          ")]),_vm._v(" "),_vm._m(31),_vm._v(" "),_c('p',[_vm._v("\n            Dependendo do problema existem algumas restrições. No entanto, não é aconselhável o abandono total da\n            prática do exercício físico.\n          ")]),_vm._v(" "),_vm._m(32),_vm._v(" "),_c('p',[_vm._v("\n            Para ir eliminando gordura é necessário melhorar a atividade cardiorrespiratória, tendo como alvo os\n            exercícios aeróbicos\n            (caminhada e bicicleta). Posteriormente e, não havendo restrições, implementar a musculação ou\n            fisioterapia\n            para melhorar os movimentos articulares.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Lembre-se que para os casos de obesidade, o essencial é iniciar bem devagar, ou seja, uma atividade de\n            baixo impacto\n            (caminhada, bicicleta, natação e hidroginástica, por exemplo) com 10 minutos e depois ir aumentando\n            periodicamente 5\n            minutos até chegar ao máximo de 40 minutos diários.\n          ")]),_vm._v(" "),_vm._m(33),_vm._v(" "),_c('p',[_vm._v("\n            Confira quais exercícios você pode fazer sem riscos:\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            1° Caminhada - Elas aceleram o batimento cardíaco e o sistema respiratório, queimando calorias e\n            consumindo glicose.\n            Ao caminhar, o diabético deve optar por locais seguros e tranquilos como um parque e, se possível, estar\n            sempre acompanhado de alguém.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            2° Bicicleta - Devido ao risco de quedas, é recomendável fazer o exercício em uma bicicleta ergométrica.\n            Pedalar aumenta a frequência cardíaca e respiratória e queima gorduras. Além disso, causa um grande\n            estímulo na circulação,\n            sobretudo nas pernas, onde o risco é maior nos diabéticos.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            3° Natação e hidroginástica - Permitem uma ampla gama de atividades físicas mas atenuam todo impacto no\n            corpo.\n            A água dá uma sustentação maior para o corpo, diminuindo o peso nas juntas e articulações. Além disso a\n            natação\n            promove uma melhora na circulação de todo o corpo, fortalece a musculatura, queima gorduras e aumenta a\n            captação da glicose pelos músculos.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Lembrando que é sempre recomendável levar algum tipo de carboidrato para os momentos de exercícios,\n            como castanhas e snacks integrais, para os casos de baixa glicêmica repentina.\n            Água também é crucial nos momentos de atividade física e ainda mais para pessoas com diabetes,\n            pois além de repor as perdas durante o exercício, a água ajuda a controlar os níveis de açúcar no sangue.\n          ")]),_vm._v(" "),_vm._m(34),_vm._v(" "),_c('p',[_vm._v("\n            Uma das principais formas de prevenir e tratar a hipertensão arterial é praticando regularmente atividades\n            físicas.\n            O exercício provoca uma queda da pressão auxiliando no combate da doença, no entanto, alguns cuidados são\n            necessários durante a\n            atividade para garantir a sua segurança.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            É importante determinar o ritmo e a intensidade da atividade física, lembrando que se você não está\n            habituado a fazer atividade\n            física deve iniciar com caminhadas leves de 10 à 20 minutos por dia, com ritmo lento e sem paradas.\n            Depois de adquirida uma certa segurança e confiança, o tempo pode ir aumentando periodicamente.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Ressaltamos, ainda, que durante a prática da atividade física, o ideal é estar sempre com uma garrafa de\n            água por perto,\n            especialmente se for ao ar livre. Desidratação aumenta a chance de pico de pressão durante exercício!\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Depois da atividade física, podem aparecer dores musculares e cansaço. Este tipo de sintoma é considerado\n            normal,\n            já que o corpo não está acostumado. Essas sensações tendem a melhorar com o passar do tempo.\n            Por outro lado, tontura, falta de ar intensa e aperto no peito podem indicar que há um problema mais sério\n            e você deverá\n            ir ao médico para consultar.\n          ")])]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-longevidade-saudavel')?_c('div',{staticClass:"text"},[_c('p',[_vm._v("\n            Vamos tentar melhorar a sua qualidade de vida construindo novos significados para que consiga ultrapassar\n            qualquer barreira entre você e o seu corpo.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Iremos lhe passar 5 meios para ajudar a aumentar a sua qualidade de vida, fazendo com que você fique mais\n            saudável.\n          ")]),_vm._v(" "),_vm._m(35),_vm._v(" "),_vm._m(36),_vm._v(" "),_vm._m(37),_vm._v(" "),_vm._m(38),_vm._v(" "),_vm._m(39),_vm._v(" "),_vm._m(40),_vm._v(" "),_c('p',[_vm._v("\n            Outros exercícios como a natação, a hidroginástica, o ciclismo, a ioga ou o tai chi chuan, melhoram a\n            função cardiovascular,\n            assim como a concentração, o equilíbrio e a força, ajudando a diminuir o risco à sua saúde.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Por fim, mas não menos importante, lembre-se que antes de praticar qualquer exercício, é importante\n            consultar o\n            médico para avaliar a densidade óssea e adaptar os exercícios ao seu condicionamento físico e sua idade.\n          ")])]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-saude-do-coracao')?_c('div',{staticClass:"section"},[_vm._m(41),_vm._v(" "),_vm._m(42)]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-saude-do-coracao')?_c('div',{staticClass:"section"},[_vm._m(43),_vm._v(" "),_vm._m(44)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"section",attrs:{"id":"mente"}},[_c('div',{staticClass:"centralized"},[_vm._m(45),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-saude-do-coracao')?_c('div',{staticClass:"text"},[_c('p',[_vm._v("\n              Fortes emoções podem gerar palpitações no peito, falta de ar e outros sintomas que, em geral, associamos\n              às doenças cardíacas.\n              De fato, o coração é afetado pelo que pensamos e sentimos. E quando o coração vai mal, ele também pode\n              afetar nosso estado de espírito.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Por isso, os sintomas emocionais manifestados por pessoas que têm cardiopatias nunca devem ser ignorados\n              por familiares ou amigos próximos.\n              Paralelamente, quem é deprimido também tem mais chances de desenvolver doenças do coração.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Pressão no peito, sensação de bola na garganta, falta de ar e palpitações são alguns dos sintomas físicos\n              que podem estar associados a\n              problemas emocionais. Isso é consequência da conexão entre corpo e mente, gerada principalmente pelo\n              sistema nervoso autônomo - a parte do sistema\n              nervoso responsável por coordenar o funcionamento dos órgãos internos do corpo, como estômago, genitais e\n              coração.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Assim, quando recebemos uma ótima notícia ou ficamos emocionados, nosso coração acelera. Da mesma forma,\n              quando somos surpreendidos por algo negativo,\n              podemos sentir palpitações. Estas reações do organismo são normais e todo mundo as sente. Porém, quando as\n              emoções negativas se perpetuam, provocando\n              descargas contínuas de cortisol e outros hormônios, o corpo pode sofrer as consequências. Sono, apetite e\n              humor podem ficar prejudicados,\n              gerando distúrbios emocionais e cardiopatias relacionadas.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Sabemos hoje da importância de mantermos nossos pensamentos e sentimentos equilibrados para se ter saúde\n              física.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Seguindo nossas orientações e dicas aqui oferecidas, bem como o plano de cuidado que estruturamos para\n              você, sua saúde lhe agradecerá.\n            ")])]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-doencas-cronicas')?_c('div',{staticClass:"text"},[_c('p',[_vm._v("\n              A menos que você tenha vivido sob uma rocha na última década, provavelmente já ouviu falar sobre os muitos\n              benefícios que a meditação\n              alegou oferecer: tudo, desde diminuição da ansiedade e depressão até menos estresse, melhor sono e até\n              redução da perda de memória.\n              Mas muitas pessoas estão começando a recorrer à meditação para ajudar a controlar as doenças crônicas.\n              Isso é bom demais para ser verdade,\n              ou algo que vale a pena adicionar ao seu regime de autocuidado? Vamos olhar para a ciência e descobrir.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              A meditação o ajudará a relaxar e a lidar com os estressores cotidianos da vida! Para as pessoas o\n              estresse de lidar com uma doença\n              crônica pode ser monumental. Pesquisas mostram que a meditação regular reduz a resposta ao estresse do\n              corpo, diminuindo a pressão arterial,\n              diminuindo a frequência cardíaca, reduzindo a ingestão de oxigênio e até mesmo modifica as ondas cerebrais\n              para um modo mais relaxado.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              A meditação também pode ajudar com o controle de impulsos e ajudar a fazer escolhas mais conscientes\n              quando se trata de exercícios e\n              alimentação saudável, o que pode ter enormes benefícios em seus níveis de glicose no sangue, que cria um\n              ciclo de escolhas saudáveis\n              ​​que levam a um controle ainda melhor.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              A importância de uma prática regular de meditação não deve ser ignorada quando se contempla o cuidado com\n              as doenças crônicas.\n              Discuta as possibilidades de meditação com seu médico, e talvez essa importante ferramenta possa se tornar\n              parte de seu gerenciamento e\n              sucesso em geral.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Seguindo nossas orientações e dicas aqui oferecidas, bem como o plano de cuidado que estruturamos para\n              você, sua saúde lhe agradecerá.\n            ")])]):_vm._e(),_vm._v(" "),(_vm.result.kit_type.tag_type === 'check-up-longevidade-saudavel')?_c('div',{staticClass:"text"},[_vm._m(46),_vm._v(" "),_c('p',[_vm._v("\n              Cada vez mais a meditação vem sendo objeto de pesquisa e estudo de vários cientistas, que descobrem e\n              comprovam que ela tem um grande efeito benéfico principalmente sobre o cérebro.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              A prática diária da meditação traz efeitos surpreendentes, tanto para o bem-estar físico como para o\n              psicológico,\n              podendo ajudar a controlar a dor, o sofrimento e a ansiedade.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Ainda, estudos comprovam que a prática pode ser tão eficaz quanto certos medicamentos.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Além de trabalhar a mente com a meditação, também é importante incluir em sua rotina a dança,\n              teatro e viagens, pois são aliados importantes na busca de uma longevidade saudável, além de reforçar\n              vínculos com amigos e familiares.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Seguindo nossas orientações e dicas aqui oferecidas, bem como o plano de cuidado que estruturamos para\n              você, sua saúde lhe agradecerá.\n            ")])]):_vm._e()])])])]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Como base essencial para o seu cuidado, foram traçados três pilares para um plano de cuidado eficiente, quais\n\t\t\t\tsejam: "),_c('span',{staticClass:"bold"},[_c('a',{attrs:{"href":"#alimentacao"}},[_vm._v("alimentação")]),_vm._v(", "),_c('a',{attrs:{"href":"#rotina"}},[_vm._v("rotina")]),_vm._v(" e "),_c('a',{attrs:{"href":"#mente"}},[_vm._v("mente.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Como base essencial para o seu cuidado, foram traçados três pilares para um plano de cuidado eficiente, quais\n\t\t\tsejam: "),_c('span',{staticClass:"bold"},[_c('a',{attrs:{"href":"#alimentacao"}},[_vm._v("alimentação")]),_vm._v(", "),_c('a',{attrs:{"href":"#rotina"}},[_vm._v("rotina")]),_vm._v(" e "),_c('a',{attrs:{"href":"#mente"}},[_vm._v("mente.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Como base essencial para o seu cuidado, foram traçados três pilares para um plano de cuidado eficiente, "),_c('span',{staticClass:"bold"},[_c('a',{attrs:{"href":"#alimentacao"}},[_vm._v("alimentação")]),_vm._v(", "),_c('a',{attrs:{"href":"#rotina"}},[_vm._v("rotina")]),_vm._v(" e "),_c('a',{attrs:{"href":"#mente"}},[_vm._v("mente.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"alimentacao"}},[_c('div',{staticClass:"section-title"},[_c('span',{staticClass:"upper"},[_vm._v("Cuidados com sua")]),_vm._v(" "),_c('span',{staticClass:"lower"},[_vm._v("alimentação")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-veggies"},[_c('img',{attrs:{"alt":"Mulher bebendo suco verde, sobre mesa com vegetais.","src":__webpack_require__(/*! @/assets/images/alimentacao_saudavel.jpg */ 803)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("Composição corporal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-healthy-food"},[_c('img',{attrs:{"alt":"Alguns dos alimentos que contribuem para um organismo saudável.","src":__webpack_require__(/*! @/assets/images/alimentacao_saude.png */ 385)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("Particularidade para você que apresenta obesidade:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n\t\t\t\tOs principais conselhos que podemos trazer para quem apresenta obesidade são:\n\t\t\t"),_c('ul',{staticClass:"ul"},[_c('li',[_vm._v("Coma devagar, mastigando muito bem os alimentos e parar de comer com o estômago “meio vazio”;")]),_vm._v(" "),_c('li',[_vm._v("Use as gorduras na quantidade mínima para cozinhar e temperar como, por exemplo, algumas gotas de azeite\n\t\t\t\tno peixe cozido e nas hortaliças, e um pouco de manteiga nas torradas;\n\t\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("Coma de todas as maneiras, isto é, não ingerir só grelhados e cozidos, mas, também, alimentar-se com\n\t\t\t\tassados e fritos, tendo o cuidado de lhes retirar a gordura;\n\t\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("Não beba vinho nem outras bebidas alcoólicas. O álcool, além de ser um alimento muito rico em calorias,\n\t\t\t\te que só por si engorda, tem, ainda, o inconveniente de abrir o apetite;\n\t\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("Beba água, mas não exageradamente durante as refeições, a fim de se não distender o estômago e aumentar\n\t\t\t\to apetite;\n\t\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("Não coma pão nem ao almoço nem ao jantar e fora destas refeições comê-lo o menos possível, e torrado,\n\t\t\t\tpara dificultar a mastigação;\n\t\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("Não coma açúcar, mesmo que este seja só para adoçar o café e outras bebidas amargas (se o médico\n\t\t\t\tpermitir pode usar-se sacarina). Não coma, também, doces e bolos que têm enormes quantidades de açúcar;\n\t\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("Coma no mínimo cinco refeições por dia: café da manhã, almoço, lanche, jantar e antes de deitar;")]),_vm._v(" "),_c('li',[_vm._v("Evite os medicamentos para emagrecer. Use-os somente com orientação médica.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("Particularidade para você que é diabético:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n\t\t\t\tOs alimentos que devem ser evitados na dieta para diabéticos são aqueles ricos em açúcar ou carboidratos\n\t\t\t\tsimples, como:\n\t\t\t"),_c('ul',{staticClass:"ul"},[_c('li',[_vm._v("Açúcar e doces em geral;")]),_vm._v(" "),_c('li',[_vm._v("Mel, geleia de frutas, compotas, marmelada, produtos de confeitaria e pastelaria;")]),_vm._v(" "),_c('li',[_vm._v("Doces em geral, chocolates e guloseimas;")]),_vm._v(" "),_c('li',[_vm._v("Bebidas açucaradas, como refrigerantes, sucos industrializados e achocolatados;")]),_vm._v(" "),_c('li',[_vm._v("Tubérculos em geral, como batata, batata doce, macaxeira e inhame, pois têm elevada concentração de\n\t\t\t\tcarboidratos e devem ser consumidos em pequenas porções;\n\t\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("Carnes processadas, como presunto, peito de peru, salsicha, linguiça, bacon, mortadela e salame;")]),_vm._v(" "),_c('li',[_vm._v("Bebidas alcoólicas, como cervejas, vinhos e destilados.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("Particularidade para você que é hipertenso:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n\t\t\t\tAs principais recomendações para casos de hipertensão são:\n\t\t\t"),_c('ul',{staticClass:"ul"},[_c('li',[_vm._v("Procure usar o mínimo de sal no preparo dos alimentos (1 colher de chá considerando todas as\n\t\t\t\trefeições);\n\t\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("Para não exagerar no sal, evite deixar o saleiro na mesa;")]),_vm._v(" "),_c('li',[_vm._v("Leia sempre o rótulo dos alimentos, verificando a quantidade de sódio;")]),_vm._v(" "),_c('li',[_vm._v("Prefira temperos naturais (cebola, alho, cheiro verde, limão, orégano…) e evite temperos prontos (caldo\n\t\t\t\tde carne, caldo de galinha, sopa industrializada);\n\t\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("Procure evitar alimentos industrializados, como embutidos, enlatados e carnes salgadas. Além de conter\n\t\t\t\tmuito sódio, eles também têm alto teor de gorduras;\n\t\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("Diminua o consumo de gorduras, preferindo alimentos cozidos, assados ou grelhados;")]),_vm._v(" "),_c('li',[_vm._v("Evitar o consumo excessivo de bebidas alcoólicas e o tabagismo;")]),_vm._v(" "),_c('li',[_vm._v("Consumir, pelo menos, três porções de frutas e hortaliças por dia;")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-healthy-food"},[_c('img',{attrs:{"alt":"Casal dançando sob luzes coloridas.","src":__webpack_require__(/*! @/assets/images/alimentacao_saude2.jpg */ 804)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("1º passo")]),_vm._v(" - Faça três refeições ao dia (café da manhã, almoço e jantar) e, caso\n            necessário, faça outras refeições nos intervalos.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("2º passo")]),_vm._v(" - Dê preferência aos grãos integrais e aos alimentos na sua forma mais\n            natural.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("3º passo")]),_vm._v(" - Inclua frutas, legumes e verduras em todas as refeições ao longo do\n            dia.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("4º passo")]),_vm._v(" - Coma feijão com arroz, de preferência no almoço ou no jantar.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("5º passo")]),_vm._v(" - Lembre-se de incluir carnes, aves, peixes, ovos, leite e derivados em\n            pelo menos uma refeição durante o dia.\n            Retirar a gordura aparente das carnes e a pele das aves antes da preparação torna esses alimentos mais\n            saudáveis.\n            Os leites e derivados são ricos em cálcio, que ajuda no fortalecimento dos ossos. Já as carnes, as aves, os\n            peixes e os ovos são ricos\n            em proteínas e minerais.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("6º passo")]),_vm._v(" - Use pouca quantidade de óleos, gorduras, açúcar e sal no preparo dos\n            alimentos.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("7º passo")]),_vm._v(" - Beba água mesmo sem sentir sede, de preferência nos intervalos das\n            refeições.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("8º passo")]),_vm._v(" - Evite bebidas açucaradas (refrigerantes, sucos e chás\n            industrializados), bolos e biscoitos recheados, doces e outras guloseimas como regra da alimentação.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("9º passo")]),_vm._v(" - Fique atento às informações nutricionais dos rótulos dos produtos\n            processados e ultraprocessados para favorecer a escolha de produtos alimentícios mais saudáveis.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-image"},[_c('span',[_vm._v("Entre eles estão:")]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{attrs:{"alt":"Alguns dos alimentos que contribuem para um organismo saudável.","src":__webpack_require__(/*! @/assets/images/alimentacao_saude.png */ 385)}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"items"},[_c('span',[_vm._v("aveia,")]),_vm._v(" "),_c('span',[_vm._v("abacate,")]),_vm._v(" "),_c('span',[_vm._v("azeite,")]),_vm._v(" "),_c('span',[_vm._v("castanhas,")]),_vm._v(" "),_c('span',[_vm._v("grãos como feijões, linhaça, lentilha, grão-de-bico,")]),_vm._v(" "),_c('span',[_vm._v("frutas como morango, mirtilo, banana, tomate e framboesa,")]),_vm._v(" "),_c('span',[_vm._v("chocolate amargo,")]),_vm._v(" "),_c('span',[_vm._v("chá-verde")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"middle"},[_c('div',{staticClass:"hashtag"},[_c('span',{attrs:{"id":"1"}},[_vm._v("#Não consuma álcool exageradamente")])]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',{staticStyle:{"max-width":"600px"}},[_vm._v("A ingestão exagerada de álcool pode causar infarto do miocárdio e insuficiência\n              cardíaca,\n              entre muitos outros problemas que não atacam diretamente o coração, mas interferem nos rins e outros\n              órgãos.")])]),_vm._v(" "),_c('div',{staticClass:"float-image"},[_c('img',{staticStyle:{"margin-left":"150px","margin-top":"-35px"},attrs:{"alt":"Taça de vinho sendo derrubada.","src":__webpack_require__(/*! @/assets/images/taca.png */ 805)}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-shadow"},[_c('img',{attrs:{"alt":"Homem correndo sob sombra da obesidade.","src":__webpack_require__(/*! @/assets/images/sombra.png */ 806)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('div',{staticClass:"hashtag"},[_vm._v("\n            # Evite ingerir alimentos ricos em gordura e sal\n          ")]),_vm._v(" "),_c('p',[_vm._v("Alimentos gordurosos são prejudiciais para a nossa saúde e ainda mais para o coração.")]),_vm._v(" "),_c('div',{staticClass:"hashtag"},[_vm._v("\n            # Realize consultas periódicas\n          ")]),_vm._v(" "),_c('p',[_vm._v("O colesterol alto, diabetes e a pressão alta são preocupantes. Além de uma boa alimentação, consultas\n            periódicas são muito\n            importantes para controlar esses tipos de distúrbios, siga o plano de cuidado que realizamos especialmente\n            para você.")]),_vm._v(" "),_c('div',{staticClass:"hashtag"},[_vm._v("\n            # Mantenha o peso ideal\n          ")]),_vm._v(" "),_c('p',[_vm._v("A obesidade é uma aliada para o surgimento de doenças vasculares, procure optar sempre por uma alimentação\n            balanceada e rica em proteínas, além de praticar atividade física.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"rotina"}},[_c('div',{staticClass:"section-title"},[_c('span',{staticClass:"upper"},[_vm._v("Pratique")]),_vm._v(" "),_c('span',{staticClass:"lower"},[_vm._v("atividade física")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-running"},[_c('img',{attrs:{"alt":"Casal correndo em um gramado perto da água.","src":__webpack_require__(/*! @/assets/images/correndo.jpg */ 807)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("Mas então eu devo ficar parado até buscar auxílio?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("Quais são as atividades físicas mais indicadas?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("Para quem apresenta obesidade")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("Para quem é diabético:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("Para quem é hipertenso:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-dancing"},[_c('img',{attrs:{"alt":"Casal dançando sob luzes coloridas.","src":__webpack_require__(/*! @/assets/images/dancando.jpg */ 808)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("1° Caminhada")]),_vm._v(" - A caminhada ajuda a aumentar a densidade óssea, fazendo com que\n            os ossos fiquem mais fortes.\n            Além disso, este exercício melhora o equilíbrio e a coordenação motora, diminuindo o risco de quedas e,\n            consequentemente,\n            de fraturas. Faça caminhadas de no mínimo 20 minutos, diariamente.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("2° Dança")]),_vm._v(" - A dança trabalha diretamente sobre os ossos das pernas, quadril e\n            coluna, ajudando a retardar a\n            perda mineral óssea. Além disso, ela melhora a circulação sanguínea e o coração.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("3° Subir escadas")]),_vm._v(" - Subir escadas é também um ótimo exercício para você, sendo\n            recomendado trocar todos os elevadores pelas escadas,\n            desde que em andares mais baixos, principalmente na descida, porque o impacto é maior e, por isso, há\n            maior estimulação da produção de massa óssea.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("4° Jardinagem")]),_vm._v(" - A jardinagem é também um ótimo exercício para você, desde que\n            seja mantida a postura correta,\n            porque implica fazer movimentos de impacto como cortar a grama ou usar a tesoura de poda para cortar as\n            plantas, por exemplo,\n            que ajudam a fortalecer os ossos. A jardinagem é um ótimo exercício para fortalecer os ossos dos braços.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"bold"},[_vm._v("5° Musculação")]),_vm._v(" - A musculação exerce tensão nos músculos e ossos, ajudando a\n            aumentar a densidade óssea e a fortalecer ossos, sendo o levantamento de pesos excelente para favorecer a\n            formação de ossos fortes e sadios.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title"},[_c('span',{staticClass:"upper"},[_vm._v("Por quanto")]),_vm._v(" "),_c('span',{staticClass:"lower"},[_vm._v("tempo?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n              São recomendados pelo menos 150 minutos por semana de atividade física moderada.\n              É possível dividir em cinco sessões diárias de 30 minutos, por exemplo, ou 50 minutos por três vezes por\n              semana.\n              Já para quem pratica musculação, a recomendação é de dois a três treinos, em dias alternados.\n            ")]),_c('p'),_c('p',[_vm._v("\n              O estilo de vida sedentário está associado ao risco maior de doença coronariana, por isso a prática de\n              atividade física\n              é uma das maiores aliadas da saúde de todos os corações.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title"},[_c('span',{staticClass:"upper"},[_vm._v("Qual")]),_vm._v(" "),_c('span',{staticClass:"lower"},[_vm._v("intensidade?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n              É importante que o exercício seja prescrito pelo médico de forma individualizada, assim como é feito com a\n              indicação de medicamentos.\n              Orientações de frequência, tempo adequado, intensidade e progressão levam em conta fatores de risco e o\n              histórico clínico do paciente,\n              complementando exame físico completo e uso de medicações. Em alguns casos pode ser necessário iniciar a\n              atividade física em um ambiente\n              supervisionado, inclusive com monitor cardíaco.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title"},[_c('span',{staticClass:"upper"},[_vm._v("Sua")]),_vm._v(" "),_c('span',{staticClass:"lower"},[_vm._v("mente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n              Conforme mencionado anteriormente, são muitos os benefícios de uma boa alimentação e da prática regular de\n              atividades físicas.\n              Mas não é demais lembrar também da "),_c('span',{staticClass:"bold"},[_vm._v("importância do exercício mental:")]),_vm._v(" aquelas para\n              manter a mente ativa,\n              exercitar a memória, retardar sintomas ou doenças.\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 803 */
/*!****************************************************!*\
  !*** ./src/assets/images/alimentacao_saudavel.jpg ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/alimentacao_saudavel.7fcd56b0.jpg";

/***/ }),
/* 804 */
/*!**************************************************!*\
  !*** ./src/assets/images/alimentacao_saude2.jpg ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/alimentacao_saude2.2281ca72.jpg";

/***/ }),
/* 805 */
/*!************************************!*\
  !*** ./src/assets/images/taca.png ***!
  \************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/taca.502d9091.png";

/***/ }),
/* 806 */
/*!**************************************!*\
  !*** ./src/assets/images/sombra.png ***!
  \**************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/sombra.a3e79864.png";

/***/ }),
/* 807 */
/*!****************************************!*\
  !*** ./src/assets/images/correndo.jpg ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/correndo.4c7a8381.jpg";

/***/ }),
/* 808 */
/*!****************************************!*\
  !*** ./src/assets/images/dancando.jpg ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/dancando.e6730046.jpg";

/***/ }),
/* 809 */
/*!**************************************************************!*\
  !*** ./src/components/OrientationModal/OrientationModal.vue ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_OrientationModal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OrientationModal.vue */ 386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c929eb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrientationModal_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-42c929eb","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OrientationModal.vue */ 811);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-42c929eb","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./OrientationModal.vue */ 810)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42c929eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_OrientationModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c929eb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrientationModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 810 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42c929eb","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OrientationModal/OrientationModal.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/*!**************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42c929eb","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrientationModal/OrientationModal.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orientation modal",on:{"click":function($event){return _vm.outsideClick()}}},[_c('div',{staticClass:"orientation modal-box"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),(_vm.shippingType === 3)?_c('div',{staticClass:"orientation modal-body"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Entendi")])])]):_vm._e(),_vm._v(" "),(_vm.shippingType !== 3)?_c('div',{staticClass:"orientation modal-body"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Entendi")])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('h5',[_vm._v("Que bom que você chegou até aqui, agora é com a gente!")]),_vm._v(" "),_c('p',[_vm._v("Fique tranquilo que o nosso parceiro fará o envio da sua amostra para o nosso laboratório.")]),_vm._v(" "),_c('p',[_vm._v("Assim que recebermos sua coleta, iremos aferir seus exames e disponibilizá-los aqui no seu perfil mesmo.\n                Você será notificado por e-mail e WhatsApp quando os resultados estiverem disponíveis para consulta.")]),_vm._v(" "),_c('p',[_vm._v("Agora é só aguardar e em poucos dias você receberá os resultados.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("Lembre-se que a sua região está coberta pelo sistema de envios dos correios!")]),_vm._v(" "),_c('p',[_vm._v("Para seguir adiante, você já deve ter realizado sua coleta corretamente, esperado o tempo recomendado de 1 hora para\n                        secagem do cartão de coleta e colocado o mesmo dentro do saco hermético metalizado.")]),_vm._v(" "),_c('p',[_vm._v("Tudo pronto? "),_c('span',{staticClass:"bold"},[_vm._v("Então, com sua amostra devidamente embalada dentro do envelope preto, dirija-se a uma agência dos correios para encaminhar\n                        o seu exame ao laboratório.")])]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/correios_3.png */ 387)}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("Não esqueça de levar junto a sua \"SOLICITAÇÃO DE AUTORIZAÇÃO DE POSTAGEM EM AGÊNCIA\" que foi encaminhada junto com o seu Kit.")]),_vm._v(" "),_c('p',[_vm._v("E, qualquer dúvida pode entrar em contato com nosso SAC, viu? Teremos prazer em te auxiliar.")]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/correios_2.png */ 388)}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 812 */
/*!********************************************************!*\
  !*** ./src/components/ScheduleModal/ScheduleModal.vue ***!
  \********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduleModal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ScheduleModal.vue */ 389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cd07848_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduleModal_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7cd07848","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ScheduleModal.vue */ 814);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7cd07848","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ScheduleModal.vue */ 813)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cd07848"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduleModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cd07848_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduleModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 813 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cd07848","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ScheduleModal/ScheduleModal.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cd07848","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleModal/ScheduleModal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schedule modal",on:{"click":function($event){return _vm.outsideClick()}}},[(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"schedule modal-box"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"schedule modal-body"},[(!_vm.success)?[_vm._m(0),_vm._v(" "),_c('form',{staticClass:"form",on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.zip_code},attrs:{"for":"zip"}},[_vm._v("CEP *")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('#####-###'),expression:"'#####-###'"},{name:"model",rawName:"v-model",value:(_vm.form.zip_code),expression:"form.zip_code"}],attrs:{"type":"text","name":"zip","id":"zip"},domProps:{"value":(_vm.form.zip_code)},on:{"blur":_vm.findAddress,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "zip_code", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.zip_code)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.zip_code.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.address},attrs:{"for":"address"}},[_vm._v("Logradouro *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.address),expression:"form.address"}],attrs:{"type":"text","name":"address","id":"address"},domProps:{"value":(_vm.form.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "address", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.address)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.address.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.neighbourhood},attrs:{"for":"address"}},[_vm._v("Bairro *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.neighbourhood),expression:"form.neighbourhood"}],attrs:{"type":"text","name":"neighbourhood","id":"neighbourhood"},domProps:{"value":(_vm.form.neighbourhood)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "neighbourhood", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.neighbourhood)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.neighbourhood.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.number},attrs:{"for":"number"}},[_vm._v("Número *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.number),expression:"form.number"}],attrs:{"type":"text","name":"number","id":"number"},domProps:{"value":(_vm.form.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "number", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.number)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.number.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{attrs:{"for":"address"}},[_vm._v("Complemento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.complement),expression:"form.complement"}],attrs:{"type":"text","name":"complement","id":"complement"},domProps:{"value":(_vm.form.complement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "complement", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.city},attrs:{"for":"address"}},[_vm._v("Cidade *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.city_name),expression:"form.city_name"}],attrs:{"type":"text","name":"city","id":"city","disabled":""},domProps:{"value":(_vm.form.city_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "city_name", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.city)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.city.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm",style:({'margin-bottom: 1.7rem' : !!_vm.turns})},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.state},attrs:{"for":"state"}},[_vm._v("Estado *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.state_name),expression:"form.state_name"}],attrs:{"type":"text","name":"state","id":"state","disabled":""},domProps:{"value":(_vm.form.state_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "state_name", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.state)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.state.join()))]):_vm._e()]),_vm._v(" "),(_vm.turns)?_c('div',{staticClass:"input-box sm"},[_c('label',{staticClass:"datepicker-label",class:{'has-error': _vm.errors && _vm.errors.schedule},attrs:{"for":"birthdate"}},[_vm._v("Escolha a Data *")]),_vm._v(" "),_c('select',{attrs:{"name":"schedule","id":"schedule"},on:{"change":function($event){return _vm.handleOnScheduleChange($event.target)}}},[_c('option',{attrs:{"value":"null"}},[_vm._v("Selecione uma opção")]),_vm._v(" "),_vm._l((_vm.turns),function(turn,key){return _c('option',{key:key,domProps:{"value":key}},[_vm._v("\n                          "+_vm._s(turn.day)+" - "+_vm._s(turn.turn)+" das "+_vm._s(turn.start_time)+" às "+_vm._s(turn.end_time)+"\n                      ")])})],2),_vm._v(" "),(_vm.errors && _vm.errors.schedule)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.schedule.join()))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.notFound)?_c('div',{},[_c('span',[_vm._v("\n                      Ops!! Infelizmente o local indicado ainda não faz parte da área de cobertura para coleta.\n                      Indique um local em Porto Alegre/RS.\n                  ")])]):_vm._e(),_vm._v(" "),(!_vm.notFound)?_c('div',{staticClass:"form-actions"},[(!_vm.loading)?_c('button',{staticClass:"button btn-primary",on:{"click":_vm.handleSubmit}},[_vm._v("Agendar")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary",attrs:{"disabled":""},on:{"click":_vm.handleSubmit}},[_c('loading')],1):_vm._e()]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.success)?[_c('div',{staticClass:"text"},[_c('div',{staticClass:"text"},[_c('h5',[_vm._v("Parabéns!")]),_vm._v(" "),_c('p',[_vm._v("Agendamento realizado com sucesso e em breve você receberá os resultados.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Voltar para meus Check-Ups")])])])])]:_vm._e()],2)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("Preencha os campos a seguir e agende a coleta do seu KIT.")]),_vm._v(" "),_c('h4',[_vm._v("Dados para coleta")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/vector-fluxo-healthid-lab-moto.png */ 390)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 815 */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59366e6b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Kits/Kits.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-menu'),_vm._v(" "),(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"container profile-container"},[_c('div',{staticClass:"kits"},[(_vm.checkCurrentKit(0) && _vm.currKit.type !== 'rsl' && _vm.currKit.type !== 'tps' && _vm.currKit.type !== 'rsk' && _vm.currKit.type !== 'pln')?_c('div',{staticClass:"header"},[_c('h2',{staticClass:"title"},[_vm._v("Olá "+_vm._s(_vm.user)+",")]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("\n                    Bem-vindo ao seu painel de Check-ups Health ID.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    Daqui você consegue preencher formulários e acessar os seus resultados clicando em cada Check-up e também a sua identidade de saúde no\n                    menu localizado à esquerda.\n                ")])]):_vm._e(),_vm._v(" "),(_vm.currKit.type !== 'rsl' && _vm.currKit.type !== 'tps' && _vm.currKit.type !== 'rsk' && _vm.currKit.type !== 'pln')?_c('div',{staticClass:"flex-container"},[_c('div',{staticClass:"flex-child"},[_c('div',[(_vm.checkCurrentKit())?_c('button',{staticClass:"button btn-purple back-button",on:{"click":function($event){return _vm.setCurrentKit(null, null)}}},[_vm._v("\n\t\t\t\t\tVoltar\n\t\t\t\t")]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"no-mobile"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),(!!_vm.results && _vm.results.length > 0)?[_vm._l((_vm.results),function(result,index){return [(_vm.checkCurrentKit(index) && _vm.currKit.type !== 'rsl' && _vm.currKit.type !== 'tps' && _vm.currKit.type !== 'rsk' && _vm.currKit.type !== 'pln')?_c('div',{key:index},[_c('div',{staticClass:"kit-card"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"kit-image"},[(result.kit_type.tag_type === 'check-up-anticorpos-igg-covid')?_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/kits/igg.png */ 816)}}):_vm._e(),_vm._v(" "),(result.kit_type.tag_type === 'check-up-anticorpos-vacina-covid')?_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/kits/vacina.png */ 817)}}):_vm._e(),_vm._v(" "),(result.kit_type.tag_type === 'check-up-saude-do-coracao')?_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/kits/coracao.png */ 818)}}):_vm._e(),_vm._v(" "),(result.kit_type.tag_type === 'check-up-longevidade-saudavel')?_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/kits/longevidade.png */ 819)}}):_vm._e(),_vm._v(" "),(result.kit_type.tag_type === 'check-up-doencas-cronicas')?_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/kits/cronicos.png */ 820)}}):_vm._e(),_vm._v(" "),(result.kit_type.tag_type === 'check-up-saude-preventiva')?_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/kits/preventivo.png */ 821)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"kit-details"},[_c('span',{staticClass:"kit-name"},[_vm._v(_vm._s(_vm.altKitName(_vm.getKitType(result.kit_type.tag_type))))]),_vm._v(" "),_c('span',{staticClass:"kit-date"},[_vm._v(_vm._s(_vm.getSampleDate(result) ? ("Data da coleta de sangue: " + (_vm.getSampleDate(result))) : ""))]),_vm._v(" "),(!result.steps_confirmed)?_c('span',{staticClass:"kit-info"},[_vm._v("Você ainda não preencheu o formulário para esse check-up.")]):_vm._e(),_vm._v(" "),(result.steps_confirmed && result.exam == null)?_c('span',{staticClass:"kit-info"},[_vm._v("Aguardando resultados do check-up.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kit-steps"},[_c('div',{staticClass:"step"},[_vm._v("\n                                            Check-up Ativo\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"step",class:{'active': result.status === 'in_use' && !result.steps_confirmed}},[_vm._v("\n                                            Questionário Respondido\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"step",class:{'active': (result.status === 'in_use' || result.status === 'sent_laboratory') && result.steps_confirmed && result.exam === null }},[_vm._v("\n                                            Análise pelo laboratório\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"step",class:{'active': result.status === 'finished' && result.steps_confirmed && result.exam === null}},[_vm._v("\n                                            Resultado Disponível\n                                        ")])])]),_vm._v(" "),_c('div',{staticClass:"kit-buttons"},[(!result.steps_confirmed)?_c('div',{staticClass:"actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.goToForm(result.number)}}},[_vm._v("Preencher formulário")])]):_vm._e(),_vm._v(" "),(result.steps_confirmed && !result.exam && (_vm.getShippingType(result.order[0]) == 1 || _vm.getShippingType(result.order[0]) == 3))?_c('div',{staticClass:"actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();_vm.openOrientationModal(_vm.getShippingType(result.order[0]))}}},[_vm._v("Orientações de Envio da Amostra")])]):_vm._e(),_vm._v(" "),(result.steps_confirmed && !result.exam && !result.schedule && _vm.getShippingType(result.order[0]) == 2)?_c('div',{staticClass:"actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.openScheduleModal(result.id, result.number)}}},[_vm._v("Agendar Coleta da minha amostra")])]):_vm._e(),_vm._v(" "),(result.exam && result.exam.result)?_c('div',{staticClass:"actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.setCurrentKit(index, 'rsl')}}},[_vm._v("Resultados")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row-reverse"},[_c('div',{staticClass:"kit-steps"},[_c('div',{staticClass:"step"},[_vm._v("\n                                        Check-up Ativo\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"step",class:{'active': result.status === 'in_use' && !result.steps_confirmed}},[_vm._v("\n                                        Questionário Respondido\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"step",class:{'active': (result.status === 'in_use' || result.status === 'sent_laboratory') && result.steps_confirmed && result.exam === null }},[_vm._v("\n                                        Análise pelo laboratório\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"step",class:{'active': result.status === 'finished' && result.steps_confirmed && result.exam === null}},[_vm._v("\n                                        Resultado Disponível\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"kit-buttons"},[(!result.steps_confirmed)?_c('div',{staticClass:"actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.goToForm(result.number)}}},[_vm._v("Preencher formulário")])]):_vm._e(),_vm._v(" "),(result.steps_confirmed && !result.exam && _vm.getShippingType(result.order[0]) == 1)?_c('div',{staticClass:"actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.openOrientationModal()}}},[_vm._v("Orientações de Envio da Amostra")])]):_vm._e(),_vm._v(" "),(result.steps_confirmed && !result.exam && !result.schedule && _vm.getShippingType(result.order[0]) == 2)?_c('div',{staticClass:"actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.openScheduleModal(result.id, result.number)}}},[_vm._v("Agendar Coleta da minha amostra")])]):_vm._e(),_vm._v(" "),(result.exam && result.exam.result)?_c('div',{staticClass:"actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.setCurrentKit(index, 'rsl')}}},[_vm._v("Resultados")])]):_vm._e()])])])]):_vm._e()]})]:[(_vm.results.lenght == 0)?_c('div',[_c('div',{staticClass:"kit-card",staticStyle:{"color":"var(--primary-color)"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"kit-buttons"},[_c('div',{staticClass:"actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.goToForm('')}}},[_vm._v("Cadastrar novo kit")])])])])]):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"kit-box"},[(_vm.orientationModalOpen)?_c('orientation-modal',{attrs:{"shipping-type":_vm.orientationModalPartner},on:{"close":function($event){_vm.orientationModalOpen = false}}}):_vm._e(),_vm._v(" "),(_vm.scheduleModalOpen)?_c('schedule-modal',{attrs:{"kit_id":_vm.scheduleModalKit,"kit_number":_vm.scheduleModalKitNumber},on:{"close":function($event){_vm.scheduleModalOpen = false},"updateKit":_vm.updateKitSchedule}}):_vm._e(),_vm._v(" "),(_vm.currKit.type === 'rsl')?_c('kit-results',{attrs:{"result":_vm.results[_vm.currKit.id]},on:{"changeView":_vm.setInnerView,"back":function($event){return _vm.setCurrentKit(null, null)},"download":_vm.getLink}}):_vm._e(),_vm._v(" "),(_vm.currKit.type === 'rsk')?_c('kit-risks',{attrs:{"result":_vm.results[_vm.currKit.id]},on:{"changeView":_vm.setInnerView,"back":function($event){return _vm.setCurrentKit(null, null)},"download":_vm.getLink}}):_vm._e(),_vm._v(" "),(_vm.currKit.type === 'pln')?_c('kit-plans',{attrs:{"result":_vm.results[_vm.currKit.id]},on:{"changeView":_vm.setInnerView,"back":function($event){return _vm.setCurrentKit(null, null)},"download":_vm.getLink}}):_vm._e(),_vm._v(" "),(_vm.currKit.type === 'tps')?_c('kit-tips',{attrs:{"result":_vm.results[_vm.currKit.id]},on:{"changeView":_vm.setInnerView,"back":function($event){return _vm.setCurrentKit(null, null)},"download":_vm.getLink}}):_vm._e()],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kit-image"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/kits/-1.png */ 822)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kit-details no-kit"},[_c('span',{staticClass:"kit-name"},[_vm._v("Você não possui um Check-up cadastrado")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 816 */
/*!****************************************!*\
  !*** ./src/assets/images/kits/igg.png ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/igg.2a4cbea1.png";

/***/ }),
/* 817 */
/*!*******************************************!*\
  !*** ./src/assets/images/kits/vacina.png ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/vacina.1935978a.png";

/***/ }),
/* 818 */
/*!********************************************!*\
  !*** ./src/assets/images/kits/coracao.png ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coracao.29c563f2.png";

/***/ }),
/* 819 */
/*!************************************************!*\
  !*** ./src/assets/images/kits/longevidade.png ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/longevidade.36b1c949.png";

/***/ }),
/* 820 */
/*!*********************************************!*\
  !*** ./src/assets/images/kits/cronicos.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/cronicos.aed84e60.png";

/***/ }),
/* 821 */
/*!***********************************************!*\
  !*** ./src/assets/images/kits/preventivo.png ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/preventivo.a4f5543c.png";

/***/ }),
/* 822 */
/*!***************************************!*\
  !*** ./src/assets/images/kits/-1.png ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/-1.c26495e3.png";

/***/ }),
/* 823 */
/*!***************************************!*\
  !*** ./src/views/Results/Results.vue ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Results.vue */ 391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f66c7af4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f66c7af4","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Results.vue */ 825);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f66c7af4","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Results.vue */ 824)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f66c7af4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f66c7af4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 824 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f66c7af4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Results/Results.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/*!***************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f66c7af4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Results/Results.vue ***!
  \***************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-menu'),_vm._v(" "),(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"container profile-container"},[_c('div',{staticClass:"profile"},[_c('h1',[_vm._v("Resultados")]),_vm._v(" "),_c('div',{staticClass:"card no-mobile"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-table"},[_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',[(!_vm.loadingScreen && _vm.results.length === 0)?_c('tr',[_c('td',{staticClass:"td",attrs:{"colspan":"8"}},[_vm._v("Não foram encontrados resultados")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.results),function(result){return _c('tr',{key:result.kit_id},[_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(result.kit.number)+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(result.kit.kit_type.name)+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(result.result.value)+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"td"},[_c('a',{attrs:{"href":result.result_document.url,"target":"_blank"}},[_vm._v("Baixar")])]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(result.insufficient == 1 ? "Sim" : "--")+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(_vm.getDate(result.result_document.created_at))+"\n                                        ")])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"})]),_vm._v(" "),_c('div',{staticClass:"cards"},[(!_vm.loadingScreen && _vm.results.length === 0)?_c('div',{staticClass:"card mobile"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.results),function(result){return _c('div',{key:result.kit_id,staticClass:"card mobile"},[_c('div',{staticClass:"card-details"},[_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Nº Kit")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(result.kit.number))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Tipo de KIT")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(result.kit.kit_type.name))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Resultado")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(result.result.value))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Arquivo")]),_vm._v(" "),_c('span',[_c('a',{attrs:{"href":result.result_document.url,"target":"_blank"}},[_vm._v("Baixar")])])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Insuficiente")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(result.insufficient == 1 ? "Sim" : "--"))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Data de conclusão")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getDate(result.result_document.created_at)))])])])])})],2)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"t-row"},[_c('th',[_vm._v("\n                                            Nº Kit\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Tipo de KIT\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Resultado\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Arquivo\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Insuficiente\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Data de conclusão\n                                        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-details"},[_c('div',{staticClass:"detail"},[_vm._v("\n                                Não foram encontrados resultados\n                            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 826 */
/*!***************************************!*\
  !*** ./src/views/Returns/Returns.vue ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Returns_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Returns.vue */ 392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c299a93_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Returns_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1c299a93","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Returns.vue */ 828);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1c299a93","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Returns.vue */ 827)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c299a93"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Returns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c299a93_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Returns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 827 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c299a93","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Returns/Returns.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/*!***************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c299a93","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Returns/Returns.vue ***!
  \***************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-menu'),_vm._v(" "),(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"container profile-container"},[_c('div',{staticClass:"profile"},[_c('h1',[_vm._v("Devolutivas")]),_vm._v(" "),_c('div',{staticClass:"card no-mobile"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-table"},[_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',[(!_vm.loadingScreen && _vm.results.length === 0)?_c('tr',[_c('td',{staticClass:"td",attrs:{"colspan":"8"}},[_vm._v("Não foram encontrados devolutivas")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.results),function(result){return _c('tr',{key:result.kit_id},[_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(result.kit.number)+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(result.kit.kit_type.name)+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(result.result.value)+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"td"},[_c('a',{attrs:{"href":result.annex.url,"target":"_blank"}},[_vm._v("Baixar")])]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(_vm.getDate(result.annex.created_at))+"\n                                        ")])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"})]),_vm._v(" "),_c('div',{staticClass:"cards"},[(!_vm.loadingScreen && _vm.results.length === 0)?_c('div',{staticClass:"card mobile"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.results),function(result){return _c('div',{key:result.kit_id,staticClass:"card mobile"},[_c('div',{staticClass:"card-details"},[_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Nº Kit")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(result.kit.number))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Tipo de KIT")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(result.kit.kit_type.name))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Resultado")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(result.result.value))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Devolutiva")]),_vm._v(" "),_c('span',[_c('a',{attrs:{"href":result.annex.url,"target":"_blank"}},[_vm._v("Baixar")])])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Data de conclusão")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getDate(result.annex.created_at)))])])])])})],2)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"t-row"},[_c('th',[_vm._v("\n                                            Nº Kit\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Tipo de KIT\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Resultado\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Devolutiva\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Data de conclusão\n                                        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-details"},[_c('div',{staticClass:"detail"},[_vm._v("\n                                Não foram encontrados devolutivas\n                            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 829 */
/*!*******************************************!*\
  !*** ./src/views/Schedules/Schedules.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Schedules_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Schedules.vue */ 393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04b6fc10_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Schedules_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-04b6fc10","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Schedules.vue */ 831);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-04b6fc10","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Schedules.vue */ 830)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04b6fc10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Schedules_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04b6fc10_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Schedules_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 830 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04b6fc10","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Schedules/Schedules.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04b6fc10","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Schedules/Schedules.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-menu'),_vm._v(" "),(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"container profile-container"},[_c('div',{staticClass:"profile"},[_c('h1',[_vm._v("Agendamentos")]),_vm._v(" "),_c('div',{staticClass:"card no-mobile"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-table"},[_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',[(!_vm.loadingScreen && _vm.schedules.length === 0)?_c('tr',[_c('td',{staticClass:"td",attrs:{"colspan":"8"}},[_vm._v("Não foram encontrados agendamentos")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.schedules),function(schedule){return _c('tr',{key:schedule.kit_id},[_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(schedule.details.day)+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(schedule.kit.number)+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(schedule.city.name)+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(schedule.address.address)+" "+_vm._s(schedule.address.number)+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(schedule.details.start_time)+" às "+_vm._s(schedule.details.end_time)+"\n                                        ")]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v("\n                                            "+_vm._s(schedule.status)+"\n                                        ")])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"})]),_vm._v(" "),_c('div',{staticClass:"cards"},[(!_vm.loadingScreen && _vm.schedules.length === 0)?_c('div',{staticClass:"card mobile"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.schedules),function(schedule){return _c('div',{key:schedule.kit_id,staticClass:"card mobile"},[_c('div',{staticClass:"card-details"},[_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Data")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(schedule.details.day))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Nº Kit")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(schedule.kit.number))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Cidade")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(schedule.city.name))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Endereço")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(schedule.address.address)+" "+_vm._s(schedule.address.number))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Horário")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(schedule.details.start_time)+" às "+_vm._s(schedule.details.end_time))])]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('h5',[_vm._v("Status")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(schedule.status))])])])])})],2)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"t-row"},[_c('th',[_vm._v("\n                                            Data\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Nº Kit\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Cidade\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Endereço\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Horário\n                                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                                            Status\n                                        ")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-details"},[_c('div',{staticClass:"detail"},[_vm._v("\n                                Não foram encontrados agendamentos\n                            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 832 */
/*!*******************************************************!*\
  !*** ./src/views/HealthIdDigital/HealthIdDigital.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_HealthIdDigital_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./HealthIdDigital.vue */ 394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_040ae6bc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthIdDigital_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-040ae6bc","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HealthIdDigital.vue */ 856);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-040ae6bc","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./HealthIdDigital.vue */ 833)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-040ae6bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_HealthIdDigital_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_040ae6bc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HealthIdDigital_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 833 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-040ae6bc","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/HealthIdDigital/HealthIdDigital.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d5e05426","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CardHealthId/CardHealthId.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/*!***************************************************!*\
  !*** ./src/components/CardHealthId/EditModal.vue ***!
  \***************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_EditModal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditModal.vue */ 397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b682402_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditModal_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0b682402","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditModal.vue */ 853);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0b682402","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EditModal.vue */ 836)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b682402"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_EditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b682402_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 836 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b682402","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CardHealthId/EditModal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/*!*******************************************************!*\
  !*** ./src/components/CardHealthId/EditAllergies.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_EditAllergies_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditAllergies.vue */ 398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91bacc56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAllergies_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-91bacc56","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditAllergies.vue */ 839);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-91bacc56","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EditAllergies.vue */ 838)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-91bacc56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_EditAllergies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91bacc56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAllergies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 838 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-91bacc56","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CardHealthId/EditAllergies.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/*!*******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91bacc56","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardHealthId/EditAllergies.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.customer.health_information)?_c('form',{on:{"submit":_vm.handleSubmit}},[_c('div',_vm._l((_vm.allergies),function(allergy,x){return _c('div',{key:x,staticClass:"input-box"},[_c('span',{staticClass:"trash-icon"},[_c('font-awesome-icon',{staticClass:"trash-svg",attrs:{"icon":['fa', 'trash-alt']},on:{"click":function($event){return _vm.reomveAllergy(x)}}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allergies[x]),expression:"allergies[x]"}],attrs:{"type":"text","name":"name","id":"name","placeholder":"Digite aqui sua alergia"},domProps:{"value":(_vm.allergies[x])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allergies, x, $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors[x])?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors[x]))]):_vm._e()])}),0),_vm._v(" "),_c('button',{staticClass:"button btn-secondary btn-plus",staticStyle:{"width":"100%"},on:{"click":function($event){$event.preventDefault();return _vm.addAllergy.apply(null, arguments)}}},[_vm._v("+")]),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_vm._v("Salvar")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary",attrs:{"disabled":""}},[_c('loading')],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 840 */
/*!*******************************************************!*\
  !*** ./src/components/CardHealthId/EditBloodType.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_EditBloodType_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditBloodType.vue */ 399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1be61e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBloodType_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7e1be61e","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditBloodType.vue */ 842);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7e1be61e","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EditBloodType.vue */ 841)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e1be61e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_EditBloodType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1be61e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBloodType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 841 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e1be61e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CardHealthId/EditBloodType.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/*!*******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e1be61e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardHealthId/EditBloodType.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.customer.health_information)?_c('form',{on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',[_vm._v("Tipo sanguíneo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.health_information.blood_type),expression:"customer.health_information.blood_type"}],attrs:{"id":"blood_type","name":"blood_type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.customer.health_information, "blood_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Selecione uma opção")]),_vm._v(" "),_c('option',{attrs:{"value":"A+"}},[_vm._v("A+")]),_vm._v(" "),_c('option',{attrs:{"value":"A-"}},[_vm._v("A-")]),_vm._v(" "),_c('option',{attrs:{"value":"B+"}},[_vm._v("B+")]),_vm._v(" "),_c('option',{attrs:{"value":"B-"}},[_vm._v("B-")]),_vm._v(" "),_c('option',{attrs:{"value":"AB+"}},[_vm._v("AB+")]),_vm._v(" "),_c('option',{attrs:{"value":"AB-"}},[_vm._v("AB-")]),_vm._v(" "),_c('option',{attrs:{"value":"O+"}},[_vm._v("O+")]),_vm._v(" "),_c('option',{attrs:{"value":"O-"}},[_vm._v("O-")])]),_vm._v(" "),(_vm.errors != '')?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors))]):_vm._e()]),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_vm._v("Salvar")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary",attrs:{"disabled":""}},[_c('loading')],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 843 */
/*!**************************************************************!*\
  !*** ./src/components/CardHealthId/EditEmergencyContact.vue ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_EditEmergencyContact_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditEmergencyContact.vue */ 400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fee29c56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditEmergencyContact_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-fee29c56","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditEmergencyContact.vue */ 845);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-fee29c56","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EditEmergencyContact.vue */ 844)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fee29c56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_EditEmergencyContact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fee29c56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditEmergencyContact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 844 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fee29c56","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CardHealthId/EditEmergencyContact.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/*!**************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fee29c56","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardHealthId/EditEmergencyContact.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.customer.emergency_contact)?_c('form',{on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Nome do contato")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.emergency_contact.name),expression:"customer.emergency_contact.name"}],attrs:{"id":"name","name":"name","type":"text"},domProps:{"value":(_vm.customer.emergency_contact.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.emergency_contact, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.name)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.name))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"cellphone"}},[_vm._v("Telefone do contato")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(##) #####-####'),expression:"'(##) #####-####'"},{name:"model",rawName:"v-model",value:(_vm.customer.emergency_contact.phone),expression:"customer.emergency_contact.phone"}],attrs:{"id":"cellphone","name":"cellphone","type":"text"},domProps:{"value":(_vm.customer.emergency_contact.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.emergency_contact, "phone", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.phone)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.phone))]):_vm._e()]),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_vm._v("Salvar")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary",attrs:{"disabled":""}},[_c('loading')],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 846 */
/*!*************************************************************!*\
  !*** ./src/components/CardHealthId/EditHealthInsurance.vue ***!
  \*************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_EditHealthInsurance_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditHealthInsurance.vue */ 401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f069d130_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHealthInsurance_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f069d130","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditHealthInsurance.vue */ 848);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f069d130","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EditHealthInsurance.vue */ 847)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f069d130"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_EditHealthInsurance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f069d130_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHealthInsurance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 847 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f069d130","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CardHealthId/EditHealthInsurance.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f069d130","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardHealthId/EditHealthInsurance.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.customer.health_information)?_c('form',{on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Nome do plano de saúde")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.health_information.health_insurance),expression:"customer.health_information.health_insurance"}],attrs:{"id":"name","name":"name","type":"text"},domProps:{"value":(_vm.customer.health_information.health_insurance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer.health_information, "health_insurance", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors != '')?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors))]):_vm._e()]),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_vm._v("Salvar")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary",attrs:{"disabled":""}},[_c('loading')],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 849 */
/*!*****************************************************!*\
  !*** ./src/components/CardHealthId/EditPicture.vue ***!
  \*****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_EditPicture_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditPicture.vue */ 402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cffbb66_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPicture_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4cffbb66","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditPicture.vue */ 852);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4cffbb66","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EditPicture.vue */ 850)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cffbb66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_EditPicture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cffbb66_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPicture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 850 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4cffbb66","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CardHealthId/EditPicture.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */,
/* 852 */
/*!*****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cffbb66","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardHealthId/EditPicture.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('form',{on:{"submit":_vm.handleSubmit}},[_c('div',{class:this.dragging ? 'active-dropzone' : 'dropzone',on:{"dragenter":function($event){$event.preventDefault();return _vm.toggleActive.apply(null, arguments)},"dragleave":function($event){$event.preventDefault();return _vm.toggleActive.apply(null, arguments)},"dragover":function($event){$event.preventDefault();},"drop":function($event){$event.preventDefault();return _vm.dropImage.apply(null, arguments)},"click":function($event){return _vm.findInput()}}},[(!this.dragging && !this.hasImage)?_c('span',{staticClass:"dragndrop-text"},[_vm._v("Clique ou arraste uma imagem")]):_vm._e(),_vm._v(" "),(this.dragging)?_c('span',{staticClass:"dragndrop-text"},[_vm._v("Solte sua imagem aqui")]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"preview-img",attrs:{"src":_vm.preview}})]),_vm._v(" "),_c('image-uploader',{ref:"file",attrs:{"preview":false,"outputFormat":"blob","capture":"environment","maxWidth":300,"debug":1,"autoRotate":true},on:{"input":_vm.setImage}}),_vm._v(" "),(_vm.image)?_c('span',{staticStyle:{"text-align":"center","color":"var(--text-main)","opacity":".9"}},[_vm._v(" "+_vm._s(this.fileName)+" ")]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[(_vm.customer.profile_picture != null)?_c('span',[_vm._v("Alterar")]):_c('span',[_vm._v("Adicionar")])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 853 */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b682402","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardHealthId/EditModal.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",on:{"click":function($event){return _vm.outsideClick()}}},[(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-box"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.getTitle()))]),_vm._v(" "),(_vm.isMounted && _vm.field == 0)?_c('edit-allergies',{attrs:{"values":_vm.customer},on:{"updateCustomer":_vm.updateCustomer,"setLoadingScreen":_vm.setLoadingScreen}}):_vm._e(),_vm._v(" "),(_vm.isMounted && _vm.field == 1)?_c('edit-blood-type',{attrs:{"values":_vm.customer},on:{"updateCustomer":_vm.updateCustomer,"setLoadingScreen":_vm.setLoadingScreen}}):_vm._e(),_vm._v(" "),(_vm.isMounted && _vm.field == 2)?_c('edit-emergency-contact',{attrs:{"values":_vm.customer},on:{"updateCustomer":_vm.updateCustomer,"setLoadingScreen":_vm.setLoadingScreen}}):_vm._e(),_vm._v(" "),(_vm.isMounted && _vm.field == 3)?_c('edit-health-insurance',{attrs:{"values":_vm.customer},on:{"updateCustomer":_vm.updateCustomer,"setLoadingScreen":_vm.setLoadingScreen}}):_vm._e(),_vm._v(" "),(_vm.isMounted && _vm.field == 4)?_c('edit-picture',{attrs:{"values":_vm.customer},on:{"updateCustomer":_vm.updateCustomer,"setLoadingScreen":_vm.setLoadingScreen}}):_vm._e()],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 854 */
/*!******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5e05426","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardHealthId/CardHealthId.vue ***!
  \******************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"healthcard"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"photo"},[(_vm.profile_picture != null)?_c('img',{attrs:{"src":_vm.profile_picture}}):_c('span',{staticClass:"initial"},[_vm._v(_vm._s(_vm.data.customer.name[0])+"\n        ")]),_vm._v(" "),_c('img',{staticClass:"edit",attrs:{"src":__webpack_require__(/*! @/assets/images/edit-round-prm.png */ 855)},on:{"click":function($event){return _vm.openEditModal(true, 4)}}})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('div',{staticClass:"details"},[_c('span',{staticClass:"label"},[_vm._v("Nome")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.data.customer.name))])]),_vm._v(" "),_c('div',{staticClass:"details-container"},[_c('div',{staticClass:"circle",on:{"click":function($event){return _vm.printFile()}}}),_vm._v(" "),_c('div',{staticClass:"details"},[_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Nascimento")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.birth_date))])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Sexo biológico")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.data.customer.gender === 'M' ? 'Masculino' : 'Feminino'))])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Etnia")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.getEthnicity()))])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Cpf")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.data.customer.cpf))])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Altura")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.imc && this.imc['heigth'] ? this.imc['heigth'] : '--'))])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Peso")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.imc && this.imc['weigth'] ? this.imc['weigth'] : '--'))])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Imc")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.imc && this.imc['calc'] ? this.imc['calc'].toFixed(2) : '--'))])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Fumante")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.answers.fumante ? this.answers.fumante : '--'))])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Pressão(sistólica e diastólica)")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(" "+_vm._s(this.answers.sistolica)+" / "+_vm._s(this.answers.diastolica))])])])])])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"flex-container"},[_c('div',{staticClass:"grid-container"},[_c('div',{staticClass:"details"},[_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Alergias Informadas\n                "),_c('font-awesome-icon',{staticClass:"edit",attrs:{"icon":['fa','edit']},on:{"click":function($event){return _vm.openEditModal(true, 0)}}})],1),_vm._v(" "),(_vm.customer.health_information && _vm.customer.health_information.allergies && _vm.customer.health_information.allergies.length > 0)?_c('span',_vm._l((_vm.customer.health_information.allergies),function(allergy,x){return _c('span',{key:x,staticClass:"value"},[_c('div',{staticClass:"dot primary"}),_vm._v(" "+_vm._s(allergy))])}),0):_c('span',{staticClass:"value"},[_vm._v(" Não informado")])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Doenças Informadas")]),_vm._v(" "),(_vm.informedDiseases.length > 0)?_c('span',_vm._l((_vm.informedDiseases),function(disease,x){return _c('span',{key:x,staticClass:"value"},[_c('div',{staticClass:"dot primary"}),_vm._v(" "+_vm._s(disease)+"\n                ")])}),0):_c('span',{staticClass:"value"},[_vm._v(" Não informado")])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Contato de emergência\n                "),_c('font-awesome-icon',{staticClass:"edit",attrs:{"icon":['fa','edit']},on:{"click":function($event){return _vm.openEditModal(true, 2)}}})],1),_vm._v(" "),(!!_vm.customer.emergency_contact && !!_vm.customer.emergency_contact.name)?_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.customer.emergency_contact.name))]):_vm._e(),_vm._v(" "),(!!_vm.customer.emergency_contact && !!_vm.customer.emergency_contact.phone)?_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.customer.emergency_contact.phone))]):_c('span',{staticClass:"value"},[_vm._v("Não informado")])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Plano de saúde")]),_vm._v(" "),(!!this.answers.health_insurance)?_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.answers.health_insurance))]):_c('span',{staticClass:"value"},[_vm._v("Não informado")])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Tipo sanguíneo\n                  "),_c('font-awesome-icon',{staticClass:"edit",attrs:{"icon":['fa','edit']},on:{"click":function($event){return _vm.openEditModal(true, 1)}}})],1),_vm._v(" "),(_vm.customer.health_information && _vm.customer.health_information.blood_type != null && _vm.customer.health_information.blood_type != '')?_c('span',{staticClass:"value"},[_c('div',{staticClass:"blood"},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'tint']}})],1),_vm._v(" "+_vm._s(_vm.customer.health_information.blood_type)+"\n                    ")]):_c('span',{staticClass:"value"},[_vm._v(" Não informado")])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Vacina Covid\n              ")]),_vm._v(" "),(!!this.answers.vaccine)?_c('span',{staticClass:"value"},[_vm._v("\n                  "+_vm._s(this.answers.vaccine)+"\n                ")]):_c('span',{staticClass:"value"},[_vm._v("\n                  Não informado\n                ")])])])]),_vm._v(" "),(_vm.diagnostics.length > 0 || _vm.risks.length > 0 || _vm.factors.length > 0)?_c('div',{staticClass:"line"}):_vm._e(),_vm._v(" "),(_vm.diagnostics.length > 0 || _vm.risks.length > 0 || _vm.factors.length > 0)?_c('div',{staticClass:"grid-container"},[_c('div',{staticClass:"details"},[_c('div',{staticClass:"box"},[_vm._m(0),_vm._v(" "),(_vm.risks && _vm.risks.length > 0)?_c('span',_vm._l((_vm.risks),function(risk,x){return _c('div',{key:x,staticClass:"risk"},[_c('span',{staticClass:"value"},[(risk.level === 'low')?_c('div',{staticClass:"dot green"}):_vm._e(),_vm._v(" "),(risk.level === 'medium')?_c('div',{staticClass:"dot yellow"}):_vm._e(),_vm._v(" "),(risk.level === 'high')?_c('div',{staticClass:"dot red"}):_vm._e(),_vm._v("\n                        "+_vm._s(risk.label)+"\n                      ")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v("\n                        última aferição "+_vm._s(_vm.getDate(risk.date))+"\n                      ")])])}),0):_c('span',{staticClass:"value"},[_vm._v(" Não informado")])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),(_vm.diagnostics && _vm.diagnostics.length > 0)?_c('span',_vm._l((_vm.diagnostics),function(diagnostic,x){return _c('div',{key:x,staticClass:"risk"},[_c('span',{staticClass:"value"},[(diagnostic.level === 'low')?_c('div',{staticClass:"dot green"}):_vm._e(),_vm._v(" "),(diagnostic.level === 'medium')?_c('div',{staticClass:"dot yellow"}):_vm._e(),_vm._v(" "),(diagnostic.level === 'high')?_c('div',{staticClass:"dot red"}):_vm._e(),_vm._v("\n                        "+_vm._s(diagnostic.label)+" \n                      ")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v("\n                        última aferição "+_vm._s(_vm.getDate(diagnostic.date))+"\n                      ")])])}),0):_c('span',{staticClass:"value"},[_vm._v(" Não informado")])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('div',{staticClass:"box"},[_vm._m(2),_vm._v(" "),(_vm.factors && _vm.factors.length > 0)?_c('span',_vm._l((_vm.factors),function(factor,x){return _c('div',{key:x,staticClass:"risk"},[_c('span',{staticClass:"value"},[(factor.level === 'low')?_c('div',{staticClass:"dot green"}):_vm._e(),_vm._v(" "),(factor.level === 'medium')?_c('div',{staticClass:"dot yellow"}):_vm._e(),_vm._v(" "),(factor.level === 'high')?_c('div',{staticClass:"dot red"}):_vm._e(),_vm._v("\n                        "+_vm._s(factor.label)+"\n                      ")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v("\n                        última aferição "+_vm._s(_vm.getDate(factor.date))+"\n                      ")])])}),0):_c('span',{staticClass:"value"},[_vm._v(" Não informado")])])])]):_vm._e()])]),_vm._v(" "),_vm._m(3),_vm._v(" "),(_vm.modal)?_c('edit-modal',{attrs:{"field":_vm.modalField,"values":_vm.customer},on:{"close":function($event){return _vm.openEditModal(false, 0)},"updateCustomer":_vm.updateCustomer}}):_vm._e(),_vm._v(" "),(_vm.loadingScreen)?_c('loading-screen'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label"},[_vm._v("Riscos "),_c('div',{staticClass:"dot-container"},[_c('div',{staticClass:"dot"}),_vm._v(" "),_c('div',{staticClass:"dot green"}),_vm._v(" "),_c('div',{staticClass:"dot yellow"}),_vm._v(" "),_c('div',{staticClass:"dot red"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label"},[_vm._v("Diagnósticos Preliminares"),_c('div',{staticClass:"dot-container"},[_c('div',{staticClass:"dot"}),_vm._v(" "),_c('div',{staticClass:"dot green",staticStyle:{"margin-right":"7px"}}),_c('div',{staticClass:"dot red",staticStyle:{"margin-right":"7px"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label"},[_vm._v("Fatores Preliminares"),_c('div',{staticClass:"dot-container"},[_c('div',{staticClass:"dot"}),_vm._v(" "),_c('div',{staticClass:"dot green",staticStyle:{"margin-right":"7px"}}),_c('div',{staticClass:"dot yellow",staticStyle:{"margin-right":"7px"}}),_c('div',{staticClass:"dot red",staticStyle:{"margin-right":"7px"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/new_logo_horizontal.png */ 137)}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 855 */
/*!**********************************************!*\
  !*** ./src/assets/images/edit-round-prm.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 856 */
/*!*******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-040ae6bc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HealthIdDigital/HealthIdDigital.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-menu'),_vm._v(" "),(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"container profile-container"},[_c('div',{staticClass:"profile"},[_c('h1',[_vm._v("Identidade de Saúde")]),_vm._v(" "),(!_vm.loadingScreen && _vm.values)?_c('card-health-id',{attrs:{"data":_vm.values}}):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 857 */
/*!***********************************************!*\
  !*** ./src/views/RegisterKit/RegisterKit.vue ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterKit_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RegisterKit.vue */ 403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69fd7c80_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterKit_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-69fd7c80","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RegisterKit.vue */ 887);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-69fd7c80","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RegisterKit.vue */ 858)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69fd7c80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterKit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69fd7c80_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterKit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 858 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69fd7c80","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/RegisterKit/RegisterKit.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/*!*************************************************************!*\
  !*** ./src/components/RegisterKitSteps/DataKitCustomer.vue ***!
  \*************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DataKitCustomer_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DataKitCustomer.vue */ 404);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_834b6318_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataKitCustomer_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-834b6318","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DataKitCustomer.vue */ 861);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-834b6318","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DataKitCustomer.vue */ 860)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-834b6318"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DataKitCustomer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_834b6318_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataKitCustomer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 860 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-834b6318","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RegisterKitSteps/DataKitCustomer.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-834b6318","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterKitSteps/DataKitCustomer.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-register-kit"},[_c('h4',[_vm._v("Agora falta pouco!")]),_vm._v(" "),_c('h5',[_vm._v("Preencha os campos a seguir para conhecermos mais sobre você.")]),_vm._v(" "),_c('p',[_vm._v("É rápido, seguro, e você já começa a ter mais saúde.")]),_vm._v(" "),_c('h4',[_vm._v("Dados Pessoais")]),_vm._v(" "),_c('form',{staticClass:"form",on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"cpf"}},[_vm._v("CPF")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cpf),expression:"form.cpf"}],attrs:{"type":"text","name":"cpf","id":"cpf"},domProps:{"value":(_vm.form.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cpf", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.cpf)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.cpf.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Nome Completo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],attrs:{"type":"text","name":"name","id":"name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.name)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.name.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"gender"}},[_vm._v("Sexo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.gender),expression:"form.gender"}],attrs:{"name":"gender","id":"gender"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"}},[_vm._v("Selecione uma opção")]),_vm._v(" "),_c('option',{attrs:{"value":"M"}},[_vm._v("Masculino")]),_vm._v(" "),_c('option',{attrs:{"value":"F"}},[_vm._v("Feminino")]),_vm._v(" "),_c('option',{attrs:{"value":"O"}},[_vm._v("Outro")])]),_vm._v(" "),(_vm.errors && _vm.errors.gender)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.gender.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"ethnicity"}},[_vm._v("Etnia")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.ethnicity),expression:"form.ethnicity"}],attrs:{"name":"ethnicity","id":"ethnicity"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "ethnicity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"}},[_vm._v("Selecione uma opção")]),_vm._v(" "),_c('option',{attrs:{"value":"A"}},[_vm._v("Amarelo")]),_vm._v(" "),_c('option',{attrs:{"value":"B"}},[_vm._v("Branco")]),_vm._v(" "),_c('option',{attrs:{"value":"I"}},[_vm._v("Indígena")]),_vm._v(" "),_c('option',{attrs:{"value":"M"}},[_vm._v("Mestiço")]),_vm._v(" "),_c('option',{attrs:{"value":"N"}},[_vm._v("Negro")]),_vm._v(" "),_c('option',{attrs:{"value":"P"}},[_vm._v("Pardo")])]),_vm._v(" "),(_vm.errors && _vm.errors.ethnicity)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.ethnicity.join()))]):_vm._e()]),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"button btn-primary",on:{"click":_vm.handleSubmit}},[_vm._v("Salvar e Próximo")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary",attrs:{"disabled":""},on:{"click":_vm.handleSubmit}},[_c('loading')],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 862 */
/*!*******************************************************!*\
  !*** ./src/components/RegisterKitSteps/KitNumber.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitNumber_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./KitNumber.vue */ 405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117503c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitNumber_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-117503c8","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./KitNumber.vue */ 864);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-117503c8","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./KitNumber.vue */ 863)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-117503c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117503c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 863 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-117503c8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RegisterKitSteps/KitNumber.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 864 */
/*!*******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117503c8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterKitSteps/KitNumber.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-register-kit"},[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("É rápido, seguro e você ja começa a ter mais saúde.")]),_vm._v(" "),_c('div',{staticClass:"split"}),_vm._v(" "),_c('h4',[_vm._v("Registrar KIT")]),_vm._v(" "),_c('form',{staticClass:"form",on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"kit_number"}},[_vm._v("Inserir número do KIT *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.kit_number),expression:"form.kit_number"}],attrs:{"type":"text","name":"kit_number","id":"kit_number"},domProps:{"value":(_vm.form.kit_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "kit_number", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.kit_number)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.kit_number.join()))]):_vm._e()]),_vm._v(" "),(!_vm.loading)?_c('button',{staticClass:"button btn-primary",on:{"click":_vm.handleSubmit}},[_vm._v("Salvar e Próximo")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary",attrs:{"disabled":""},on:{"click":_vm.handleSubmit}},[_c('loading')],1):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_vm._v("Olá!"),_c('br'),_vm._v("\n    Chegou a hora de registrar "),_c('br'),_vm._v("o kit e realizar o seu cadastro!")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 865 */
/*!*******************************************************************!*\
  !*** ./src/components/RegisterKitSteps/DataKitHealthCustomer.vue ***!
  \*******************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DataKitHealthCustomer_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DataKitHealthCustomer.vue */ 406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68656386_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataKitHealthCustomer_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-68656386","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DataKitHealthCustomer.vue */ 877);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-68656386","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DataKitHealthCustomer.vue */ 866)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68656386"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DataKitHealthCustomer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68656386_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataKitHealthCustomer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 866 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68656386","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RegisterKitSteps/DataKitHealthCustomer.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/*!************************************************!*\
  !*** ./src/components/FormSteps/FormSteps.vue ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormSteps_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./FormSteps.vue */ 407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de68a9ce_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSteps_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-de68a9ce","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./FormSteps.vue */ 876);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-de68a9ce","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./FormSteps.vue */ 868)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de68a9ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormSteps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de68a9ce_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSteps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 868 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-de68a9ce","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FormSteps/FormSteps.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/*!****************************************************!*\
  !*** ./src/components/FormBuilder/FormBuilder.vue ***!
  \****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormBuilder_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./FormBuilder.vue */ 409);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06fc5480_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormBuilder_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-06fc5480","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./FormBuilder.vue */ 875);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-06fc5480","scoped":false,"hasInlineConfig":true}!@/assets/vue-multiselect.min.css */ 870)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormBuilder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06fc5480_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormBuilder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 870 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06fc5480","scoped":false,"hasInlineConfig":true}!./src/assets/vue-multiselect.min.css ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/*!********************************************!*\
  !*** ./src/assets/vue-multiselect.min.css ***!
  \********************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/*!*****************************************************!*\
  !*** ./src/components/FormBuilder/Fields/Cid10.vue ***!
  \*****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Cid10_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Cid10.vue */ 411);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fc17fd6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cid10_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5fc17fd6","hasScoped":true,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Cid10.vue */ 874);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5fc17fd6","scoped":true,"hasInlineConfig":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Cid10.vue */ 873)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fc17fd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Cid10_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fc17fd6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cid10_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 873 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fc17fd6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FormBuilder/Fields/Cid10.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/*!*****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fc17fd6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormBuilder/Fields/Cid10.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',{attrs:{"allow-empty":false,"disabled":_vm.disabled,"loading":_vm.isLoading,"max-height":600,"multiple":true,"options":_vm.items,"required":_vm.required,"searchable":true,"deselect-label":"Remover seleção","label":"name","placeholder":"Selecione uma ou mais opções","select-label":"Selecionar","track-by":"name"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 875 */
/*!*****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06fc5480","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormBuilder/FormBuilder.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_vm._l((_vm.builder),function(component,x){return [((component.type === 'title') && _vm.isValid(component))?_c('div',{key:x,staticClass:"input-box xs"},[_c('h4',[_vm._v(_vm._s(component.title))])]):_vm._e(),_vm._v(" "),((component.type === 'label') && _vm.isValid(component))?_c('div',{key:x,staticClass:"input-box xs"},[_c('label',{staticClass:"no-float"},[_vm._v(_vm._s(component.title))])]):_vm._e(),_vm._v(" "),(component.type === 'text' && _vm.isValid(component))?_c('div',{key:x,staticClass:"input-box",class:_vm.getLabelSize(component.title.length)},[_c('label',{class:{'has-error': _vm.errors && _vm.errors[component.id]}},[_vm._v(_vm._s(component.title))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value[component.id]),expression:"value[component.id]"}],staticClass:"w-full form-control form-input form-input-bordered",attrs:{"required":component.required,"type":"text"},domProps:{"value":(_vm.value[component.id])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, component.id, $event.target.value)},function($event){return _vm.force()}]}}),_vm._v(" "),(_vm.errors && _vm.errors[component.id])?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors[component.id]))]):_vm._e()]):_vm._e(),_vm._v(" "),(component.type === 'float' && _vm.isValid(component))?_c('div',{key:x,staticClass:"input-box",class:_vm.getLabelSize(component.title.length)},[_c('label',{class:{'has-error': _vm.errors && _vm.errors[component.id]}},[_vm._v(_vm._s(component.title))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value[component.id]),expression:"value[component.id]"}],staticClass:"w-full form-control form-input form-input-bordered",attrs:{"required":component.required,"type":"text","pattern":"[0-9]*"},domProps:{"value":(_vm.value[component.id])},on:{"keypress":_vm.onlyNumbers,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, component.id, $event.target.value)},function($event){return _vm.force()}]}}),_vm._v(" "),(_vm.errors && _vm.errors[component.id])?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors[component.id]))]):_vm._e()]):_vm._e(),_vm._v(" "),((component.type === 'date' ) && _vm.isValid(component))?_c('div',{key:x,staticClass:"input-box",class:_vm.getLabelSize(component.title.length)},[_c('label',{class:{'has-error': _vm.errors && _vm.errors[component.id]}},[_vm._v(_vm._s(component.title))]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"},{name:"model",rawName:"v-model",value:(_vm.value[component.id]),expression:"value[component.id]"}],staticClass:"w-full form-control form-input form-input-bordered",attrs:{"required":component.required,"type":"text","placeholder":"Ex: 01/01/2021"},domProps:{"value":(_vm.value[component.id])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, component.id, $event.target.value)},function($event){return _vm.force()}]}}),_vm._v(" "),(_vm.errors && _vm.errors[component.id])?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors[component.id]))]):_vm._e()]):_vm._e(),_vm._v(" "),((component.type === 'datetime' ) && _vm.isValid(component))?_c('div',{key:x,staticClass:"input-box",class:_vm.getLabelSize(component.title.length)},[_c('h5',{class:{'has-error': _vm.errors && _vm.errors[component.id]}},[_vm._v(_vm._s(component.title))]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',[_vm._v("Data")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"},{name:"model",rawName:"v-model",value:(_vm.value[component.id].date),expression:"value[component.id].date"}],staticClass:"w-full form-control form-input form-input-bordered",attrs:{"required":component.required,"type":"text","placeholder":"Ex: 01/01/2021"},domProps:{"value":(_vm.value[component.id].date)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.value[component.id], "date", $event.target.value)},function($event){return _vm.force()}],"keypress":_vm.onlyNumbers}}),_vm._v(" "),(_vm.errors && _vm.errors['date'])?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors['date']))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{},[_vm._v("Hora")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.value[component.id].time),expression:"value[component.id].time"}],staticClass:"w-full form-control form-input form-input-bordered",attrs:{"required":component.required,"type":"text","placeholder":"Ex: 12:00"},domProps:{"value":(_vm.value[component.id].time)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.value[component.id], "time", $event.target.value)},function($event){return _vm.force()}]}}),_vm._v(" "),(_vm.errors && _vm.errors['time'])?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors['time']))]):_vm._e()])]):_vm._e(),_vm._v(" "),((component.type === 'imc') && _vm.isValid(component))?_c('div',{key:x,staticClass:"input-wrapper"},[_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors['height'] }},[_vm._v("Altura (metros)")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('#,##'),expression:"'#,##'"},{name:"model",rawName:"v-model",value:(_vm.value[component.id].heigth),expression:"value[component.id].heigth"}],staticClass:"w-full form-control form-input form-input-bordered",attrs:{"required":component.required,"type":"text","placeholder":"Ex: 1,75"},domProps:{"value":(_vm.value[component.id].heigth)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.value[component.id], "heigth", $event.target.value)},function($event){return _vm.force()}]}}),_vm._v(" "),(_vm.errors && _vm.errors['height'])?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors['height']))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors['weight']}},[_vm._v("Peso (quilos)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value[component.id].weigth),expression:"value[component.id].weigth"}],staticClass:"w-full form-control form-input form-input-bordered",attrs:{"required":component.required,"type":"text","placeholder":"Ex: 75","pattern":"[0-9]*"},domProps:{"value":(_vm.value[component.id].weigth)},on:{"keypress":_vm.onlyNumbers,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.value[component.id], "weigth", $event.target.value)},function($event){return _vm.force()}]}}),_vm._v(" "),(_vm.errors && _vm.errors['weight'])?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors['weight']))]):_vm._e()])]):_vm._e(),_vm._v(" "),(component.type === 'select' && _vm.isValid(component, 'select'))?_c('div',{key:x,staticClass:"input-box",class:_vm.getLabelSize(component.title.length)},[_c('label',{class:{'has-error': _vm.errors && _vm.errors[component.id]}},[_vm._v(_vm._s(component.title))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.value[component.id]),expression:"value[component.id]"}],staticClass:"block w-full form-control-sm form-select",attrs:{"label":"name"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.value, component.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.emit()}]}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v("Selecione uma opção")]),_vm._v(" "),_vm._l((component.options),function(item){return (_vm.isValid(item, 'select'))?_c('option',{key:item.id,domProps:{"value":item.id}},[_vm._v(_vm._s(item.label)+"\n          ")]):_vm._e()})],2),_vm._v(" "),(_vm.errors && _vm.errors[component.id])?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors[component.id]))]):_vm._e()]):_vm._e(),_vm._v(" "),(component.type === 'multiselect')?_c('div',{key:x,staticClass:"input-box",class:_vm.getLabelSize(component.title.length)},[_c('label',{class:{'has-error': _vm.errors && _vm.errors[component.id]}},[_vm._v(_vm._s(component.title))]),_vm._v(" "),_c('multiselect',{attrs:{"allow-empty":true,"multiple":true,"options":component.options,"searchable":false,"deselect-label":"Remover seleção","label":"label","placeholder":"Selecione uma ou mais opções","select-label":"Selecionar","selectedLabel":"Selecionado","track-by":"value"},on:{"change":function($event){return _vm.emitMultiselect(component.id)},"input":function($event){return _vm.emitMultiselect(component.id)}},model:{value:(_vm.answers[component.id]),callback:function ($$v) {_vm.$set(_vm.answers, component.id, $$v)},expression:"answers[component.id]"}}),_vm._v(" "),(_vm.errors && _vm.errors[component.id])?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors[component.id]))]):_vm._e()],1):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 876 */
/*!************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de68a9ce","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormSteps/FormSteps.vue ***!
  \************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.fakeSubmit.apply(null, arguments)}}},[_vm._l((_vm.steps),function(step,x){return _c('div',{key:x},[(_vm.currentFormStepId == step.id)?_c('h4',[_vm._v(_vm._s(step.title))]):_vm._e(),_vm._v(" "),_c('form-builder',{staticClass:"form-step",class:{ 'show': _vm.currentFormStepId == step.id },attrs:{"builder":step.fields,"formAnswers":_vm.answers,"errors":_vm.errors},model:{value:(_vm.answers[step.id]),callback:function ($$v) {_vm.$set(_vm.answers, step.id, $$v)},expression:"answers[step.id]"}})],1)}),_vm._v(" "),_c('div',{staticClass:"flex-buttons"},[(!_vm.loading && !_vm.loadingScreen)?_c('button',{staticClass:"button item-btn",attrs:{"disabled":_vm.currentFormStepId == _vm.firstFormStep},on:{"click":function($event){return _vm.returnStep()}}},[_vm._v("Voltar")]):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.loadingScreen && (_vm.currentFormStepId != _vm.lastFormStep))?_c('button',{staticClass:"button btn-primary",on:{"click":function($event){return _vm.nextStep()}}},[_vm._v("Próximo")]):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.loadingScreen && (_vm.currentFormStepId == _vm.lastFormStep))?_c('button',{staticClass:"button btn-primary",on:{"click":function($event){return _vm.handleSubmit()}}},[_vm._v("Salvar e Próximo")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary full",attrs:{"disabled":""}},[_c('loading')],1):_vm._e()]),_vm._v(" "),(_vm.loadingScreen)?_c('loading-screen'):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 877 */
/*!*******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68656386","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterKitSteps/DataKitHealthCustomer.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-register-kit"},[(_vm.step == 1)?_c('h4',[_vm._v("Pronto! "),_c('br'),_vm._v("Vamos iniciar com o preenchimento do formulário para conseguirmos entregar muito mais do que simples resultados!")]):_vm._e(),_vm._v(" "),(_vm.step == 1)?_c('p',[_vm._v("Preencha os campos a seguir, pois para cruzar os resultados de seus exames com nossos algoritmos médicos, precisamos conhecer mais sobre sua saúde e hábitos de vida! \n    "),_c('span',{staticClass:"bold"},[_vm._v("É rápido, seguro e você já começa a ter mais saúde.")])]):_vm._e(),_vm._v(" "),(_vm.step == 1)?_c('div',{staticClass:"split"}):_vm._e(),_vm._v(" "),(_vm.kit_type)?_c('form-steps',{attrs:{"kit_type":_vm.kit_type},on:{"formNextStep":_vm.formNextStep,"send":_vm.sendAnswers,"setFormSteps":_vm.setFormSteps}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 878 */
/*!*************************************************************!*\
  !*** ./src/components/RegisterKitSteps/DataKitSchedule.vue ***!
  \*************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DataKitSchedule_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DataKitSchedule.vue */ 412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7862847f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataKitSchedule_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7862847f","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DataKitSchedule.vue */ 880);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7862847f","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DataKitSchedule.vue */ 879)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7862847f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DataKitSchedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7862847f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataKitSchedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 879 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7862847f","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RegisterKitSteps/DataKitSchedule.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 880 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7862847f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterKitSteps/DataKitSchedule.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-register-kit"},[(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),(_vm.step === 0)?_c('div',{},[(_vm.shipping_type == 1)?[_c('div',{staticClass:"text"},[_c('h5',{staticClass:"title-pink"},[_vm._v("Que bom que você chegou até aqui, agora falta pouco!")]),_vm._v(" "),_c('p',{staticClass:"purple bold"},[_vm._v("Lembre-se que a sua região está coberta pelo sistema de envios dos correios!")]),_vm._v(" "),_c('p',{staticClass:"purple"},[_vm._v("Para seguir adiante, você já deve ter realizado sua coleta corretamente, esperado o tempo recomendado de 1 hora para\n            secagem do cartão de coleta e colocado o mesmo dentro do saco hermético metalizado.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/correios_3.png */ 387)}}),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.toView(3)}}},[_vm._v("Prosseguir")])])])]:_vm._e(),_vm._v(" "),(_vm.shipping_type == 2)?[_c('h5',[_vm._v("Viu, foi rápido e seguro! ;D")]),_vm._v(" "),_c('p',[_vm._v("Preencha os campos a seguir e agende a coleta do seu KIT.")]),_vm._v(" "),_c('div',{staticClass:"split"}),_vm._v(" "),_c('h4',[_vm._v("Dados para coleta")]),_vm._v(" "),_c('form',{staticClass:"form",on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.zip_code},attrs:{"for":"zip"}},[_vm._v("CEP *")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('#####-###'),expression:"'#####-###'"},{name:"model",rawName:"v-model",value:(_vm.form.zip_code),expression:"form.zip_code"}],attrs:{"type":"text","name":"zip","id":"zip"},domProps:{"value":(_vm.form.zip_code)},on:{"blur":_vm.findAddress,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "zip_code", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.zip_code)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.zip_code.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.address},attrs:{"for":"address"}},[_vm._v("Logradouro *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.address),expression:"form.address"}],attrs:{"type":"text","name":"address","id":"address"},domProps:{"value":(_vm.form.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "address", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.address)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.address.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.neighbourhood},attrs:{"for":"address"}},[_vm._v("Bairro *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.neighbourhood),expression:"form.neighbourhood"}],attrs:{"type":"text","name":"neighbourhood","id":"neighbourhood"},domProps:{"value":(_vm.form.neighbourhood)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "neighbourhood", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.neighbourhood)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.neighbourhood.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.number},attrs:{"for":"number"}},[_vm._v("Número *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.number),expression:"form.number"}],attrs:{"type":"text","name":"number","id":"number"},domProps:{"value":(_vm.form.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "number", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.number)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.number.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{attrs:{"for":"address"}},[_vm._v("Complemento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.complement),expression:"form.complement"}],attrs:{"type":"text","name":"complement","id":"complement"},domProps:{"value":(_vm.form.complement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "complement", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.city},attrs:{"for":"address"}},[_vm._v("Cidade *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.city_name),expression:"form.city_name"}],attrs:{"type":"text","name":"city","id":"city","disabled":""},domProps:{"value":(_vm.form.city_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "city_name", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.city)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.city.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm",style:({'margin-bottom: 1.7rem' : !!_vm.turns})},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.state},attrs:{"for":"state"}},[_vm._v("Estado *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.state_name),expression:"form.state_name"}],attrs:{"type":"text","name":"state","id":"state","disabled":""},domProps:{"value":(_vm.form.state_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "state_name", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.state)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.state.join()))]):_vm._e()]),_vm._v(" "),(_vm.turns)?_c('div',{staticClass:"input-box sm"},[_c('label',{staticClass:"datepicker-label",class:{'has-error': _vm.errors && _vm.errors.schedule},attrs:{"for":"birthdate"}},[_vm._v("Escolha a Data *")]),_vm._v(" "),_c('select',{attrs:{"name":"schedule","id":"schedule"},on:{"change":function($event){return _vm.handleOnScheduleChange($event.target)}}},[_c('option',{attrs:{"value":"null"}},[_vm._v("Selecione uma opção")]),_vm._v(" "),_vm._l((_vm.turns),function(turn,key){return _c('option',{key:key,domProps:{"value":key}},[_vm._v("\n                        "+_vm._s(turn.day)+" - "+_vm._s(turn.turn)+" das "+_vm._s(turn.start_time)+" às "+_vm._s(turn.end_time)+"\n                    ")])})],2),_vm._v(" "),(_vm.errors && _vm.errors.schedule)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.schedule.join()))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.notFound)?_c('div',{},[_c('span',[_vm._v("\n                    Ops!! Infelizmente o local indicado ainda não faz parte da área de cobertura para coleta.\n                    Indique um local em Porto Alegre/RS.\n                ")])]):_vm._e(),_vm._v(" "),(!_vm.notFound)?_c('div',{staticClass:"form-actions"},[(!_vm.loading)?_c('button',{staticClass:"button btn-primary",on:{"click":_vm.handleSubmit}},[_vm._v("Salvar e Próximo")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary",attrs:{"disabled":""},on:{"click":_vm.handleSubmit}},[_c('loading')],1):_vm._e()]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.shipping_type == 3)?[_c('h5',[_vm._v("Que bom que você chegou até aqui, agora é com a gente!")]),_vm._v(" "),_c('p',[_vm._v("Fique tranquilo que o nosso parceiro fará o envio da sua amostra para o nosso laboratório.")]),_vm._v(" "),_c('p',[_vm._v("Assim que recebermos sua coleta, iremos aferir seus exames e disponibilizá-los aqui no seu perfil mesmo.\n            Você será notificado por e-mail e WhatsApp quando os resultados estiverem disponíveis para consulta.")]),_vm._v(" "),_c('p',[_vm._v("Agora é só aguardar e em poucos dias você receberá os resultados.")]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){return _vm.toKits()}}},[_vm._v("Voltar para meus Check-Ups")])])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.step === 1)?_c('div'):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('div',[_c('h5',[_vm._v("Viu, foi rápido e seguro! ;D")]),_vm._v(" "),_c('p',[_vm._v("Preencha os campos a seguir e agende a coleta do seu KIT.")]),_vm._v(" "),_c('div',{staticClass:"split"}),_vm._v(" "),_c('h4',[_vm._v("Dados para coleta")]),_vm._v(" "),_c('form',{staticClass:"form",on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.zip_code},attrs:{"for":"zip"}},[_vm._v("CEP *")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('#####-###'),expression:"'#####-###'"},{name:"model",rawName:"v-model",value:(_vm.form.zip_code),expression:"form.zip_code"}],attrs:{"type":"text","name":"zip","id":"zip"},domProps:{"value":(_vm.form.zip_code)},on:{"blur":_vm.findAddress,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "zip_code", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.zip_code)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.zip_code.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.address},attrs:{"for":"address"}},[_vm._v("Logradouro *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.address),expression:"form.address"}],attrs:{"type":"text","name":"address","id":"address"},domProps:{"value":(_vm.form.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "address", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.address)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.address.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.neighbourhood},attrs:{"for":"address"}},[_vm._v("Bairro *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.neighbourhood),expression:"form.neighbourhood"}],attrs:{"type":"text","name":"neighbourhood","id":"neighbourhood"},domProps:{"value":(_vm.form.neighbourhood)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "neighbourhood", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.neighbourhood)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.neighbourhood.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.number},attrs:{"for":"number"}},[_vm._v("Número *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.number),expression:"form.number"}],attrs:{"type":"text","name":"number","id":"number"},domProps:{"value":(_vm.form.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "number", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.number)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.number.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{attrs:{"for":"address"}},[_vm._v("Complemento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.complement),expression:"form.complement"}],attrs:{"type":"text","name":"complement","id":"complement"},domProps:{"value":(_vm.form.complement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "complement", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-box sm"},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.city},attrs:{"for":"address"}},[_vm._v("Cidade *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.city_name),expression:"form.city_name"}],attrs:{"type":"text","name":"city","id":"city","disabled":""},domProps:{"value":(_vm.form.city_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "city_name", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.city)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.city.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box sm",style:({'margin-bottom: 1.7rem' : !!_vm.turns})},[_c('label',{class:{'has-error': _vm.errors && _vm.errors.state},attrs:{"for":"state"}},[_vm._v("Estado *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.state_name),expression:"form.state_name"}],attrs:{"type":"text","name":"state","id":"state","disabled":""},domProps:{"value":(_vm.form.state_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "state_name", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.state)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.state.join()))]):_vm._e()]),_vm._v(" "),(_vm.turns)?_c('div',{staticClass:"input-box sm"},[_c('label',{staticClass:"datepicker-label",class:{'has-error': _vm.errors && _vm.errors.schedule},attrs:{"for":"birthdate"}},[_vm._v("Escolha a Data *")]),_vm._v(" "),_c('select',{attrs:{"name":"schedule","id":"schedule"},on:{"change":function($event){return _vm.handleOnScheduleChange($event.target)}}},[_c('option',{attrs:{"value":"null"}},[_vm._v("Selecione uma opção")]),_vm._v(" "),_vm._l((_vm.turns),function(turn,key){return _c('option',{key:key,domProps:{"value":key}},[_vm._v("\n                    "+_vm._s(turn.day)+" - "+_vm._s(turn.turn)+" das "+_vm._s(turn.start_time)+" às "+_vm._s(turn.end_time)+"\n                ")])})],2),_vm._v(" "),(_vm.errors && _vm.errors.schedule)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.schedule.join()))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.notFound)?_c('div',{},[_c('span',[_vm._v("\n                Ops!! Infelizmente o local indicado ainda não faz parte da área de cobertura para coleta.\n                Indique um local em Porto Alegre/RS.\n            ")])]):_vm._e(),_vm._v(" "),(!_vm.notFound)?_c('div',{staticClass:"form-actions"},[(!_vm.loading)?_c('button',{staticClass:"button btn-primary",on:{"click":_vm.handleSubmit}},[_vm._v("Salvar e Próximo")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary",attrs:{"disabled":""},on:{"click":_vm.handleSubmit}},[_c('loading')],1):_vm._e()]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 3)?_c('div',[(_vm.shipping_type == 1)?_c('div',{staticClass:"text"},[_c('h5',{},[_vm._v("Prontinho! Mas, antes que corra para os correios, um lembrete:")]),_vm._v(" "),_c('p',{},[_vm._v("Não esqueça de levar junto a sua \"SOLICITAÇÃO DE AUTORIZAÇÃO DE POSTAGEM EM AGÊNCIA\" que foi encaminhada junto com o seu Kit.")]),_vm._v(" "),_c('p',{},[_vm._v("E, qualquer dúvida pode entrar em contato com nosso SAC, viu? Teremos prazer em te auxiliar.")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/correios_2.png */ 388)}}),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.toKits.apply(null, arguments)}}},[_vm._v("Voltar para meus Check-Ups")])])]):_c('div',{staticClass:"text"},[_c('div',{staticClass:"text"},[_c('h5',{},[_vm._v("Parabéns!")]),_vm._v(" "),_c('p',{},[_vm._v("Agendamento realizado com sucesso e em breve você receberá os resultados.")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/vector-fluxo-healthid-lab-moto.png */ 390)}}),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.toKits.apply(null, arguments)}}},[_vm._v("Voltar para meus Check-Ups")])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"purple"},[_vm._v("Tudo pronto? "),_c('span',{staticClass:"bold"},[_vm._v("Então, com sua amostra devidamente embalada dentro do envelope preto, dirija-se a uma agência dos correios para encaminhar\n            o seu exame ao laboratório.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 881 */
/*!************************************************************!*\
  !*** ./src/components/RegisterKitSteps/KitOrientation.vue ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitOrientation_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./KitOrientation.vue */ 413);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cac8abc8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitOrientation_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-cac8abc8","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./KitOrientation.vue */ 883);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-cac8abc8","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./KitOrientation.vue */ 882)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cac8abc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_KitOrientation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cac8abc8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KitOrientation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 882 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cac8abc8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RegisterKitSteps/KitOrientation.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/*!************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cac8abc8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterKitSteps/KitOrientation.vue ***!
  \************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-register-kit"},[_c('div',{},[_vm._m(0),_vm._v(" "),_c('h6',[_vm._v("Caso já tenha finalizado, clique no botão abaixo do vídeo para concluir esta etapa. ")]),_vm._v(" "),_c('p',[_vm._v("É rápido, seguro, e você já começa a ter mais saúde.")]),_vm._v(" "),_c('div',{staticClass:"video-box"},[(_vm.shipping_type == 1)?_c('iframe',{attrs:{"width":"100%","height":"315","src":"https://www.youtube.com/embed/tZCMFts3rec","title":"Coleta Health ID Lab","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}}):_vm._e(),_vm._v(" "),(_vm.shipping_type == 2)?_c('iframe',{attrs:{"width":"100%","height":"315","src":"https://www.youtube.com/embed/X8l76_x7CGo","title":"Coleta Health ID Lab","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}}):_vm._e(),_vm._v(" "),(_vm.shipping_type == 3)?_c('iframe',{attrs:{"width":"100%","height":"315","src":"https://www.youtube.com/embed/q6nQ6oy5beE","title":"Coleta Health ID Lab","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button btn-primary",on:{"click":function($event){return _vm.$emit('next')}}},[_vm._v("Prosseguir")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_vm._v("Perfeito!\n        Se você ainda não realizou a sua coleta, basta assistir o vídeo abaixo e realizá-la. "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 884 */
/*!***********************************************************!*\
  !*** ./src/components/RegisterKitSteps/PrivacyPolicy.vue ***!
  \***********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PrivacyPolicy.vue */ 414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f949d22c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f949d22c","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PrivacyPolicy.vue */ 886);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f949d22c","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PrivacyPolicy.vue */ 885)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f949d22c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f949d22c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 885 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f949d22c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RegisterKitSteps/PrivacyPolicy.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/*!***********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f949d22c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterKitSteps/PrivacyPolicy.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"size-card"},[_c('div',{staticClass:"input-box"},[_c('div',{staticClass:"checkbox-text"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.accept_terms),expression:"accept_terms"}],attrs:{"id":"accept_terms","type":"checkbox","value":"1"},domProps:{"checked":Array.isArray(_vm.accept_terms)?_vm._i(_vm.accept_terms,"1")>-1:(_vm.accept_terms)},on:{"change":function($event){var $$a=_vm.accept_terms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.accept_terms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.accept_terms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.accept_terms=$$c}}}}),_vm._v(" "),_c('p',{staticStyle:{"line-height":"2"},attrs:{"for":"accept_terms"}},[_vm._v("\n            Declaro estar ciente e aceito os termos da política de privacidade apresentados.\n          ")])]),_vm._v(" "),(_vm.errors && _vm.errors.accept_terms.length > 0)?_c('div',{staticClass:"form-error"},[_c('small',{staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.errors.accept_terms.join())+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"button btn-primary",on:{"click":_vm.handleSubmit}},[_vm._v("Salvar e Próximo")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"privacy-policy-container size-card shadow-container-policy",attrs:{"id":"PAGES_CONTAINER","tabindex":"-1"}},[_c('div',{staticClass:"_1gF1C",attrs:{"id":"SITE_PAGES"}},[_c('div',{staticClass:"Ry26q",attrs:{"id":"a6qx8"}},[_c('div',{staticClass:"_3CemL",attrs:{"data-testid":"page-bg"}}),_vm._v(" "),_c('div',{staticClass:"_3K7uv"},[_c('div',{staticClass:"_1KV2M",attrs:{"id":"Containera6qx8"}},[_c('div',{attrs:{"data-mesh-id":"Containera6qx8inlineContent","data-testid":"inline-content"}},[_c('div',{attrs:{"data-mesh-id":"Containera6qx8inlineContent-gridContainer","data-testid":"mesh-container-content"}},[_c('div',{staticClass:"_2Hij5 _3bcaz",attrs:{"id":"comp-l56rkrdz","data-testid":"richTextElement"}},[_c('p',{staticClass:"font_8",staticStyle:{"font-size":"38px","text-align":"justify"}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_c('span',{staticStyle:{"font-size":"38px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("Política de Privacidade Health ID")])])])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('b',[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("Introdução")])])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("Esta Política de Privacidade regulamenta o tratamento de dados pessoais de clientes, colaboradores, parceiros, usuários finais dos clientes sob a responsabilidade da Health ID Lab, além de visitantes dos serviços online mantidos pela empresa.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("A presente Política de Privacidade representa o nosso compromisso com a transparência, a integridade e o respeito à privacidade, à proteção e à segurança dos dados pessoais dos usuários e de nossos stakeholders, em particular de nossos colaboradores, parceiros e restantes dos titulares dos dados que estejam sob a nossa guarda.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("Por favor leia atentamente esta política antes de usar ou obter quaisquer materiais, informações, produtos ou serviços da empresa. Nos reservamos o direito de alterar, atualizar ou corrigir esta política a qualquer momento. Ao usar nossos serviços, você consente com a nossa Política de Privacidade e Proteção de Dados e com a coleta, uso e compartilhamento de suas informações conforme descrito abaixo.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_c('b',[_vm._v("Entidade Responsável pelo tratamento de Dados")])])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("A entidade responsável pelo tratamento dos dados é Health ID Lab Lab Ltda., inscrita no CNPJ sob o número 34.037.799/0001-02, com sede na Av. Cristóvão Colombo, n° 1757, - 1° andar - Porto Alegre, RS, CEP 90560-003. Você pode contatar o nosso Encarregado de Dados (DPO) Rodrigo Thimmig Ferreira Gomes pelo telefone (51) 3029-8087 ou pelo e-mail "),_c('span',{staticStyle:{"text-decoration":"underline"}},[_c('a',{attrs:{"data-auto-recognition":"true","href":"mailto:seguranca@clichealthid.com"}},[_vm._v("seguranca@clichealthid.com")])])])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_c('b',[_vm._v("Princípios observados\n                    ")])])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("Toda informação pessoal identificável que você nos fornece será usada somente de acordo com o permitido por lei, incluindo o necessário para oferecer o produto, serviço ou informação solicitada por você.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("Seus dados pessoais não serão vendidos ou alugados e o compartilhamento, se houver, se limita a nossos parceiros de negócio conforme requerido na execução de nossos serviços ou conforme exigido por leis e regulamentações, caso em que a Health ID Lab adota todas medidas necessárias para assegurar que os subcontratados satisfazem os requisitos legais aplicáveis e oferecem as garantias adequadas para a proteção dos dados.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("Certos clientes e parceiros de negócio da Health ID Lab também poderão compartilhar dados pessoais com nossa empresa para fins necessários ao seu relacionamento direto com aquelas entidades e neste caso reportar-se-á à Política de Privacidade destas entidades específicas.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("A Health ID Lab também observa as práticas recomendadas de Segurança da Informação e adota medidas técnicas, organizacionais e administrativas para proteger os dados pessoais de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou difusão, bem como para atuar de conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/18) e demais regulamentos sobre a matéria.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_c('b',[_vm._v("Fundamento para o Tratamento de Dados")])])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("No exercício das atividades empresariais da Health ID Lab, o tratamento de dados pessoais enquadra-se no consentimento dos titulares, na execução e cumprimento de contrato a pedido do titular, no exercício regular de direito em processo judicial e no legítimo interesse da empresa, sendo assegurados aos titulares os direitos previstos na Lei Geral de Proteção de Dados Pessoais (Lei Nº 13.709/18). Que dados pessoais são recolhidos e tratados?")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_c('b',[_vm._v("A Health ID Lab poderá recolher e tratar, entre outros, os seguintes dados pessoais:")])])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("a) Visitantes do Site: Endereço IP, porta de conexão, informações fornecidas pelo navegador, cookies necessários para o correto funcionamento do site ou aplicação e ainda, no caso de visitantes autenticados, informações de usuário e senha de acesso;")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("b) Recrutamento e seleção de colaboradores: nome, endereço de correio eletrônico e currículo vitae;")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("c) Usuários das aplicações web providas pela Health ID Lab: Nome, CPF, e-mail, telefone, senha de acesso, foto de perfil, data de nascimento e outras informações que o titular dos dados optou por nos fornecer;")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("d) Titulares cujo controlador do tratamento de dados pessoais seja entidade, empresa ou organização cliente da Health ID Lab: Nome, CPF, RG, data de nascimento, dados de saúde e outras informações presentes nas aplicações providas pela Health ID Lab a seus clientes.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_c('b',[_vm._v("\n                      De que forma os seus dados são coletados?\n                    ")])])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("Os dados pessoais podem ser coletados através dos seguintes meios:")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("a) Website e formulários online;")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("b) Chamadas telefônicas;")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("c) Correio eletrônico;")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("d) Através de aplicações (“apps”) instaladas em dispositivos móveis;")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("e) Quando fornecidos pelos clientes da Health ID Lab.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("​")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("Alguns dados pessoais recolhidos são de preenchimento obrigatório e necessários para a execução e realização de nossas atividades, sendo que, em caso de falta ou insuficiência desses dados, a Health ID Lab se resguarda no direito de não prestar os serviços ou as informações solicitadas. Em cada caso concreto, a Health ID Lab irá informá-lo sobre a natureza obrigatória do fornecimento destes dados pessoais e a finalidade de sua utilização.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_c('b',[_vm._v("Por quanto tempo os dados pessoais são armazenados?")])])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("A Health ID Lab cumpre com as normas legais relativas aos prazos de retenção de dados pessoais, podendo mantê-los conforme requerido por lei ou enquanto for necessário para execução de contrato ou serviço.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_c('b',[_vm._v("Direitos dos titulares de dados pessoais")])])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("A Health ID Lab assegura aos titulares o exercício dos direitos de confirmação de tratamento, acesso aos dados, correção de dados, eliminação,\n                        revogação do consentimento e demais direitos previstos em lei. Para exercer os seus direitos, entre em contato com a Health ID Lab através do email:\n                        "),_c('span',{staticStyle:{"text-decoration":"underline"}},[_c('a',{attrs:{"data-auto-recognition":"true","href":"mailto:seguranca@clichealthid.com"}},[_vm._v("seguranca@clichealthid.com")])]),_vm._v(", encaminhando-nos, conforme for o caso, pedido para adaptação, alteração ou exclusão de seus dados.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("​\n                    "),_c('b',[_vm._v("Utilização de Cookies")])])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("Cookies são pequenos dados enviados por um servidor web para o seu navegador e armazenado no seu computador ou dispositivo pessoal. Para oferecer melhor experiência no uso de nossos serviços web e aplicações, poderemos usar cookies de sessão (que expiram quando você fecha o navegador) e cookies persistentes (que permanecem no seu computador até que você os delete). Este tipo de informação é coletada para tornar o serviço mais útil e oferecer uma experiência mais conveniente e valiosa para você.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("Usamos duas categorias de cookies: Cookies servidos diretamente por nós ao seu computador ou dispositivo para que possamos reconhecê-lo quando você retorna ao nosso site e cookies de terceiros, usados para estatísticas de acesso, segurança e disponibilidade do site.")])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_c('b',[_vm._v("Alterações na Política")])])]),_vm._v(" "),_c('p',{staticClass:"font_8",staticStyle:{"text-align":"justify","font-size":"16px"}},[_c('span',{staticStyle:{"color":"#216D40"}},[_vm._v("Se fizermos alterações nessa Política de Privacidade, iremos informá-lo da mudança na próxima visita ao site e você também poderá entrar em contato com a Health ID Lab via o e-mail "),_c('span',{staticStyle:{"text-decoration":"underline"}},[_c('a',{attrs:{"data-auto-recognition":"true","href":"mailto:seguranca@clichealthid.com"}},[_vm._v("seguranca@clichealthid.com")])]),_vm._v(" para direcionar seus questionamentos em relação à mesma.")])])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 887 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69fd7c80","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/RegisterKit/RegisterKit.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-menu'),_vm._v(" "),(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"container"},[[(_vm.stepsResponsible())?_c('a-steps',{attrs:{"direction":"horizontal","current":_vm.activeStep,"size":"small"}},[_c('a-step'),_vm._v(" "),_c('a-step'),_vm._v(" "),_vm._l((_vm.formSteps),function(step,x){return _c('a-step',{key:x})}),_vm._v(" "),_c('a-step')],2):_vm._e(),_vm._v(" "),(!_vm.stepsResponsible())?_c('a-steps',{attrs:{"direction":"vertical","current":_vm.activeStep,"size":"small"}},[_c('a-step'),_vm._v(" "),_c('a-step'),_vm._v(" "),_vm._l((_vm.formSteps),function(step,x){return _c('a-step',{key:x})}),_vm._v(" "),_c('a-step')],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[(_vm.activeStep === 0)?_c('kit-number',{on:{"next":_vm.nextStep}}):_vm._e(),_vm._v(" "),(_vm.activeStep === 1)?_c('privacy-policy',{on:{"next":_vm.nextStep}}):_vm._e(),_vm._v(" "),(_vm.activeStep === 2)?_c('kit-orientation',{attrs:{"shipping_type":_vm.shipping_type},on:{"next":_vm.forceNextStep}}):_vm._e(),_vm._v(" "),(_vm.activeStep >= 3 && _vm.activeStep - 2 <= _vm.totalFormSteps && !!_vm.kit_type)?_c('data-kit-health-customer',{attrs:{"kit_id":_vm.kit_id,"kit_type":_vm.kit_type,"kit":_vm.form.kit_number,"step":_vm.activeStep},on:{"next":function($event){_vm.nextStep($event);_vm.scheduleActiveStep=true},"formNextStep":_vm.formNextStep,"setFormSteps":_vm.setFormSteps}}):_vm._e(),_vm._v(" "),(_vm.scheduleActiveStep)?_c('data-kit-schedule',{attrs:{"shipping_type":_vm.shipping_type,"tag_type":_vm.tag_type,"kit":_vm.form.kit_number},on:{"next":_vm.nextStep}}):_vm._e()],1),_vm._v("\n        "+_vm._s(_vm.activeStep)+"\n      ")]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 888 */
/*!*****************************************************!*\
  !*** ./src/views/ForgotPassword/ForgotPassword.vue ***!
  \*****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ForgotPassword.vue */ 415);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ffe473e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1ffe473e","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ForgotPassword.vue */ 890);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1ffe473e","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ForgotPassword.vue */ 889)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ffe473e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ffe473e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 889 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ffe473e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ForgotPassword/ForgotPassword.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */
/*!*****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ffe473e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ForgotPassword/ForgotPassword.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-bg"},[_c('header-div'),_vm._v(" "),_c('section',{staticClass:"home-container"},[_c('div',{staticClass:"form-container"},[_c('div',{staticClass:"form-box"},[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],attrs:{"type":"text","name":"email","id":"email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.email)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.email.join()))]):_vm._e()]),_vm._v(" "),(!_vm.confirmed)?_c('div',{staticClass:"form-actions"},[(!_vm.loading)?_c('button',{staticClass:"button btn-orange"},[_vm._v("\n                                RECUPERAR\n                            ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-orange",attrs:{"disabled":""}},[_c('loading')],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.confirmed)?_c('div',{staticClass:"form-actions"},[_c('p',[_vm._v("Foi enviado para o seu e-mail um link para redefinir sua senha.")])]):_vm._e()])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("\n                            Insira seu e-mail para recuperar sua senha.\n                        ")]),_vm._v(" "),_c('p',[_vm._v("\n                            Em seguida você receberá um e-mail contendo um link para inserir sua nova senha.\n                        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 891 */
/*!*******************************************************!*\
  !*** ./src/views/RecoverPassword/RecoverPassword.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RecoverPassword_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RecoverPassword.vue */ 416);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70241150_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoverPassword_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-70241150","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RecoverPassword.vue */ 893);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-70241150","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RecoverPassword.vue */ 892)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70241150"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RecoverPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70241150_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoverPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 892 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70241150","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/RecoverPassword/RecoverPassword.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/*!*******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70241150","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/RecoverPassword/RecoverPassword.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-bg"},[_c('header-div'),_vm._v(" "),(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"home-container"},[(_vm.loadingScreen)?_c('div',{staticClass:"form-container"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.notFound && !_vm.loadingScreen)?_c('div',{staticClass:"form-container"},[_c('div',{staticClass:"form-box"},[_vm._m(1),_vm._v(" "),_c('form',{on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Nova senha *")]),_vm._v(" "),_c('span',{staticClass:"password-icon"},[(!_vm.showPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye-slash']},on:{"click":function($event){return _vm.handleShowPassword(0)}}}):_vm._e(),_vm._v(" "),(_vm.showPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye']},on:{"click":function($event){return _vm.handleShowPassword(0)}}}):_vm._e()],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],attrs:{"id":"password","name":"password","type":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.password)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.password.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"confirm_password"}},[_vm._v("Confirmar nova senha *")]),_vm._v(" "),_c('span',{staticClass:"password-icon"},[(!_vm.showConfirmPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye-slash']},on:{"click":function($event){return _vm.handleShowPassword(1)}}}):_vm._e(),_vm._v(" "),(_vm.showConfirmPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye']},on:{"click":function($event){return _vm.handleShowPassword(1)}}}):_vm._e()],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password_confirmation),expression:"form.password_confirmation"}],attrs:{"id":"confirm_password","name":"confirm_password","type":"password"},domProps:{"value":(_vm.form.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password_confirmation", $event.target.value)}}})]),_vm._v(" "),(!_vm.confirmed)?_c('div',{staticClass:"form-actions"},[(!_vm.loading)?_c('button',{staticClass:"button btn-orange"},[_vm._v("\n                                RECUPERAR\n                            ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-orange",attrs:{"disabled":""}},[_c('loading')],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.confirmed)?_c('div',{staticClass:"form-actions"},[_vm._m(2)]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.notFound && !_vm.loadingScreen)?_c('div',{staticClass:"form-container"},[_vm._m(3)]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-box"},[_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("\n                            Insira sua nova senha para acessar o Health ID Lab\n                        ")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Sua senha foi alterada com sucesso! Clique "),_c('a',{attrs:{"href":"../"}},[_vm._v("aqui")]),_vm._v(" para fazer o seu login.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-box"},[_c('div',[_c('h1',[_vm._v("\n                            Não foi possível solicitar uma nova senha\n                        ")]),_vm._v(" "),_c('p',[_vm._v("\n                            O link que você acessou pode ser inválido ou já tenha sido expirado. Clique aqui para solicitar uma nova senha.\n                        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 894 */
/*!**********************************************!*\
  !*** ./src/components/CarePlan/CarePlan.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CarePlan_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CarePlan.vue */ 417);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7d9b91_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarePlan_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2f7d9b91","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CarePlan.vue */ 896);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2f7d9b91","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CarePlan.vue */ 895)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f7d9b91"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CarePlan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7d9b91_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarePlan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 895 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f7d9b91","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CarePlan/CarePlan.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 896 */
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f7d9b91","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CarePlan/CarePlan.vue ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('side-menu'),_vm._v(" "),_c('div',{staticClass:"care-plans"},[(_vm.carePlans && _vm.carePlans.documents.length > 0)?_c('div',_vm._l((_vm.carePlans.documents),function(document){return _c('div',{staticClass:"card"},[_c('div',{staticClass:"wrapper"},[_c('h2',[_vm._v("Plano de cuidado "+_vm._s(_vm.getDate(document.created_at)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.carePlans.doctor.name))]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',[_c('strong',[_vm._v("Resultado dos exames:")]),_vm._v(" "+_vm._s(_vm.carePlans.result_exams))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Orientações de saúde:")]),_vm._v(" "+_vm._s(_vm.carePlans.health_orientation))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Encaminhamentos/Medicações:")]),_vm._v(" "+_vm._s(_vm.carePlans.forwarding_medication))])])]),_vm._v(" "),_c('a',{staticClass:"action",attrs:{"target":"blank","href":document.url}},[_c('span',[_vm._v("Acessar Plano   ")]),_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fa', 'external-link-alt']}})],1)])}),0):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 897 */
/*!************************************************************!*\
  !*** ./src/components/CoordinatedCare/CoordinatedCare.vue ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CoordinatedCare_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CoordinatedCare.vue */ 418);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa92fe16_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordinatedCare_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-aa92fe16","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CoordinatedCare.vue */ 901);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-aa92fe16","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CoordinatedCare.vue */ 898)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa92fe16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CoordinatedCare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa92fe16_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordinatedCare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 898 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aa92fe16","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CoordinatedCare/CoordinatedCare.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/*!******************************************!*\
  !*** ./src/services/coordinated_care.js ***!
  \******************************************/
/*! exports provided: GET_COORDINATED_CARES, GET_CARE_FILES */
/*! exports used: GET_CARE_FILES, GET_COORDINATED_CARES */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_COORDINATED_CARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_CARE_FILES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(/*! ./api */ 39);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var GET_COORDINATED_CARES = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/coordinated-care', {
							headers: {
								'Authorization': 'Bearer ' + window.localStorage.getItem('token')
							}
						});

					case 2:
						response = _context.sent;
						return _context.abrupt('return', response.data);

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function GET_COORDINATED_CARES() {
		return _ref.apply(this, arguments);
	};
}();

var GET_CARE_FILES = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* AXIOS_INSTANCE */].get(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* API_HOST */] + '/coordinated-care/' + id, {
							headers: {
								'Authorization': 'Bearer ' + window.localStorage.getItem('token')
							}
						});

					case 2:
						response = _context2.sent;
						return _context2.abrupt('return', response.data);

					case 4:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function GET_CARE_FILES(_x) {
		return _ref2.apply(this, arguments);
	};
}();

/***/ }),
/* 900 */
/*!****************************************!*\
  !*** ./src/assets/images/no-cover.png ***!
  \****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/no-cover.16f79148.png";

/***/ }),
/* 901 */
/*!************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa92fe16","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CoordinatedCare/CoordinatedCare.vue ***!
  \************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('side-menu'),_vm._v(" "),_c('div',{staticClass:"coordinated-care"},_vm._l((_vm.categories),function(category){return (_vm.categories)?_c('div',[_c('h1',[_vm._v(_vm._s(category.title))]),_vm._v(" "),(category.posts.length > 0)?_c('div',_vm._l((category.posts),function(post){return _c('div',{staticClass:"card"},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":post.cover_image},on:{"error":function($event){return _vm.fixBrokenImage($event)}}})]),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"text"},[_c('h2',[_vm._v(_vm._s(post.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(post.description))])]),_vm._v(" "),_c('div',{staticClass:"action"},[(post.attachment)?_c('a',{attrs:{"href":post.attachment,"target":"blank"}},[_vm._v("Download")]):_c('button',{attrs:{"disabled":""}},[_vm._v("Indisponível")])])])])}),0):_c('div',{staticClass:"empty"},[_c('p',[_vm._v("Não há posts para essa categoria")])])]):_c('div',{staticClass:"empty"},[_c('p',[_vm._v("Não há cuidados coordenados para exibir")])])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */
/*!*********************************!*\
  !*** ./src/globalComponents.js ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_Header__ = __webpack_require__(/*! ./components/Header/Header */ 1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer_Footer__ = __webpack_require__(/*! ./components/Footer/Footer */ 1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu_Menu__ = __webpack_require__(/*! ./components/Menu/Menu */ 1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Input_InputText__ = __webpack_require__(/*! ./components/Input/InputText */ 1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LoadingIcon_LoadingIcon__ = __webpack_require__(/*! ./components/LoadingIcon/LoadingIcon */ 1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LoadingScreen_LoadingScreen__ = __webpack_require__(/*! ./components/LoadingScreen/LoadingScreen */ 1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RegisterModal_RegisterModal__ = __webpack_require__(/*! ./components/RegisterModal/RegisterModal */ 1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ForgotPasswordModal_ForgotPasswordModal__ = __webpack_require__(/*! ./components/ForgotPasswordModal/ForgotPasswordModal */ 1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_KitResults_KitResults__ = __webpack_require__(/*! ./components/KitResults/KitResults */ 362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_KitRisks_KitRisks__ = __webpack_require__(/*! ./components/KitRisks/KitRisks */ 366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_KitPlans_KitPlans__ = __webpack_require__(/*! ./components/KitPlans/KitPlans */ 377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_KitTips_KitTips__ = __webpack_require__(/*! ./components/KitTips/KitTips */ 380);













var GlobalComponents = {
  install: function install(Vue) {
    Vue.component("header-div", __WEBPACK_IMPORTED_MODULE_0__components_Header_Header__["a" /* default */]);
    Vue.component("footer-div", __WEBPACK_IMPORTED_MODULE_1__components_Footer_Footer__["a" /* default */]);
    Vue.component("side-menu", __WEBPACK_IMPORTED_MODULE_2__components_Menu_Menu__["a" /* default */]);
    Vue.component("input-text", __WEBPACK_IMPORTED_MODULE_3__components_Input_InputText__["a" /* default */]);
    Vue.component("loading", __WEBPACK_IMPORTED_MODULE_4__components_LoadingIcon_LoadingIcon__["a" /* default */]);
    Vue.component("loading-screen", __WEBPACK_IMPORTED_MODULE_5__components_LoadingScreen_LoadingScreen__["a" /* default */]);
    Vue.component("register-modal", __WEBPACK_IMPORTED_MODULE_6__components_RegisterModal_RegisterModal__["a" /* default */]);
    Vue.component("forgot-password-modal", __WEBPACK_IMPORTED_MODULE_7__components_ForgotPasswordModal_ForgotPasswordModal__["a" /* default */]);
    Vue.component("kit-results", __WEBPACK_IMPORTED_MODULE_8__components_KitResults_KitResults__["a" /* default */]);
    Vue.component("kit-risks", __WEBPACK_IMPORTED_MODULE_9__components_KitRisks_KitRisks__["a" /* default */]);
    Vue.component("kit-plans", __WEBPACK_IMPORTED_MODULE_10__components_KitPlans_KitPlans__["a" /* default */]);
    Vue.component("kit-tips", __WEBPACK_IMPORTED_MODULE_11__components_KitTips_KitTips__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),
/* 1384 */
/*!******************************************!*\
  !*** ./src/components/Header/Header.vue ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Header.vue */ 584);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9ac01d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f9ac01d0","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Header.vue */ 1386);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f9ac01d0","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Header.vue */ 1385)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9ac01d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9ac01d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1385 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f9ac01d0","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header/Header.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1386 */
/*!******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9ac01d0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Header.vue ***!
  \******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"header-container"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/logo-healthid-lab_sbg.png */ 1387)}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1387 */
/*!*****************************************************!*\
  !*** ./src/assets/images/logo-healthid-lab_sbg.png ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/logo-healthid-lab_sbg.ab020625.png";

/***/ }),
/* 1388 */
/*!******************************************!*\
  !*** ./src/components/Footer/Footer.vue ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Footer.vue */ 585);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29ee59d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-29ee59d0","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Footer.vue */ 1390);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-29ee59d0","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Footer.vue */ 1389)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29ee59d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29ee59d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1389 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29ee59d0","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer/Footer.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1390 */
/*!******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29ee59d0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer/Footer.vue ***!
  \******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1391 */
/*!**************************************!*\
  !*** ./src/components/Menu/Menu.vue ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Menu.vue */ 586);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c0e14f2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0c0e14f2","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Menu.vue */ 1393);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0c0e14f2","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Menu.vue */ 1392)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c0e14f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c0e14f2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1392 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c0e14f2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Menu/Menu.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1393 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c0e14f2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu/Menu.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('div',{staticClass:"menu-box"},[_c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":_vm.kitsUrl}},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/new_logo_horizontal.png */ 137)}})])]),_vm._v(" "),_c('div',{staticClass:"menu-items"},[_c('button',{staticClass:"button item-btn",staticStyle:{"width":"100%","margin":"21px 0"},on:{"click":_vm.toRegisterKit}},[_vm._v("\n          Registrar\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"to":_vm.kitsUrl,"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'box']}}),_vm._v("\n          Meus Check-Ups\n        ")],1),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"to":_vm.coordinatedCareUrl,"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'book-medical']}}),_vm._v("\n          Cuidado Coordenado\n        ")],1),_vm._v(" "),(_vm.examsQuantity > 0)?_c('router-link',{staticClass:"item",attrs:{"to":_vm.digitalUrl,"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'id-card']}}),_vm._v("\n          Identidade de Saúde\n        ")],1):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"to":_vm.profileUrl,"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'user-tie']}}),_vm._v("\n          Perfil\n        ")],1),_vm._v(" "),_c('a',{staticClass:"item",on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'arrow-alt-circle-left']}}),_vm._v("\n          Sair\n        ")],1)],1)]),_vm._v(" "),_c('div',{staticClass:"menu-box-mobile"},[_c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":_vm.kitsUrl}},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/new_logo_horizontal.png */ 137)}})])]),_vm._v(" "),_c('div',{staticClass:"mobile-button",on:{"click":function($event){return _vm.switchDropdownMenu()}}},[_c('button',{staticClass:"menu-mobile item-btn button",on:{"click":function($event){$event.preventDefault();return _vm.toRegisterKit.apply(null, arguments)}}},[_vm._v("\n          Registrar Kit\n        ")]),_vm._v(" "),(!_vm.dropddownMenu)?_c('font-awesome-icon',{staticClass:"dropdown-bars",attrs:{"icon":['fa', 'bars']}}):_vm._e(),_vm._v(" "),(_vm.dropddownMenu)?_c('font-awesome-icon',{staticClass:"dropdown-bars",attrs:{"icon":['fa', 'times']}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"menu-dropdown",class:{ active: (_vm.dropddownMenu == true) }},[_c('div',{staticClass:"menu-items"},[_c('button',{staticClass:"menu-desktop item-btn button",staticStyle:{"width":"88%","margin":"21px 0"},on:{"click":function($event){$event.preventDefault();return _vm.toRegisterKit.apply(null, arguments)}}},[_vm._v("\n            Registrar Kit\n          ")]),_vm._v(" "),_c('a',{staticClass:"item",attrs:{"href":_vm.kitsUrl}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'box']}}),_vm._v("\n            Meus Check-Ups\n          ")],1),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"to":_vm.coordinatedCareUrl,"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'book-medical']}}),_vm._v("\n            Cuidado Coordenado\n          ")],1),_vm._v(" "),(_vm.examsQuantity > 0)?_c('a',{staticClass:"item",attrs:{"href":_vm.digitalUrl}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'id-card']}}),_vm._v("\n            Identidade de Saúde\n          ")],1):_vm._e(),_vm._v(" "),_c('a',{staticClass:"item",attrs:{"href":_vm.profileUrl}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'user-tie']}}),_vm._v("\n            Perfil\n          ")],1),_vm._v(" "),_c('a',{staticClass:"item",on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'arrow-alt-circle-left']}}),_vm._v("\n            Sair\n          ")],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1394 */
/*!********************************************!*\
  !*** ./src/components/Input/InputText.vue ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_InputText_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./InputText.vue */ 587);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb038a68_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputText_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-fb038a68","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./InputText.vue */ 1396);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-fb038a68","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./InputText.vue */ 1395)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fb038a68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_InputText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb038a68_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1395 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fb038a68","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Input/InputText.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1396 */
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb038a68","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Input/InputText.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-box"},[_c('label',[_vm._v(_vm._s(_vm.name)+" "),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),(_vm.type == 'password' || _vm.type == 'password_confirm' )?_c('span',{staticClass:"password-icon"},[(!_vm.showPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye-slash']},on:{"click":_vm.handleShowPassword}}):_vm._e(),_vm._v(" "),(_vm.showPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye']},on:{"click":_vm.handleShowPassword}}):_vm._e()],1):_vm._e(),_vm._v(" "),((_vm.setType())==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],attrs:{"name":_vm.id,"id":_vm.id,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.content)?_vm._i(_vm.content,null)>-1:(_vm.content)},on:{"input":_vm.handleInput,"blur":function($event){return _vm.validate()},"keyup":function($event){return _vm.clearErrors()},"change":function($event){var $$a=_vm.content,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.content=$$a.concat([$$v]))}else{$$i>-1&&(_vm.content=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.content=$$c}}}}):((_vm.setType())==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],attrs:{"name":_vm.id,"id":_vm.id,"type":"radio"},domProps:{"checked":_vm._q(_vm.content,null)},on:{"input":_vm.handleInput,"blur":function($event){return _vm.validate()},"keyup":function($event){return _vm.clearErrors()},"change":function($event){_vm.content=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],attrs:{"name":_vm.id,"id":_vm.id,"type":_vm.setType()},domProps:{"value":(_vm.content)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.content=$event.target.value},_vm.handleInput],"blur":function($event){return _vm.validate()},"keyup":function($event){return _vm.clearErrors()}}}),_vm._v(" "),(_vm.errorMessage)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1397 */
/*!****************************************************!*\
  !*** ./src/components/LoadingIcon/LoadingIcon.vue ***!
  \****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingIcon_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LoadingIcon.vue */ 588);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c96be2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingIcon_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-25c96be2","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LoadingIcon.vue */ 1399);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-25c96be2","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LoadingIcon.vue */ 1398)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25c96be2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c96be2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1398 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25c96be2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LoadingIcon/LoadingIcon.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1399 */
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25c96be2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingIcon/LoadingIcon.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-div"},[_c('font-awesome-icon',{staticClass:"loading",attrs:{"icon":"spinner"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1400 */
/*!********************************************************!*\
  !*** ./src/components/LoadingScreen/LoadingScreen.vue ***!
  \********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingScreen_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LoadingScreen.vue */ 589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4281368_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingScreen_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-a4281368","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LoadingScreen.vue */ 1402);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-a4281368","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LoadingScreen.vue */ 1401)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a4281368"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4281368_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1401 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a4281368","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LoadingScreen/LoadingScreen.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1402 */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4281368","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingScreen/LoadingScreen.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"loading-div"},[_c('font-awesome-icon',{staticClass:"loading",attrs:{"icon":"spinner"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1403 */
/*!********************************************************!*\
  !*** ./src/components/RegisterModal/RegisterModal.vue ***!
  \********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterModal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RegisterModal.vue */ 590);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_533801bc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterModal_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-533801bc","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RegisterModal.vue */ 1411);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-533801bc","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RegisterModal.vue */ 1404)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-533801bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_533801bc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1404 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-533801bc","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RegisterModal/RegisterModal.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1405 */
/*!*************************************************************!*\
  !*** ./src/components/RegisterModal/steps/RegisterForm.vue ***!
  \*************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RegisterForm.vue */ 591);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069f2172_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-069f2172","hasScoped":true,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RegisterForm.vue */ 1407);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-069f2172","scoped":true,"hasInlineConfig":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RegisterForm.vue */ 1406)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-069f2172"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069f2172_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1406 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-069f2172","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RegisterModal/steps/RegisterForm.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1407 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-069f2172","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterModal/steps/RegisterForm.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("Crie seu acesso")]),_vm._v(" "),_c('form',{on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Nome Completo *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],attrs:{"type":"text","name":"name","id":"name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.name)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.name.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],attrs:{"type":"text","name":"email","id":"email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.email)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.email.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Senha *")]),_vm._v(" "),_c('span',{staticClass:"password-icon"},[[_c('a-tooltip',{staticStyle:{"margin":"0 5px"}},[_c('template',{slot:"title"},[_vm._v("\n                                A senha deve ter no mínimo 6 caracteres e ser composta de, ao menos, letras e números.\n                            ")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":['fa', 'question-circle']}})],2)],_vm._v(" "),(!_vm.showPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye-slash']},on:{"click":function($event){return _vm.handleShowPassword(0)}}}):_vm._e(),_vm._v(" "),(_vm.showPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye']},on:{"click":function($event){return _vm.handleShowPassword(0)}}}):_vm._e()],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],attrs:{"type":"password","name":"password","id":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.password)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.password.join()))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"confirm_password"}},[_vm._v("Confirmar Senha *")]),_vm._v(" "),_c('span',{staticClass:"password-icon"},[[_c('a-tooltip',{staticStyle:{"margin":"0 5px"}},[_c('template',{slot:"title"},[_vm._v("\n                                Lembre-se, as senhas devem coincidir.\n                            ")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":['fa', 'question-circle']}})],2)],_vm._v(" "),(!_vm.showConfirmPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye-slash']},on:{"click":function($event){return _vm.handleShowPassword(1)}}}):_vm._e(),_vm._v(" "),(_vm.showConfirmPassword)?_c('font-awesome-icon',{attrs:{"icon":['fa', 'eye']},on:{"click":function($event){return _vm.handleShowPassword(1)}}}):_vm._e()],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password_confirmation),expression:"form.password_confirmation"}],attrs:{"type":"password","name":"confirm_password","id":"confirm_password"},domProps:{"value":(_vm.form.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password_confirmation", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.password_confirmation)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.password_confirmation.join()))]):_vm._e()]),_vm._v(" "),(!_vm.success)?_c('div',{staticClass:"form-actions"},[(!_vm.loading)?_c('button',{staticClass:"button btn-primary"},[_vm._v("\n                    Cadastrar\n                ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary",attrs:{"disabled":""}},[_c('loading')],1):_vm._e()]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1408 */
/*!*************************************************************!*\
  !*** ./src/components/RegisterModal/steps/RegisterTips.vue ***!
  \*************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterTips_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RegisterTips.vue */ 592);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d948656_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterTips_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1d948656","hasScoped":true,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RegisterTips.vue */ 1410);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1d948656","scoped":true,"hasInlineConfig":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RegisterTips.vue */ 1409)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d948656"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterTips_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d948656_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterTips_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1409 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d948656","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RegisterModal/steps/RegisterTips.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1410 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d948656","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterModal/steps/RegisterTips.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentStep === 0)?_c('div',{staticClass:"modal-finished"},[_c('h4',[_vm._v("Seu acesso foi criado com sucesso. Você já pode acessar nosso sistema e realizar o seu cadastro!")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"button-box"},[(!_vm.loading)?_c('button',{staticClass:"button btn-purple",on:{"click":function($event){return _vm.login()}}},[_vm._v("\n                Entrar no sistema\n              ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-purple"},[_c('loading')],1):_vm._e()])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__(/*! @/assets/images/vector-fluxo-healthid-lab-com.png */ 221),"width":"300"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1411 */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-533801bc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterModal/RegisterModal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"register-modal modal-box"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.currentStep === 0)?_c('register-form',{on:{"next":_vm.nextStep}}):_vm._e(),_vm._v(" "),(_vm.currentStep === 1)?_c('register-tips',{on:{"login":_vm.login}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1412 */
/*!********************************************************************!*\
  !*** ./src/components/ForgotPasswordModal/ForgotPasswordModal.vue ***!
  \********************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPasswordModal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ForgotPasswordModal.vue */ 593);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02b59068_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPasswordModal_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-02b59068","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ForgotPasswordModal.vue */ 1414);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-02b59068","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ForgotPasswordModal.vue */ 1413)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02b59068"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_atlassian_pipelines_agent_build_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPasswordModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02b59068_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPasswordModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1413 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02b59068","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ForgotPasswordModal/ForgotPasswordModal.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1414 */
/*!********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b59068","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPasswordModal/ForgotPasswordModal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-box"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(!_vm.confirmed)?_c('div',{staticClass:"form-box"},[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":_vm.handleSubmit}},[_c('div',{staticClass:"input-box"},[_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],attrs:{"type":"text","name":"email","id":"email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),(_vm.errors && _vm.errors.email)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.errors.email.join()))]):_vm._e()]),_vm._v(" "),(!_vm.confirmed)?_c('div',{staticClass:"form-actions"},[(!_vm.loading)?_c('button',{staticClass:"button btn-primary"},[_vm._v("\n                                Recuperar\n                            ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"button btn-primary",attrs:{"disabled":""}},[_c('loading')],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.confirmed)?_c('div',{staticClass:"form-actions"},[_c('p',[_vm._v("Foi enviado para o seu e-mail um link para redefinir sua senha.")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.confirmed)?_c('div',{staticClass:"form-box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button btn-purple",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n                            OK\n                        ")])])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Insira seu e-mail para recuperar sua senha.")]),_vm._v(" "),_c('p',[_vm._v("\n                            Em seguida você receberá um e-mail contendo um link para inserir sua nova senha.\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Confirmado!")]),_vm._v(" "),_c('p',[_vm._v("Foi enviado para o seu e-mail um link para redefinir sua senha.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]),[594]);


// WEBPACK FOOTER //
// client.441a48a6.js